webpackJsonp([1],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REQUIRED_PASSWORD_STRENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PERMISSION_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESPONSE_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NOTIFICATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHAT_TYPES; });
/* harmony default export */ __webpack_exports__["a"] = ({
    serverURI: "http://174.138.22.78/api",
    websocketURI: "ws://174.138.22.78/api",
    appURI: "http://174.138.22.78:3000",
    fixedLayout: false,
    hideLogoOnMobile: false
});

var resources = {
    user: {
        alias: 'user',
        associations: {
            groups: {
                alias: 'group'
            },
            permissions: {
                alias: 'permission'
            },
            connections: {
                alias: 'connection'
            },
            conversations: {
                alias: 'conversation'
            },
            notifications: {
                alias: 'notification'
            },
            documents: {
                alias: 'document'
            },
            sharedDocuments: {
                alias: 'shared-document'
            },
            images: {
                alias: 'image'
            }
        }
    },
    conversation: {
        alias: 'conversation'
    },
    notification: {
        alias: 'notification'
    },
    connection: {
        alias: 'connection'
    },
    auditLog: {
        alias: 'auditLog',
        options: {
            filterDeleted: false
        }
    },
    document: {
        alias: 'document',
        associations: {
            users: {
                alias: 'user'
            }
        }
    },
    image: {
        alias: 'image'
    },
    visitor: {
        alias: 'visitor'
    },
    role: {
        alias: 'role',
        associations: {
            users: {
                alias: 'user'
            },
            permissions: {
                alias: 'permission'
            }
        }
    },
    group: {
        alias: 'group',
        associations: {
            users: {
                alias: 'user'
            },
            permissions: {
                alias: 'permission'
            }
        }
    },
    permission: {
        alias: 'permission',
        associations: {
            users: {
                alias: 'user'
            },
            roles: {
                alias: 'role'
            },
            groups: {
                alias: 'group'
            }
        }
    },
    deviceData: {
        alias: 'device'
    },
    regionData: {
        alias: 'region'
    },
    regionsData: {
        alias: 'regions'
    },
    vehicleData: {
        alias: 'vehicle'
    },
    siteData: {
        alias: 'site'
    },
    tripData: {
        alias: 'trip'
    },
    triprouteData: {
        alias: 'triproute'
    },
    tripCreateRouteData: {
        alias: 'v1/createTripRoute'
    },
    driverData: {
        alias: 'driver'
    },
    salesdataData: {
        alias: 'salesdata'
    },
    tripdetailsData: {
        alias: 'tripdetails'
    },
    tripExceptionData: {
        alias: 'tripException'
    },
    triplocationData: {
        alias: 'triplocation'
    },
    reportgenerationData: {
        alias: 'reportgeneration'
    },
    schedulereportData: {
        alias: 'schedulereport'
    },
    expiringLicenseData: {
        alias: 'expiringLicense'
    },
    livedetailsData: {
        alias: 'livedetails'
    },
    hcvdetailsData: {
        alias: 'hcvdetails'
    },
    tempuserData: {
        alias: 'tempuser'
    },
    reportScheduleReminderData: {
        alias: 'reportScheduleReminder'
    },
    reportData: {
        alias: 'report'
    },
    techchecklistData: {
        alias: 'techchecklist'
    },
    driverComplianceData: {
        alias: 'driverCompliance'
    },
    vehicleComplianceData: {
        alias: 'vehicleCompliance'
    },
    tripGroupData: {
        alias: 'tripgroup'
    }

};

var API = {
    USER: resources.user.alias || 'user',
    PERMISSION: resources.permission.alias || 'permission'
};

var REQUIRED_PASSWORD_STRENGTH = 3;

var USER_ROLES = {
    REPORT_STAFF: 'Report Staff',
    SALES_MANAGER: 'Sales Manager',
    JOURNEY_MANAGER: 'Journey Manager',
    GA_HEAD: 'GA Head',
    ADMIN: 'Admin',
    SUPER_ADMIN: 'Super Admin'
};

var PERMISSION_STATES = {
    INCLUDED: 'Included',
    EXCLUDED: 'Excluded',
    FORBIDDEN: 'Forbidden'
};

var RESPONSE_MESSAGES = {
    EXPIRED_ACCESS_TOKEN: 'Expired Access Token',
    EXPIRED_REFRESH_TOKEN: 'Expired Refresh Token'
};

var EVENTS = {
    USER_PERMISSIONS_UPDATED: 'user-permissions-updated',
    USER_PERMISSIONS_SAVED: 'user-permissions-saved',
    USER_GROUPS_UPDATED: 'user-groups-updated',
    USER_GROUPS_SAVED: 'user-groups-saved',
    GROUP_USERS_UPDATED: 'group-users-updated',
    GROUP_USERS_SAVED: 'group-users-saved',
    GROUP_PERMISSIONS_UPDATED: 'group-permissions-updated',
    GROUP_PERMISSIONS_SAVED: 'group-permissions-saved',
    PERMISSION_USERS_UPDATED: 'permission-users-updated',
    PERMISSION_USERS_SAVED: 'permission-users-saved',
    PERMISSION_GROUPS_UPDATED: 'permission-groups-updated',
    PERMISSION_GROUPS_SAVED: 'permission-groups-saved',
    PASSWORD_SCORE_UPDATED: 'password-score-updated',
    UPDATING_PASSWORD_SCORE: 'updating-password-score',

    DATA_REQUESTED: 'data-requested',
    DATA_READY: 'data-ready',
    CLEAR_REQUESTED: 'clear-requested',

    OPEN_CHAT: 'open-chat',
    CLOSE_CHAT: 'close-chat',
    OPEN_CHAT_CREATE: 'open-chat-create',
    CLOSE_CHAT_CREATE: 'close-chat-create',

    MARK_CONVERSATION_AS_READ: 'mark-conversation-as-read',
    MARK_CONVERSATION_AS_UNREAD: 'mark-conversation-as-unread',

    MARK_NOTIFICATION_AS_READ: 'mark-notification-as-read',
    MARK_NOTIFICATION_AS_UNREAD: 'mark-notification-as-unread'
};

var NOTIFICATION_TYPES = {
    SHARED_DOCUMENT: 'shared-document',
    FOLLOW: 'follow',
    CONTACT: 'contact'
};

var CHAT_TYPES = {
    DIRECT: 'direct',
    GROUP: 'group'
};

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_css_Custom_scss__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_css_Custom_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_css_Custom_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_snotify_styles_material_css__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_snotify_styles_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_snotify_styles_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_croppa_dist_vue_croppa_css__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_croppa_dist_vue_croppa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_croppa_dist_vue_croppa_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pderas_vue2_geocoder__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_querystring__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_router__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_repository_plugin__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_snotify__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_moment__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_form__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_select__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_js_modal__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_js_toggle_button__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_password_dist_custom__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_password_dist_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_password_dist_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_masked_input__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_croppa__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_croppa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_carousel_3d__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_grid_layout__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_grid_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_grid_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_v_tooltip__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_utilities_Box_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_utilities_Box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_utilities_Box_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_utilities_VueFormInput_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_utilities_VueFormInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_utilities_VueFormInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue2_datepicker__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_simple_vue2_datetimepicker__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_firebase__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue2_timepicker__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_datetime__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_ctk_date_time_picker__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_ctk_date_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vue_ctk_date_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__directives_v_permission__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__filters__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_App_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_msal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_vue_msal__);


























































__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_42__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_42__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_42__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_42__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('shortMessage', __WEBPACK_IMPORTED_MODULE_42__filters__["e" /* shortMessage */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].filter('userList', __WEBPACK_IMPORTED_MODULE_42__filters__["f" /* userList */]);

__WEBPACK_IMPORTED_MODULE_12_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].serverURI;

__WEBPACK_IMPORTED_MODULE_12_axios___default.a.defaults.paramsSerializer = function (params) {
  return __WEBPACK_IMPORTED_MODULE_13_querystring___default.a.stringify(params);
};

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('box', __WEBPACK_IMPORTED_MODULE_31__components_utilities_Box_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('vue-form-input', __WEBPACK_IMPORTED_MODULE_32__components_utilities_VueFormInput_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('pulse-loader', __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_PulseLoader_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('vue-select', __WEBPACK_IMPORTED_MODULE_22_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('vue-password', __WEBPACK_IMPORTED_MODULE_25_vue_password_dist_custom___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('vue-masked-input', __WEBPACK_IMPORTED_MODULE_26_vue_masked_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('grid-layout', __WEBPACK_IMPORTED_MODULE_29_vue_grid_layout___default.a.GridLayout);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('grid-item', __WEBPACK_IMPORTED_MODULE_29_vue_grid_layout___default.a.GridItem);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('date-picker', __WEBPACK_IMPORTED_MODULE_33_vue2_datepicker___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('datetimepicker', __WEBPACK_IMPORTED_MODULE_34_simple_vue2_datetimepicker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('vue-timepicker', __WEBPACK_IMPORTED_MODULE_36_vue2_timepicker___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('datetime', __WEBPACK_IMPORTED_MODULE_37_vue_datetime__["Datetime"]);

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__plugins_repository_plugin__["a" /* default */], { httpClient: __WEBPACK_IMPORTED_MODULE_11__services__["a" /* httpClient */], resources: __WEBPACK_IMPORTED_MODULE_14__config__["b" /* resources */], log: true });
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_tables_2__["ServerTable"], {}, false);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_form___default.a, {
  inputClasses: {
    valid: 'form-control-success',
    invalid: 'form-control-danger'
  }
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__pderas_vue2_geocoder__["a" /* default */], {
  defaultLanguage: 'en',
  defaultMode: 'lat-lng',
  googleMapsApiKey: 'AIzaSyBvu5T76L9QqcebnQuUYUAAsdrI-DmvGK4'
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_snotify__["a" /* default */], {
  toast: {
    position: __WEBPACK_IMPORTED_MODULE_17_vue_snotify__["b" /* SnotifyPosition */].rightTop
  }
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_vue_croppa___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_vue_carousel_3d___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('VueCtkDateTimePicker', __WEBPACK_IMPORTED_MODULE_39_vue_ctk_date_time_picker___default.a);

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__, {
  load: {
    key: 'AIzaSyAbpjPvMo7ycCaYrT1mChG7sZsrcZgKJ-8',
    libraries: 'places',
    region: 'INDIA',
    language: 'English'
  }
});
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].directive('permission', __WEBPACK_IMPORTED_MODULE_41__directives_v_permission__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_15_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_9__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.auth.accessToken || router.app.$store.state.auth.accessToken === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresUnauth;
  }) && router.app.$store.state.auth.accessToken) {
    window.console.log('Authenticated');
    next({
      path: '/'
    });
  } else {
    next();
  }
});

router.beforeEach(function (to, from, next) {
  if ((__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.auth.user.passwordUpdateRequired || __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.auth.user.pinUpdateRequired) && to.fullPath !== '/profile?settings=true') {
    next({
      path: '/profile',
      query: { settings: true }
    });
  } else {
    next();
  }
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('setBreadcrumbs', { currentPath: to.path });
  next();
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], router);

if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.auth.accessToken) {
  __WEBPACK_IMPORTED_MODULE_11__services__["b" /* wsClient */].connect();
}

__WEBPACK_IMPORTED_MODULE_12_axios___default.a.interceptors.response.use(function (response) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
}, __WEBPACK_IMPORTED_MODULE_11__services__["c" /* authInterceptor */].responseError);
__WEBPACK_IMPORTED_MODULE_12_axios___default.a.defaults.headers.common = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

__WEBPACK_IMPORTED_MODULE_12_axios___default.a.defaults.headers.common.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.auth.accessToken;

__WEBPACK_IMPORTED_MODULE_35_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyDG2xPrh11YI7Krp11vc2HeHs7YHPO9wRw',
  authDomain: 'thinkgas-390bf.firebaseapp.com',
  databaseURL: 'https://thinkgas-390bf.firebaseio.com',
  projectId: 'thinkgas-390bf',
  storageBucket: 'thinkgas-390bf.appspot.com',
  messagingSenderId: '363262839911',
  appId: '1:363262839911:web:b141652a0cbc4adddcd8c2',
  measurementId: 'G-JLK2E9FWB7'
});

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_44_vue_msal___default.a, {
  auth: {
    clientId: '7663863f-523a-41e3-a21a-7a353aa939d4',
    tenantId: '1a63eded-aece-4b7f-a3d7-39828b274d9b',
    authority: 'https://login.microsoftonline.com/1a63eded-aece-4b7f-a3d7-39828b274d9b/',
    redirectUri: 'https://journeymanagement.think-gas.com' },
  cache: {
    cacheLocation: 'sessionStorage' },

  accessToken: ''
});

var vm = new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_43__components_App_vue___default.a);
  },
  created: function created() {
    var _this = this;

    if (this.$msal.isAuthenticated()) {
      this.loading = true;
      var payload = {
        email: this.$msal.data.user.userName,
        id: this.$msal.data.user.idTokenClaims.oid
      };
      __WEBPACK_IMPORTED_MODULE_11__services__["d" /* authService */].loginAzure(payload).then(function (response) {
        _this.loading = false;
        _this.$snotify.success('Login successful', 'Success!');
        _this.$router.push('/');
      }).catch(function (error) {
        _this.loading = false;
        _this.flash = true;
        _this.flashType = 'error';
        if (error.data.message === 'User is not active') {
          console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>', error.data.message);
          _this.$snotify.error('You are an Inactive User. Please contact your administrator');
        }
        if (error.data.message === 'User does not exist in database.') {
          console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>', error.data.message);
          _this.$snotify.error('You are not a existing user in database. Please contact your administrator.');
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (vm);

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_change_case__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_change_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_change_case__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var generateMutations = function generateMutations(initialState) {
	var mutations = {};

	var _loop = function _loop(prop) {

		mutations['SET_' + __WEBPACK_IMPORTED_MODULE_0_change_case___default.a.constantCase(prop)] = function (state, data) {
			state[prop] = data;
		};

		mutations['DELETE_' + __WEBPACK_IMPORTED_MODULE_0_change_case___default.a.constantCase(prop)] = function (state) {
			state[prop] = null;
		};

		mutations['CLEAR_' + __WEBPACK_IMPORTED_MODULE_0_change_case___default.a.constantCase(prop)] = function (state) {

			if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(state[prop])) {
				state[prop] = '';
			}
			if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(state[prop])) {
				state[prop] = {};
			}
			if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(state[prop])) {
				state[prop] = [];
			}
			if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isBoolean(state[prop])) {
				state[prop] = false;
			}
			if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNumber(state[prop])) {
				state[prop] = 0;
			}
		};

		if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(initialState[prop])) {

			mutations['ADD_' + __WEBPACK_IMPORTED_MODULE_0_change_case___default.a.constantCase(prop)] = function (state, data) {
				state[prop].push(data);
			};

			mutations['REMOVE_' + __WEBPACK_IMPORTED_MODULE_0_change_case___default.a.constantCase(prop)] = function (state, data) {
				var index = state[prop].indexOf(data);

				if (index !== -1) {
					state[prop].splice(index, 1);
				}
			};
		}
	};

	for (var prop in initialState) {
		_loop(prop);
	}

	return mutations;
};

/* harmony default export */ __webpack_exports__["a"] = (generateMutations);

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 167,
	"./af.js": 167,
	"./ar": 174,
	"./ar-dz": 168,
	"./ar-dz.js": 168,
	"./ar-kw": 169,
	"./ar-kw.js": 169,
	"./ar-ly": 170,
	"./ar-ly.js": 170,
	"./ar-ma": 171,
	"./ar-ma.js": 171,
	"./ar-sa": 172,
	"./ar-sa.js": 172,
	"./ar-tn": 173,
	"./ar-tn.js": 173,
	"./ar.js": 174,
	"./az": 175,
	"./az.js": 175,
	"./be": 176,
	"./be.js": 176,
	"./bg": 177,
	"./bg.js": 177,
	"./bm": 178,
	"./bm.js": 178,
	"./bn": 180,
	"./bn-bd": 179,
	"./bn-bd.js": 179,
	"./bn.js": 180,
	"./bo": 181,
	"./bo.js": 181,
	"./br": 182,
	"./br.js": 182,
	"./bs": 183,
	"./bs.js": 183,
	"./ca": 184,
	"./ca.js": 184,
	"./cs": 185,
	"./cs.js": 185,
	"./cv": 186,
	"./cv.js": 186,
	"./cy": 187,
	"./cy.js": 187,
	"./da": 188,
	"./da.js": 188,
	"./de": 191,
	"./de-at": 189,
	"./de-at.js": 189,
	"./de-ch": 190,
	"./de-ch.js": 190,
	"./de.js": 191,
	"./dv": 192,
	"./dv.js": 192,
	"./el": 193,
	"./el.js": 193,
	"./en-au": 194,
	"./en-au.js": 194,
	"./en-ca": 195,
	"./en-ca.js": 195,
	"./en-gb": 196,
	"./en-gb.js": 196,
	"./en-ie": 197,
	"./en-ie.js": 197,
	"./en-il": 198,
	"./en-il.js": 198,
	"./en-in": 199,
	"./en-in.js": 199,
	"./en-nz": 200,
	"./en-nz.js": 200,
	"./en-sg": 201,
	"./en-sg.js": 201,
	"./eo": 202,
	"./eo.js": 202,
	"./es": 206,
	"./es-do": 203,
	"./es-do.js": 203,
	"./es-mx": 204,
	"./es-mx.js": 204,
	"./es-us": 205,
	"./es-us.js": 205,
	"./es.js": 206,
	"./et": 207,
	"./et.js": 207,
	"./eu": 208,
	"./eu.js": 208,
	"./fa": 209,
	"./fa.js": 209,
	"./fi": 210,
	"./fi.js": 210,
	"./fil": 211,
	"./fil.js": 211,
	"./fo": 212,
	"./fo.js": 212,
	"./fr": 215,
	"./fr-ca": 213,
	"./fr-ca.js": 213,
	"./fr-ch": 214,
	"./fr-ch.js": 214,
	"./fr.js": 215,
	"./fy": 216,
	"./fy.js": 216,
	"./ga": 217,
	"./ga.js": 217,
	"./gd": 218,
	"./gd.js": 218,
	"./gl": 219,
	"./gl.js": 219,
	"./gom-deva": 220,
	"./gom-deva.js": 220,
	"./gom-latn": 221,
	"./gom-latn.js": 221,
	"./gu": 222,
	"./gu.js": 222,
	"./he": 223,
	"./he.js": 223,
	"./hi": 224,
	"./hi.js": 224,
	"./hr": 225,
	"./hr.js": 225,
	"./hu": 226,
	"./hu.js": 226,
	"./hy-am": 227,
	"./hy-am.js": 227,
	"./id": 228,
	"./id.js": 228,
	"./is": 229,
	"./is.js": 229,
	"./it": 231,
	"./it-ch": 230,
	"./it-ch.js": 230,
	"./it.js": 231,
	"./ja": 232,
	"./ja.js": 232,
	"./jv": 233,
	"./jv.js": 233,
	"./ka": 234,
	"./ka.js": 234,
	"./kk": 235,
	"./kk.js": 235,
	"./km": 236,
	"./km.js": 236,
	"./kn": 237,
	"./kn.js": 237,
	"./ko": 238,
	"./ko.js": 238,
	"./ku": 239,
	"./ku.js": 239,
	"./ky": 240,
	"./ky.js": 240,
	"./lb": 241,
	"./lb.js": 241,
	"./lo": 242,
	"./lo.js": 242,
	"./lt": 243,
	"./lt.js": 243,
	"./lv": 244,
	"./lv.js": 244,
	"./me": 245,
	"./me.js": 245,
	"./mi": 246,
	"./mi.js": 246,
	"./mk": 247,
	"./mk.js": 247,
	"./ml": 248,
	"./ml.js": 248,
	"./mn": 249,
	"./mn.js": 249,
	"./mr": 250,
	"./mr.js": 250,
	"./ms": 252,
	"./ms-my": 251,
	"./ms-my.js": 251,
	"./ms.js": 252,
	"./mt": 253,
	"./mt.js": 253,
	"./my": 254,
	"./my.js": 254,
	"./nb": 255,
	"./nb.js": 255,
	"./ne": 256,
	"./ne.js": 256,
	"./nl": 258,
	"./nl-be": 257,
	"./nl-be.js": 257,
	"./nl.js": 258,
	"./nn": 259,
	"./nn.js": 259,
	"./oc-lnc": 260,
	"./oc-lnc.js": 260,
	"./pa-in": 261,
	"./pa-in.js": 261,
	"./pl": 262,
	"./pl.js": 262,
	"./pt": 264,
	"./pt-br": 263,
	"./pt-br.js": 263,
	"./pt.js": 264,
	"./ro": 265,
	"./ro.js": 265,
	"./ru": 266,
	"./ru.js": 266,
	"./sd": 267,
	"./sd.js": 267,
	"./se": 268,
	"./se.js": 268,
	"./si": 269,
	"./si.js": 269,
	"./sk": 270,
	"./sk.js": 270,
	"./sl": 271,
	"./sl.js": 271,
	"./sq": 272,
	"./sq.js": 272,
	"./sr": 274,
	"./sr-cyrl": 273,
	"./sr-cyrl.js": 273,
	"./sr.js": 274,
	"./ss": 275,
	"./ss.js": 275,
	"./sv": 276,
	"./sv.js": 276,
	"./sw": 277,
	"./sw.js": 277,
	"./ta": 278,
	"./ta.js": 278,
	"./te": 279,
	"./te.js": 279,
	"./tet": 280,
	"./tet.js": 280,
	"./tg": 281,
	"./tg.js": 281,
	"./th": 282,
	"./th.js": 282,
	"./tk": 283,
	"./tk.js": 283,
	"./tl-ph": 284,
	"./tl-ph.js": 284,
	"./tlh": 285,
	"./tlh.js": 285,
	"./tr": 286,
	"./tr.js": 286,
	"./tzl": 287,
	"./tzl.js": 287,
	"./tzm": 289,
	"./tzm-latn": 288,
	"./tzm-latn.js": 288,
	"./tzm.js": 289,
	"./ug-cn": 290,
	"./ug-cn.js": 290,
	"./uk": 291,
	"./uk.js": 291,
	"./ur": 292,
	"./ur.js": 292,
	"./uz": 294,
	"./uz-latn": 293,
	"./uz-latn.js": 293,
	"./uz.js": 294,
	"./vi": 295,
	"./vi.js": 295,
	"./x-pseudo": 296,
	"./x-pseudo.js": 296,
	"./yo": 297,
	"./yo.js": 297,
	"./zh-cn": 298,
	"./zh-cn.js": 298,
	"./zh-hk": 299,
	"./zh-hk.js": 299,
	"./zh-mo": 300,
	"./zh-mo.js": 300,
	"./zh-tw": 301,
	"./zh-tw.js": 301
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1771;

/***/ }),

/***/ 1868:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(2020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1869:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(2013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1870:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(2008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1871:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1964),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1872:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1959),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1873:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(2019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1874:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(2001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1875:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1978),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1876:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1974),
  /* scopeId */
  "data-v-46799b2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1877:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1989),
  /* scopeId */
  "data-v-628891a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1878:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(2014),
  /* scopeId */
  "data-v-c7a561a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1879:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(2022),
  /* scopeId */
  "data-v-f085f6c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1880:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1881:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1984),
  /* scopeId */
  "data-v-5c62651a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1882:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1953),
  /* scopeId */
  "data-v-1bd546a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1883:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1969),
  /* scopeId */
  "data-v-3d416b89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1884:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(2006),
  /* scopeId */
  "data-v-9104104a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1885:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1962),
  /* scopeId */
  "data-v-281cbcb0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1886:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1985),
  /* scopeId */
  "data-v-5cb1c1f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1887:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(2000),
  /* scopeId */
  "data-v-780b91bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1888:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1950),
  /* scopeId */
  "data-v-1601f79b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(2024),
  /* scopeId */
  "data-v-f2be8720",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1890:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1949),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1891:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(2012),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1892:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1893:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1963),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1894:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1965),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1895:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1944),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1896:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1960),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1897:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(2016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1898:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1966),
  /* scopeId */
  "data-v-2ad490bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1899:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1947),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1900:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(2017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1901:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1986),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1902:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1979),
  /* scopeId */
  "data-v-4d8b5782",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1903:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1975),
  /* scopeId */
  "data-v-48b4da1b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1904:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(2005),
  /* scopeId */
  "data-v-8d58c220",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1905:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1906:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1976),
  /* scopeId */
  "data-v-48b4deb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1907:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1992),
  /* scopeId */
  "data-v-639876c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1908:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(2015),
  /* scopeId */
  "data-v-c7d31702",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1909:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1999),
  /* scopeId */
  "data-v-7787ca5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1910:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1957),
  /* scopeId */
  "data-v-2056f7f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1911:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1983),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1912:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(2002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(2009),
  /* scopeId */
  "data-v-97820b0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1971),
  /* scopeId */
  "data-v-404484bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1915:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(2010),
  /* scopeId */
  "data-v-9e396ce0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1990),
  /* scopeId */
  "data-v-6317f3b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1956),
  /* scopeId */
  "data-v-1ea9d0bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1998),
  /* scopeId */
  "data-v-76b4f69b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1919:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1942),
  /* scopeId */
  "data-v-06cf53b3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1948),
  /* scopeId */
  "data-v-12f03aa6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1977),
  /* scopeId */
  "data-v-49af88cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1922:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1943),
  /* scopeId */
  "data-v-07db0c02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1923:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1980),
  /* scopeId */
  "data-v-4fae3873",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1924:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1982),
  /* scopeId */
  "data-v-5401e492",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1925:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(2003),
  /* scopeId */
  "data-v-87672c7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1926:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1996),
  /* scopeId */
  "data-v-74eb719f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1927:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1967),
  /* scopeId */
  "data-v-2f56bb64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1928:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1946),
  /* scopeId */
  "data-v-115d9760",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1929:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(2018),
  /* scopeId */
  "data-v-e033f640",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1930:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1972),
  /* scopeId */
  "data-v-45975d7b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1931:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1987),
  /* scopeId */
  "data-v-612e476c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1932:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1970),
  /* scopeId */
  "data-v-4007a11f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1933:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1968),
  /* scopeId */
  "data-v-3b764ca9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1934:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1935:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(2004),
  /* scopeId */
  "data-v-897e55a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1936:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1981),
  /* scopeId */
  "data-v-53bf4780",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1937:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1952),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1938:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1961),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1939:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1945),
  /* scopeId */
  "data-v-10dface0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1940:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(2025),
  /* scopeId */
  "data-v-fd031c96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1941:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1995),
  /* scopeId */
  "data-v-730f9adf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1942:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteTechnicianModal
    }
  }, [_vm._v("Delete Operator")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.name),
      expression: "tempuser.name",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "20",
      "name": "name",
      "required": "",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.tempuser.name)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "name",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Operator name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Operator Name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Technician name should be more than 3 characters")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Technician name should be less than 20 characters")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobileNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.mobileNumber),
      expression: "tempuser.mobileNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000000000",
      "name": "mobileNumber",
      "required": "",
      "placeholder": "Mobile number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.tempuser.mobileNumber)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "mobileNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobileNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Mobile number is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Mobile number is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Minimum 10 digit")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateOfBirth),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "dateOfBirth",
      "max": this.minDate,
      "required": "",
      "lang": "en",
      "name": "dateOfBirth",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": _vm.getEligibleDate
    },
    model: {
      value: (_vm.tempuser.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.tempuser, "dateOfBirth", $$v)
      },
      expression: "tempuser.dateOfBirth"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateOfBirth",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date of Birth is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Minimum Age is 18 years")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.deviceId),
      expression: "tempuser.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_id), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.region),
      expression: "tempuser.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.manager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.manager),
      expression: "tempuser.manager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "manager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "manager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Journey Manager")]), _vm._v(" "), _vm._l((_vm.manager), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "manager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Journey Manager is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.languageKnown),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Language Known")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.languageKnown),
      expression: "tempuser.languageKnown"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "languageKnown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "languageKnown", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "languageKnown",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Language is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.defaultLanguage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.defaultLanguage),
      expression: "tempuser.defaultLanguage"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "defaultLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "defaultLanguage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.userPin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Operator Pin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.userPin),
      expression: "tempuser.userPin",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "name": "technicianPin",
      "required": "",
      "placeholder": "Technician Pin"
    },
    domProps: {
      "value": (_vm.tempuser.userPin)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "userPin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "technicianPin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Technician pin is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Technician pin is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Technician pin is minimum 4 digit")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Technician pin is Maximum 4 digit")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.addressDetails)
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.addressDetails),
      expression: "tempuser.addressDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "addressDetails",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.tempuser.addressDetails)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "addressDetails", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.status),
      expression: "tempuser.status",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.userType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.userType),
      expression: "tempuser.userType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "operator"
    }
  }, [_vm._v("Operator")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "userType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Type is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.site),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.site),
      expression: "tempuser.site"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "endSite"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "site", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.site_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  }), 0), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "site",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Technician'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateTechnician
    }
  }, [_vm._v("Update Operator")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1943:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER,
        _vm.USER_ROLES.GIS_USER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n  USER_ROLES.GIS_USER,\n]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "main_select_wrp_relative"
  }, [_c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "filtertoogle",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilterFilter()
      }
    }
  }, [_vm._v("Clear\n              All")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "format": 'DD-MM-YYYY',
      "placeholder": "Start date"
    },
    on: {
      "change": function($event) {
        return _vm.startDateFilter()
      }
    },
    model: {
      value: (_vm.dateFilter.startDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.dateFilter, "startDateFilter", $$v)
      },
      expression: "dateFilter.startDateFilter"
    }
  }), _vm._v(" "), _c('label', [_vm._v("End Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "not-before": _vm.startDateIso,
      "format": 'DD-MM-YYYY',
      "placeholder": "End date"
    },
    on: {
      "change": function($event) {
        return _vm.endDateFilter()
      }
    },
    model: {
      value: (_vm.dateFilter.endDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.dateFilter, "endDateFilter", $$v)
      },
      expression: "dateFilter.endDateFilter"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "main_select_wrp_relative"
  }, [_c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "exportCSV",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Export ")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Clear\n              All")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "format": 'DD-MM-YYYY',
      "placeholder": "Start date"
    },
    on: {
      "change": function($event) {
        return _vm.startDate()
      }
    },
    model: {
      value: (_vm.date.startDate),
      callback: function($$v) {
        _vm.$set(_vm.date, "startDate", $$v)
      },
      expression: "date.startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "not-before": _vm.startDateIso,
      "format": 'DD-MM-YYYY',
      "placeholder": "End date"
    },
    on: {
      "change": function($event) {
        return _vm.endDate()
      }
    },
    model: {
      value: (_vm.date.endDate),
      callback: function($$v) {
        _vm.$set(_vm.date, "endDate", $$v)
      },
      expression: "date.endDate"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right export_CSV"
  }, [_c('button', {
    staticClass: "mr-2 btn gradientbt ",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_vm._v("\n              Export\n            ")])])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResult]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "scheduled"
    }
  }, [_vm._v("Scheduled")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ongoing"
    }
  }, [_vm._v("Ongoing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatus
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n        USER_ROLES.ADMIN,\n        USER_ROLES.SUPER_ADMIN,\n        USER_ROLES.GA_HEAD,\n        USER_ROLES.JOURNEY_MANAGER,\n      ]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('div', {
    staticClass: "filter_wrpp filtered"
  }, [_c('div', {
    staticClass: "applyFilter"
  }, [_c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#filtertoogle"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0 -1028.4)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m10 11v10l4 3v-13h-4z",
      "fill": "#fff",
      "transform": "translate(0 1028.4)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m10 11v10l2 1.5v-11.5h-2z",
      "fill": "#fff",
      "transform": "translate(0 1028.4)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m1 1028.4 9 11h4l9-11z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m1 1028.4 9 11h2v-11z",
      "fill": "#fff"
    }
  })])]), _vm._v("\n              Apply Filter\n            ")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exportCSV"
    }
  }, [_vm._v("\n          Export\n        ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroupCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn addnew"
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "haltsCount",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showArea(props.row)
            }
          }
        }, [_vm._v(_vm._s(props.row.subTripDetails.length - 1))])])]
      }
    }, {
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "permission",
            rawName: "v-permission.if",
            value: ([
              _vm.USER_ROLES.ADMIN,
              _vm.USER_ROLES.SUPER_ADMIN,
              _vm.USER_ROLES.GA_HEAD,
              _vm.USER_ROLES.JOURNEY_MANAGER ]),
            expression: "[\n            USER_ROLES.ADMIN,\n            USER_ROLES.SUPER_ADMIN,\n            USER_ROLES.GA_HEAD,\n            USER_ROLES.JOURNEY_MANAGER,\n          ]",
            modifiers: {
              "if": true
            }
          }]
        }, [(props.row.status == 'ongoing' || props.row.status == 'scheduled') ? _c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.UpdateDestination(props.row)
            }
          }
        }) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)]), _vm._v(" "), (_vm.isAreaTable) ? _c('div', {
    staticClass: "password-popup"
  }, [_c('div', {
    staticClass: "password-popup-width"
  }, [_c('h4', {
    staticClass: "heading_pop"
  }, [_vm._v("Sub-Trip Details")]), _vm._v(" "), _c('a', {
    staticClass: "toggle",
    on: {
      "click": _vm.closeAreaTableModal
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Layer_1",
      "x": "0",
      "y": "0",
      "version": "1.1",
      "viewBox": "0 0 29 29",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#706c6c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      "d": "M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "tablePopUp"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.tripDetailsList), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.tripCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.startSiteSiteName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.endSiteSiteName))])])
  })], 2)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Trip Code")]), _vm._v(" "), _c('th', [_vm._v("Start Site")]), _vm._v(" "), _c('th', [_vm._v("End Site")])])
}]}

/***/ }),

/***/ 1944:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav",
    staticStyle: {
      "float": "right"
    }
  }, [_c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "dropdown-notifications-menu"
    }
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.unreadNotificationsCount) + " notification(s)")]), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('li', {
      key: index,
      class: {
        'message-unread': !notification.hasRead
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(notification.actingUser)
        }
      }
    }, [_c('img', {
      staticClass: "contacts-list-img",
      attrs: {
        "src": notification.actingUser.profileImageUrl,
        "alt": "Contact Avatar"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message-list-info"
    }, [_c('span', {
      staticClass: "message-list-name"
    }, [_c('span', [_vm._v(_vm._s(notification.actingUser.firstName) + " " + _vm._s(notification.actingUser.lastName))]), _vm._v(" "), _c('small', {
      staticClass: "message-list-date pull-right"
    }, [_vm._v(_vm._s(_vm._f("moment")(notification.createdAt, "MMM D, h:mm a")))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "message-list-msg"
    }, [_vm._v(_vm._s(notification.message))]), _vm._v(" "), (notification.hasRead) ? _c('span', {
      staticClass: "message-list-dot"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Mark as unread'),
        expression: "'Mark as unread'"
      }],
      staticClass: "btn btn-box-tool",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.markNotificationAsUnread(notification)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    })])]) : _c('span', {
      staticClass: "message-list-dot"
    }, [_c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Mark as read'),
        expression: "'Mark as read'"
      }],
      staticClass: "btn btn-box-tool",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.markNotificationAsRead(notification)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    })])])])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    staticClass: "message-menu-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.markAllNotificationsAsRead($event)
      }
    }
  }, [_vm._v("Mark All as Read")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.pictureUrl,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.pictureUrl,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " - " + _vm._s(_vm.user.roleName) + "\n                "), _c('small', [_vm._v("Member since " + _vm._s(_vm._f("moment")(_vm.user.createdAt, "MMMM, YYYY")))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profile")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])])])])])])])]), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "16%"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini col-xs-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_c('h2', {
    staticClass: " logo1",
    staticStyle: {
      "margin-bottom": "12px",
      "font-size": "22px",
      "color": "black",
      "font-weight": "900",
      "margin-top": "12px",
      "margin-left": "65px"
    }
  }, [_vm._v("HASHBULLS ALGOTRADE PLATFORM ")])]), _vm._v(" "), _c('h2', {
    staticClass: "logo3 ",
    staticStyle: {
      "margin-bottom": "1px",
      "font-size": "22px",
      "color": "black",
      "font-weight": "900",
      "margin-top": "13px"
    }
  }, [_vm._v("HASHBULLS ALGOTRADE PLATFORM  ")])])
}]}

/***/ }),

/***/ 1945:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.region),
      expression: "vehicle.region"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isVehicleDisable,
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regNo),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Registration No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.regNo),
      expression: "vehicle.regNo",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "regNo",
      "required": "",
      "placeholder": "Registration No",
      "pattern": "^[a-zA-Z0-9]{10}$"
    },
    domProps: {
      "value": (_vm.vehicle.regNo)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "regNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regNo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Registration no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Registration no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of registration no is 10 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.capacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Capacity (WL)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.capacity),
      expression: "vehicle.capacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "100",
      "max": "30000",
      "name": "capacity",
      "required": "",
      "placeholder": "Capacity"
    },
    domProps: {
      "value": (_vm.vehicle.capacity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "capacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "capacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Capacity is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Minimum 100 kg Capacity")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum 30000 kg Capacity")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cylinders),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Cascade Capacity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.cylinders),
      expression: "vehicle.cylinders",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "cylinders",
      "required": "",
      "placeholder": "Cascade Capacity"
    },
    domProps: {
      "value": (_vm.vehicle.cylinders)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "cylinders", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cylinders",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" Cascade Capacity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateCommissioning),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Date of Commissioning")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateCommissioning",
      "lang": "en",
      "name": "dateCommissioning",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.dateCommissioning),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "dateCommissioning", $$v)
      },
      expression: "vehicle.dateCommissioning"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateCommissioning",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date of Commissioning is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Date of Commissioning is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.deviceId),
      expression: "vehicle.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerName),
      expression: "vehicle.ownerName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ownerName",
      "required": "",
      "placeholder": "Transporter Name"
    },
    domProps: {
      "value": (_vm.vehicle.ownerName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "ownerName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Transporter name is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerContact),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transporter Contact No.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerContact),
      expression: "vehicle.ownerContact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "ownerContact",
      "required": "",
      "placeholder": "Transporter contact number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.vehicle.ownerContact)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "ownerContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerContact",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Transporter contact no. is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Transporter contact no. is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportSupervisorName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Supervisor Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.transportSupervisorName),
      expression: "vehicle.transportSupervisorName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "transportSupervisorName",
      "required": "",
      "placeholder": "Transport Supervisor Name"
    },
    domProps: {
      "value": (_vm.vehicle.transportSupervisorName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "transportSupervisorName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportSupervisorName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Supervisor Name is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportSupervisorContact),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Supervisor Contact")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.transportSupervisorContact),
      expression: "vehicle.transportSupervisorContact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "transportSupervisorContact",
      "required": "",
      "placeholder": "Transport Supervisor Contact",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.vehicle.transportSupervisorContact)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "transportSupervisorContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportSupervisorContact",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Supervisor Contact is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" Supervisor Contact no. is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.ownerDetails)
  }, [_c('label', [_vm._v("Transporter Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerDetails),
      expression: "vehicle.ownerDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ownerDetails",
      "placeholder": "Other Info"
    },
    domProps: {
      "value": (_vm.vehicle.ownerDetails)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "ownerDetails", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("RC validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "rcValidity",
      "lang": "en",
      "name": "rcValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.rcValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "rcValidity", $$v)
      },
      expression: "vehicle.rcValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "rcValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("RC validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.rcDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("RC Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput1",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged1
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Insurance Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "insuranceValidity",
      "lang": "en",
      "name": "insuranceValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.insuranceValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "insuranceValidity", $$v)
      },
      expression: "vehicle.insuranceValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "insuranceValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Insurance Validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.insuranceDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Insurance Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput2",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged2
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("PUC validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "pucValidity",
      "lang": "en",
      "name": "pucValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.pucValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "pucValidity", $$v)
      },
      expression: "vehicle.pucValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "pucValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("PUC validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.pucDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("PUC Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput3",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged3
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Fitness Certificate Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "fitCertValidity",
      "lang": "en",
      "name": "fitCertValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.fitCertValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "fitCertValidity", $$v)
      },
      expression: "vehicle.fitCertValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "fitCertValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Fitness Certificate Validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.fitCertDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Fitnness Certificate Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput4",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged4
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Goods Carriage permit validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "gcpValidity",
      "lang": "en",
      "name": "gcpValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.gcpValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "gcpValidity", $$v)
      },
      expression: "vehicle.gcpValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "gcpValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Goods Carriage permit validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.gcpDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Goods Carriage permit Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput5",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged5
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.hCVCommissioningCumAuditReport),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" HCV Commissioning cum Audit Report")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput6",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged6
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" Vehicle images")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput7",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged7
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.status),
      expression: "vehicle.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "mt"
  }, [_c('validate', {
    staticClass: "form-group inline",
    class: _vm.fieldClassName(_vm.formstate.cgpsMonitoring)
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.camera),
      expression: "vehicle.camera",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "value": "false",
      "name": "camera"
    },
    domProps: {
      "checked": _vm.vehicle.camera,
      "checked": Array.isArray(_vm.vehicle.camera) ? _vm._i(_vm.vehicle.camera, "false") > -1 : (_vm.vehicle.camera)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vehicle.camera,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "false",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.vehicle, "camera", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.vehicle, "camera", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.vehicle, "camera", $$c)
        }
      }
    }
  }), _vm._v("Camera")])]), _vm._v(" "), _c('validate', {
    staticClass: "form-group inline",
    class: _vm.fieldClassName(_vm.formstate.camera)
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.cgpsMonitoring),
      expression: "vehicle.cgpsMonitoring",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "value": "false",
      "name": "cgpsMonitoring"
    },
    domProps: {
      "checked": _vm.vehicle.cgpsMonitoring,
      "checked": Array.isArray(_vm.vehicle.cgpsMonitoring) ? _vm._i(_vm.vehicle.cgpsMonitoring, "false") > -1 : (_vm.vehicle.cgpsMonitoring)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vehicle.cgpsMonitoring,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "false",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.vehicle, "cgpsMonitoring", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.vehicle, "cgpsMonitoring", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.vehicle, "cgpsMonitoring", $$c)
        }
      }
    }
  }), _vm._v("GPS Monitoring")])])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Vehicle'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && _vm.formValid)
    },
    on: {
      "click": _vm.createVehicle
    }
  }, [_vm._v("Add\n                            Vehicle")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1946:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteTripModal
    }
  }, [_vm._v("Delete Trip")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group ",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.vehicleId),
      expression: "trip.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.driverId),
      expression: "trip.driverId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "driverId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "driverId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Driver")]), _vm._v(" "), _vm._l((_vm.driver_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "required": "",
      "not-before": _vm.disabledBefore,
      "lang": "en",
      "name": "scheduleDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Schedule Date is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduleTime",
      "required": ""
    },
    model: {
      value: (_vm.trip.scheduleTime),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleTime", $$v)
      },
      expression: "trip.scheduleTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Schedule Time is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.routeId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Route Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.routeId),
      expression: "trip.routeId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "routeId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "routeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSites]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Route")]), _vm._v(" "), _vm._l((_vm.route_name), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "sourceSite": item.startSite,
        "destinationSite": item.endSite
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                            " + _vm._s(item.name) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "routeId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Route is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.regionManager),
      expression: "trip.regionManager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "regionManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "regionManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select HCV Operation Manager")]), _vm._v(" "), _vm._l((_vm.region_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("HCV Operation Manager is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.journeyManager),
      expression: "trip.journeyManager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "journeyManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "journeyManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Journey Manager")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Journey Manager is a required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Trip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updateTrip
    }
  }, [_vm._v("Update Trip")])])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1947:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "margin-left": "110px"
    }
  }, [_c('div', {
    staticClass: "main_table",
    staticStyle: {
      "overflow-x": "auto",
      "width": "992px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "1",
      "border": "0"
    }
  }, [_c('div', {
    staticClass: "header_top"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "50%",
      "padding-left": "10px"
    }
  }, [_vm._v("Location Name: "), _c('b', [_vm._v(_vm._s(_vm.techchecklist.siteName))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    }
  }, [_vm._v("DATE: "), _c('b', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(this.selectedDate) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("SHIFT: "), _c('b', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.shift) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("SI.No."), _c('b', [_vm._v(_vm._s("1"))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("1.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Diesel/Water in DG set checked"), _c('b', {
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dgSet.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.dgSet.subList[0].value == "false") ? "No" : "Na") + " ")])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("1.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v(" DG set started once in shift\t"), _c('b', {
    staticStyle: {
      "margin-left": "112px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dgSet.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.dgSet.subList[1].value == "false") ? "No" : "Na") + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "5"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("2.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Air compressor filter cleaned "), _c('b', {
    staticStyle: {
      "margin-left": "102px"
    }
  }, [_vm._v("\t" + _vm._s((_vm.techchecklist.airCompressor.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.airCompressor.subList[0].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("2.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Air compressor oil level checked "), _c('b', {
    staticStyle: {
      "margin-left": "75px"
    }
  }, [_vm._v("\t " + _vm._s((_vm.techchecklist.airCompressor.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.airCompressor.subList[1].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("2.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Air compressor receiver drained "), _c('b', {
    staticStyle: {
      "margin-left": "77px"
    }
  }, [_vm._v("\t " + _vm._s((_vm.techchecklist.airCompressor.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.airCompressor.subList[2].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "10%",
      "border": "1px solid #000",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("3.1\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "width": "40%",
      "border-bottom": "0px"
    }
  }, [_vm._v("Working Condition :")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "50%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.remarks.subList[0].natureOfAbnormality))])]), _vm._v(" "), _vm._m(6), _vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Dispenser filters drained\t  "), _c('b', {
    staticStyle: {
      "margin-left": "130px"
    }
  }, [_vm._v("\t" + _vm._s((_vm.techchecklist.dispenser.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[0].value == "false") ? "No" : "Na") + "\t\t")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Dispenser nozzles checked and cleaned  "), _c('b', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dispenser.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[1].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Condition of dispenser seals  "), _c('b', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dispenser.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[2].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.5")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Ensure two hour reading of dispensers  "), _c('b', {
    staticStyle: {
      "margin-left": "27px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.dispenser.subList[3].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[3].value == "false") ? "No" : "Na") + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "50%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Cause: ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Cascade:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.remarks.subList[1].cause))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("4.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Check cascade leakage,if any "), _c('b', {
    staticStyle: {
      "margin-left": "88px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.cascade.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.cascade.subList[0].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("5.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Check power supply "), _c('b', {
    staticStyle: {
      "margin-left": "156px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.electrical.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.electrical.subList[0].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("5.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Energy meter/UPS seals "), _c('b', {
    staticStyle: {
      "margin-left": "125px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.electrical.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.electrical.subList[1].value == "false") ? "No" : "Na"))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Action Taken : ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("5.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Electrical Room lock checked "), _c('b', {
    staticStyle: {
      "margin-left": "91px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.electrical.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.electrical.subList[2].value == "false") ? "No" : "Na"))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "11"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.remarks.subList[2].actionTaken))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Tools handed over "), _c('b', {
    staticStyle: {
      "margin-left": "169px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[0].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Waste cloth availability on the station "), _c('b', {
    staticStyle: {
      "margin-left": "38px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[1].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Check DSM duty handed over "), _c('b', {
    staticStyle: {
      "margin-left": "86px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[2].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Take over log book "), _c('b', {
    staticStyle: {
      "margin-left": "164px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[3].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[3].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("First Aid Box "), _c('b', {
    staticStyle: {
      "margin-left": "208px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[0].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Tool Box  "), _c('b', {
    staticStyle: {
      "margin-left": "236px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[1].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Adapter/Remote  "), _c('b', {
    staticStyle: {
      "margin-left": "180px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[2].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Oil/Coolant/Diesel  "), _c('b', {
    staticStyle: {
      "margin-left": "168px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[3].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[3].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "padding": "50px 0px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Details of Breakdown/power cut & DG set running hours : " + _vm._s(_vm.techchecklist.additionalInfo.subList[0].dgSetRunningHour) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "padding": "50px 0px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Instructions received from control room in the shift : " + _vm._s(_vm.techchecklist.additionalInfo.subList[1].instructionReceived))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "padding": "50px 0px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Other Information for next shift Technician : " + _vm._s(_vm.techchecklist.additionalInfo.subList[2].otherInformation))])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Name :"), _c('b', [_vm._v(_vm._s(_vm.techchecklist.operatorName))])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Signature : " + _vm._s(_vm.techchecklist.sign))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-13 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'OperatorReport'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "right",
      "padding-right": "10px"
    }
  }, [_vm._v("Doc No: "), _c('b', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "24px",
      "border": "1px solid #000",
      "width": "56%",
      "padding-left": "10px",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("TECHNICIAN LOG BOOK/CHECK LIST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "border": "1px solid #000",
      "text-align": "center",
      "padding-left": "10px"
    }
  }, [_vm._v("S.NO.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "center",
      "padding-left": "10px"
    }
  }, [_vm._v("TASK TO BE CARRIED OUT")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "center",
      "font-weight": "bold",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    }
  }, [_vm._v("REMARKS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" DG Set:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Abnormality/Breakdown reported to (if any,in Dispenser,Cascade,DG set,UPS,Air Compressor,etc):\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Air Compressor:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Dispenser:\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Nature of Abnormality/Breakdown :  \t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0px",
      "border-right": "0",
      "width": "45%",
      "padding-left": "10px",
      "border-left": "0px"
    }
  }, [_vm._v("Dispenser - 1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "width": "65%",
      "border": "1px solid #000",
      "border-top": "0",
      "border-left": "0px",
      "border-right": "0px"
    }
  }, [_vm._v("Side - A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0",
      "text-align": "center",
      "padding-left": "10px",
      "border-right": "0px",
      "border-left": "0px",
      "border-bottom": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Side - B")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0px",
      "border-right": "0",
      "width": "45%",
      "padding-left": "10px",
      "border-left": "0px"
    }
  }, [_vm._v("Dispenser - 2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "width": "65%",
      "border": "1px solid #000",
      "border-top": "0",
      "border-left": "0px",
      "border-right": "0px"
    }
  }, [_vm._v("Side - A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0",
      "text-align": "center",
      "padding-left": "10px",
      "border-right": "0px",
      "border-left": "0px",
      "border-bottom": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Side - B")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Electrical / UPS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("General:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Assets:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px",
      "height": "21px"
    },
    attrs: {
      "colspan": "3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Technician-In-Charge  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px",
      "height": "21px"
    },
    attrs: {
      "colspan": "3"
    }
  })])
}]}

/***/ }),

/***/ 1948:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Group Trip Details")]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('div', [_c('span', {
    staticClass: "label label-success mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-right": "20px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Ongoing\n                        Trip")])]) : (_vm.trip.status == 'completed') ? _c('div', [_c('span', {
    staticClass: "label label-primary mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "156px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Completed\n                        Trip")])]) : (_vm.trip.status == 'halt') ? _c('div', [_c('span', {
    staticClass: "label label-danger mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Halt\n                        Trip")])]) : (_vm.trip.status == 'scheduled') ? _c('div', [_c('span', {
    staticClass: "label label-warning mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "153px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Scheduled\n                        Trip")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "heading_trip"
  }, [_c('h3', [_vm._v(_vm._s(((_vm.trip.tripGroupCode) + ": ")) + _vm._s(_vm.concatenatedData) + " ")])]), _vm._v(" "), _vm._l((_vm.subTripList), function(trips, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "border-bottom": "1px solid gray",
        "padding": "20px 0"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('label', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("Trip Code : " + _vm._s(trips.tripCode))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(trips.status == 'ongoing') ? _c('div', [_c('span', {
      staticClass: "label label-success mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "139px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Ongoing\n                                    Trip")])]) : (trips.status == 'completed') ? _c('div', [_c('span', {
      staticClass: "label label-primary mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "156px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Completed\n                                    Trip")])]) : (trips.status == 'halt') ? _c('div', [_c('span', {
      staticClass: "label label-danger mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "139px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Halt\n                                    Trip")])]) : (trips.status == 'scheduled') ? _c('div', [_c('span', {
      staticClass: "label label-warning mr-5",
      staticStyle: {
        "float": "right",
        "font-size": "134%",
        "font-weight": "500",
        "height": "28px",
        "width": "153px",
        "margin-top": "-20px"
      }
    }, [_vm._v("Scheduled\n                                    Trip")])]) : _vm._e()]), _vm._v(" "), (trips.status == 'ongoing') ? _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.tripEnd('cancel', trips)
        }
      }
    }, [_vm._v("Cancel Trip")]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.openEditTripDia(trips)
        }
      }
    }, [_vm._v("Update Trip")]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.tripEnd('end', trips)
        }
      }
    }, [_vm._v("End Trip")])]) : _vm._e(), _vm._v(" "), (trips.status == 'completed') ? _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.openEditTripDia(trips)
        }
      }
    }, [_vm._v("Update Trip")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row trip-detail-tbl"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('tr', [_c('th', [_vm._v("From - To :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.startSiteSiteName) + " - " + _vm._s(trips.endSiteSiteName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scheduled Date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTripSchedule(trips)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle Registration No :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.vehicleIdRegNo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Driver Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.driverIdDriverName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Device ID :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trips.deviceIdImei))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "font-size": "17px",
        "color": "#3c8dbc"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("At " + _vm._s(trips.startSiteSiteName) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.originReachedAt,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.startDate,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', {
      staticStyle: {
        "font-size": "17px",
        "color": "#3c8dbc"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("At " + _vm._s(trips.endSiteSiteName) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.destinationReachedAt,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(trips.endDate,
      'DD-MM-YYYY hh:mm A'
    )) + "\n                                    ")])])])])]), _vm._v(" "), (_vm.trip.status == 'ongoing' || _vm.trip.status == 'completed') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "2%"
      }
    }, [_c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.showDetails(index)
        }
      }
    }, [_c('a', {
      staticClass: "btn dropdown-toggle",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "data-toggle": "collapse",
        "href": "#gasfilling",
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "gasfilling"
      },
      on: {
        "click": function($event) {
          return _vm.toggleGasFlowDetails(trips._id, index)
        }
      }
    }, [_vm._v("Gas Flow Meter Detail")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.showDetails(index)
        }
      }
    }, [_c('a', {
      staticClass: "btn dropdown-toggle",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "data-toggle": "collapse",
        "href": "#odometer",
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "odometer"
      },
      on: {
        "click": function($event) {
          return _vm.toggleOdometerDetails(trips._id, index)
        }
      }
    }, [_vm._v("Odometer Details")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.showDetails(index)
        }
      }
    }, [_c('a', {
      staticClass: "btn dropdown-toggle",
      staticStyle: {
        "color": "white"
      },
      attrs: {
        "data-toggle": "collapse",
        "href": "#driverDetailsList",
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "driverDetailsList"
      },
      on: {
        "click": function($event) {
          return _vm.driverDetails(trips._id, index)
        }
      }
    }, [_vm._v("Driver Details")])])]), _vm._v(" "), (_vm.activeIndex === index) ? _c('div', [_c('div', {
      staticClass: "container collapse",
      staticStyle: {
        "width": "auto"
      },
      attrs: {
        "id": "gasfilling"
      }
    }, [_c('div', [_vm._m(0, true), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Challan Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Capture Type")]), _vm._v(" "), _c('th', [_vm._v("Pressure Gauge Reading")]), _vm._v(" "), (trips.startSiteSiteType != 'LNGT') ? _c('th', [_vm._v("Gas Flow Meter Reading")]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType == 'LNGT') ? _c('th', [_vm._v("Weight")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportData), function(gs) {
      return _c('tr', [_c('td', [(gs.reading_1 == 'startTrip' &&
        gs.reading_2 == 'post'
      ) ? _c('div', [_c('a', {
        attrs: {
          "href": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "height": "50px",
          "margin": "2px",
          "width": "50px"
        },
        attrs: {
          "src": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
          "alt": "Not Available"
        }
      })])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(gs.reading_1 == 'startTrip' ?
        trips.startSiteSiteType :
        trips.endSiteSiteType) + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(gs.reading_2 == 'pre' ? 'Initial' : 'Final') + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_3 ? gs.reading_3 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_4 ? gs.reading_4 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_5 ? gs.reading_5 : ''))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openUpdateGasFlowDia(gs, trips._id)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('edit details'),
          expression: "'edit details'"
        }],
        staticClass: "fa fa-edit",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v("\n                                                     \n                                                    "), _c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteopenUpdateGasFlowDia(gs)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('delete details'),
          expression: "'delete details'"
        }],
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.reportData && _vm.reportData.length < 4) ? _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.openNewGasFlowDia(trips._id)
        }
      }
    }, [_vm._v("\n                                            Add Gas Flow Meter Details\n                                        ")]) : _vm._e()])]), _vm._v(" "), (trips.startSiteSiteType != 'LNGT' &&
      _vm.postStartGas &&
      _vm.preStartGas &&
      _vm.postStartGas.length > 0 &&
      _vm.preStartGas.length > 0 &&
      _vm.postStartGas[_vm.postStartGas.length - 1] &&
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading &&
      _vm.preStartGas[_vm.preStartGas.length - 1] &&
      _vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading -
      _vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType == 'LNGT' &&
      _vm.postStartGas &&
      _vm.preStartGas &&
      _vm.postStartGas.length > 0 &&
      _vm.preStartGas.length > 0 &&
      _vm.postStartGas[_vm.postStartGas.length - 1] &&
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading &&
      _vm.preStartGas[_vm.preStartGas.length - 1] &&
      _vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((_vm.preStartGas[_vm.preStartGas.length - 1]
      .meterReading -
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.postStartGas &&
      _vm.preStartGas &&
      _vm.postStartGas.length > 0 &&
      _vm.preStartGas.length == 0 &&
      _vm.postStartGas[_vm.postStartGas.length - 1] &&
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((
      _vm.postStartGas[_vm.postStartGas.length - 1]
      .meterReading - 0
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.preStartGas &&
      _vm.postStartGas &&
      _vm.preStartGas.length > 0 &&
      _vm.postStartGas.length == 0 &&
      _vm.preStartGas[_vm.postStartGas.length - 1] &&
      _vm.preStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.startSiteSiteType) + " is\n                                            " + _vm._s((
      0 -
      _vm.preStartGas[_vm.postStartGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType == 'LNGT' &&
      _vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length > 0 &&
      _vm.preEndGas.length > 0 &&
      _vm.postEndGas[_vm.postEndGas.length - 1] &&
      _vm.postEndGas[_vm.postEndGas.length - 1]
      .meterReading &&
      _vm.preEndGas[_vm.preEndGas.length - 1] &&
      _vm.preEndGas[_vm.preEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s((_vm.preEndGas[_vm.preEndGas.length - 1].meterReading - _vm.postEndGas[_vm.postEndGas.length -
      1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (trips.startSiteSiteType != 'LNGT' &&
      _vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length > 0 &&
      _vm.preEndGas.length > 0 &&
      _vm.postEndGas[_vm.postEndGas.length - 1] &&
      _vm.postEndGas[_vm.postEndGas.length - 1]
      .meterReading &&
      _vm.preEndGas[_vm.preEndGas.length - 1] &&
      _vm.preEndGas[_vm.preEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s((_vm.postEndGas[_vm.postEndGas.length - 1].meterReading - _vm.preEndGas[_vm.preEndGas.length -
      1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length > 0 &&
      _vm.preEndGas.length == 0 &&
      _vm.postEndGas[_vm.postEndGas.length - 1] &&
      _vm.postEndGas[_vm.postEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s(_vm.postEndGas[
      _vm.postEndGas.length - 1
    ].meterReading.toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (_vm.preStartGas &&
      _vm.postStartGas &&
      _vm.postEndGas.length == 0 &&
      _vm.preEndGas.length > 0 &&
      _vm.preEndGas[_vm.preEndGas.length - 1] &&
      _vm.preEndGas[_vm.preEndGas.length - 1].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s((
      0 -
      _vm.preEndGas[_vm.preEndGas.length - 1]
      .meterReading
    ).toFixed(2)))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "container collapse",
      staticStyle: {
        "width": "auto"
      },
      attrs: {
        "id": "odometer"
      }
    }, [_c('div', [_vm._m(1, true), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((_vm.odometer), function(o) {
      return _c('tr', [_c('td', _vm._l((o.image), function(imgs1) {
        return _c('div', [_c('a', {
          attrs: {
            "href": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
            "target": "_blank"
          }
        }, [_c('img', {
          staticStyle: {
            "height": "50px",
            "margin": "2px",
            "width": "50px"
          },
          attrs: {
            "src": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
            "alt": "Not Available"
          }
        })]), _vm._v(" "), _c('br')])
      }), 0), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(o.tripType == 'startTrip' ?
        trips.startSiteSiteType :
        trips.endSiteSiteType) + "\n                                                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.longitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.meterReading))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.recordedTime))]), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openUpdateTripDia(o)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('edit details'),
          expression: "'edit details'"
        }],
        staticClass: "fa fa-edit",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v("\n                                                     \n                                                    "), _c('a', {
        staticClass: "icons",
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteTripDetail(o)
          }
        }
      }, [_c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('delete details'),
          expression: "'delete details'"
        }],
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.odometer && _vm.odometer.length < 2) ? _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.openNewTripDia(trips._id)
        }
      }
    }, [_vm._v("\n                                            Add Odometer Details\n                                        ")]) : _vm._e()])]), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.startOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading &&
      _vm.endOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ] &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ].meterReading &&
      _vm.startOdoMeterReading[
        _vm.startOdoMeterReading.length - 1
      ] &&
      _vm.startOdoMeterReading[
        _vm.startOdoMeterReading.length - 1
      ].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                                            " + _vm._s((_vm.endOdoMeterReading[_vm.endOdoMeterReading.length - 1].meterReading -
      _vm.startOdoMeterReading[_vm.startOdoMeterReading.length -
        1].meterReading).toFixed(2)) + "\n                                            km")])])]) : _vm._e(), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.endOdoMeterReading &&
      _vm.startOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading.length == 0
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to\n                                            " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.startOdoMeterReading.length == 0 &&
      _vm.endOdoMeterReading &&
      _vm.endOdoMeterReading.length > 0 &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ] &&
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ].meterReading
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to\n                                            " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                                            " + _vm._s((
      _vm.endOdoMeterReading[
        _vm.endOdoMeterReading.length - 1
      ].meterReading - 0
    ).toFixed(2)) + "\n                                            km")])])]) : _vm._e(), _vm._v(" "), (_vm.startOdoMeterReading &&
      _vm.endOdoMeterReading &&
      _vm.startOdoMeterReading.length == 0 &&
      _vm.endOdoMeterReading.length == 0
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to\n                                            " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (_vm.startRecordedTime &&
      _vm.startRecordedTime.length > 0 &&
      _vm.endRecordedTime &&
      _vm.endRecordedTime.length > 0
    ) ? _c('div', [_c('h5', [_c('b', [_vm._v("Travel time from " + _vm._s(trips.startSiteSiteType) + " to\n                                            " + _vm._s(trips.endSiteSiteType) + " is\n                                            " + _vm._s(_vm.getTimeDifference(trips.destinationReachedAt, trips.startDate)) + " sec")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "container collapse",
      staticStyle: {
        "width": "auto"
      },
      attrs: {
        "id": "driverDetailsList"
      }
    }, [_c('div', [_vm._m(3, true), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', _vm._l((_vm.driverDetailsList), function(data) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(data.driverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.checkIn, 'DD-MM-YYYY hh:mm A')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.checkOut, 'DD-MM-YYYY hh:mm A')))])])
    }), 0)])])])]) : _vm._e()]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.trip.status == 'scheduled' || _vm.trip.status == 'halt') ? _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripDetail'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabcontent",
    staticStyle: {
      "display": "none",
      "margin-top": "10px"
    },
    attrs: {
      "id": "exceptionTable"
    }
  }, [_c('div', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "tripExceptionTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "tripEditDialog",
      "height": "220"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.editSubTrip.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('tripEditDialog')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.originReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "originReachedAt", $$v)
      },
      expression: "editSubTrip.originReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.startDate),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "startDate", $$v)
      },
      expression: "editSubTrip.startDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.destinationReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "destinationReachedAt", $$v)
      },
      expression: "editSubTrip.destinationReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editSubTrip.endDate),
      callback: function($$v) {
        _vm.$set(_vm.editSubTrip, "endDate", $$v)
      },
      expression: "editSubTrip.endDate"
    }
  })], 1)]), _vm._v(" "), (_vm.editSubTrip.status == 'ongoing') ? _c('tr', [_c('th', [_vm._v("Change Trip Status")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatus]
    }
  }, [_c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.tripEnd('update', _vm.editSubTrip)
      }
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "tripDialog",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.edit.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('tripDialog');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.tripType),
      expression: "edit.tripType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edit, "tripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("Destination")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Latitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.latitude),
      expression: "edit.latitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Longitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.longitude),
      expression: "edit.longitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "longitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.meterReading),
      expression: "edit.meterReading"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.meterReading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "meterReading", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.edit.recordedTime),
      callback: function($$v) {
        _vm.$set(_vm.edit, "recordedTime", $$v)
      },
      expression: "edit.recordedTime"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.edit.title == 'Create trip') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Image:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "image"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.edit.title == 'Create trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.createTrip()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.edit.title == 'Update trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.updateTrip()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.editGasFlow.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('gasFlowDia');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_1),
      expression: "editGasFlow.reading_1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("DBS")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Capture Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_2),
      expression: "editGasFlow.reading_2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre"
    }
  }, [_vm._v("Initial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "post"
    }
  }, [_vm._v("Final")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Pressure Gauge Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_3),
      expression: "editGasFlow.reading_3"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Gas Flow Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_4),
      expression: "editGasFlow.reading_4"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_4", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editGasFlow.reading_5),
      callback: function($$v) {
        _vm.$set(_vm.editGasFlow, "reading_5", $$v)
      },
      expression: "editGasFlow.reading_5"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.editGasFlow.title == 'Add Gas Flow Details' && _vm.editGasFlow.reading_1 === 'startTrip' && _vm.editGasFlow.reading_2 === 'post') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Challan:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "Upload Challan"
    },
    on: {
      "change": _vm.onFilechanged1
    }
  })]), _vm._v(" "), _c('td', [_c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "Upload Challan"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.editGasFlow.title == 'Add Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.createGasFlowDetails()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.editGasFlow.title == 'Update Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.updateGasFlowDetails()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Gas Flow Meter Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Odometer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Latitude")]), _vm._v(" "), _c('th', [_vm._v("Longitude")]), _vm._v(" "), _c('th', [_vm._v("Meter Reading")]), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Driver Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Driver Name")]), _vm._v(" "), _c('th', [_vm._v("Check In")]), _vm._v(" "), _c('th', [_vm._v("Check Out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Exception")])])
}]}

/***/ }),

/***/ 1949:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (!_vm.emailSent) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "ui form",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendResetLink($event)
      }
    }
  }, [_c('validate', {
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('vue-form-input', {
    staticClass: "input-group",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'email',
      "name": 'email',
      "placeholder": 'Email',
      "messages": {
        required: 'This field is required',
        email: 'Please input a valid email'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$dirty || _vm.formstate.$invalid
    }
  }, [_vm._v("Request Link")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.accountActive && _vm.emailSent) ? _c('div', {
    staticClass: "content-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("\n              Proceed to Login\n            ")])])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Forgot Password")])])
}]}

/***/ }),

/***/ 1950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n]",
      modifiers: {
        "if": true
      }
    }]
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.region),
      expression: "driver.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Geographical Area is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverName),
      expression: "driver.driverName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "20",
      "name": "driverName",
      "required": "",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.driver.driverName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "driverName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Driver Name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Driver name should be more than 3 characters\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                      Driver name should be less than 20 characters\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverLastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverLastName),
      expression: "driver.driverLastName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "driverLastName",
      "required": "",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.driver.driverLastName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "driverLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverLastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Last Name is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobileNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.mobileNumber),
      expression: "driver.mobileNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "min": "1000000000",
      "name": "mobileNumber",
      "required": "",
      "placeholder": "Mobile number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.driver.mobileNumber)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "mobileNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobileNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Mobile number is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Mobile number is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.status),
      expression: "driver.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateOfBirth),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "max": this.minDate,
      "id": "dateOfBirth",
      "required": "",
      "lang": "en",
      "name": "dateOfBirth",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY",
      "disabledDates": _vm.disabledDates
    },
    on: {
      "change": _vm.getEligibleDate
    },
    model: {
      value: (_vm.driver.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.driver, "dateOfBirth", $$v)
      },
      expression: "driver.dateOfBirth"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateOfBirth",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Date of Birth is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Minimum age is 18 years")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverPin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Pin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverPin),
      expression: "driver.driverPin",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "name": "driverPin",
      "required": "",
      "placeholder": "Driver Pin"
    },
    domProps: {
      "value": (_vm.driver.driverPin)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "driverPin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverPin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver pin is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Driver pin is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Driver pin is minimum 4 digit")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Driver pin is Maximum 4 digit")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lisenceNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("License No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.lisenceNumber),
      expression: "driver.lisenceNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "lisenceNumber",
      "required": "",
      "placeholder": "License No"
    },
    domProps: {
      "value": (_vm.driver.lisenceNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.driver, "lisenceNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lisenceNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("License no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("License no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of license no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("License Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "licenseExpiryDate",
      "lang": "en",
      "name": "licenseExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": _vm.highlight
    },
    model: {
      value: (_vm.driver.licenseExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "licenseExpiryDate", $$v)
      },
      expression: "driver.licenseExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "licenseExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      License Expiry Date is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.DDTNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("DDT Certificate No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.DDTNumber),
      expression: "driver.DDTNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "DDTNumber",
      "required": "",
      "placeholder": "DDT Number No"
    },
    domProps: {
      "value": (_vm.driver.DDTNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.driver, "DDTNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "DDTNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("DDT no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("DDT no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of license no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("DDT Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "ddtExpiryDate",
      "lang": "en",
      "name": "ddtExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.driver.ddtExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "ddtExpiryDate", $$v)
      },
      expression: "driver.ddtExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ddtExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      DDT Expiry Date is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.hazNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HAZ Goods carrige Certificate No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.hazNumber),
      expression: "driver.hazNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "hazNumber",
      "required": "",
      "placeholder": "DDT Number No"
    },
    domProps: {
      "value": (_vm.driver.hazNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.driver, "hazNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "hazNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("HAZ no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("HAZ no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of license no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("HAZ Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "hazExpiryDate",
      "lang": "en",
      "name": "hazExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.driver.hazExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "hazExpiryDate", $$v)
      },
      expression: "driver.hazExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "hazExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HAZ Expiry Date is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.languageKnown),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Language Known")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.languageKnown),
      expression: "driver.languageKnown"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "languageKnown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "languageKnown", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "languageKnown",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Language is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.defaultLanguage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.defaultLanguage),
      expression: "driver.defaultLanguage"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "defaultLanguage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Photo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg",
      "id": "fileinput",
      "name": "driverImage",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverImage",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Please upload less than 3mb picture\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.documents),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Other Document")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "id": "fileinput1",
      "name": "documents"
    },
    on: {
      "change": _vm.onDocumentchanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "documents",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Please upload less than 3mb document\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.addressDetails)
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.addressDetails),
      expression: "driver.addressDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "addressDetails",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.driver.addressDetails)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "addressDetails", $event.target.value)
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Driver'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(
        _vm.formstate.$dirty &&
        _vm.formstate.$valid &&
        _vm.formstatePhoto &&
        _vm.formstateDocument
      )
    },
    on: {
      "click": _vm.createDriver
    }
  }, [_vm._v("\n              Add Driver\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1951:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "box",
    staticClass: "box",
    class: _vm.classes
  }, [(!_vm.disableHeader) ? _c('div', {
    staticClass: "box-header",
    class: _vm.headerBorder ? 'with-border' : ''
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_vm._t("box-tools"), _vm._v(" "), (_vm.canCollapse && !_vm.collapsed) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Collapse'),
      expression: "'Collapse'"
    }],
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.collapse
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]) : _vm._e(), _vm._v(" "), (_vm.canCollapse && _vm.collapsed) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Expand'),
      expression: "'Expand'"
    }],
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.expand
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.canClose) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Close'),
      expression: "'Close'"
    }],
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()], 2), _vm._v(" "), _vm._t("header")], 2) : _vm._e(), _vm._v(" "), (!_vm.disableBody) ? _c('div', {
    ref: "body",
    staticClass: "box-body",
    class: [_vm.collapsed ? 'collapsed' : '', _vm.noPadding ? 'no-padding' : '']
  }, [_vm._t("body")], 2) : _vm._e(), _vm._v(" "), (!_vm.disableFooter) ? _c('div', {
    ref: "footer",
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1952:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Reset User Password")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "flash-message"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-info'
  }, [_vm._v("NOTE: This will send a reset password email to the user, however this\n          will "), _c('i', [_vm._v("NOT")]), _vm._v(" require the user to enter their PIN, so make sure you have verified their identity.")])]), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.emailSent
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1953:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.REPORT_STAFF]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('v-server-table', {
    ref: "schedulesExpiryTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1954:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass,
    attrs: {
      "id": "addUser"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "name": "onGoing",
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "permission",
            rawName: "v-permission.if",
            value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
            expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
            modifiers: {
              "if": true
            }
          }]
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.UpdateDestination(props.row)
            }
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1955:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Add/Remove Permissions")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionSearchText),
      expression: "permissionSearchText"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Search for permissions to add"
    },
    domProps: {
      "value": (_vm.permissionSearchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.permissionSearchText = $event.target.value
      }, function($event) {
        return _vm.getAvailablePermissions()
      }]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-info box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAvailablePermissions),
      expression: "selectedAvailablePermissions"
    }],
    ref: "availablelist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAvailablePermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedRolePermissions = []
      }]
    }
  }, _vm._l((_vm.availablePermissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s((obj.permission || {}).name) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 content-centered"
  }, [_c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.addPermissions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-3x icon-btn icon-btn-primary"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.removePermissions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-3x icon-btn icon-btn-info"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedRolePermissions),
      expression: "selectedRolePermissions"
    }],
    ref: "rolelist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedRolePermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedAvailablePermissions = []
      }]
    }
  }, _vm._l((_vm.newRole.permissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s(obj.permission.name) + "\n              ")])
  }), 0)])])])]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": true,
      "placeholder": _vm.permissionDescription
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "box box-success box-solid"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedIncludedPermissions),
      expression: "selectedIncludedPermissions"
    }],
    ref: "includedlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedIncludedPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.includedPermissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s((obj.permission || {}).name) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 content-centered"
  }, [_c('div', {
    staticClass: "box box-warning box-solid"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedExcludedPermissions),
      expression: "selectedExcludedPermissions"
    }],
    ref: "excludedlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedExcludedPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.excludedPermissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s(obj.permission.name) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "box box-danger box-solid"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedForbiddenPermissions),
      expression: "selectedForbiddenPermissions"
    }],
    ref: "forbiddenlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedForbiddenPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.forbiddenPermissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s(obj.permission.name) + "\n              ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.lodash.isEmpty(_vm.selectedIncludedPermissions)
    },
    on: {
      "click": _vm.applyStateToIncluded
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedToState),
      expression: "includedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "includedToState_includedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.INCLUDED,
      "checked": _vm._q(_vm.includedToState, _vm.PERMISSION_STATES.INCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.includedToState = _vm.PERMISSION_STATES.INCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includedToState_includedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.INCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-warning"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedToState),
      expression: "includedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "includedToState_excludedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.EXCLUDED,
      "checked": _vm._q(_vm.includedToState, _vm.PERMISSION_STATES.EXCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.includedToState = _vm.PERMISSION_STATES.EXCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includedToState_excludedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.EXCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedToState),
      expression: "includedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "includedToState_forbiddenPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.FORBIDDEN,
      "checked": _vm._q(_vm.includedToState, _vm.PERMISSION_STATES.FORBIDDEN)
    },
    on: {
      "change": function($event) {
        _vm.includedToState = _vm.PERMISSION_STATES.FORBIDDEN
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includedToState_forbiddenPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.FORBIDDEN))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.lodash.isEmpty(_vm.selectedExcludedPermissions)
    },
    on: {
      "click": _vm.applyStateToExcluded
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excludedToState),
      expression: "excludedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "excludedToState_includedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.INCLUDED,
      "checked": _vm._q(_vm.excludedToState, _vm.PERMISSION_STATES.INCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.excludedToState = _vm.PERMISSION_STATES.INCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "excludedToState_includedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.INCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-warning"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excludedToState),
      expression: "excludedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "excludedToState_excludedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.EXCLUDED,
      "checked": _vm._q(_vm.excludedToState, _vm.PERMISSION_STATES.EXCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.excludedToState = _vm.PERMISSION_STATES.EXCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "excludedToState_excludedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.EXCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excludedToState),
      expression: "excludedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "excludedToState_forbiddenPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.FORBIDDEN,
      "checked": _vm._q(_vm.excludedToState, _vm.PERMISSION_STATES.FORBIDDEN)
    },
    on: {
      "change": function($event) {
        _vm.excludedToState = _vm.PERMISSION_STATES.FORBIDDEN
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "excludedToState_forbiddenPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.FORBIDDEN))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.lodash.isEmpty(_vm.selectedForbiddenPermissions)
    },
    on: {
      "click": _vm.applyStateToForbidden
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbiddenToState),
      expression: "forbiddenToState"
    }],
    attrs: {
      "type": "radio",
      "id": "forbiddenToState_includedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.INCLUDED,
      "checked": _vm._q(_vm.forbiddenToState, _vm.PERMISSION_STATES.INCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.forbiddenToState = _vm.PERMISSION_STATES.INCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "forbiddenToState_includedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.INCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-warning"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbiddenToState),
      expression: "forbiddenToState"
    }],
    attrs: {
      "type": "radio",
      "id": "forbiddenToState_excludedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.EXCLUDED,
      "checked": _vm._q(_vm.forbiddenToState, _vm.PERMISSION_STATES.EXCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.forbiddenToState = _vm.PERMISSION_STATES.EXCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "forbiddenToState_excludedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.EXCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbiddenToState),
      expression: "forbiddenToState"
    }],
    attrs: {
      "type": "radio",
      "id": "forbiddenToState_forbiddenPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.FORBIDDEN,
      "checked": _vm._q(_vm.forbiddenToState, _vm.PERMISSION_STATES.FORBIDDEN)
    },
    on: {
      "change": function($event) {
        _vm.forbiddenToState = _vm.PERMISSION_STATES.FORBIDDEN
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "forbiddenToState_forbiddenPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.FORBIDDEN))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newRole._id),
      expression: "newRole._id"
    }],
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['role', 'addRolePermissions', 'removeRolePermissions',
        'addRoleAssociations', 'removeRoleAssociations'
      ]),
      expression: "['role', 'addRolePermissions', 'removeRolePermissions',\n              'addRoleAssociations', 'removeRoleAssociations']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dirty
    },
    on: {
      "click": _vm.updateRolePermissions
    }
  }, [_vm._v("Update Role Permissions")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Available Permissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Current Permissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Included")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Excluded")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Forbidden")])])
}]}

/***/ }),

/***/ 1956:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TechnicianCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn "
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "tempuserTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1957:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteschedulereportModal
    }
  }, [_vm._v("Delete Schedule")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.reportType),
      expression: "schedulereport.reportType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "reportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSelectiveStation]
    }
  }, [_c('option', {
    attrs: {
      "value": "logbook"
    }
  }, [_vm._v("Vehicle Log Book")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_ms"
    }
  }, [_vm._v("Data HCV Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_dbs"
    }
  }, [_vm._v("Data HCV DB Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dsr"
    }
  }, [_vm._v("Daily Sales Report")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.downloadType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Download Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.downloadType),
      expression: "schedulereport.downloadType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "downloadType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "downloadType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PDF"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XLSX"
    }
  }, [_vm._v("Excel")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "downloadType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Download Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportFrequency),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Frequency")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.reportFrequency),
      expression: "schedulereport.reportFrequency"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportFrequency"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "reportFrequency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.validateReportFrequency]
    }
  }, [_c('option', {
    attrs: {
      "value": "daily"
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekly"
    }
  }, [_vm._v("Weekly")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportFrequency",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Frequency is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.status),
      expression: "schedulereport.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "scheduleStartDate"
    }
  }, [_vm._v("Schedule Start Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleStartDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "id": "scheduleStartDate",
      "lang": "en",
      "name": "scheduleStartDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.schedulereport.scheduleStartDate),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "scheduleStartDate", $$v)
      },
      expression: "schedulereport.scheduleStartDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleStartDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start date is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "scheduleEndDate"
    }
  }, [_vm._v("Schedule End Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleEndDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "id": "scheduleEndDate",
      "lang": "en",
      "name": "scheduleEndDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.schedulereport.scheduleEndDate),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "scheduleEndDate", $$v)
      },
      expression: "schedulereport.scheduleEndDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleEndDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("End date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.scheduleDay),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Schedule Day")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.scheduleDay),
      expression: "schedulereport.scheduleDay"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "scheduleDay",
      "disabled": _vm.disabledInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "scheduleDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sunday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Monday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Tuesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Wednesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Thursday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Friday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Saturday")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDay",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Schedule day is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastDays),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Days")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.lastDays),
      expression: "schedulereport.lastDays"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "scheduleDay"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "lastDays", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 days")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "reportTime"
    }
  }, [_vm._v("Report Generation Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportGenerationTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "reportGenerationTime",
      "required": ""
    },
    model: {
      value: (_vm.schedulereport.reportGenerationTime),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "reportGenerationTime", $$v)
      },
      expression: "schedulereport.reportGenerationTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportGenerationTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Generation Time is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Filter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.region),
      expression: "schedulereport.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSites]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), (this.schedulereport.reportType != 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.station),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.station),
      expression: "schedulereport.station"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "station"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "station", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.station_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "station",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), (this.schedulereport.reportType == 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.vehicleId),
      expression: "schedulereport.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "disabled": _vm.disabledVehicleInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Vehicles")])], 2)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Recipients")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "emailTo"
    }
  }, [_vm._v(" To ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('vue-select', {
    attrs: {
      "label": "user",
      "multiple": "",
      "options": this.user_list,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.schedulereport.emailTo),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "emailTo", $$v)
      },
      expression: "schedulereport.emailTo"
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "emailCc"
    }
  }, [_vm._v(" CC ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('vue-select', {
    attrs: {
      "label": "user",
      "multiple": "",
      "options": this.user_list,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.schedulereport.emailCc),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "emailCc", $$v)
      },
      expression: "schedulereport.emailCc"
    }
  })], 1)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ReportSchedule'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateSchedule
    }
  }, [_vm._v("Update Schedule")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1958:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Add/Remove Permissions")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionSearchText),
      expression: "permissionSearchText"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Search for permissions to add"
    },
    domProps: {
      "value": (_vm.permissionSearchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.permissionSearchText = $event.target.value
      }, function($event) {
        return _vm.getAvailablePermissions()
      }]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-info box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAvailablePermissions),
      expression: "selectedAvailablePermissions"
    }],
    ref: "availablelist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAvailablePermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedUserPermissions = []
      }]
    }
  }, _vm._l((_vm.availablePermissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v(_vm._s((obj.permission || {}).name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 content-centered"
  }, [_c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.addPermissions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-3x icon-btn icon-btn-primary"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.removePermissions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-3x icon-btn icon-btn-info"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUserPermissions),
      expression: "selectedUserPermissions"
    }],
    ref: "userlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUserPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedAvailablePermissions = []
      }]
    }
  }, _vm._l((_vm.newUser.permissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v(_vm._s(obj.permission.name))])
  }), 0)])])])]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": true,
      "placeholder": _vm.permissionDescription
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "box box-success box-solid"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedIncludedPermissions),
      expression: "selectedIncludedPermissions"
    }],
    ref: "includedlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedIncludedPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.includedPermissions), function(obj) {
    return _c('option', {
      key: obj.id,
      domProps: {
        "value": obj
      }
    }, [_vm._v(_vm._s((obj.permission || {}).name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 content-centered"
  }, [_c('div', {
    staticClass: "box box-warning box-solid"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedExcludedPermissions),
      expression: "selectedExcludedPermissions"
    }],
    ref: "excludedlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedExcludedPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.excludedPermissions), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v(_vm._s(obj.permission.name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "box box-danger box-solid"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedForbiddenPermissions),
      expression: "selectedForbiddenPermissions"
    }],
    ref: "forbiddenlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedForbiddenPermissions = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.forbiddenPermissions), function(obj) {
    return _c('option', {
      key: obj.id,
      domProps: {
        "value": obj
      }
    }, [_vm._v(_vm._s(obj.permission.name))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.lodash.isEmpty(_vm.selectedIncludedPermissions)
    },
    on: {
      "click": _vm.applyStateToIncluded
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedToState),
      expression: "includedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "includedToState_includedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.INCLUDED,
      "checked": _vm._q(_vm.includedToState, _vm.PERMISSION_STATES.INCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.includedToState = _vm.PERMISSION_STATES.INCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includedToState_includedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.INCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-warning"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedToState),
      expression: "includedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "includedToState_excludedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.EXCLUDED,
      "checked": _vm._q(_vm.includedToState, _vm.PERMISSION_STATES.EXCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.includedToState = _vm.PERMISSION_STATES.EXCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includedToState_excludedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.EXCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedToState),
      expression: "includedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "includedToState_forbiddenPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.FORBIDDEN,
      "checked": _vm._q(_vm.includedToState, _vm.PERMISSION_STATES.FORBIDDEN)
    },
    on: {
      "change": function($event) {
        _vm.includedToState = _vm.PERMISSION_STATES.FORBIDDEN
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "includedToState_forbiddenPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.FORBIDDEN))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.lodash.isEmpty(_vm.selectedExcludedPermissions)
    },
    on: {
      "click": _vm.applyStateToExcluded
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excludedToState),
      expression: "excludedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "excludedToState_includedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.INCLUDED,
      "checked": _vm._q(_vm.excludedToState, _vm.PERMISSION_STATES.INCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.excludedToState = _vm.PERMISSION_STATES.INCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "excludedToState_includedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.INCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-warning"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excludedToState),
      expression: "excludedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "excludedToState_excludedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.EXCLUDED,
      "checked": _vm._q(_vm.excludedToState, _vm.PERMISSION_STATES.EXCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.excludedToState = _vm.PERMISSION_STATES.EXCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "excludedToState_excludedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.EXCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excludedToState),
      expression: "excludedToState"
    }],
    attrs: {
      "type": "radio",
      "id": "excludedToState_forbiddenPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.FORBIDDEN,
      "checked": _vm._q(_vm.excludedToState, _vm.PERMISSION_STATES.FORBIDDEN)
    },
    on: {
      "change": function($event) {
        _vm.excludedToState = _vm.PERMISSION_STATES.FORBIDDEN
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "excludedToState_forbiddenPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.FORBIDDEN))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row content-centered"
  }, [_c('div', {
    staticClass: "col-sm-6 text-right pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.lodash.isEmpty(_vm.selectedForbiddenPermissions)
    },
    on: {
      "click": _vm.applyStateToForbidden
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbiddenToState),
      expression: "forbiddenToState"
    }],
    attrs: {
      "type": "radio",
      "id": "forbiddenToState_includedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.INCLUDED,
      "checked": _vm._q(_vm.forbiddenToState, _vm.PERMISSION_STATES.INCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.forbiddenToState = _vm.PERMISSION_STATES.INCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "forbiddenToState_includedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.INCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-warning"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbiddenToState),
      expression: "forbiddenToState"
    }],
    attrs: {
      "type": "radio",
      "id": "forbiddenToState_excludedPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.EXCLUDED,
      "checked": _vm._q(_vm.forbiddenToState, _vm.PERMISSION_STATES.EXCLUDED)
    },
    on: {
      "change": function($event) {
        _vm.forbiddenToState = _vm.PERMISSION_STATES.EXCLUDED
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "forbiddenToState_excludedPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.EXCLUDED))])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbiddenToState),
      expression: "forbiddenToState"
    }],
    attrs: {
      "type": "radio",
      "id": "forbiddenToState_forbiddenPermission"
    },
    domProps: {
      "value": _vm.PERMISSION_STATES.FORBIDDEN,
      "checked": _vm._q(_vm.forbiddenToState, _vm.PERMISSION_STATES.FORBIDDEN)
    },
    on: {
      "change": function($event) {
        _vm.forbiddenToState = _vm.PERMISSION_STATES.FORBIDDEN
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "forbiddenToState_forbiddenPermission"
    }
  }, [_vm._v(_vm._s(_vm.PERMISSION_STATES.FORBIDDEN))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser._id),
      expression: "newUser._id"
    }],
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['user', 'addUserPermissions', 'removeUserPermissions',
        'addUserAssociations', 'removeUserAssociations'
      ]),
      expression: "['user', 'addUserPermissions', 'removeUserPermissions',\n              'addUserAssociations', 'removeUserAssociations']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dirty
    },
    on: {
      "click": _vm.updateUserPermissions
    }
  }, [_vm._v("Update User Permissions")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Available Permissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Current Permissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Included")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Excluded")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Forbidden")])])
}]}

/***/ }),

/***/ 1959:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1960:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1961:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.isUserDashBoard) ? _c('div', {
    staticClass: "password-popup"
  }, [_c('div', {
    staticClass: "password-popup-width"
  }, [_c('h4', {
    staticClass: "heading_pop"
  }, [_vm._v("Investment Dashboard - " + _vm._s(_vm.userName))]), _vm._v(" "), _c('a', {
    staticClass: "toggle",
    on: {
      "click": _vm.closeUserDashBoard
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Layer_1",
      "x": "0",
      "y": "0",
      "version": "1.1",
      "viewBox": "0 0 29 29",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#706c6c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      "d": "M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "total_investment_wrp"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                      " + _vm._s(_vm.investedAmount ? _vm.investedAmount : '0') + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("Total Investment Amount")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                      " + _vm._s(_vm.totalInvestmentAmount ? _vm.totalInvestmentAmount : '0') + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("Current Investment Value")])]), _vm._v(" "), (_vm.totalInvestmentAmount !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.netProfitAndLoss > 0,
        negative: _vm.netProfitAndLoss < 0,
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.netProfitAndLoss ? _vm.netProfitAndLoss : '0') + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("Unrealised Profit/Loss")])]), _vm._v(" "), (_vm.netProfitAndLoss !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.net_pnl > 0,
        negative: _vm.net_pnl < 0,
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.net_pnl ? _vm.net_pnl : '0') + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("Net Profilt/Loss")])]), _vm._v(" "), (_vm.net_pnl !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.net_profit_percentage > 0,
        negative: _vm.net_profit_percentage < 0,
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.net_profit_percentage === 'No data' ?
    _vm.net_profit_percentage :
    (_vm.net_profit_percentage + "%")) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("Net Profit/Loss %")])]), _vm._v(" "), (_vm.net_profit_percentage !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                      " + _vm._s(_vm.withdrawlAmount ? _vm.withdrawlAmount : '0') + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("Withdrawal Amount")])]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tablewrp"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Investment History")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.history_table), function(data) {
    return (_vm.history_table.length > 0) ? _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(data.createdAt) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.current_investment_value) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pnl_value ? data.pnl_value : '0'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.net_pnl ? data.net_pnl : '0'))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.net_profit_percentage ? ((data.net_profit_percentage) + "%") : '0') + "\n            ")])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.history_table.length === 0) ? _c('h4', {
    staticClass: "teext"
  }, [_vm._v("No Investment History Found")]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.isAreaTable) ? _c('div', {
    staticClass: "password-popup"
  }, [_c('div', {
    staticClass: "password-popup-width"
  }, [_c('h4', {
    staticClass: "heading_pop"
  }, [_vm._v("Update Password")]), _vm._v(" "), _c('a', {
    staticClass: "toggle",
    on: {
      "click": _vm.closeAreaTableModal
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Layer_1",
      "x": "0",
      "y": "0",
      "version": "1.1",
      "viewBox": "0 0 29 29",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#706c6c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      "d": "M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.password),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Password :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "password-toggle-icon",
    on: {
      "click": function($event) {
        return _vm.togglePasswordVisibility('password')
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-eye': _vm.showPassword,
      'fa fa-eye-slash': !_vm.showPassword,
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "password",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(
      _vm.formstate.confirmPassword,
      _vm.passwordValidation
    ),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Confirm Password :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "password",
      "name": "confirmPassword",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "password-toggle-icon",
    on: {
      "click": function($event) {
        return _vm.togglePasswordVisibility('confirmPassword')
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-eye': _vm.showPassword,
      'fa fa-eye-slash': !_vm.showPassword,
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "confirmPassword",
      "show": "$touched || $submitted"
    }
  }), _vm._v(" "), (_vm.passwordValidation) ? _c('a', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Passwords do not match.")]) : _vm._e()], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && !_vm.passwordValidation)
    },
    on: {
      "click": _vm.chnagePassword
    }
  }, [_vm._v("\n          Update Password\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserCreate'
      }
    }
  }, [_c('button', {
    staticClass: " btn gradientbt"
  }, [_vm._v("Add User")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          Export User\n        ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "userTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.rowClick,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "passwordChange",
      fn: function(props) {
        return [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.UpdatePassword(props.row)
            }
          }
        })]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "total_investment_wrp"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.totalPnL > 0, negative: _vm.totalPnL < 0
    }
  }, [_vm._v("\n                " + _vm._s(_vm.totalPnL ? _vm.totalPnL : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Net Profit/Loss All Users")])]), _vm._v(" "), _vm._m(3)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Current Investment Value ($)")]), _vm._v(" "), _c('th', [_vm._v("Unrealised Profit/Loss ($)")]), _vm._v(" "), _c('th', [_vm._v("Net Profit/Loss ($)")]), _vm._v(" "), _c('th', [_vm._v("Net Profit/Loss %")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-1px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
}]}

/***/ }),

/***/ 1962:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.GA_HEAD ]),
      expression: "[\n                USER_ROLES.SUPER_ADMIN,\n                USER_ROLES.ADMIN,\n                USER_ROLES.GA_HEAD,\n              ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteDeviceModal
    }
  }, [_vm._v("\n              Delete Device\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.brand),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Brand")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.brand),
      expression: "device.brand",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "brand",
      "required": "",
      "placeholder": "Brand Name"
    },
    domProps: {
      "value": (_vm.device.brand)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "brand", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "brand",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Brand name is a required field\n                      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Brand name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                        Minimum length of brand is 3 character\n                      ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceModel),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceModel),
      expression: "device.deviceModel",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "deviceModel",
      "required": "",
      "placeholder": "Model"
    },
    domProps: {
      "value": (_vm.device.deviceModel)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "deviceModel", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "minlength": "3",
      "name": "deviceModel",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Model is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Model is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                        Minimum length of model is 3 character\n                      ")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.imei),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("IMEI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.imei),
      expression: "device.imei",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "imei",
      "minlength": "14",
      "placeholder": "IMEI"
    },
    domProps: {
      "value": (_vm.device.imei)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "imei", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "imei",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("IMEI is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum 14 number required")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.connectionId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Connection Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.connectionId),
      expression: "device.connectionId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "connectionId",
      "minlength": "14",
      "placeholder": "Connection ID"
    },
    domProps: {
      "value": (_vm.device.connectionId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "connectionId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "connectionId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Connection ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum 14 number required")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceId),
      expression: "device.deviceId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control required-field",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "deviceId",
      "required": "",
      "placeholder": "Device ID"
    },
    domProps: {
      "value": (_vm.device.deviceId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "deviceId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device ID is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Device ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of Device is 3 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateAdded),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Registration Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateAdded",
      "lang": "en",
      "name": "dateAdded",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.device.dateAdded),
      callback: function($$v) {
        _vm.$set(_vm.device, "dateAdded", $$v)
      },
      expression: "device.dateAdded"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Registration date is a required field\n                      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Registration date is invalid")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.deviceDescription)
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceDescription),
      expression: "device.deviceDescription",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "description",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.device.deviceDescription)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "deviceDescription", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device.status),
      expression: "device.status"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.device, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Devices'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n                USER_ROLES.SUPER_ADMIN,\n                USER_ROLES.ADMIN,\n                USER_ROLES.GA_HEAD,\n                USER_ROLES.JOURNEY_MANAGER,\n              ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formstate.$dirty
    },
    on: {
      "click": _vm.updateDevice
    }
  }, [_vm._v("\n              Update Device\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1963:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n    " + _vm._s(_vm.$route.meta.title) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb breadcrumb-below"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])], 1), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(breadcrumb, index) {
    return _c('li', {
      class: _vm.isActive(index)
    }, [_c('router-link', {
      attrs: {
        "to": breadcrumb.path
      }
    }, [_vm._v(_vm._s(breadcrumb.title))])], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1964:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1965:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('main-header', {
    attrs: {
      "display-name": _vm.displayName,
      "picture-url": _vm.user.profileImageUrl
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.displayName,
      "picture-url": _vm.user.profileImageUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('content-header'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("\n      Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("HashStudioz")]), _vm._v(".\n    ")]), _vm._v(" All rights reserved.\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1966:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "operatorReportTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "download",
      fn: function(props) {
        return [_c('div', [_c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.download(props.row)
            }
          }
        }, [_vm._v("Download")])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1967:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Details")]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('div', [_c('span', {
    staticClass: "label label-success mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-right": "20px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Ongoing\n            Trips")])]) : (_vm.trip.status == 'completed') ? _c('div', [_c('span', {
    staticClass: "label label-primary mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "156px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Completed\n            Trips")])]) : (_vm.trip.status == 'halt') ? _c('div', [_c('span', {
    staticClass: "label label-danger mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "139px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Halt\n            Trips")])]) : (_vm.trip.status == 'scheduled') ? _c('div', [_c('span', {
    staticClass: "label label-warning mr-5",
    staticStyle: {
      "float": "right",
      "font-size": "134%",
      "font-weight": "500",
      "height": "28px",
      "width": "153px",
      "margin-top": "-20px"
    }
  }, [_vm._v("Scheduled\n            Trips")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.tripEnd('cancel')
      }
    }
  }, [_vm._v("Cancel Trip")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#exampleModal"
    },
    on: {
      "click": function($event) {
        return _vm.EditTrip()
      }
    }
  }, [_vm._v("Update\n            Trip")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.tripEnd('end')
      }
    }
  }, [_vm._v("End Trip")])]) : _vm._e(), _vm._v(" "), (_vm.trip.status == 'completed') ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#exampleModal"
    },
    on: {
      "click": function($event) {
        return _vm.EditTrip()
      }
    }
  }, [_vm._v("Update\n            Trip")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("Trip Code : " + _vm._s(_vm.trip.tripCode))])])]), _vm._v(" "), _c('div', {
    staticClass: "row trip-detail-tbl"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', [_vm._v("From - To :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.startSiteSiteName) + " - " + _vm._s(_vm.trip.endSiteSiteName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scheduled Time :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.scheduleTime))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle Registration No :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.vehicleIdRegNo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scheduled Date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.scheduledDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Driver Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.driverIdDriverName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Device ID :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.trip.deviceIdImei))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "17px",
      "color": "#3c8dbc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("At " + _vm._s((_vm.trip && _vm.trip.startSiteSiteName) ? _vm.trip.startSiteSiteName : '--'))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.originReached))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.startedDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "font-size": "17px",
      "color": "#3c8dbc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("At " + _vm._s((_vm.trip && _vm.trip.endSiteSiteName) ? _vm.trip.endSiteSiteName : '-- '))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.destinationReached))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s((this.endedDate)))])])])])]), _vm._v(" "), (_vm.trip.status == 'ongoing' || _vm.trip.status == 'completed') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container collapse",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "odometer"
    }
  }, [_c('div', [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((this.odometer), function(o) {
    return _c('tr', [_c('td', _vm._l((o.image), function(imgs1) {
      return _c('div', [_c('a', {
        attrs: {
          "href": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "height": "50px",
          "margin": "2px",
          "width": "50px"
        },
        attrs: {
          "src": ("" + _vm.i_url + (o.tripID) + "/" + (o.tripType) + "/" + (o.imageType) + "/" + (o.captureType) + "/" + imgs1),
          "alt": "Not Available"
        }
      })]), _vm._v(" "), _c('br')])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.tripType == 'startTrip' ? _vm.trip.startSiteSiteType : _vm.trip.endSiteSiteType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.longitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.meterReading))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(o.recordedTime))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openUpdateTripDia(o)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('edit details'),
        expression: "'edit details'"
      }],
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                       \n                      "), _c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTripDetail(o)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('delete details'),
        expression: "'delete details'"
      }],
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(this.odometer.length < 2) ? _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.openNewTripDia()
      }
    }
  }, [_vm._v("Add Odometer\n                  Details")]) : _vm._e()])]), _vm._v(" "), (this.startOdoMeterReading.length > 0 && this.endOdoMeterReading.length > 0 && this.endOdoMeterReading[this.endOdoMeterReading.length - 1] && this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading && this.startOdoMeterReading[this.startOdoMeterReading.length - 1] && this.startOdoMeterReading[this.startOdoMeterReading.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                  " + _vm._s((this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading -
    this.startOdoMeterReading[this.startOdoMeterReading.length - 1].meterReading).toFixed(2)) + "\n                  km")])])]) : _vm._e(), _vm._v(" "), (this.startOdoMeterReading.length > 0 && this.endOdoMeterReading.length == 0) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (this.startOdoMeterReading.length == 0 && this.endOdoMeterReading.length > 0 && this.endOdoMeterReading[this.endOdoMeterReading.length - 1] && this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                  " + _vm._s((this.endOdoMeterReading[this.endOdoMeterReading.length - 1].meterReading - 0).toFixed(2)) + " km")])])]) : _vm._e(), _vm._v(" "), (this.startOdoMeterReading.length == 0 && this.endOdoMeterReading.length == 0) ? _c('div', [_c('h5', [_c('b', [_vm._v("Distance Travel from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is 0 km")])])]) : _vm._e(), _vm._v(" "), (this.startRecordedTime.length > 0 && this.endRecordedTime.length > 0) ? _c('div', [_c('h5', [_c('b', [_vm._v("Travel time from " + _vm._s(_vm.trip.startSiteSiteType) + " to " + _vm._s(_vm.trip.endSiteSiteType) + " is " + _vm._s(this.timeDifference) + "\n                  sec")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container collapse",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "gasfilling"
    }
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((this.reportData), function(gs) {
    return _c('tr', [_c('td', [(gs.reading_1 == 'startTrip' && gs.reading_2 == 'post') ? _c('div', [_c('a', {
      attrs: {
        "href": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "height": "50px",
        "margin": "2px",
        "width": "50px"
      },
      attrs: {
        "src": (_vm.challan_img_url + "/" + _vm.urlId + "/startTrip/challan/pre/" + _vm.challanImage),
        "alt": "Not Available"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_1 == "startTrip" ? _vm.trip.startSiteSiteType : _vm.trip.endSiteSiteType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_2 == "pre" ? 'Initial' : 'Final'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_3 ? gs.reading_3 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_4 ? gs.reading_4 : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gs.reading_5 ? gs.reading_5 : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openUpdateGasFlowDia(gs)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('edit details'),
        expression: "'edit details'"
      }],
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("  \n                      "), _c('a', {
      staticClass: "icons",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteopenUpdateGasFlowDia(gs)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('delete details'),
        expression: "'delete details'"
      }],
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(this.reportData.length < 4) ? _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.openNewGasFlowDia()
      }
    }
  }, [_vm._v("Add Gas Flow Meter\n                  Details")]) : _vm._e()])]), _vm._v(" "), (this.postStartGas.length > 0 && this.preStartGas.length > 0 && this.postStartGas[this.postStartGas.length - 1] && this.postStartGas[this.postStartGas.length - 1].meterReading && this.preStartGas[this.preStartGas.length - 1] && this.preStartGas[this.preStartGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.startSiteSiteType) + " is\n                  " + _vm._s((this.postStartGas[this.postStartGas.length - 1].meterReading -
    this.preStartGas[this.preStartGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postStartGas.length > 0 && this.preStartGas.length == 0 && this.postStartGas[this.postStartGas.length - 1] && this.postStartGas[this.postStartGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.startSiteSiteType) + " is\n                  " + _vm._s((this.postStartGas[this.postStartGas.length - 1].meterReading - 0).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.preStartGas.length > 0 && this.postStartGas.length == 0 && this.preStartGas[this.postStartGas.length - 1] && this.preStartGas[this.postStartGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.startSiteSiteType) + " is\n                  " + _vm._s((0 - this.preStartGas[this.postStartGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postEndGas.length > 0 && this.preEndGas.length > 0 && this.postEndGas[this.postEndGas.length - 1] && this.postEndGas[this.postEndGas.length - 1].meterReading && this.preEndGas[this.preEndGas.length - 1] && this.preEndGas[this.preEndGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                  " + _vm._s((this.postEndGas[this.postEndGas.length - 1].meterReading - this.preEndGas[this.preEndGas.length -
    1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postEndGas.length > 0 && this.preEndGas.length == 0 && this.postEndGas[this.postEndGas.length - 1] && this.postEndGas[this.postEndGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                  " + _vm._s((this.postEndGas[this.postEndGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), (this.postEndGas.length == 0 && this.preEndGas.length > 0 && this.preEndGas[this.preEndGas.length - 1] && this.preEndGas[this.preEndGas.length - 1].meterReading) ? _c('div', [_c('h5', [_c('b', [_vm._v("Gas Flow Meter Difference at " + _vm._s(_vm.trip.endSiteSiteType) + " is\n                  " + _vm._s((0 - this.preEndGas[this.preEndGas.length - 1].meterReading).toFixed(2)))])])]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.trip.status == 'ongoing' || _vm.trip.status == 'completed') ? _c('div', {
    staticClass: "tab"
  }, [_c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": _vm.exceptionTable
    }
  }, [_vm._v("Show Exceptions")]), _vm._v(" "), _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": _vm.locationLogTable
    }
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Trip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), (_vm.trip.status == 'scheduled' || _vm.trip.status == 'halt') ? _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripDetail'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabcontent",
    staticStyle: {
      "display": "none",
      "margin-top": "10px"
    },
    attrs: {
      "id": "exceptionTable"
    }
  }, [_c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "tripExceptionTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])]), _vm._v(" "), _c('div', [_c('TripLocationLog', {
    staticClass: "tabcontent",
    staticStyle: {
      "display": "none",
      "margin-top": "10px"
    },
    attrs: {
      "id": "tripLocationLogTable"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached origin At (Waiting Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.originReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.trip, "originReachedAt", $$v)
      },
      expression: "trip.originReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Started At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.startDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "startDate", $$v)
      },
      expression: "trip.startDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("HCV reached Destination At (Idling Started At) :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.destinationReachedAt),
      callback: function($$v) {
        _vm.$set(_vm.trip, "destinationReachedAt", $$v)
      },
      expression: "trip.destinationReachedAt"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Trip Completed At :")]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.trip.endDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "endDate", $$v)
      },
      expression: "trip.endDate"
    }
  })], 1)]), _vm._v(" "), (_vm.trip.status == 'ongoing') ? _c('tr', [_c('th', [_vm._v("Change Trip Status")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatus]
    }
  }, [_c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.tripEnd('update')
      }
    }
  }, [_vm._v("Save")])])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "tripDialog",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.edit.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('tripDialog');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.tripType),
      expression: "edit.tripType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.edit, "tripType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("Origin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("Destination")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Latitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.latitude),
      expression: "edit.latitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Longitude:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.longitude),
      expression: "edit.longitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "longitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.meterReading),
      expression: "edit.meterReading"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.edit.meterReading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.edit, "meterReading", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.edit.recordedTime),
      callback: function($$v) {
        _vm.$set(_vm.edit, "recordedTime", $$v)
      },
      expression: "edit.recordedTime"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.edit.title == 'Create trip') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Image:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "image"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.edit.title == 'Create trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.createTrip()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.edit.title == 'Update trip') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.updateTrip()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.editGasFlow.title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('gasFlowDia');
        _vm.refreshTab();
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Trip Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_1),
      expression: "editGasFlow.reading_1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "startTrip"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "endTrip"
    }
  }, [_vm._v("DBS")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Capture Type:")])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_2),
      expression: "editGasFlow.reading_2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editGasFlow, "reading_2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "pre"
    }
  }, [_vm._v("Initial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "post"
    }
  }, [_vm._v("Final")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Pressure Gauge Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_3),
      expression: "editGasFlow.reading_3"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Gas Flow Meter Reading:")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editGasFlow.reading_4),
      expression: "editGasFlow.reading_4"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.editGasFlow.reading_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editGasFlow, "reading_4", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recorded Time:")])]), _vm._v(" "), _c('td', [_c('datetime', {
    attrs: {
      "type": "datetime",
      "use12-hour": ""
    },
    model: {
      value: (_vm.editGasFlow.reading_5),
      callback: function($$v) {
        _vm.$set(_vm.editGasFlow, "reading_5", $$v)
      },
      expression: "editGasFlow.reading_5"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [(_vm.editGasFlow.title == 'Add Gas Flow Details' && _vm.editGasFlow.reading_1 === 'startTrip' && _vm.editGasFlow.reading_2 === 'post') ? _c('div', [_c('td', [_c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Challan:")])]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "Upload Challan"
    },
    on: {
      "change": _vm.onFilechanged1
    }
  })]), _vm._v(" "), _c('td', [_c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "Upload Challan"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.editGasFlow.title == 'Add Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.createGasFlowDetails()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.editGasFlow.title == 'Update Gas Flow Details') ? _c('button', {
    staticClass: "tablinks btn",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.updateGasFlowDetails()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn dropdown-toggle",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#odometer",
      "role": "button",
      "aria-expanded": "false",
      "aria-controls": "odometer"
    }
  }, [_vm._v("Odometer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn dropdown-toggle",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "data-toggle": "collapse",
      "href": "#gasfilling",
      "role": "button",
      "aria-expanded": "false",
      "aria-controls": "gasfilling"
    }
  }, [_vm._v("Gas Flow Meter Detail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Odometer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Latitude")]), _vm._v(" "), _c('th', [_vm._v("Longitude")]), _vm._v(" "), _c('th', [_vm._v("Meter Reading")]), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Gas Flow Meter Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Challan Image")]), _vm._v(" "), _c('th', [_vm._v("Trip Type")]), _vm._v(" "), _c('th', [_vm._v("Capture Type")]), _vm._v(" "), _c('th', [_vm._v("Pressure Gauge Reading")]), _vm._v(" "), _c('th', [_vm._v("Gas Flow Meter Reading")]), _vm._v(" "), _c('th', [_vm._v("RecordedTime")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Exception")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),

/***/ 1968:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 clear_button"
  }, [_c('button', {
    staticClass: "inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RouteCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn"
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export Route")])]), _vm._v(" "), _c('v-server-table', {
    ref: "tripRouteTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1969:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(this.user.roleName == 'Super Admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.userCount))]), _vm._v(" "), _c('p', [_vm._v("User")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      }
    }
  }, [_c('div', {
    staticClass: "panel-footer bg-primary"
  }, [_vm._v("\n          More Info "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total_investment_wrp"
  }, [(this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                " + _vm._s(_vm.investedAmount ? _vm.investedAmount : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Total Investment Amount")])]), _vm._v(" "), _vm._m(1)])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                " + _vm._s(_vm.totalInvestmentAmount ? _vm.totalInvestmentAmount : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Current Investment Value")])]), _vm._v(" "), (_vm.totalInvestmentAmount !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.netProfitAndLoss > 0,
        negative: _vm.netProfitAndLoss < 0,
    }
  }, [_vm._v("\n                " + _vm._s(_vm.netProfitAndLoss ? _vm.netProfitAndLoss : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Unrealised Profit/Loss")])]), _vm._v(" "), (_vm.netProfitAndLoss !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [(_vm.net_pnl) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.net_pnl > 0, negative: _vm.net_pnl < 0
    }
  }, [_vm._v("\n                " + _vm._s(_vm.net_pnl ? _vm.net_pnl : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Net Profilt/Loss")])]) : _vm._e(), _vm._v(" "), (_vm.net_pnl !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number",
    class: {
      positive: _vm.net_profit_percentage > 0,
        negative: _vm.net_profit_percentage < 0,
    }
  }, [_vm._v("\n                " + _vm._s(_vm.net_profit_percentage === 'No data' ?
    _vm.net_profit_percentage :
    (_vm.net_profit_percentage + "%")) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Net Profit/Loss %")])]), _vm._v(" "), (_vm.net_profit_percentage !== 'No data') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dash-box"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v("\n                " + _vm._s(_vm.withdrawlAmount ? _vm.withdrawlAmount : '0') + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("Withdrawl Amount")])]), _vm._v(" "), _vm._m(2)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tablewrp"
  }, [(this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Investment History")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.history_table), function(data) {
    return (_vm.history_table.length > 0) ? _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(data.createdAt) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.current_investment_value) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pnl_value ? data.pnl_value : '0'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.net_pnl ? data.net_pnl : '0'))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.net_profit_percentage ? ((data.net_profit_percentage) + "%") : '0') + "\n            ")])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.history_table.length === 0) ? _c('h4', {
    staticClass: "teext"
  }, [_vm._v("No Investment History Found")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/user.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-19px"
    },
    attrs: {
      "src": "/static/img/logo-usd.png",
      "alt": "Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Current Investment Value ($)")]), _vm._v(" "), _c('th', [_vm._v("Unrealised Profit/Loss ($)")]), _vm._v(" "), _c('th', [_vm._v("Net Profit/Loss ($)")]), _vm._v(" "), _c('th', [_vm._v("Net Profit/Loss %")])])])
}]}

/***/ }),

/***/ 1970:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteRouteModal
    }
  }, [_vm._v("Delete\n                                Route")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.region),
      expression: "tripRoute.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "click": _vm.selectGA,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Start Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.startSite),
      expression: "tripRoute.startSite"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "startSite"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "startSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.addLatLng]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.start_site), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "lat": item.latitude,
        "long": item.longitude,
        "startmessageMarker": item.siteName
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                                " + _vm._s(item.siteName) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start Location is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("End Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.endSite),
      expression: "tripRoute.endSite"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "endSite"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "endSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.addEndLatLng]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("End Location")]), _vm._v(" "), _vm._l((_vm.end_site), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "endLat": item.latitude,
        "endLong": item.longitude,
        "endmessageMarker": item.siteName
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                                " + _vm._s(item.siteName) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("End Location is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.approxDistance),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Approx. Distance(km) ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.approxDistance),
      expression: "tripRoute.approxDistance",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "approxDistance",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.tripRoute.approxDistance)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "approxDistance", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "approxDistance",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Approx. Distance is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.approxTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Approx. Time (in Min)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.approxTime),
      expression: "tripRoute.approxTime",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "2880",
      "name": "approxTime",
      "required": "",
      "placeholder": "Approx. Time"
    },
    domProps: {
      "value": (_vm.tripRoute.approxTime)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "approxTime", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "approxTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Approx. Time is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum Time for a Trip is 2 days")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.status),
      expression: "tripRoute.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.reportAssessment),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Route Risk Assessment Report")]), _vm._v(" "), _c('input', {
    ref: "reportAssesssment",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportAssessment",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Route'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-4 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid) && !(_vm.photoRepoertAssessment)
    },
    on: {
      "click": _vm.updateRoute
    }
  }, [_vm._v("Update\n                                Route")])], 1)], 1)])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1971:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.region),
      expression: "site.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.selectGA($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2)]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.siteName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.siteName),
      expression: "site.siteName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "siteName",
      "required": "",
      "placeholder": "Location Name"
    },
    domProps: {
      "value": (_vm.site.siteName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "siteName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Location name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of Location is 3 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.location_tag),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Tag")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.location_tag),
      expression: "site.location_tag",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "location_tag",
      "required": "",
      "placeholder": "Location Tag"
    },
    domProps: {
      "value": (_vm.site.location_tag)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "location_tag", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "location_tag",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location tag is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Location tag is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of Location is 3 character")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.siteType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.siteType),
      expression: "site.siteType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "siteType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "siteType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Location Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBS"
    }
  }, [_vm._v("Daughter Booster Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DS"
    }
  }, [_vm._v("Daughter Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LNGT"
    }
  }, [_vm._v("LNG Terminal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCU"
    }
  }, [_vm._v("Decompression Unit")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.status),
      expression: "site.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "siteType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.gisId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("GIS ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.gisId),
      expression: "site.gisId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "gisId",
      "required": "",
      "placeholder": "GIS ID"
    },
    domProps: {
      "value": (_vm.site.gisId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "gisId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "gisId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("GIS ID is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("GIS ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of GIS ID is 3 character")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cascadeCapacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Cascade Capacity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.cascadeCapacity),
      expression: "site.cascadeCapacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9999999",
      "name": "cascadeCapacity",
      "required": "",
      "placeholder": "Cascade Capacity"
    },
    domProps: {
      "value": (_vm.site.cascadeCapacity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "cascadeCapacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cascadeCapacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Cascade Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Maximum capacity is 1")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum capacity is 9999999")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.capacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Capacity (WL)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.capacity),
      expression: "site.capacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9999999",
      "name": "capacity",
      "required": "",
      "placeholder": "Capacity"
    },
    domProps: {
      "value": (_vm.site.capacity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "capacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "capacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Maximum capacity is 1")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum capacity is 9999999")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateAdded),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Commissioning Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateAdded",
      "lang": "en",
      "name": "dateAdded",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.site.dateAdded),
      callback: function($$v) {
        _vm.$set(_vm.site, "dateAdded", $$v)
      },
      expression: "site.dateAdded"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Commissioning date is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Commissioning date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.latitude),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "latitude"
    }
  }, [_vm._v("Latitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.latitude),
      expression: "site.latitude",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d{2,}(\\.\\d+)?",
      "name": "latitude",
      "required": "",
      "placeholder": "Latitude"
    },
    domProps: {
      "value": (_vm.site.latitude)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "latitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "latitude",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Latitude is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Latitude is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.longitude),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "longitude"
    }
  }, [_vm._v("Longitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.longitude),
      expression: "site.longitude",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d{2,}(\\.\\d+)?",
      "name": "longitude",
      "required": "",
      "placeholder": "Longitude"
    },
    domProps: {
      "value": (_vm.site.longitude)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "longitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "longitude",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Longitude is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Longitude is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.address),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.address),
      expression: "site.address",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "maxlength": _vm.maxAddress,
      "required": "",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.site.address)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "address",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Address is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Address is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Maximum Address length is 150 characters")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.siteInfoImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "siteInfoImage"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteInfoImage",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.supervisor),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.supervisor),
      expression: "site.supervisor"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "supervisor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "supervisor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Location Supervisor")]), _vm._v(" "), _vm._l((_vm.ga_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "supervisor",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("GA Head is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dispenserCount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Dispenser Count")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.dispenserCount),
      expression: "site.dispenserCount",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "25",
      "name": "dispenserCount",
      "placeholder": "Dispenser Count"
    },
    domProps: {
      "value": (_vm.site.dispenserCount)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "dispenserCount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dispenserCount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Dispenser Count is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum Dispenser can be 25")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(this.site.siteType == 'DBS' || this.site.siteType == 'DS') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.defaultMS),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Mother Station")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.defaultMS),
      expression: "site.defaultMS"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "defaultMS"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "defaultMS", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.mother_station_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "defaultMS",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location Type is a required field")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Dealer Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.ownerName),
      expression: "site.ownerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": _vm.max,
      "required": "",
      "name": "ownerName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.site.ownerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.site, "ownerName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Dealer Name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Dealer Name should not be more than 20 characters\n                                            ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerMobile),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerMobile),
      expression: "site.ownerMobile",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "ownerMobile",
      "minlength": "3",
      "name": "ownerMobile",
      "required": "",
      "placeholder": "Mobile",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.site.ownerMobile)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "ownerMobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerMobile",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Owner mobile is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Mobile No is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerEmail),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerEmail),
      expression: "site.ownerEmail",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "minlength": "3",
      "name": "ownerEmail",
      "required": "",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.site.ownerEmail)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "ownerEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerEmail",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Dealer Email is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerAddress),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerAddress),
      expression: "site.ownerAddress",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "ownerAddress",
      "minlength": "3",
      "name": "ownerAddress",
      "required": "",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.site.ownerAddress)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "ownerAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerAddress",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Owner Address is a required field")])])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sites'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createSite
    }
  }, [_vm._v("Add Location")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Trip Code")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v(" " + _vm._s(_vm.trip.tripCode) + " ")])])]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Present Destination")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.trip.endSiteSiteName) + " ")])])]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v(" New Destination ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripException.divertedDestination),
      expression: "tripException.divertedDestination"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "divertedDestination"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripException, "divertedDestination", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.site_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                        " + _vm._s(item.value) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1)]), _c('br'), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Trip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateTrip
    }
  }, [_vm._v("Update")])], 1)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Update Destination")])])
}]}

/***/ }),

/***/ 1973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block login logo",
    attrs: {
      "src": "/static/img/logo-white.png"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (!_vm.passwordReset) ? _c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.newPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notStrong: _vm.passwordScoreValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'password',
      "label": 'New Password:',
      "name": 'newPassword',
      "placeholder": 'Please enter your new password.',
      "messages": {
        required: 'This field is required',
        notStrong: 'Password not strong enough'
      }
    },
    on: {
      "input": _vm.validateConfirm
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.confirmPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notMatch: _vm.passwordConfirmValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'password',
      "label": 'Confirm Password:',
      "name": 'confirmPassword',
      "placeholder": 'Please confirm your password.',
      "messages": {
        required: 'This field is required',
        notMatch: 'Passwords do not match'
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), (_vm.pinRequired) ? _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.pin),
    attrs: {
      "auto-label": "",
      "custom": {
        minlength: _vm.minlengthValidator(4)
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'PIN:',
      "name": 'pin',
      "mask": '1111',
      "minlength": '4',
      "placeholder": 'Please enter your 4 digit PIN.',
      "messages": {
        required: 'This field is required',
        minlength: 'PIN must be 4 digits.'
      }
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.formstate.$dirty || _vm.formstate.$invalid || _vm.passwordScoreUpdating
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), (_vm.error) ? _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Proceed to Login")])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.passwordReset) ? _c('div', {
    staticClass: "content-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Proceed to Login")])])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Reset Password")])])
}]}

/***/ }),

/***/ 1974:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographic Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.region),
      expression: "salesdata.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSite]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.site),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.site),
      expression: "salesdata.site"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "site"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "site", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getDispenserCount]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" Select Location")]), _vm._v(" "), _vm._l((_vm.site_list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "count": item.dispenserCount
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                            " + _vm._s(item.siteName) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "site",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportedDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Date")]), _vm._v(" "), _c('VueCtkDateTimePicker', {
    attrs: {
      "id": "reportedDate",
      "required": "",
      "lang": "en",
      "name": "reportedDate",
      "input-class": "form-control",
      "width": "100%",
      "format": "MM-DD-YYYY hh:mm a"
    },
    model: {
      value: (_vm.salesdata.reportedDate),
      callback: function($$v) {
        _vm.$set(_vm.salesdata, "reportedDate", $$v)
      },
      expression: "salesdata.reportedDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportedDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Sales Data")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "Car"
    }
  }, _vm._l((this.totalDispenser), function(dispenser_number, i) {
    return _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "dispenser"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Dispenser " + _vm._s(dispenser_number) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleAOpening'][i]),
        expression: "dispenserFormData['nozzleAOpening'][i]"
      }],
      ref: "nozzleAOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "name": "a",
        "required": ""
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleAOpening'][i])
      },
      on: {
        "change": function($event) {
          return _vm.fillNext($event, i, 'nozzleAOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleAOpening'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleAClosing'][i]),
        expression: "dispenserFormData['nozzleAClosing'][i]"
      }],
      ref: "nozzleAClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": this.refs,
        "name": "b",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleAClosing'][i])
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleAClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleAClosing'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump A")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleAMeterJump'][i]),
        expression: "dispenserFormData['nozzleAMeterJump'][i]"
      }],
      ref: "nozzleAMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleAMeterJump'][i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleAMeterJump'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle B Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleBOpening'][i]),
        expression: "dispenserFormData['nozzleBOpening'][i]"
      }],
      ref: "nozzleBOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleBOpening'][i])
      },
      on: {
        "change": function($event) {
          return _vm.fillNext($event, i, 'nozzleBOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleBOpening'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle B closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleBClosing'][i]),
        expression: "dispenserFormData['nozzleBClosing'][i]"
      }],
      ref: "nozzleBClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleBClosing'][i])
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleBClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleBClosing'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump B")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleBMeterJump'][i]),
        expression: "dispenserFormData['nozzleBMeterJump'][i]"
      }],
      ref: "nozzleBMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleBMeterJump'][i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleBMeterJump'], i, $event.target.value)
        }
      }
    })])])])
  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-left"
  }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Total Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.totalValue),
      expression: "salesdata.totalValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "totalValue"
    },
    domProps: {
      "value": (_vm.salesdata.totalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesdata, "totalValue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'salesdata'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-5 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createSaleData
    }
  }, [_vm._v("Add Sales Status")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.region.name),
      expression: "region.name",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "name",
      "required": "",
      "placeholder": "G.A Name",
      "pattern": "[a-zA-Z-\\sand mod]+"
    },
    domProps: {
      "value": (_vm.region.name)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.region, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "name",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("G.A name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of G.A is 3 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region.status),
      expression: "region.status"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.region, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region.regionManager),
      expression: "region.regionManager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "regionManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.region, "regionManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A Head")]), _vm._v(" "), _vm._l((_vm.managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("HCV Operation Manager is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" Journey Manager ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "journeyManager",
      "multiple": "",
      "options": this.journey_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "change": _vm.onChanged1
    },
    model: {
      value: (_vm.region.journeyManager),
      callback: function($$v) {
        _vm.$set(_vm.region, "journeyManager", $$v)
      },
      expression: "region.journeyManager"
    }
  }), _vm._v(" "), (!_vm.docsValid1) ? _c('div', {
    staticClass: "error-message",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                                        Please select at least one Journey Manager.\n                                    ")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.jmaUser),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "jmaUser"
    }
  }, [_vm._v(" JMA Users ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "jmaUser",
      "multiple": "",
      "options": this.jma_users,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "change": _vm.onChanged2
    },
    model: {
      value: (_vm.region.jmaUser),
      callback: function($$v) {
        _vm.$set(_vm.region, "jmaUser", $$v)
      },
      expression: "region.jmaUser"
    }
  }), _vm._v(" "), (!_vm.docsValid2) ? _c('div', {
    staticClass: "error-message",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                                        Please select at least one JMA User.\n                                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionCode),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Region Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.region.regionCode),
      expression: "region.regionCode",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "regionCode",
      "required": "",
      "placeholder": "Region Code",
      "pattern": "[A-Z]{2}"
    },
    domProps: {
      "value": (_vm.region.regionCode)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.region, "regionCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionCode",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Region Code is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Region Code is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of Region Code is 3 character")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Region'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && _vm.formValid)
    },
    on: {
      "click": _vm.createRegion
    }
  }, [_vm._v("Add G.A")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.REPORT_STAFF, _vm.USER_ROLES.SALES_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER, USER_ROLES.REPORT_STAFF, USER_ROLES.SALES_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.REPORT_STAFF]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER, USER_ROLES.REPORT_STAFF]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [(_vm.forDelete.length > 0) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.deleteMultiple
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ReportCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Generate New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "reportgenerationTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(props) {
        return [_c('div', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.deleteIds && _vm.deleteIds.length > 0 && _vm.deleteIds.includes(props.row._id)
          },
          on: {
            "change": function($event) {
              return _vm.multiDelete($event, props.row)
            }
          }
        })])]
      }
    }, {
      key: "download",
      fn: function(props) {
        return [_c('div', [_c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.download(props.row)
            }
          }
        }, [_vm._v("Download")])])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [_c('div', [_c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteReport(props.row)
            }
          }
        }, [_vm._v("Delete")])])]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_list,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.selectGA
    },
    model: {
      value: (_vm.trip.region),
      callback: function($$v) {
        _vm.$set(_vm.trip, "region", $$v)
      },
      expression: "trip.region"
    }
  })], 1), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                    Geographical Area is a required field\n                  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.vehicle_no,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.getDeviceName
    },
    model: {
      value: (_vm.trip.vehicleId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "vehicleId", $$v)
      },
      expression: "trip.vehicleId"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "message",
      "placeholder": "Device",
      "id": "chat-input"
    },
    domProps: {
      "value": (_vm.trip.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trip, "deviceId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "journeyManager"
    }
  }, [_vm._v("\n                    Drivers\n                  ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "drivers",
      "multiple": "",
      "options": this.driver_name,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.driverStatus
    },
    model: {
      value: (_vm.trip.driverId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "driverId", $$v)
      },
      expression: "trip.driverId"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.HCVOperationStatus
    },
    model: {
      value: (_vm.trip.regionManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "regionManager", $$v)
      },
      expression: "trip.regionManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.journey_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.journeyManagerStatus
    },
    model: {
      value: (_vm.trip.journeyManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "journeyManager", $$v)
      },
      expression: "trip.journeyManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Journey Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "disabled": "",
      "required": "",
      "lang": "en",
      "name": "scheduleDate",
      "not-before": _vm.disabledBefore,
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduledTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduledTime",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduledTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Time is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.remark),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.remark),
      expression: "trip.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "placeholder": "Remarks"
    },
    domProps: {
      "value": (_vm.trip.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trip, "remark", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [(index === 0) ? _c('label', [_vm._v("Start Location")]) : (index === _vm.locations.length - 1) ? _c('label', [_vm._v("End Location")]) : _c('label', [_vm._v("Halt " + _vm._s(index))]), _vm._v(" "), _c('vue-select', {
      attrs: {
        "label": "siteName",
        "options": _vm.getFilteredLocationList(
          index
        ),
        "searchable": true,
        "language": "en-US"
      },
      on: {
        "change": function($event) {
          return _vm.handleChange($event, index)
        }
      },
      model: {
        value: (input.locationId),
        callback: function($$v) {
          _vm.$set(input, "locationId", $$v)
        },
        expression: "input.locationId"
      }
    }), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                        HCV Operation Manager is a required field\n                      ")])])], 1), _vm._v(" "), (index === _vm.locations.length - 2) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.addField('locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "green",
        "d": "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      }
    })]) : _vm._e(), _vm._v(" "), (index > 1 && index < _vm.locations.length - 1) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index, 'locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "#EC4899",
        "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
      }
    })]) : _vm._e()], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroup'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$valid && _vm.formValid)
    },
    on: {
      "click": _vm.createTrip
    }
  }, [_vm._v("\n              Add Group Trip\n            ")])], 1)], 1)])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425",
      "adaptive": false,
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('gasFlowDia')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Start Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.startLocation),
      expression: "routeData.startLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Start Location",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.startLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "startLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("End Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.endLocation),
      expression: "routeData.endLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "End Location",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.endLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "endLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Time (in Min) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.time),
      expression: "routeData.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Time"
    },
    domProps: {
      "value": (_vm.routeData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Distance(km) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.distance),
      expression: "routeData.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "distance", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeRoute()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createRoute()
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1978:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.isAreaTable) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {}), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    attrs: {
      "id": "details house_details_wrp"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Edit Mother Station Details")]), _vm._v(" "), _c('vue-form', {
    staticClass: "formadd_scroll formadd_scroll_margin",
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Present Mother Station")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.motherStationDetails.name) + " ")])])]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("New Mother Station")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripException.divertedDestination),
      expression: "tripException.divertedDestination"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "divertedDestination"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripException, "divertedDestination", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Mother Station")]), _vm._v(" "), _vm._l((_vm.motherStationDetails.stations), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                          " + _vm._s(item.siteName) + "\n                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "divertedDestination",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1)]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateMotherStation
    }
  }, [_vm._v("Update")])])], 1)])])])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tableBox"
    }
  }, [_c('div', {
    staticClass: "box-body box-body-hcv"
  }, [_c('div', {
    staticClass: "headerText"
  }, [_vm._v("HCV Optimization System")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroupCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn addnew"
  }, [_vm._v("Add Group Trip")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "hcvdetailsTable",
    staticClass: "table-responsive-hcv ",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "map",
      fn: function(props) {
        return [_c('div', [_c('button', {
          staticClass: "btn gradientbt",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#exampleModal"
          },
          on: {
            "click": function($event) {
              return _vm.getstartLocation(props.row)
            }
          }
        }, [_vm._v("\n              Show Map\n            ")])])]
      }
    }, {
      key: "motherStation",
      fn: function(props) {
        return [(props.row.motherStation !== '') ? _c('div', [_c('span', [_vm._v(_vm._s(props.row.motherStation))]), _c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (props.row.motherStation === '') ? _c('span', [_vm._v(_vm._s('--'))]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])])
}]}

/***/ }),

/***/ 1979:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box-solid"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN ]),
      expression: "[\n        USER_ROLES.ADMIN,\n        USER_ROLES.SUPER_ADMIN,\n\n      ]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegionCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          Export Geographical Areas\n        ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "regionsTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1980:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD ]),
      expression: "[\n              USER_ROLES.ADMIN,\n              USER_ROLES.SUPER_ADMIN,\n              USER_ROLES.GA_HEAD,\n            ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteTripModal
    }
  }, [_vm._v("\n              Delete Trip\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_list,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.selectGA
    },
    model: {
      value: (_vm.trip.region),
      callback: function($$v) {
        _vm.$set(_vm.trip, "region", $$v)
      },
      expression: "trip.region"
    }
  })], 1), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                    Geographical Area is a required field\n                  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.vehicle_no,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.getDeviceName
    },
    model: {
      value: (_vm.trip.vehicleId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "vehicleId", $$v)
      },
      expression: "trip.vehicleId"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                    Drivers\n                  ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "multiple": "",
      "options": this.driver_name,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.driverStatus
    },
    model: {
      value: (_vm.trip.driverId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "driverId", $$v)
      },
      expression: "trip.driverId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "required": "",
      "not-before": _vm.disabledBefore,
      "disabled": "",
      "lang": "en",
      "name": "scheduleDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduleTime",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.trip.scheduleTime),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleTime", $$v)
      },
      expression: "trip.scheduleTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Time is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.HCVOperationStatus
    },
    model: {
      value: (_vm.trip.regionManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "regionManager", $$v)
      },
      expression: "trip.regionManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.journey_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.journeyManagerStatus
    },
    model: {
      value: (_vm.trip.journeyManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "journeyManager", $$v)
      },
      expression: "trip.journeyManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Journey Manager is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.remark),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.remark),
      expression: "trip.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "placeholder": "Remarks"
    },
    domProps: {
      "value": (_vm.trip.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trip, "remark", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [(index === 0) ? _c('label', [_vm._v("Start Location")]) : (index === _vm.locations.length - 1) ? _c('label', [_vm._v("End Location")]) : _c('label', [_vm._v("Halt " + _vm._s(index))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.locationId),
        expression: "input.locationId"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": "",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(input, "locationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleChange($event, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.getFilteredLocationList(
      index
    )), function(item, itemIndex) {
      return _c('option', {
        key: itemIndex,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                        " + _vm._s(item.siteName) + "\n                      ")])
    })], 2), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                        HCV Operation Manager is a required field\n                      ")])])], 1)], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroup'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n              USER_ROLES.ADMIN,\n              USER_ROLES.SUPER_ADMIN,\n              USER_ROLES.GA_HEAD,\n              USER_ROLES.JOURNEY_MANAGER,\n            ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "disabled": !(_vm.formValid),
      "type": "submit"
    },
    on: {
      "click": _vm.updateTripGroupDetails
    }
  }, [_vm._v("\n                Update Group Trip\n              ")])])], 1)], 1)])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425",
      "adaptive": false,
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('gasFlowDia')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Start Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.startLocation),
      expression: "routeData.startLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.startLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "startLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("End Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.endLocation),
      expression: "routeData.endLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.endLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "endLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Time (in Min) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.time),
      expression: "routeData.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Distance(km) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.distance),
      expression: "routeData.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "distance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Region :")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.region),
      expression: "routeData.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.routeData, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                " + _vm._s(item.value) + "\n              ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeRoute()
      }
    }
  }, [_vm._v("Close")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n          " + _vm._s(_vm.newUser.firstName) + " " + _vm._s(_vm.newUser.lastName) + "\n        ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: _vm.detailsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    class: _vm.detailsActive,
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('br'), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN]),
      expression: "[USER_ROLES.ADMIN]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5 mt-5",
    on: {
      "click": _vm.deleteUserModal
    }
  }, [_vm._v("\n              Delete User\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("First Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.firstName),
      expression: "newUser.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "maxlength": _vm.max,
      "type": "text",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.newUser.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                      First name should be less than 20 characters\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.lastName),
      expression: "newUser.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.newUser.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator,
        notUnique: _vm.emailUniqueValidator,
      }
    }
  }, [_c('label', [_vm._v("Email :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.invested_amount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Invested Amount :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.invested_amount),
      expression: "newUser.invested_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "number",
      "name": "investedAmount",
      "maxlength": _vm.max,
      "placeholder": "Invested Amount"
    },
    domProps: {
      "value": (_vm.newUser.invested_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "invested_amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "investedAmount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                      Invested Amount should be less than 20 characters\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "startDate"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "licenseExpiryDate",
      "lang": "en",
      "name": "startDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.newUser.startDate),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "startDate", $$v)
      },
      expression: "newUser.startDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Start Date is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.withdrawl_amount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Withdrawal Amount :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.withdrawl_amount),
      expression: "newUser.withdrawl_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "number",
      "name": "withdrawl_amount",
      "maxlength": _vm.max,
      "placeholder": "Withdrawal Amount"
    },
    domProps: {
      "value": (_vm.newUser.withdrawl_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "withdrawl_amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "withdrawl_amount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Withdrawal Amount should be less than 20 characters")])])], 1)], 1)]), _vm._v(" "), _c('validate', {
    staticClass: "hide"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userGroupsUpdated),
      expression: "userGroupsUpdated"
    }],
    attrs: {
      "type": "text",
      "name": "userGroupsUpdated"
    },
    domProps: {
      "value": (_vm.userGroupsUpdated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userGroupsUpdated = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('validate', {
    staticClass: "hide"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPermissionsUpdated),
      expression: "userPermissionsUpdated"
    }],
    attrs: {
      "type": "text",
      "name": "userPermissionsUpdated"
    },
    domProps: {
      "value": (_vm.userPermissionsUpdated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPermissionsUpdated = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-5 text-right row",
    staticStyle: {
      "margin-top": "10px",
      "margin-right": "auto"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['user', 'updateUser']),
      expression: "['user', 'updateUser']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formstate.$dirty
    },
    on: {
      "click": _vm.updateUser
    }
  }, [_vm._v("\n              Update User\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "password"
    }
  }, [(!_vm.loading) ? _c('user-password', {
    attrs: {
      "user": _vm.newUser
    }
  }) : _vm._e()], 1)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: _vm.addButtonClass
  }, [_c('button', {
    staticClass: "btn btn-primary glyphicon glyphicon-refresh",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "value": "Refresh Page"
    },
    on: {
      "click": _vm.refresh
    }
  })]), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "triplocationTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Details")])])
}]}

/***/ }),

/***/ 1983:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Name:',
      "name": 'name',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.role.name),
      callback: function($$v) {
        _vm.$set(_vm.role, "name", $$v)
      },
      expression: "role.name"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.description),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Description:',
      "name": 'description'
    },
    model: {
      value: (_vm.role.description),
      callback: function($$v) {
        _vm.$set(_vm.role, "description", $$v)
      },
      expression: "role.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$valid)
    },
    on: {
      "click": _vm.createRole
    }
  }, [_vm._v("Create Role")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "permissions"
    }
  }, [(!_vm.loading) ? _c('role-permissions', {
    attrs: {
      "role": _vm.role
    }
  }) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#permissions"
    }
  }, [_vm._v("Permissions")])])])
}]}

/***/ }),

/***/ 1984:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('v-server-table', {
    ref: "expiringLicenseTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [(this.user.roleName == 'Admin') ? _c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeviceCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn "
  }, [_vm._v("Add New")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          Export Device\n        ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "deviceTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "box box-solid box-clear"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row content-centered profile"
  }, [_c('croppa', {
    attrs: {
      "width": 350,
      "height": 350,
      "placeholder": "Click here to choose an image.",
      "placeholder-font-size": 14,
      "accept": ".png,.jpg,.jpeg,.gif",
      "prevent-white-space": true,
      "zoom-speed": 5
    },
    on: {
      "init": _vm.onReady,
      "image-remove": _vm.onImageRemove,
      "file-type-mismatch": _vm.onFileTypeMismatch,
      "file-size-exceed": _vm.onFileSizeExceed,
      "file-choose": _vm.onFileChoose
    },
    model: {
      value: (_vm.profileImage),
      callback: function($$v) {
        _vm.profileImage = $$v
      },
      expression: "profileImage"
    }
  }, [_c('img', {
    attrs: {
      "slot": "initial",
      "crossorigin": "anonymous",
      "src": _vm.displayUrl
    },
    slot: "initial"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "placeholder",
      "src": "/static/img/fa-expand.png"
    },
    slot: "placeholder"
  })])], 1), _vm._v(" "), (_vm.fileUploading) ? _c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "progress active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ('width: ' + _vm.percentCompleted + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.percentCompleted,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.percentCompleted) + "% Complete")])])])])]) : _vm._e(), _vm._v(" "), (_vm.profileloading && _vm.percentCompleted >= 100) ? _c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body content-centered"
  }, [_c('pulse-loader')], 1)]) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": (!_vm.profileImage.hasImage() || _vm.profileImageUrl.includes('gravatar') || !this.dirty) && !_vm.fileChosen
    },
    on: {
      "click": _vm.setProfileImage
    }
  }, [_vm._v("Set Profile Image")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.profileImageUrl.includes('gravatar') || _vm.profileloading
    },
    on: {
      "click": _vm.removeProfileImage
    }
  }, [_vm._v("Remove Profile Image")])])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa"
  }, [_c('pulse-loader')], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header content-centered"
  }, [_c('h3', [_vm._v("Uploading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header content-centered"
  }, [_c('h3', [_vm._v("Finalizing...")])])
}]}

/***/ }),

/***/ 1987:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.region),
      expression: "tripRoute.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selectGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Start Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.startSite),
      expression: "tripRoute.startSite"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "startSite"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "startSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.addLatLng]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Start Location")]), _vm._v(" "), _vm._l((_vm.start_site), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "lat": item.latitude,
        "long": item.longitude,
        "startmessageMarker": item.siteName
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                            " + _vm._s(item.siteName) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start Location is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("End Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.endSite),
      expression: "tripRoute.endSite"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "endSite"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "endSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.addEndLatLng]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select End Location")]), _vm._v(" "), _vm._l((_vm.end_site), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "endLat": item.latitude,
        "endLong": item.longitude,
        "endmessageMarker": item.siteName
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                            " + _vm._s(item.siteName) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("End Location is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.approxDistance),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Approx. Distance(km) ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.approxDistance),
      expression: "tripRoute.approxDistance",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "approxDistance",
      "required": "",
      "min": "0",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.tripRoute.approxDistance)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "approxDistance", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "approxDistance",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Approx. Distance is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.approxTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Approx. Time (in Min)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.approxTime),
      expression: "tripRoute.approxTime",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2880",
      "name": "approxTime",
      "required": "",
      "placeholder": "Approx. Time"
    },
    domProps: {
      "value": (_vm.tripRoute.approxTime)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "approxTime", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "approxTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Approx. Time is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum Time for a Trip is 2 days")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.status),
      expression: "tripRoute.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.reportAssessment),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Route Risk Assessment Report")]), _vm._v(" "), _c('input', {
    ref: "reportAssesssment",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportAssessment",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Route'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-4 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createRoute
    }
  }, [_vm._v("Add Route")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1988:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "mr-5 btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.proceedToLogin
    }
  }, [_vm._v("Proceed To Login")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Account Activation")])])
}]}

/***/ }),

/***/ 1989:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deletesalesdataModal
    }
  }, [_vm._v("Delete Data")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("Geographic Area")]), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "35px",
      "font-size": "20px"
    }
  }, [_vm._v(" " + _vm._s(_vm.salesdata.regionName))])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.site),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("Location")]), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "30px",
      "font-size": "20px"
    }
  }, [_vm._v(" " + _vm._s(_vm.salesdata.siteSiteName))])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "site",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportedDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "reportedDate",
      "required": "",
      "lang": "en",
      "name": "reportedDate",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.salesdata.reportedDate),
      callback: function($$v) {
        _vm.$set(_vm.salesdata, "reportedDate", $$v)
      },
      expression: "salesdata.reportedDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportedDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Sales Data")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nozzlesNumber"
    }
  }, _vm._l((_vm.total_dispancer), function(dispenser_number, i) {
    return _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "dispenser"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Dispenser " + _vm._s(dispenser_number) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleA.nozzleAOpening),
        expression: "salesdata.dispenserData[i].nozzleA.nozzleAOpening"
      }],
      ref: "nozzleAOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleA.nozzleAOpening)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleAOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleA, "nozzleAOpening", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleA.nozzleAClosing),
        expression: "salesdata.dispenserData[i].nozzleA.nozzleAClosing"
      }],
      ref: "nozzleAClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleA.nozzleAClosing)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleAClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleA, "nozzleAClosing", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump A")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleA.nozzleAMeterJump),
        expression: "salesdata.dispenserData[i].nozzleA.nozzleAMeterJump"
      }],
      ref: "nozzleAMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleA.nozzleAMeterJump)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleA, "nozzleAMeterJump", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle B Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleB.nozzleBOpening),
        expression: "salesdata.dispenserData[i].nozzleB.nozzleBOpening"
      }],
      ref: "nozzleBOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleB.nozzleBOpening)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleBOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleB, "nozzleBOpening", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzles B closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleB.nozzleBClosing),
        expression: "salesdata.dispenserData[i].nozzleB.nozzleBClosing"
      }],
      ref: "nozzleBClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleB.nozzleBClosing)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleBClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleB, "nozzleBClosing", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 "
    }, [_c('label', [_vm._v("Meter Jump B")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleB.nozzleBMeterJump),
        expression: "salesdata.dispenserData[i].nozzleB.nozzleBMeterJump"
      }],
      ref: "nozzleBMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleB.nozzleBMeterJump)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleB, "nozzleBMeterJump", $event.target.value)
        }
      }
    })])])])
  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-left"
  }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Total Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.totalValue),
      expression: "salesdata.totalValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "totalValue"
    },
    domProps: {
      "value": (_vm.salesdata.totalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesdata, "totalValue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'salesdata'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-5 btn gradientbt2",
    staticStyle: {
      "background-image": "linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255))",
      "color": "white"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updatesalesdata
    }
  }, [_vm._v("Update Sales Status")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1990:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.SALES_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER, USER_ROLES.SALES_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 clear_button"
  }, [_c('button', {
    staticClass: "inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (this.user.roleName === 'Admin') ? _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'SiteCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Add New")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export Location")])]), _vm._v(" "), _c('v-server-table', {
    ref: "siteTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1991:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1992:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.reportType),
      expression: "reportgeneration.reportType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "reportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "logbook"
    }
  }, [_vm._v("Vehicle Log Book")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_ms"
    }
  }, [_vm._v("Data HCV Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_dbs"
    }
  }, [_vm._v("Data HCV DB Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dsr"
    }
  }, [_vm._v("Daily Sales Report")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "driver"
    }
  }, [_vm._v("Driver Compliance Report")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vehicle"
    }
  }, [_vm._v("Vehicle Compliance Report")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "trip_analysis"
    }
  }, [_vm._v("Vehicle Compliance Report")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.downloadType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Download Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.downloadType),
      expression: "reportgeneration.downloadType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "downloadType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "downloadType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PDF"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XLSX"
    }
  }, [_vm._v("Excel")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "downloadType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Download Type is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Criterion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Record Start Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startDate),
    attrs: {
      "auto-label": ""
    }
  }, [(this.reportgeneration.reportType != 'dsr') ? _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.reportgeneration.startDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "startDate", $$v)
      },
      expression: "reportgeneration.startDate"
    }
  }) : _vm._e(), _vm._v(" "), (this.reportgeneration.reportType == 'dsr') ? _c('VueCtkDateTimePicker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "MM-DD-YYYY hh:mm a"
    },
    model: {
      value: (_vm.reportgeneration.startDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "startDate", $$v)
      },
      expression: "reportgeneration.startDate"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Record Start Date is a required field\n                      ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Record End Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endDate),
    attrs: {
      "auto-label": ""
    }
  }, [(this.reportgeneration.reportType != 'dsr') ? _c('date-picker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.reportgeneration.endDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "endDate", $$v)
      },
      expression: "reportgeneration.endDate"
    }
  }) : _vm._e(), _vm._v(" "), (this.reportgeneration.reportType == 'dsr') ? _c('VueCtkDateTimePicker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "MM-DD-YYYY hh:mm a"
    },
    model: {
      value: (_vm.reportgeneration.endDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "endDate", $$v)
      },
      expression: "reportgeneration.endDate"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Record End Date is a required field\n                      ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.region),
      expression: "reportgeneration.region"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isGADisable,
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getStationList]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                        " + _vm._s(item.value) + "\n                      ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), (_vm.reportgeneration.reportType !== 'driver' && _vm.reportgeneration.reportType !== 'vehicle') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.station),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.station),
      expression: "reportgeneration.station"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "station"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "station", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.station_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                        " + _vm._s(item.value) + "\n                      ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "station",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.reportgeneration.reportType == 'logbook') ? _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.vehicleId),
      expression: "reportgeneration.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "disabled": this.disabledInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                        " + _vm._s(item.value) + "\n                      ")])
  })], 2)]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Report'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gredientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createReport
    }
  }, [_vm._v("\n              Generate Report\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1993:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "name": "demo5",
      "limit": 5,
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1994:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.label ? 'vf-labeled' : ''
  }, [_vm._t("default"), _vm._v(" "), (_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.type === 'text' || _vm.type === 'email') ? _c('div', [(_vm.mask) ? _c('vue-masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.mask,
      "type": _vm.type,
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.maskedInput)
      }
    },
    model: {
      value: (_vm.maskedInput),
      callback: function($$v) {
        _vm.maskedInput = $$v
      },
      expression: "maskedInput"
    }
  }) : _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('vue-password', {
    attrs: {
      "placeholder": _vm.placeholder,
      "score": _vm.passwordScore
    },
    on: {
      "input": _vm.updateScore
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    attrs: {
      "state": _vm.formstate,
      "name": _vm.name,
      "show": "$touched || $submitted"
    }
  }, [
    [_c('span', {
      staticClass: "glyphicon glyphicon-ok form-control-feedback"
    })], _vm._v(" "), _vm._l((_vm.messages), function(message, key) {
      return _c('template', {
        slot: key
      }, [_c('div', {
        key: key
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-remove form-control-feedback"
      }), _vm._v(" "), _c('span', {
        staticClass: "has-error"
      }, [_vm._v(_vm._s(message))])])])
    }), _vm._v(" "), _c('template', {
      slot: 'notStrong'
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove form-control-feedback"
    }), _vm._v(" "), _vm._l((_vm.suggestions), function(suggestion, key) {
      return _c('div', {
        key: key
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-remove form-control-feedback"
      }), _vm._v(" "), _c('span', {
        staticClass: "has-error"
      }, [_vm._v(_vm._s(suggestion))])])
    })], 2)
  ], 2)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1995:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 clear_button"
  }, [_c('button', {
    staticClass: "inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'VehicleCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Add New")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          Export Vehicle\n        ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "vehicleTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1996:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER,
        _vm.USER_ROLES.GIS_USER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n  USER_ROLES.GIS_USER,\n]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResult]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("All Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "scheduled"
    }
  }, [_vm._v("Scheduled")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ongoing"
    }
  }, [_vm._v("Ongoing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatus
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (this.user.roleName == 'Super Admin' || this.user.roleName == 'Admin') ? _c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n        USER_ROLES.ADMIN,\n        USER_ROLES.SUPER_ADMIN,\n        USER_ROLES.GA_HEAD,\n        USER_ROLES.JOURNEY_MANAGER,\n      ]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn addnew"
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "permission",
            rawName: "v-permission.if",
            value: ([
              _vm.USER_ROLES.ADMIN,
              _vm.USER_ROLES.SUPER_ADMIN,
              _vm.USER_ROLES.GA_HEAD,
              _vm.USER_ROLES.JOURNEY_MANAGER ]),
            expression: "[\n            USER_ROLES.ADMIN,\n            USER_ROLES.SUPER_ADMIN,\n            USER_ROLES.GA_HEAD,\n            USER_ROLES.JOURNEY_MANAGER,\n          ]",
            modifiers: {
              "if": true
            }
          }]
        }, [(props.row.status == 'ongoing') ? _c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.UpdateDestination(props.row)
            }
          }
        }) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1997:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content close-date-picker"
  }, [_c('div', {
    staticClass: "main_select_wrp_relative"
  }, [_c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "exportCSV",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Export ")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilterCSV()
      }
    }
  }, [_vm._v("Clear\n              All")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "format": 'DD-MM-YYYY',
      "placeholder": "Start date"
    },
    on: {
      "change": function($event) {
        return _vm.startDateCSV()
      }
    },
    model: {
      value: (_vm.dateCSV.startDateCSV),
      callback: function($$v) {
        _vm.$set(_vm.dateCSV, "startDateCSV", $$v)
      },
      expression: "dateCSV.startDateCSV"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "not-before": _vm.startDateIsoCSV,
      "format": 'DD-MM-YYYY',
      "placeholder": "End date"
    },
    on: {
      "change": function($event) {
        return _vm.endDateCSV()
      }
    },
    model: {
      value: (_vm.dateCSV.endDateCSV),
      callback: function($$v) {
        _vm.$set(_vm.dateCSV, "endDateCSV", $$v)
      },
      expression: "dateCSV.endDateCSV"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right export_CSV"
  }, [_c('button', {
    staticClass: "mr-2 btn gradientbt ",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_vm._v("\n              Export\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "filtertoogle",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Clear\n              All")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "format": 'DD-MM-YYYY',
      "placeholder": "Start date"
    },
    on: {
      "change": function($event) {
        return _vm.startDate()
      }
    },
    model: {
      value: (_vm.date.startDate),
      callback: function($$v) {
        _vm.$set(_vm.date, "startDate", $$v)
      },
      expression: "date.startDate"
    }
  }), _vm._v(" "), _c('label', [_vm._v("End Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "not-before": _vm.startDateIso,
      "format": 'DD-MM-YYYY',
      "placeholder": "End date"
    },
    on: {
      "change": function($event) {
        return _vm.endDate()
      }
    },
    model: {
      value: (_vm.date.endDate),
      callback: function($$v) {
        _vm.$set(_vm.date, "endDate", $$v)
      },
      expression: "date.endDate"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filter_wrpp filtered"
  }, [_c('div', {
    staticClass: "sorting2"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                " + _vm._s(item.value) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "applyFilter",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#filtertoogle"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0 -1028.4)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m10 11v10l4 3v-13h-4z",
      "fill": "#fff",
      "transform": "translate(0 1028.4)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m10 11v10l2 1.5v-11.5h-2z",
      "fill": "#fff",
      "transform": "translate(0 1028.4)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m1 1028.4 9 11h4l9-11z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m1 1028.4 9 11h2v-11z",
      "fill": "#fff"
    }
  })])]), _vm._v("\n            Apply Filter\n          ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: _vm.driverActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDriver()
      }
    }
  }, [_vm._v("Driver")])]), _vm._v(" "), _c('li', {
    class: _vm.vehicleActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showVehicle()
      }
    }
  }, [_vm._v("Vehicle")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDriverTable),
      expression: "showDriverTable"
    }],
    staticClass: "tab-pane fade in",
    class: _vm.driverActive
  }, [_c('div', {
    staticClass: "filter"
  }), _vm._v(" "), _c('v-server-table', {
    ref: "driverTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.column,
      "options": _vm.option
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "licenseExpiryDate",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.licenseExpiryDate)
        }, [_vm._v("\n              " + _vm._s(props.row.licenseExpiryDate ? _vm.dateFormatters(props.row.licenseExpiryDate) : 'NA') + "\n            ")])]
      }
    }, {
      key: "ddtExpiryDate",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.ddtExpiryDate)
        }, [_vm._v("\n              " + _vm._s(props.row.ddtExpiryDate ? _vm.dateFormatters(props.row.ddtExpiryDate) : 'NA') + "\n            ")])]
      }
    }, {
      key: "hazExpiryDate",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.hazExpiryDate)
        }, [_vm._v("\n              " + _vm._s(props.row.hazExpiryDate ? _vm.dateFormatters(props.row.hazExpiryDate) : 'NA') + "\n            ")])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVehicleTable),
      expression: "showVehicleTable"
    }],
    staticClass: "tab-pane fade in",
    class: _vm.vehicleActive
  }, [_c('div', {
    class: _vm.addButtonClass
  }), _vm._v(" "), _c('v-server-table', {
    ref: "vehilceTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoad
    },
    scopedSlots: _vm._u([{
      key: "rcValidity",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.rcValidity)
        }, [_vm._v("\n              " + _vm._s(props.row.rcValidity ? _vm.dateFormatters(props.row.rcValidity) : 'NA') + "\n            ")])]
      }
    }, {
      key: "insuranceValidity",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.insuranceValidity)
        }, [_vm._v("\n              " + _vm._s(props.row.insuranceValidity ? _vm.dateFormatters(props.row.insuranceValidity) : 'NA') + "\n            ")])]
      }
    }, {
      key: "pucValidity",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.pucValidity)
        }, [_vm._v("\n              " + _vm._s(props.row.pucValidity ? _vm.dateFormatters(props.row.pucValidity) : 'NA') + "\n            ")])]
      }
    }, {
      key: "fitCertValidity",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.fitCertValidity)
        }, [_vm._v("\n              " + _vm._s(props.row.fitCertValidity ? _vm.dateFormatters(props.row.fitCertValidity) : 'NA') + "\n            ")])]
      }
    }, {
      key: "gcpValidity",
      fn: function(props) {
        return [_c('div', {
          class: _vm.getDateClass(props.row.gcpValidity)
        }, [_vm._v("\n              " + _vm._s(props.row.gcpValidity ? _vm.dateFormatters(props.row.gcpValidity) : 'NA') + "\n            ")])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loadings) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),

/***/ 1998:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.name),
      expression: "tempuser.name",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "20",
      "name": "name",
      "required": "",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.tempuser.name)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "technicianName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Operator name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Operator Name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Technician name should be more than 3 characters\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                      Technician name should be less than 20 characters\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobileNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.mobileNumber),
      expression: "tempuser.mobileNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000000000",
      "name": "mobileNumber",
      "required": "",
      "placeholder": "Mobile number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.tempuser.mobileNumber)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "mobileNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobileNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Mobile number is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Mobile number is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Minimum 10 digit")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateOfBirth),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "max": this.minDate,
      "id": "dateOfBirth",
      "required": "",
      "lang": "en",
      "name": "dateOfBirth",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": _vm.getEligibleDate
    },
    model: {
      value: (_vm.tempuser.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.tempuser, "dateOfBirth", $$v)
      },
      expression: "tempuser.dateOfBirth"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateOfBirth",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date of Birth is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Mimimum Age is 18 years")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.deviceId),
      expression: "tempuser.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_id), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.region),
      expression: "tempuser.region"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isGADisable,
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.manager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.manager),
      expression: "tempuser.manager"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isJourenyManagerDisable,
      "required": "",
      "name": "manager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "manager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Journey Manager")]), _vm._v(" "), _vm._l((_vm.manager), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "manager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Journey Manager is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.languageKnown),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Language Known")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.languageKnown),
      expression: "tempuser.languageKnown"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "languageKnown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "languageKnown", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "languageKnown",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Language is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.defaultLanguage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.defaultLanguage),
      expression: "tempuser.defaultLanguage"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "defaultLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "defaultLanguage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.userPin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Operator Pin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.userPin),
      expression: "tempuser.userPin",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "name": "technicianPin",
      "required": "",
      "placeholder": "Operator Pin"
    },
    domProps: {
      "value": (_vm.tempuser.userPin)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "userPin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "technicianPin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Operator pin is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Operator pin is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Operator pin is minimum 4 digit")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Operator pin is Maximum 4 digit")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.addressDetails)
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.addressDetails),
      expression: "tempuser.addressDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "addressDetails",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.tempuser.addressDetails)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempuser, "addressDetails", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tempuser.status),
      expression: "tempuser.status",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.userType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.userType),
      expression: "tempuser.userType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "userType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "operator"
    }
  }, [_vm._v("Operator")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "userType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Type is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.site),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempuser.site),
      expression: "tempuser.site"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "endSite"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempuser, "site", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.site_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "site",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Technician'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createTechnician
    }
  }, [_vm._v("\n              Add Operator\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1999:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.reportType),
      expression: "schedulereport.reportType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "reportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSelectiveStation]
    }
  }, [_c('option', {
    attrs: {
      "value": "logbook"
    }
  }, [_vm._v("Vehicle Log Book")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_ms"
    }
  }, [_vm._v("Data HCV Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_dbs"
    }
  }, [_vm._v("Data HCV DB Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dsr"
    }
  }, [_vm._v("Daily Sales Report")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.downloadType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Download Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.downloadType),
      expression: "schedulereport.downloadType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "downloadType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "downloadType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PDF"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XLSX"
    }
  }, [_vm._v("Excel")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "downloadType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Download Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportFrequency),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Frequency")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.reportFrequency),
      expression: "schedulereport.reportFrequency"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportFrequency"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "reportFrequency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.validateReportFrequency]
    }
  }, [_c('option', {
    attrs: {
      "value": "daily"
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekly"
    }
  }, [_vm._v("Weekly")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportFrequency",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Frequency is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.status),
      expression: "schedulereport.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "scheduleStartDate"
    }
  }, [_vm._v("Schedule Start Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleStartDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "id": "scheduleStartDate",
      "lang": "en",
      "name": "scheduleStartDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.schedulereport.scheduleStartDate),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "scheduleStartDate", $$v)
      },
      expression: "schedulereport.scheduleStartDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleStartDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start date is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "scheduleEndDate"
    }
  }, [_vm._v("Schedule End Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleEndDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "id": "scheduleEndDate",
      "lang": "en",
      "name": "scheduleEndDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY",
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: (_vm.schedulereport.scheduleEndDate),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "scheduleEndDate", $$v)
      },
      expression: "schedulereport.scheduleEndDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleEndDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("End date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.scheduleDay),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Schedule Day")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.scheduleDay),
      expression: "schedulereport.scheduleDay"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "scheduleDay",
      "disabled": _vm.disabledInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "scheduleDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sunday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Monday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Tuesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Wednesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Thursday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Friday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Saturday")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastDays),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Days")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.lastDays),
      expression: "schedulereport.lastDays"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "scheduleDay"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "lastDays", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 days")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "reportGenerationTime"
    }
  }, [_vm._v("Report Generation Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduledTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduledTime",
      "required": ""
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduledTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Generation Time is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Filter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.region),
      expression: "schedulereport.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getStationList]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                    " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), (this.schedulereport.reportType != 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.station),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.station),
      expression: "schedulereport.station"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "station"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "station", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.station_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "station",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), (this.schedulereport.reportType == 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.vehicleId),
      expression: "schedulereport.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "disabled": _vm.disabledVehicleInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Vehicles")])], 2)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Recipients")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "emailTo"
    }
  }, [_vm._v(" To ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('vue-select', {
    attrs: {
      "label": "user",
      "multiple": "",
      "options": this.user_list,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.schedulereport.emailTo),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "emailTo", $$v)
      },
      expression: "schedulereport.emailTo"
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "emailCc"
    }
  }, [_vm._v(" CC ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('vue-select', {
    attrs: {
      "label": "user",
      "multiple": "",
      "options": this.user_list,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.schedulereport.emailCc),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "emailCc", $$v)
      },
      expression: "schedulereport.emailCc"
    }
  })], 1)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ReportSchedule'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createSchedule
    }
  }, [_vm._v("Add Schedule")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2000:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 clear_button"
  }, [_c('button', {
    staticClass: "inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (this.user.roleName == 'Admin' ||
    this.user.roleName == 'Journey Manager' ||
    this.user.roleName == 'JMA User' || this.user.roleName == 'GA Head'
  ) ? _c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DriverCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Add New")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          Export Driver\n        ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "driverTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 2001:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 2002:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.newRole.name))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Name:',
      "name": 'name',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.newRole.name),
      callback: function($$v) {
        _vm.$set(_vm.newRole, "name", $$v)
      },
      expression: "newRole.name"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.description),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Description:',
      "name": 'desription'
    },
    model: {
      value: (_vm.newRole.description),
      callback: function($$v) {
        _vm.$set(_vm.newRole, "description", $$v)
      },
      expression: "newRole.description"
    }
  })], 1)], 1), _vm._v(" "), _c('validate', {
    staticClass: "hide"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roleUpdated),
      expression: "roleUpdated"
    }],
    attrs: {
      "type": "text",
      "name": "roleUpdated"
    },
    domProps: {
      "value": (_vm.roleUpdated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roleUpdated = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['role', 'updateRole']),
      expression: "['role', 'updateRole']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$pristine || _vm.formstate.$invalid
    },
    on: {
      "click": _vm.updateRole
    }
  }, [_vm._v("Update Role")])]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['role', 'deleteRole']),
      expression: "['role', 'deleteRole']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteRoleModal
    }
  }, [_vm._v("Delete Role")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$pristine
    },
    on: {
      "click": _vm.clearChanges
    }
  }, [_vm._v("Clear Changes")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "permissions"
    }
  }, [(!_vm.loading) ? _c('role-permissions', {
    attrs: {
      "role": _vm.newRole
    }
  }) : _vm._e()], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#permissions"
    }
  }, [_vm._v("Permissions")])])])
}]}

/***/ }),

/***/ 2003:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n                " + _vm._s(_vm.flashMessage) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Trip Code")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v("\n                    " + _vm._s(_vm.trip.tripGroupCode) + "\n                  ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "col-sm-6"
    }, [(index === 0) ? _c('label', [_vm._v("Start Location")]) : (index === _vm.locations.length - 1) ? _c('label', [_vm._v("End Location")]) : _c('label', [_vm._v("Halt " + _vm._s(index))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.locationId),
        expression: "input.locationId"
      }],
      staticClass: "form-control",
      attrs: {
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(input, "locationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleChange($event, index)
        }]
      }
    }, [_vm._v("\n                        >\n                        "), _c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.getFilteredLocationList(
      index
    )), function(item, itemIndex) {
      return _c('option', {
        key: itemIndex,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                          " + _vm._s(item.siteName) + "\n                        ")])
    })], 2), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                          HCV Operation Manager is a required field\n                        ")])])], 1), _vm._v(" "), (index === _vm.locations.length - 2) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.addField('locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "green",
        "d": "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      }
    })]) : _vm._e(), _vm._v(" "), (index > 1 && index < _vm.locations.length - 1) ? _c('svg', {
      staticClass: "ml-2 cursor-pointer svg-icons",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index, 'locations')
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "#EC4899",
        "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
      }
    })]) : _vm._e()], 1)])
  }), 0), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroup'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                  Cancel\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updateSubTrips
    }
  }, [_vm._v("\n                Update\n              ")])], 1)], 1)])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425",
      "adaptive": false,
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('gasFlowDia')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Start Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.startLocation),
      expression: "routeData.startLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.startLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "startLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("End Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.endLocation),
      expression: "routeData.endLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.endLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "endLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Time (in Min) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.time),
      expression: "routeData.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Distance(km) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.distance),
      expression: "routeData.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "distance", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeRoute()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createRoute()
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Update Subtrips")])])
}]}

/***/ }),

/***/ 2004:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("First Name :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "name": "firstName",
      "maxlength": _vm.max,
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("First name should be less than 20 characters")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "name": "lastName",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('label', [_vm._v("Email : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.investedAmount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Invested Amount :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.invested_amount),
      expression: "user.invested_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "number",
      "name": "investedAmount",
      "maxlength": _vm.max,
      "placeholder": "Invested Amount"
    },
    domProps: {
      "value": (_vm.user.invested_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "invested_amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "investedAmount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("Invested Amount should be less than 20 characters")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.user.startDate),
      callback: function($$v) {
        _vm.$set(_vm.user, "startDate", $$v)
      },
      expression: "user.startDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      License Expiry Date is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.password),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Password :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "password-toggle-icon",
    on: {
      "click": function($event) {
        return _vm.togglePasswordVisibility('password')
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-eye': _vm.showPassword, 'fa fa-eye-slash': !_vm.showPassword
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "password",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.confirmPassword, _vm.passwordValidation),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Confirm Password :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "password",
      "name": "confirmPassword",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "password-toggle-icon",
    on: {
      "click": function($event) {
        return _vm.togglePasswordVisibility('confirmPassword')
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-eye': _vm.showPassword, 'fa fa-eye-slash': !_vm.showPassword
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "confirmPassword",
      "show": "$touched || $submitted"
    }
  }), _vm._v(" "), (_vm.passwordValidation) ? _c('a', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Passwords do not match.")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      }
    }
  }, [_c('button', {
    staticClass: "mr-2 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && !_vm.passwordValidation)
    },
    on: {
      "click": _vm.createUser
    }
  }, [_vm._v("Add User")])], 1)], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])])])
}]}

/***/ }),

/***/ 2005:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteRegionModal
    }
  }, [_vm._v("\n              Delete G.A\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.region.name),
      expression: "region.name",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "name",
      "required": "",
      "placeholder": "G.A Name"
    },
    domProps: {
      "value": (_vm.region.name)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.region, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "name",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A name is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region.status),
      expression: "region.status"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.region, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region.regionManager),
      expression: "region.regionManager"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "regionManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.region, "regionManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A Head")]), _vm._v(" "), _vm._l((_vm.managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "journeyManager"
    }
  }, [_vm._v("\n                  Journey Manager\n                ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "journeyManager",
      "multiple": "",
      "options": this.journey_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.flagButtonCheck
    },
    model: {
      value: (_vm.region.journeyManager),
      callback: function($$v) {
        _vm.$set(_vm.region, "journeyManager", $$v)
      },
      expression: "region.journeyManager"
    }
  }), _vm._v(" "), (!_vm.flagButton) ? _c('div', {
    staticClass: "error-message",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  Please select at least one Journey Manager.\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "jmaUser"
    }
  }, [_vm._v("\n                  JMA Users\n                ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "jmaUser",
      "multiple": "",
      "options": this.jma_users,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.flagButtonCheck1
    },
    model: {
      value: (_vm.region.jmaUser),
      callback: function($$v) {
        _vm.$set(_vm.region, "jmaUser", $$v)
      },
      expression: "region.jmaUser"
    }
  }), _vm._v(" "), (!_vm.flagButton1) ? _c('div', {
    staticClass: "error-message",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  Please select at least one JMA User.\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionCode),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Region Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.region.regionCode),
      expression: "region.regionCode",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "regionCode",
      "required": "",
      "placeholder": "Region Code",
      "pattern": "[A-Z]{2}"
    },
    domProps: {
      "value": (_vm.region.regionCode)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.region, "regionCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionCode",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Region Code is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Region Code is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of Region Code is 3 character")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Region'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && _vm.flagButton && _vm.flagButton1)
    },
    on: {
      "click": _vm.updateRegion
    }
  }, [_vm._v("\n              Update G.A\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2006:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.brand),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Brand")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.brand),
      expression: "device.brand",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "2",
      "name": "brand",
      "required": "",
      "placeholder": "Brand Name"
    },
    domProps: {
      "value": (_vm.device.brand)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "brand", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "brand",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Brand name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Brand name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of brand is 2 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceModel),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceModel),
      expression: "device.deviceModel",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "deviceModel",
      "required": "",
      "placeholder": "Model"
    },
    domProps: {
      "value": (_vm.device.deviceModel)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "deviceModel", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "minlength": "3",
      "name": "deviceModel",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Model is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Model is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of model is 3 character\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.imei),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("IMEI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.imei),
      expression: "device.imei",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "imei",
      "minlength": "14",
      "required": "",
      "placeholder": "IMEI"
    },
    domProps: {
      "value": (_vm.device.imei)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "imei", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "imei",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("IMEI is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum 14 number required")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.connectionId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Connection ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.connectionId),
      expression: "device.connectionId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "connectionId",
      "minlength": "14",
      "required": "",
      "placeholder": "Connection ID"
    },
    domProps: {
      "value": (_vm.device.connectionId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "connectionId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "connectionId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Connection ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum 14 number required")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.device.deviceId),
      expression: "device.deviceId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control required-field",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "deviceId",
      "required": "",
      "placeholder": "Device ID"
    },
    domProps: {
      "value": (_vm.device.deviceId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.device, "deviceId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device ID is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Device ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of Device is 3 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateAdded),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Registration Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateAdded",
      "lang": "en",
      "name": "dateAdded",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.device.dateAdded),
      callback: function($$v) {
        _vm.$set(_vm.device, "dateAdded", $$v)
      },
      expression: "device.dateAdded"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Commissioning date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Commissioning date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.deviceDescription)
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device.deviceDescription),
      expression: "device.deviceDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "deviceDescription",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.device.deviceDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.device, "deviceDescription", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device.status),
      expression: "device.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.device, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Devices'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn bt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createDevice
    }
  }, [_vm._v("\n              Add Device\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2007:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Add/Remove Groups")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupSearchText),
      expression: "groupSearchText"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Search for groups to add"
    },
    domProps: {
      "value": (_vm.groupSearchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.groupSearchText = $event.target.value
      }, function($event) {
        return _vm.getAvailableGroups()
      }]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-info box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAvailableGroups),
      expression: "selectedAvailableGroups"
    }],
    ref: "availablelist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAvailableGroups = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedUserGroups = []
      }]
    }
  }, _vm._l((_vm.availableGroups), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s((obj.group || {}).name) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 content-centered"
  }, [_c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.addGroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-3x icon-btn icon-btn-primary"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.removeGroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-3x icon-btn icon-btn-info"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUserGroups),
      expression: "selectedUserGroups"
    }],
    ref: "userlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUserGroups = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedAvailableGroups = []
      }]
    }
  }, _vm._l((_vm.newUser.groups), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s(obj.group.name) + "\n              ")])
  }), 0)])])])]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": true,
      "placeholder": _vm.groupDescription
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser._id),
      expression: "newUser._id"
    }],
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['user', 'addUserGroups', 'removeUserGroups',
        'addUserAssociations', 'removeUserAssociations'
      ]),
      expression: "['user', 'addUserGroups', 'removeUserGroups',\n              'addUserAssociations', 'removeUserAssociations']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dirty
    },
    on: {
      "click": _vm.updateUserGroups
    }
  }, [_vm._v("Update User Groups")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Available Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Current Groups")])])
}]}

/***/ }),

/***/ 2008:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 2009:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: (['role', 'createRole']),
      expression: "['role', 'createRole']",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RoleCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Add Role")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "roleTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.rowClick
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edit(props.row)
            }
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 2010:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER,
        _vm.USER_ROLES.SALES_MANAGER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n  USER_ROLES.SALES_MANAGER,\n]",
      modifiers: {
        "if": true
      }
    }]
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD ]),
      expression: "[\n            USER_ROLES.ADMIN,\n            USER_ROLES.SUPER_ADMIN,\n            USER_ROLES.GA_HEAD,\n          ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteSiteModal
    }
  }, [_vm._v("\n              Delete Location\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.region),
      expression: "site.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region",
      "id": "regionSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.selectGA($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                    Geographical Area is a required field\n                  ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.siteName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.siteName),
      expression: "site.siteName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "siteName",
      "required": "",
      "placeholder": "Location Name"
    },
    domProps: {
      "value": (_vm.site.siteName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "siteName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Location name is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Location name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of Location is 3 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.location_tag),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Tag")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.location_tag),
      expression: "site.location_tag",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "location_tag",
      "required": "",
      "placeholder": "Location Tag"
    },
    domProps: {
      "value": (_vm.site.location_tag)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "location_tag", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "location_tag",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Location tag is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Location tag is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of Location is 3 character\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.siteType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.siteType),
      expression: "site.siteType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "siteType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "siteType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Location Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBS"
    }
  }, [_vm._v("Daughter Booster Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DS"
    }
  }, [_vm._v("Daughter Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LNGT"
    }
  }, [_vm._v("LNG Terminal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCU"
    }
  }, [_vm._v("Decompression Unit")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "siteType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Location Type is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.status),
      expression: "site.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "siteType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.gisId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("GIS ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.gisId),
      expression: "site.gisId",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "name": "gisId",
      "required": "",
      "placeholder": "GIS ID"
    },
    domProps: {
      "value": (_vm.site.gisId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "gisId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "gisId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("GIS ID is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("GIS ID is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of GIS ID is 3 character\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cascadeCapacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Cascade Capacity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.cascadeCapacity),
      expression: "site.cascadeCapacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9999999",
      "name": "cascadeCapacity",
      "required": "",
      "placeholder": "Cascade Capacity"
    },
    domProps: {
      "value": (_vm.site.cascadeCapacity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "cascadeCapacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cascadeCapacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Cascade Capacity is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Maximum capacity is 1")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum capacity is 9999999")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.capacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Capacity (WL)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.capacity),
      expression: "site.capacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "9999999",
      "name": "capacity",
      "required": "",
      "placeholder": "Capacity"
    },
    domProps: {
      "value": (_vm.site.capacity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "capacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "capacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Maximum capacity is 9999999")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateAdded),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Commissioning Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateAdded",
      "lang": "en",
      "name": "dateAdded",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.site.dateAdded),
      callback: function($$v) {
        _vm.$set(_vm.site, "dateAdded", $$v)
      },
      expression: "site.dateAdded"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateAdded",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Commissioning date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Commissioning date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.latitude),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "latitude"
    }
  }, [_vm._v("Latitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.latitude),
      expression: "site.latitude",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "\\d{2,}(\\.\\d+)?",
      "name": "latitude",
      "required": "",
      "placeholder": "Latitude"
    },
    domProps: {
      "value": (_vm.site.latitude)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "latitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "latitude",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Latitude is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Latitude is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.longitude),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "longitude"
    }
  }, [_vm._v("Longitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.longitude),
      expression: "site.longitude",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "\\d{2,}(\\.\\d+)?",
      "name": "longitude",
      "required": "",
      "placeholder": "Longitude"
    },
    domProps: {
      "value": (_vm.site.longitude)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "longitude", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "longitude",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Longitude is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Longitude is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.address),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.address),
      expression: "site.address",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "maxlength": _vm.maxAddress,
      "required": "",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.site.address)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "address",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Address is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Address is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                      Maximum length is 150 characters\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.siteInfoImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location Image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "siteInfoImage"
    },
    on: {
      "change": _vm.onFilechanged
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.supervisor),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.supervisor),
      expression: "site.supervisor"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "supervisor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "supervisor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select GA Head")]), _vm._v(" "), _vm._l((_vm.ga_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "supervisor",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("GA Head is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dispenserCount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Dispenser Count")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.dispenserCount),
      expression: "site.dispenserCount",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "25",
      "name": "dispenserCount",
      "placeholder": "Dispenser Count"
    },
    domProps: {
      "value": (_vm.site.dispenserCount)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "dispenserCount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dispenserCount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Dispenser Count is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum Dispenser can be 25")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(this.site.siteType == 'DBS' || this.site.siteType == 'DS') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.defaultMS),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Mother Station")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.defaultMS),
      expression: "site.defaultMS"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "defaultMS"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.site, "defaultMS", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.mother_station_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "defaultMS",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Location Type is a required field\n                    ")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Dealer Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Customer Owner Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.site.ownerName),
      expression: "site.ownerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": _vm.max,
      "required": "",
      "name": "ownerName",
      "placeholder": "Owner Name"
    },
    domProps: {
      "value": (_vm.site.ownerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.site, "ownerName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Owner Name is a required field\n                      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                        Owner Name should not be more than 20 characters\n                      ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerMobile),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerMobile),
      expression: "site.ownerMobile",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "ownerMobile",
      "minlength": "3",
      "name": "ownerMobile",
      "required": "",
      "placeholder": "Owner Mobile"
    },
    domProps: {
      "value": (_vm.site.ownerMobile)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "ownerMobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerMobile",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Owner mobile is a required field\n                      ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerEmail),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Owner Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerEmail),
      expression: "site.ownerEmail",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "minlength": "3",
      "name": "ownerEmail",
      "required": "",
      "placeholder": "Owner Email"
    },
    domProps: {
      "value": (_vm.site.ownerEmail)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "ownerEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerEmail",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Owner Email is a required field\n                      ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerAddress),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.site.ownerAddress),
      expression: "site.ownerAddress",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "ownerAddress",
      "minlength": "3",
      "name": "ownerAddress",
      "required": "",
      "placeholder": "Owner Address"
    },
    domProps: {
      "value": (_vm.site.ownerAddress)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.site, "ownerAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerAddress",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                        Owner Address is a required field\n                      ")])])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sites'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n                USER_ROLES.ADMIN,\n                USER_ROLES.SUPER_ADMIN,\n                USER_ROLES.GA_HEAD,\n                USER_ROLES.JOURNEY_MANAGER,\n              ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "mr-2 btn gradientbt ",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty) && !(_vm.photoSiteInfoImae)
    },
    on: {
      "click": _vm.updateSite
    }
  }, [_vm._v("\n              Update Location\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2011:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-snotify'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2012:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p",
    style: ({
      textAlign: '-webkit-center'
    })
  }, [_c('h1', [_vm._v("HASHBULLS ALGOTRADE PLATFORM")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (_vm.accountActive) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login/forgot"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('a', [_vm._v("Forgot password?")])])])], 1)]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.accountActive && !_vm.emailSent) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "ui form",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendActivationEmail($event)
      }
    }
  }, [_c('validate', {
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('vue-form-input', {
    staticClass: "input-group",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'email',
      "name": 'email',
      "placeholder": 'Email',
      "messages": {
        required: 'This field is required',
        email: 'Please input a valid email'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$invalid
    }
  }, [_vm._v("Send Activation Email")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.accountActive && _vm.emailSent) ? _c('div', {
    staticClass: "content-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Proceed to Login")])])], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  })])
}]}

/***/ }),

/***/ 2013:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 2014:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', [_vm._v("Geographic Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.region),
      expression: "salesdata.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.fiteredResult($event, 'region')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "id": "region"
      },
      domProps: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.site),
      expression: "salesdata.site"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "site"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "site", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.fiteredResult($event, 'site')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.site_list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "id": "site"
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.siteName))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', [_vm._v("On")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": function($event) {
        return _vm.fiteredResult($event, 'startDate')
      }
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "margin-top": "23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'salesdataCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn addbtn"
  }, [_vm._v("Add New")])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-server-table', {
    ref: "salesdataTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 2015:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.REPORT_STAFF, _vm.USER_ROLES.SALES_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF,USER_ROLES.SALES_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.REPORT_STAFF]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.REPORT_STAFF]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ReportScheduleCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Schedule New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "schedulereportTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 2016:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, [_c('div', {
    staticClass: "sidebar-menu"
  }, [(this.user1.roleName == 'Super Admin') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n      Masters")]) : _vm._e(), _vm._v(" "), (this.user1.roleName == 'Super Admin') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/users"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Users")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 2017:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [(_vm.updateRequiredMessage) ? _c('div', {
    staticClass: "flash-message text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-info'
  }, [_vm._v(_vm._s(_vm.updateRequiredMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: _vm.detailsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    class: _vm.settingsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#settings"
    }
  }, [_vm._v("Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in",
    class: _vm.detailsActive,
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'First Name:',
      "name": 'firstName',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.newProfile.firstName),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "firstName", $$v)
      },
      expression: "newProfile.firstName"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Last Name:',
      "name": 'lastName',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.newProfile.lastName),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "lastName", $$v)
      },
      expression: "newProfile.lastName"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator,
        notUnique: _vm.emailUniqueValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'email',
      "label": 'Email:',
      "name": 'email',
      "messages": {
        email: 'Please input a valid email',
        required: 'This field is required',
        notUnique: 'That email is already in use.'
      }
    },
    model: {
      value: (_vm.newProfile.email),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "email", $$v)
      },
      expression: "newProfile.email"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.title),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Title:',
      "placeholder": 'Ex: Central Marketing Developer',
      "name": 'title',
      "messages": {}
    },
    model: {
      value: (_vm.newProfile.title),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "title", $$v)
      },
      expression: "newProfile.title"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.location),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Location:',
      "placeholder": 'City, State, Country',
      "name": 'location',
      "messages": {}
    },
    model: {
      value: (_vm.newProfile.location),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "location", $$v)
      },
      expression: "newProfile.location"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.education),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Education:',
      "placeholder": 'Ex: B.S. in Computer Science from the University of Tennessee at Knoxville',
      "name": 'education',
      "messages": {}
    },
    model: {
      value: (_vm.newProfile.education),
      callback: function($$v) {
        _vm.$set(_vm.newProfile, "education", $$v)
      },
      expression: "newProfile.education"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("Bio:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProfile.bio),
      expression: "newProfile.bio"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "placeholder": "Ex: I'm an amazingly interesting person!"
    },
    domProps: {
      "value": (_vm.newProfile.bio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProfile, "bio", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$dirty || _vm.formstate.$invalid
    },
    on: {
      "click": _vm.updateProfile
    }
  }, [_vm._v("Update Profile")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteUserModal
    }
  }, [_vm._v("Delete Account")])]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    class: _vm.settingsActive,
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.passwordFormstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updatePassword($event)
      }
    }
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.passwordFormstate.newPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notStrong: _vm.passwordScoreValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "passwordFormstate": _vm.passwordFormstate,
      "type": 'password',
      "label": 'New Password:',
      "name": 'newPassword',
      "placeholder": 'Please enter your new password.',
      "messages": {
        required: 'This field is required',
        notStrong: 'Password not strong enough'
      }
    },
    on: {
      "input": _vm.validateConfirm
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.passwordFormstate.confirmPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notMatch: _vm.passwordConfirmValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "passwordFormstate": _vm.passwordFormstate,
      "type": 'password',
      "label": 'Confirm Password:',
      "name": 'confirmPassword',
      "placeholder": 'Please confirm your password.',
      "messages": {
        required: 'This field is required',
        notMatch: 'Passwords do not match'
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.passwordFormstate.$dirty || _vm.passwordFormstate.$invalid || _vm.passwordScoreUpdating
    }
  }, [_vm._v("Update Password")])])], 1)], 1)])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2018:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: _vm.addButtonClass
  }, [_c('button', {
    staticClass: "btn btn-primary glyphicon glyphicon-refresh",
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "value": "Refresh Page"
    },
    on: {
      "click": _vm.refresh
    }
  })]), _vm._v(" "), _c('div', [_c('v-server-table', {
    ref: "triplocationTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Trip Details")])])
}]}

/***/ }),

/***/ 2019:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 2020:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),

/***/ 2021:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "name": "demo2",
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 2022:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('gmap-map', {
    ref: "mymap",
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "center": _vm.startLocation,
      "zoom": 15
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoPosition,
      "opened": _vm.infoOpened
    },
    on: {
      "closeclick": function($event) {
        _vm.infoOpened = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.infoContent) + "\n            ")]), _vm._v(" "), _vm._l((_vm.coordinates), function(item, key) {
    return _c('gmap-marker', {
      key: key,
      attrs: {
        "position": _vm.getPosition(item),
        "clickable": true
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfo(item, key)
        }
      }
    })
  })], 2)], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tableBox"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 clear_button"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export Vehicles Status")])]), _vm._v(" "), _c('v-server-table', {
    ref: "livedetailsTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "map",
      fn: function(props) {
        return [_c('div', [_c('button', {
          staticClass: "btn gradientbt",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#exampleModal"
          },
          on: {
            "click": function($event) {
              return _vm.getstartLocation(props.row)
            }
          }
        }, [_vm._v("\n              Show Map\n            ")])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),

/***/ 2023:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.vehicleId),
      expression: "trip.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getDeviceName]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDeviceDisable,
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                \\\n                "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "journeyManager"
    }
  }, [_vm._v("\n                  Drivers\n                ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "drivers",
      "multiple": "",
      "options": this.driver_name,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.trip.drivers),
      callback: function($$v) {
        _vm.$set(_vm.trip, "drivers", $$v)
      },
      expression: "trip.drivers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "required": "",
      "lang": "en",
      "name": "scheduleDate",
      "not-before": _vm.disabledBefore,
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduledTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduledTime",
      "required": ""
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduledTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Time is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index,
      staticClass: "input wrapper flex items-center"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [_c('label', [_vm._v("Stop " + _vm._s(index + 1))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.locationId),
        expression: "input.locationId"
      }],
      staticClass: "form-control",
      attrs: {
        "required": "",
        "name": "locationsArray"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(input, "locationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleChange($event, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.locationList), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": item._id
        }
      }, [_vm._v("\n                        " + _vm._s(item.siteName) + "\n                      ")])
    })], 2), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                        HCV Operation Manager is a required field\n                      ")])])], 1), _vm._v(" "), _c('svg', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === (_vm.locations.length) - 1),
        expression: "index === (locations.length) -1"
      }],
      staticClass: "ml-2 cursor-pointer",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.addField(input, _vm.locations)
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "green",
        "d": "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      }
    })]), _vm._v(" "), _c('svg', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.locations.length > 2),
        expression: "locations.length > 2"
      }],
      staticClass: "ml-2 cursor-pointer",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index, _vm.locations)
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "#EC4899",
        "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
      }
    })])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.regionManager),
      expression: "trip.regionManager"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isGAHeadDisable,
      "required": "",
      "name": "regionManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "regionManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select HCV Operation Manager")]), _vm._v(" "), _vm._l((_vm.region_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.journeyManager),
      expression: "trip.journeyManager"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isJourenyManagerDisable,
      "required": "",
      "name": "journeyManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "journeyManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Jouney Manager")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Journey Manager is a required field\n                    ")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Trip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formstate.$valid
    },
    on: {
      "click": _vm.createTrip
    }
  }, [_vm._v("\n              Add Trip\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2024:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n]",
      modifiers: {
        "if": true
      }
    }]
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteDriverModal
    }
  }, [_vm._v("\n              Delete Driver\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.region),
      expression: "driver.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Geographical Area is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverName),
      expression: "driver.driverName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "minlength": "3",
      "maxlength": "20",
      "name": "driverName",
      "required": "",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.driver.driverName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "driverName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver name is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Driver Name is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Driver name should be more than 3 characters\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("\n                      Driver name should be less than 20 characters\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverLastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverLastName),
      expression: "driver.driverLastName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "driverLastName",
      "required": "",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.driver.driverLastName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "driverLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverLastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Last Name is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobileNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.mobileNumber),
      expression: "driver.mobileNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "min": "1000000000",
      "name": "mobileNumber",
      "required": "",
      "placeholder": "Mobile number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.driver.mobileNumber)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "mobileNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobileNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Mobile number is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Mobile number is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.status),
      expression: "driver.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateOfBirth),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "max": this.minDate,
      "id": "dateOfBirth",
      "required": "",
      "lang": "en",
      "name": "dateOfBirth",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": _vm.getEligibleDate
    },
    model: {
      value: (_vm.driver.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.driver, "dateOfBirth", $$v)
      },
      expression: "driver.dateOfBirth"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateOfBirth",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Date of Birth is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Minimum age is 18 years")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverPin),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Pin")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.driverPin),
      expression: "driver.driverPin",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "name": "driverPin",
      "required": "",
      "placeholder": "Driver Pin"
    },
    domProps: {
      "value": (_vm.driver.driverPin)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "driverPin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverPin",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver pin is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Driver pin is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Driver pin is minimum 4 digit")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Driver pin is Maximum 4 digit")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lisenceNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("License No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.lisenceNumber),
      expression: "driver.lisenceNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "lisenceNumber",
      "required": "",
      "placeholder": "License No"
    },
    domProps: {
      "value": (_vm.driver.lisenceNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.driver, "lisenceNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lisenceNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("License no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("License no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of license no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("License Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "licenseExpiryDate",
      "lang": "en",
      "name": "licenseExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": _vm.highlight
    },
    model: {
      value: (_vm.driver.licenseExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "licenseExpiryDate", $$v)
      },
      expression: "driver.licenseExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "licenseExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      License Expiry Date is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.DDTNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("DDT Certificate No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.DDTNumber),
      expression: "driver.DDTNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "DDTNumber",
      "required": "",
      "placeholder": "DDT Number No"
    },
    domProps: {
      "value": (_vm.driver.DDTNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.driver, "DDTNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "DDTNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("DDT no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("DDT no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of license no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("DDT Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "ddtExpiryDate",
      "lang": "en",
      "name": "ddtExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.driver.ddtExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "ddtExpiryDate", $$v)
      },
      expression: "driver.ddtExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ddtExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      DDT Expiry Date is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.hazNumber),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HAZ Goods carrige Certificate No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.hazNumber),
      expression: "driver.hazNumber",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "minlength": "10",
      "name": "hazNumber",
      "required": "",
      "placeholder": "DDT Number No"
    },
    domProps: {
      "value": (_vm.driver.hazNumber)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        return _vm.$set(_vm.driver, "hazNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "hazNumber",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("HAZ no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("HAZ no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of license no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("HAZ Expiry Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "hazExpiryDate",
      "lang": "en",
      "name": "hazExpiryDate",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.driver.hazExpiryDate),
      callback: function($$v) {
        _vm.$set(_vm.driver, "hazExpiryDate", $$v)
      },
      expression: "driver.hazExpiryDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "hazExpiryDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HAZ Expiry Date is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.languageKnown),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Language Known")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.languageKnown),
      expression: "driver.languageKnown"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "languageKnown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "languageKnown", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "languageKnown",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Language is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group ",
    class: _vm.fieldClassName(_vm.formstate.defaultLanguage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Default Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.defaultLanguage),
      expression: "driver.defaultLanguage"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "defaultLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.driver, "defaultLanguage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Language")]), _vm._v(" "), _vm._l((_vm.language), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group ",
    class: _vm.fieldClassName(_vm.formstate.driverImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Photo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg",
      "id": "fileinput",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Please upload less than 3mb picture\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group ",
    class: _vm.fieldClassName(_vm.formstate.documents),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Other Document")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "id": "fileinput1",
      "name": "otherInfo",
      "multiple": ""
    },
    on: {
      "change": _vm.onDocumentchanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "otherInfo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Please upload less than 3mb document\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.addressDetails)
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.addressDetails),
      expression: "driver.addressDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "addressDetails",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.driver.addressDetails)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "addressDetails", $event.target.value)
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Driver'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n  USER_ROLES.ADMIN,\n  USER_ROLES.SUPER_ADMIN,\n  USER_ROLES.GA_HEAD,\n  USER_ROLES.JOURNEY_MANAGER,\n]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(
        _vm.formstate.$dirty &&
        _vm.formstate.$invalid
      ) && !(_vm.formstatePhoto || _vm.formstateDocument)
    },
    on: {
      "click": _vm.updateDriver
    }
  }, [_vm._v("\n              Update Driver\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2025:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteVehicleModal
    }
  }, [_vm._v("Delete\n                            Vehicle")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.region),
      expression: "vehicle.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regNo),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Registration No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.regNo),
      expression: "vehicle.regNo",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "name": "regNo",
      "required": "",
      "placeholder": "Registration No",
      "readonly": true
    },
    domProps: {
      "value": (_vm.vehicle.regNo)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "regNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regNo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Registration no is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Registration no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("Minimum length of registration no is 10 character")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.capacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Capacity (WL)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.capacity),
      expression: "vehicle.capacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "100",
      "max": "30000",
      "name": "capacity",
      "required": "",
      "placeholder": "Capacity"
    },
    domProps: {
      "value": (_vm.vehicle.capacity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "capacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "capacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Capacity is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Minimum 100 kg Capacity")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum 30000 kg Capacity")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cylinders),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Cascade Capacity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.cylinders),
      expression: "vehicle.cylinders",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "cylinders",
      "required": "",
      "placeholder": "Cylinders"
    },
    domProps: {
      "value": (_vm.vehicle.cylinders)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "cylinders", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cylinders",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(" No. Of Cylinders is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateCommissioning),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Date of Commissioning")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateCommissioning",
      "lang": "en",
      "name": "dateCommissioning",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.dateCommissioning),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "dateCommissioning", $$v)
      },
      expression: "vehicle.dateCommissioning"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateCommissioning",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date of Commissioning is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Date of Commissioning is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerName),
      expression: "vehicle.ownerName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ownerName",
      "required": "",
      "placeholder": "Transporter Name"
    },
    domProps: {
      "value": (_vm.vehicle.ownerName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "ownerName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Transporter name is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerContact),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transporter Contact No.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerContact),
      expression: "vehicle.ownerContact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ownerContact",
      "required": "",
      "placeholder": "Transporter contact number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.vehicle.ownerContact)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "ownerContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerContact",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Transporter contact no. is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Transporter contact no. is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.deviceId),
      expression: "vehicle.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportSupervisorName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Supervisor Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.transportSupervisorName),
      expression: "vehicle.transportSupervisorName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "transportSupervisorName",
      "required": "",
      "placeholder": "Transport Supervisor Name"
    },
    domProps: {
      "value": (_vm.vehicle.transportSupervisorName)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "transportSupervisorName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportSupervisorName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Supervisor Name is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportSupervisorContact),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Supervisor Contact")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.transportSupervisorContact),
      expression: "vehicle.transportSupervisorContact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "transportSupervisorContact",
      "required": "",
      "placeholder": "Transport Supervisor Contact",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.vehicle.transportSupervisorContact)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "transportSupervisorContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportSupervisorContact",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Supervisor Contact is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v(" Supervisor Contact no. is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.ownerDetails)
  }, [_c('label', [_vm._v("Transporter Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerDetails),
      expression: "vehicle.ownerDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ownerDetails",
      "placeholder": "Other Info"
    },
    domProps: {
      "value": (_vm.vehicle.ownerDetails)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.vehicle, "ownerDetails", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("RC validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "rcValidity",
      "lang": "en",
      "name": "rcValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.rcValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "rcValidity", $$v)
      },
      expression: "vehicle.rcValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "rcValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("RC validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group ",
    class: _vm.fieldClassName(_vm.formstate.rcDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("RC Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput1",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged1
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Insurance Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "insuranceValidity",
      "lang": "en",
      "name": "insuranceValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.insuranceValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "insuranceValidity", $$v)
      },
      expression: "vehicle.insuranceValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "insuranceValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Insurance Validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.insuranceDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Insurance Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput2",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged2
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("PUC validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "pucValidity",
      "lang": "en",
      "name": "pucValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.pucValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "pucValidity", $$v)
      },
      expression: "vehicle.pucValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "pucValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("PUC validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.pucDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("PUC Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput3",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged3
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Fitness Certificate Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "fitCertValidity",
      "lang": "en",
      "name": "fitCertValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.fitCertValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "fitCertValidity", $$v)
      },
      expression: "vehicle.fitCertValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "fitCertValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Fitness Certificate Validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.fitCertDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Fitnness Certificate Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput4",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged4
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "licenseExpiryDiv"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Goods Carriage permit validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "gcpValidity",
      "lang": "en",
      "name": "gcpValidity",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.gcpValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "gcpValidity", $$v)
      },
      expression: "vehicle.gcpValidity"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "gcpValidity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Goods Carriage permit validity is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.gcpDoc),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Goods Carriage permit Doc")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput5",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged5
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.hCVCommissioningCumAuditReport),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" HCV Commissioning cum Audit Report")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput6",
      "accept": "image/jpeg,image/jpg,application/pdf",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged6
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vehicleImage),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v(" Vehicle images")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileinput7",
      "accept": "image/jpeg,image/jpg",
      "required": ""
    },
    on: {
      "change": _vm.onFilechanged7
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "photo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.status),
      expression: "vehicle.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "mt"
  }, [_c('validate', {
    staticClass: "form-group inline",
    class: _vm.fieldClassName(_vm.formstate.cgpsMonitoring)
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.camera),
      expression: "vehicle.camera",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "value": "false",
      "name": "camera"
    },
    domProps: {
      "checked": _vm.vehicle.camera,
      "checked": Array.isArray(_vm.vehicle.camera) ? _vm._i(_vm.vehicle.camera, "false") > -1 : (_vm.vehicle.camera)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vehicle.camera,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "false",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.vehicle, "camera", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.vehicle, "camera", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.vehicle, "camera", $$c)
        }
      }
    }
  }), _vm._v("Camera")])]), _vm._v(" "), _c('validate', {
    staticClass: "form-group inline",
    class: _vm.fieldClassName(_vm.formstate.camera)
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.cgpsMonitoring),
      expression: "vehicle.cgpsMonitoring",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "value": "false",
      "name": "cgpsMonitoring"
    },
    domProps: {
      "checked": _vm.vehicle.cgpsMonitoring,
      "checked": Array.isArray(_vm.vehicle.cgpsMonitoring) ? _vm._i(_vm.vehicle.cgpsMonitoring, "false") > -1 : (_vm.vehicle.cgpsMonitoring)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vehicle.cgpsMonitoring,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "false",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.vehicle, "cgpsMonitoring", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.vehicle, "cgpsMonitoring", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.vehicle, "cgpsMonitoring", $$c)
        }
      }
    }
  }), _vm._v("GPS Monitoring")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Vehicle'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid) && !(_vm.docsValid1 || _vm.docsValid2 || _vm.docsValid3 || _vm.docsValid4 || _vm.docsValid5 || _vm.docsValid6 || _vm.docsValid7)
    },
    on: {
      "click": _vm.updateVehicle
    }
  }, [_vm._v("Update\n                            Vehicle")])], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2141:
/***/ (function(module, exports) {

module.exports = {"_args":[["weekstart@1.1.0","/root/stock-bot/frontend"]],"_from":"weekstart@1.1.0","_id":"weekstart@1.1.0","_inBundle":false,"_integrity":"sha512-ZO3I7c7J9nwGN1PZKZeBYAsuwWEsCOZi5T68cQoVNYrzrpp5Br0Bgi0OF4l8kH/Ez7nKfxa5mSsXjsgris3+qg==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"weekstart@1.1.0","name":"weekstart","escapedName":"weekstart","rawSpec":"1.1.0","saveSpec":null,"fetchSpec":"1.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.1.0.tgz","_spec":"1.1.0","_where":"/root/stock-bot/frontend","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.1.0"}

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_service__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__auth_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interceptor_service__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__auth_interceptor_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_service__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__event_bus_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__file_service__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_3__file_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_service__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__form_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__http_client_service__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__http_client_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ws_client_service__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__ws_client_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_service__ = __webpack_require__(551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__user_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chat_service__ = __webpack_require__(530);
/* unused harmony reexport chatService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__role_service__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__role_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__device_service__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__device_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__region_service__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_11__region_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vehicle_service__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__vehicle_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driver_service__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_13__driver_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__site_service__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_14__site_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__trip_service__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_15__trip_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tripRoute_service__ = __webpack_require__(550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__tripRoute_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__salesdata_service__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_17__salesdata_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tripException_service__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_18__tripException_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reportgeneration_service__ = __webpack_require__(542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_19__reportgeneration_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__firebase_service__ = __webpack_require__(537);
/* unused harmony reexport firebaseService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__schedulereport_service__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_21__schedulereport_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__technician_service__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_22__technician_service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__filter_service__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__filter_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__filter_service__);
/* unused harmony reexport filterService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__export_service__ = __webpack_require__(534);
/* unused harmony reexport exportService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__investment_service__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_25__investment_service__["a"]; });



























/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1955),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1993),
  /* scopeId */
  "data-v-640e7486",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1954),
  /* scopeId */
  "data-v-1d316516",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(2023),
  /* scopeId */
  "data-v-f29b210a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(2021),
  /* scopeId */
  "data-v-e960660a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(2007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1958),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_generate_mutations__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_auth__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutations__ = __webpack_require__(556);













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_6__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_8__mutations__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utilities_generate_mutations__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__state__["a" /* default */])),
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_5__modules_auth__["a" /* default */]
  },
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__["a" /* default */])()]
}));

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);



var internals = {};

internals.bind = function (el, binding, vnode) {
	var userScope = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.auth.scope;
	var permissions = binding.value;

	var forbidden = !!permissions.filter(function (permission) {
		return userScope.indexOf('-' + permission) > -1;
	})[0];

	var requiredPermissions = permissions.filter(function (permission) {
		return permission[0] === '+';
	});

	var hasRequired = true;
	if (requiredPermissions[0]) {
		hasRequired = !!userScope.filter(function (scope) {
			return requiredPermissions.indexOf('+' + scope) > -1;
		})[0];
	}

	var hasPermission = !!userScope.filter(function (scope) {
		return permissions.indexOf(scope) > -1;
	})[0];

	if (userScope.indexOf('root') > -1) {
		hasPermission = true;
		forbidden = false;
		hasRequired = true;
	}

	if (!hasPermission || !hasRequired || forbidden) {
		if (binding.modifiers.enable) {
			el.disabled = true;
			el.style.position = 'relative';

			var TooltipComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend({
				template: '<span v-tooltip="\'Need Permissions\'" style="position: absolute; top: 0px; bottom: 0px; right: 0px; left: 0px;"></span>'
			});

			var tooltipComponent = new TooltipComponent().$mount();
			el.appendChild(tooltipComponent.$el);
		} else {
			var comment = document.createComment(' ');
			Object.defineProperty(comment, 'setAttribute', {
				value: function value() {
					return undefined;
				}
			});
			vnode.elm = comment;
			vnode.text = ' ';
			vnode.isComment = true;
			vnode.context = undefined;
			vnode.tag = undefined;
			vnode.data.directives = undefined;

			if (vnode.componentInstance) {
				vnode.componentInstance.$el = comment;
			}

			console.log("comment", comment);
			if (el.parentNode) {
				el.parentNode.replaceChild(comment, el);
			}
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
/* harmony export (immutable) */ __webpack_exports__["e"] = shortMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = userList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var urlParser = document.createElement('a');

function domain(url) {
	urlParser.href = url;
	return urlParser.hostname;
}

function count(arr) {
	return arr.length;
}

function prettyDate(date) {
	var a = new Date(date);
	return a.toDateString();
}

function pluralize(time, label) {
	if (time === 1) {
		return time + label;
	}

	return time + label + 's';
}

function shortMessage(message, length) {
	if (message && message.length > (length || 40)) {
		message = message.slice(0, length || 40);
		message = message + '...';
	}
	return message;
}

function userList(users) {
	var list = '';
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var user = _step.value;

			if (list === '') {
				list = list + user.firstName;
			} else {
				list = list + ', ' + user.firstName;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return list;
}

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__restful_resource_utility__ = __webpack_require__(505);




var RestHapiRepository = {
  install: function install(Vue, _ref) {
    var httpClient = _ref.httpClient,
        resources = _ref.resources,
        log = _ref.log;

    httpClient = httpClient || __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

    var fakeLogger = {
      log: function log() {},
      debug: function debug() {},
      error: function error() {}
    };

    var logger = log ? console : fakeLogger;

    var resourceHelper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__restful_resource_utility__["a" /* default */])(httpClient, logger);
    for (var resourceName in resources) {
      var resource = resources[resourceName];
      var resourceRoute = resource.alias || resourceName;
      var repoCalls = resourceHelper.generateCrudCallers(resourceRoute, resource.options);
      var associations = resource.associations;

      for (var associationName in associations) {
        var association = associations[associationName];
        var associationRoute = association.alias || associationName;
        repoCalls = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, repoCalls, resourceHelper.generateAssociationCallers(resourceRoute, associationName, associationRoute, association.options));
      }

      var repoName = '$' + resourceName + 'Repository';
      Vue.prototype[repoName] = repoCalls;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (RestHapiRepository);

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_404_vue__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_login_Login_vue__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_login_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_login_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_login_ForgotPassword_vue__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_login_ForgotPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_login_ForgotPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_login_ResetPassword_vue__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_login_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_login_ResetPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_route__ = __webpack_require__(512);








var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__main_route__["a" /* default */]), [{
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_login_Login_vue___default.a,
    name: 'Login',
    meta: { requiresUnauth: true }
}, {
    path: '/login/forgot',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_login_ForgotPassword_vue___default.a,
    name: 'ForgotPassword',
    meta: { requiresUnauth: true }
}, {
    path: '/login/reset',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_login_ResetPassword_vue___default.a,
    name: 'ResetPassword'
}, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_1__components_404_vue___default.a
}]);

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(2011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1951),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(2125)));

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(2127)));

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(2128)));

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(2133)));

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {

      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Box',
  props: ['disableHeader', 'disableBody', 'disableFooter', 'canCollapse', 'canClose', 'classes', 'noPadding', 'headerBorder'],
  data: function data() {
    return {
      collapsed: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    collapse: function collapse() {
      this.collapsed = true;
      $(this.$refs.body).slideToggle(500);
      $(this.$refs.footer).slideToggle(500);
    },
    expand: function expand() {
      this.collapsed = false;
      $(this.$refs.body).slideToggle(500);
      $(this.$refs.footer).slideToggle(500);
    },
    close: function close() {
      $(this.$refs.box).slideToggle(500);
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Notification',
  props: [],
  data: function data() {
    return {
      ready: false,
      currentUser: null,
      notifications: []
    };
  },

  computed: {},
  methods: {
    displayName: function displayName(notification) {
      console.log("DISPLAY MESSAGE:", notification);
      return notification.user.firstName + ' ' + notification.user.lastName;
    },
    userProfile: function userProfile(notification) {
      return notification.user.profileImageUrl;
    },
    markNotification: function markNotification(notification, hasRead) {
      console.log("MARKING:", notification, hasRead);
      notification.hasRead = hasRead;
      this.$store.commit('SET_NOTIFICATIONS', this.notifications);

      var promise = hasRead ? this.markAsRead(notification) : this.markAsUnread(notification);
      return promise;
    },
    markAsRead: function markAsRead(notification) {
      var _this = this;

      return this.$notificationRepository.update(notification._id, { hasRead: true }).catch(function (error) {
        console.error('Notification.markAsRead-error:', error);
        _this.$snotify.error('Mark as read failed', 'Error!');
      });
    },
    markAsUnread: function markAsUnread(notification) {
      var _this2 = this;

      return this.$notificationRepository.update(notification._id, { hasRead: false }).catch(function (error) {
        console.error('Notification.markAsRead-error:', error);
        _this2.$snotify.error('Mark as unread failed', 'Error!');
      });
    },
    notificationRecieved: function notificationRecieved(notification, flags) {
      this.formatNotification(notification);
      this.notifications.unshift(notification);
      this.$store.commit('SET_NOTIFICATIONS', this.notifications);
    },
    formatNotification: function formatNotification(notification) {
      switch (notification.type) {
        case __WEBPACK_IMPORTED_MODULE_3__config__["j" /* NOTIFICATION_TYPES */].SHARED_DOCUMENT:
          notification.message = notification.actingUser.firstName + ' ' + notification.actingUser.lastName + ' has shared a document with you.';
          break;
        case __WEBPACK_IMPORTED_MODULE_3__config__["j" /* NOTIFICATION_TYPES */].FOLLOW:
          notification.message = notification.actingUser.firstName + ' ' + notification.actingUser.lastName + ' is following you.';
          break;
        case __WEBPACK_IMPORTED_MODULE_3__config__["j" /* NOTIFICATION_TYPES */].CONTACT:
          notification.message = notification.actingUser.firstName + ' ' + notification.actingUser.lastName + ' is now a contact.';
          break;
        default:
          break;
      }
    },
    formatAllNotifications: function formatAllNotifications() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.notifications), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var notification = _step.value;

          this.formatNotification(notification);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    goToProfile: function goToProfile(user) {
      this.$router.push({ name: 'MemberProfile', params: { _id: user._id }, props: user });
    }
  },
  created: function created() {
    var _this3 = this;

    this.currentUser = this.$store.state.auth.user;
    var promises = [];

    promises.push(this.$userRepository.getNotifications(this.currentUser._id, { $embed: ['actingUser'], $sort: ['-createdAt'] }));

    __WEBPACK_IMPORTED_MODULE_2__services__["b" /* wsClient */].subscribe('/notification/' + this.currentUser._id, this.notificationRecieved);

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (response) {
      _this3.notifications = response[0].data.docs;
      _this3.formatAllNotifications();
      _this3.$store.commit('SET_NOTIFICATIONS', _this3.notifications);
      _this3.ready = true;
    });
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].MARK_NOTIFICATION_AS_READ, function (notification) {
      _this3.markNotification(notification, true);
    });
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].MARK_NOTIFICATION_AS_UNREAD, function (notification) {
      _this3.markNotification(notification, false);
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].MARK_NOTIFICATION_AS_READ);
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].MARK_NOTIFICATION_AS_UNREAD);
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['value', 'mask', 'formstate', 'type', 'name', 'placeholder', 'label', 'messages'],
	data: function data() {
		return {
			password: '',
			passwordScore: 0,
			suggestions: [],
			maskedInput: ''
		};
	},

	methods: {
		updateScore: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (password, userInputs) {
			var _this = this;

			this.$emit('input', password);
			__WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].UPDATING_PASSWORD_SCORE);
			__WEBPACK_IMPORTED_MODULE_0__services__["k" /* userService */].checkPassword(password, userInputs).then(function (result) {
				_this.passwordScore = result.data.score;
				_this.suggestions = result.data.suggestions;
				__WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].PASSWORD_SCORE_UPDATED, _this.passwordScore);
			});
		}, 250)
	}
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_querystring__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services___ = __webpack_require__(3);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HcvStatus',
  data: function data() {
    var _this = this;

    return {
      formstate: {},
      regions: [],
      motherStationOptions: [],
      pageNumber: null,
      motherStationDetails: {},
      startLocation: {
        lat: '',
        lng: ''
      },
      mapMarkers: {},
      coordinates: {},
      siteData: null,
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      stationeryGas: '',
      infoOptions: {},
      tripException: {
        prevDestination: '',
        docId: ''
      },
      isAreaTable: false,
      pixelOffset: {
        width: 0,
        height: -35
      },
      timer: '',
      hcvdetails: {},
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      loading: null,
      hcvdetailsTable: null,
      columns: ['regionName', 'siteName', 'scadaValue', 'hcvDetail', 'HCVGasAvailable', 'cascadeGas', 'total', 'livedetail', 'onGoingHCV', 'averageSalesValue', 'motherStation', 'timeTaken', 'Trigger_HCV', 'livedetailHCV', 'salesData'],
      options: {
        highlightMatches: true,
        sortable: ['scadaValue', 'HCVGasAvailable'],
        headings: {
          regionName: 'GA',
          siteName: 'Station',
          scadaValue: 'Suction Pressure (Bar)',
          status: 'HCV Availability',
          hcvDetail: 'HCV Connected',
          HCVGasAvailable: 'Gas Stock - HCV (Kg)',
          cascadeGas: 'Gas Stock - Station (Kg)',
          total: 'Total Stock (Kg)',
          onGoingHCV: 'HCV in Transit',
          averageSalesValue: 'Expected Sale Time (Hr)',
          motherStation: 'Mother Station',
          livedetail: 'Available HCV',
          livedetailHCV: 'HCV at MS',
          Trigger_HCV: 'Trigger HCV when C<D',
          timeTaken: 'Travel Time (Hr)',
          recordedTime: 'Refresh Time',
          recordedTimeSales: 'Refresh Time Sales',
          salesData: 'Sales Value'

        },
        templates: {
          status: function status(row, query) {
            if (query.livedetails) {
              if (query.livedetails.description == 'Decanting') {
                return 'Yes';
              } else {
                return 'No';
              }
            } else {
              return 'No';
            }
          },
          hcvDetail: function hcvDetail(row, query) {
            if (query.livedetails) {
              if (query.livedetails.description == 'Decanting') {
                return query.hcvDetail;
              } else {
                return '--';
              }
            } else {
              return '--';
            }
          },
          scadaValue: function scadaValue(row, query) {
            if (query.scadaValue) {
              var val = query.scadaValue;
              return val;
            } else {
              return '--';
            }
          },
          HCVGasAvailable: function HCVGasAvailable(row, query) {
            if (query.livedetails) {
              if (query.livedetails.description == 'Decanting') {
                if (query.HCVGasAvailability && !isNaN(query.HCVGasAvailability)) {
                  var HCVGas = query.HCVGasAvailability;
                  return HCVGas;
                } else {
                  return '--';
                }
              } else {
                return '--';
              }
            } else {
              return '--';
            }
          },
          cascadeGas: function cascadeGas(row, query) {
            this.stationeryGas = null;
            if (query.scadaValue && query.livedetails && query.livedetails.description !== 'Decanting') {
              this.stationeryGas = query.cascadeGasCapacity / 1.25 * (query.scadaValue - 40) / 1000 * (1.225 * 0.5813);
              return this.stationeryGas.toFixed(0);
            } else if (query.hcvDetail && query.scadaValue && query.livedetails.description == 'Decanting') {
              this.stationeryGas = query.cascadeGasCapacity / 1.25 * 140 / 1000 * (1.225 * 0.5813);
              return this.stationeryGas.toFixed(0);
            } else {
              return '--';
            }
          },
          total: function total(row, query) {
            if (query.HCVGasAvailability && this.stationeryGas) {
              var totalGasInventory = query.HCVGasAvailability + this.stationeryGas;
              return totalGasInventory.toFixed(0);
            } else if (this.stationeryGas !== null) {
              return this.stationeryGas.toFixed(0);
            } else {
              return '--';
            }
          },
          livedetail: function livedetail(row, query) {
            if (query.hCVAtDBS && query.hCVAtDBS.length > 0) {
              var hcvAtDaughterStation = [];
              query.hCVAtDBS.forEach(function (element) {
                hcvAtDaughterStation.push(element.vehicleNumber);
              });
              return hcvAtDaughterStation.join();
            } else {
              return '--';
            }
          },
          livedetailHCV: function livedetailHCV(row, query) {
            var msVehicles = [];
            var msScheduled = [];

            if (query.avialableMsVehicle && query.avialableMsVehicle.length > 0) {
              query.avialableMsVehicle.forEach(function (element) {
                msVehicles.push(element.vehicleNumber);
              });
            }
            if (query.scheduledAtMS && query.scheduledAtMS.length > 0) {
              query.scheduledAtMS.forEach(function (element) {
                msScheduled.push(element.vehicleNo);
              });
            }
            var totalVehicles = msVehicles.concat(msScheduled);
            if (totalVehicles.length > 0) {
              var test = totalVehicles.filter(function (item, index) {
                return totalVehicles.indexOf(item) === index;
              });
              return test.join();
            } else {
              return '--';
            }
          },
          timeTaken: function timeTaken(row, query) {
            if (query.timeTaken && !isNaN(query.timeTaken)) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(query.timeTaken * 60 * 1000).format('HH[h] mm[m]');
            } else {
              return '--';
            }
          },
          onGoingHCV: function onGoingHCV(row, query) {
            if (query.ongoingHCV && query.ongoingHCV.length > 0) {
              var vehicles = [];
              query.ongoingHCV.forEach(function (element) {
                vehicles.push(element.vehicleNo);
              });
              return vehicles.join();
            } else {
              return '--';
            }
          },
          averageSalesValue: function averageSalesValue(row, query) {
            if (this.stationeryGas && query.salesData) {
              var totalGasInventory = query.HCVGasAvailability + this.stationeryGas;
              var salesvalue = (totalGasInventory / query.salesData).toFixed(0);
              return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(salesvalue * 60 * 60 * 1000).format('HH[h] mm[m]');
            } else {
              return '--';
            }
          },
          Trigger_HCV: function Trigger_HCV(row, query) {
            if (query.HCVGasAvailability && this.stationeryGas && query.salesData) {
              var totalGasInventory = query.HCVGasAvailability + this.stationeryGas;
              var salesvalue = (totalGasInventory / query.salesData).toFixed(0);
              var timetaken = query.timeTaken / 60;
              var difference = salesvalue - timetaken;
              if (difference > 0) {
                return 'Not Required ';
              } else {
                return 'Required ' + difference.toFixed(0);
              }
            } else {
              return '--';
            }
          },
          recordedTime: function recordedTime(row, query) {
            if (query.recordedTime) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default()(query.recordedTime).format('DD-MM-YYYY hh:mm A');
            } else {
              return '--';
            }
          },
          recordedTimeSales: function recordedTimeSales(row, query) {
            if (query.recordedTimeSales) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default()(query.recordedTimeSales).format('DD-MM-YYYY hh:mm A');
            } else {
              return '--';
            }
          }
        },
        requestFunction: function requestFunction(request) {
          _this.loading = true;
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.query) {
            params.$term = request.query;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          }
          if (_this.$store.state.auth.user.roleName === 'Journey Manager') {
            var regionDetails = _this.$store.state.auth.userRegion.regionDetails;
            var regions = regionDetails.map(function (el) {
              return el.name;
            });
            params.regionName = regions;
          }
          return _this.$hcvdetailsDataRepository.list(params).catch(function (error) {
            _this.loading = false;
            console.error('liveStatus.requestFunction-error:', error);
            _this.$snotify.error('Get Vehicle Status', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        }
      }
    };
  },
  created: function created() {
    this.timer = setInterval(this.onLoaded1, 60000);
  },

  mounted: function mounted() {
    if (this.$store.state.auth.user.roleRank === 1) {
      this.columns.push("recordedTime");
      this.columns.push("recordedTimeSales");
    }

    console.log('called Me', this.$store.state.auth.user.roleName === 'Admin');
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  watch: {
    pageNumber: function pageNumber(newPage, oldPage) {
      this.fetchMotherStationOptions();
    }
  },

  methods: {
    action: function action(row) {
      this.isAreaTable = true;
      var motherStationDetails = {
        name: row.motherStation,
        stations: row.motherStations,
        motherStationId: row.motherstationId
      };
      this.motherStationDetails = motherStationDetails;
      this.getSiteDetail(row.siteId);
    },
    getSiteDetail: function getSiteDetail(siteId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/site/' + siteId;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url);

              case 4:
                _this2.siteData = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                console.log("error");

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 7]]);
      }))();
    },
    onCancel: function onCancel() {
      this.isAreaTable = false;
    },
    onLoaded1: function onLoaded1() {
      this.$refs.hcvdetailsTable.refresh();
    },
    onLoaded: function onLoaded() {
      this.hcvdetailsTable = this.$refs.hcvdetailsTable;
    },
    updateMotherStation: function updateMotherStation() {
      var _this3 = this;

      var Updatedsite = this.siteData.data;

      var data = {
        address: Updatedsite.address,
        capacity: Updatedsite.capacity,
        customerName: Updatedsite.customerName,
        dateAdded: Updatedsite.dateAdded,
        defaultMS: this.tripException.divertedDestination._id,
        deviceId: Updatedsite.deviceId,
        dispenserCount: Updatedsite.dispenserCount,
        email: Updatedsite.email,
        latitude: Updatedsite.latitude,
        location_tag: Updatedsite.location_tag,
        longitude: Updatedsite.longitude,
        ownerAddress: Updatedsite.ownerAddress,
        ownerEmail: Updatedsite.ownerEmail,
        ownerMobile: Updatedsite.ownerMobile,
        ownerName: Updatedsite.ownerName,
        region: Updatedsite.region,
        salesManager: Updatedsite.salesManager,
        siteCode: Updatedsite.siteCode,
        siteInfoImage: Updatedsite.siteInfoImage,
        siteName: Updatedsite.siteName,
        siteType: Updatedsite.siteType,
        status: Updatedsite.status,
        supervisor: Updatedsite.supervisor,
        _id: Updatedsite._id

      };
      return __WEBPACK_IMPORTED_MODULE_8__services___["g" /* siteService */].updateSite(data).then(function (response) {
        _this3.loading = false;
        _this3.$snotify.success('Mother station Updated successfully', 'Success!');
        _this3.isAreaTable = false;
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$snotify.error('Location Add failed! Try Again', 'Error!');
        _this3.isAreaTable = false;
      });
    },
    getVehicleStatus: function getVehicleStatus() {
      var _this4 = this;

      return this.$hcvdetailsDataRepository.list({
        isDeleted: false
      }).then(function (response) {
        console.log("called");
        _this4.hcvdetails = response.data;
        _this4.coordinates = response.data.docs;
      }).catch(function (error) {
        _this4.$snotify.error('Trip detail failed', 'Error!');
      });
    }
  },
  computed: {
    addButtonClass: function addButtonClass() {
      if (this.hcvdetailsTable) {
        return this.hcvdetailsTable.count > this.hcvdetailsTable.limit || this.hcvdetailsTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SalesdataCreate',
    data: function data() {
        return {
            count: '',
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
            disabledInput: true,
            formstate: {},
            region_list: {},
            site_list: {},
            minAClosing: 0,
            tt: 0,
            i: 1,
            salesData: [],
            salesdata: {
                status: 'active',
                dispenserFormData: {
                    nozzleAOpening: [],
                    nozzleAClosing: [],
                    nozzleAMeterJump: [],
                    nozzleBOpening: [],
                    nozzleBClosing: [],
                    nozzleBMeterJump: []
                }
            },
            dispenserFormData: {
                nozzleAOpening: [],
                nozzleAClosing: [],
                nozzleAMeterJump: [],
                nozzleBOpening: [],
                nozzleBClosing: [],
                nozzleBMeterJump: []
            },

            totalDispenser: 0
        };
    },
    mounted: function mounted() {
        this.getRegion();
    },

    methods: {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,
        fillNext: function fillNext(e, i, name) {
            if (name == 'nozzleAOpening') {
                this.$refs['nozzleAClosing'][i].disabled = false;
                this.$refs['nozzleAMeterJump'][i].disabled = false;
            }
            if (name == 'nozzleBOpening') {
                this.$refs['nozzleBClosing'][i].disabled = false;
                this.$refs['nozzleBMeterJump'][i].disabled = false;
            }
        },
        compareValue: function compareValue(e, i, name) {
            if (name == 'nozzleAClosing') {
                console.log("hello");
                if (Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value)) {
                    console.log("Please enter value greater than Opening value");
                    this.dispenserFormData['nozzleAClosing'][i] = this.dispenserFormData['nozzleAOpening'][i];
                    this.$snotify.error("Please enter value greater than Opening value");
                }
            }
            if (name == 'nozzleBClosing') {
                console.log("hello", this.$refs['nozzleAClosing'][i].value);
                if (Number(this.$refs['nozzleBOpening'][i].value) > Number(this.$refs['nozzleBClosing'][i].value)) {
                    this.dispenserFormData['nozzleBClosing'][i] = this.dispenserFormData['nozzleBOpening'][i];
                    this.$snotify.error("Please enter value greater than Opening value");
                }
            }
        },
        createSaleData: function createSaleData() {
            var _this = this;

            this.loading = true;
            for (var i = 0; i < this.totalDispenser; i++) {
                this.salesData.splice(i, 1, {
                    nozzleA: {
                        nozzleAOpening: this.dispenserFormData.nozzleAOpening[i] ? this.dispenserFormData.nozzleAOpening[i] : 0,
                        nozzleAClosing: this.dispenserFormData.nozzleAClosing[i] ? this.dispenserFormData.nozzleAClosing[i] : 0,
                        nozzleAMeterJump: this.dispenserFormData.nozzleAMeterJump[i] ? this.dispenserFormData.nozzleAMeterJump[i] : 0
                    },
                    nozzleB: {
                        nozzleBOpening: this.dispenserFormData.nozzleBOpening[i] ? this.dispenserFormData.nozzleBOpening[i] : 0,
                        nozzleBClosing: this.dispenserFormData.nozzleBClosing[i] ? this.dispenserFormData.nozzleBClosing[i] : 0,
                        nozzleBMeterJump: this.dispenserFormData.nozzleBMeterJump[i] ? this.dispenserFormData.nozzleBMeterJump[i] : 0
                    }
                });
            }
            this.salesdata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.salesdata, {
                dispenserData: this.salesData
            });

            return __WEBPACK_IMPORTED_MODULE_1__services__["q" /* salesdataService */].addsalesdata(this.salesdata).then(function (response) {
                _this.loading = false;
                _this.flash = false;
                _this.$snotify.success('Sales Data added!', 'Success!');
                _this.$router.push('/sales_settings');
            }).catch(function (error) {
                _this.loading = false;
                _this.$snotify.error('Sales Data Add failed!Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this.flash = true;
                    _this.flashType = 'error';
                    _this.flashMessage = 'New Sales Data add is failed.Please try again!';
                }
            });
        },
        getRegion: function getRegion() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var regionlist = [];
            if (this.user.roleName == 'Journey Manager') {
                params.journeyManager = '["' + this.user._id + '"]';
                this.isGAAreaDisable = true;
            }
            this.$regionDataRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this2.region_list = regionlist;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this2.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getSite: function getSite(e) {
            var _this3 = this;

            var params = {};
            params.$limit = 0;
            params.region = e.target.value;
            params.siteType = "DBS";
            var sitelist = [];
            this.$siteDataRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    sitelist = res.data.docs;
                }
                _this3.site_list = sitelist;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('Site.requestFunction-error:', error);
                _this3.$snotify.error('Get site list failed', 'Error!');
            });
        },
        getDispenserCount: function getDispenserCount(e) {
            this.count = e.target.options[e.target.selectedIndex].getAttribute('count');

            this.totalDispenser = parseInt(this.count);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SalesdataDetails',
    data: function data() {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
            formstate: {},
            region_list: {},
            site_list: {},
            salesdata: {
                status: 'active',
                dispenserData: {
                    nozzle_A_opening: [],
                    nozzle_A_closing: [],
                    meterJumpA: [],
                    nozzle_B_opening: [],
                    nozzle_B_closing: [],
                    meterJumpB: []
                }
            },
            total_dispancer: '',
            totalDispenser: ''

        };
    },
    mounted: function mounted() {
        this.getRegion();

        this.getsalesdata();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,
        compareValue: function compareValue(e, i, name) {
            if (name == 'nozzleAClosing') {
                console.log("hello");
                if (Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value)) {
                    console.log("Please enter Closing value greater than Opening value");
                    this.$snotify.error("Please enter value greater than Opening value");
                    this.salesdata.dispenserData[i].nozzleA.nozzleAClosing = this.salesdata.dispenserData[i].nozzleA.nozzleAOpening;
                }
            }
            if (name == 'nozzleBClosing') {
                console.log("hello", this.$refs['nozzleAClosing'][i].value);
                if (Number(this.$refs['nozzleBOpening'][i].value) > Number(this.$refs['nozzleBClosing'][i].value)) {
                    this.$snotify.error("Please enter Closing value greater than Opening value");
                    this.salesdata.dispenserData[i].nozzleB.nozzleBClosing = this.salesdata.dispenserData[i].nozzleB.nozzleBOpening;
                }
            }
            if (name == 'nozzleAOpening') {
                console.log("hello");
                if (Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value)) {
                    console.log("Please enter Opening value less than Closing value");
                    this.$snotify.error("Please enter value greater than Opening value");
                    this.salesdata.dispenserData[i].nozzleA.nozzleAOpening = 0;
                }
            }
            if (name == 'nozzleBOpening') {
                if (Number(this.$refs['nozzleBOpening'][i].value) > Number(this.$refs['nozzleBClosing'][i].value)) {
                    this.$snotify.error("Please enter Opening value less than Closing value");
                    this.salesdata.dispenserData[i].nozzleB.nozzleBOpening = 0;
                }
            }
        },
        getRegion: function getRegion() {
            var _this = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this.region_list = regionlist;
            }).catch(function (error) {
                _this.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getSiteName: function getSiteName() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.region = this.salesdata.region;
            var sitelist = [];
            this.$siteDataRepository.list(params).then(function (res) {

                _this2.loading = false;
                if (res.data.docs) {
                    sitelist = res.data.docs;
                }
                console.log("res", res);
                _this2.site_list = sitelist;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('Site.requestFunction-error:', error);
                _this2.$snotify.error('Get site list failed', 'Error!');
            });
        },
        getSite: function getSite(e) {
            var _this3 = this;

            this.salesdata.dispenserData = {
                nozzle_A_opening: [],
                nozzle_A_closing: [],
                meterJumpA: [],
                nozzle_B_opening: [],
                nozzle_B_closing: [],
                meterJumpB: []
            };
            this.salesdata.totalValue = '';
            var params = {};
            params.$limit = 0;
            params.region = e.target.value;
            var sitelist = [];
            this.$siteDataRepository.list(params).then(function (res) {

                _this3.loading = false;
                if (res.data.docs) {
                    sitelist = res.data.docs;
                }
                console.log("res", res);
                _this3.site_list = sitelist;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('Site.requestFunction-error:', error);
                _this3.$snotify.error('Get site list failed', 'Error!');
            });
        },
        getDispenserCount: function getDispenserCount(e) {
            this.count = e.target.options[e.target.selectedIndex].getAttribute('count');
            console.log("hhdhfj", this.count);

            this.total_dispancer = parseInt(this.count);
            console.log("total_dispenser", this.total_dispancer);
            this.totalDispenser = this.total_dispancer - 1;
            console.log("totalDispenser", this.totalDispenser);
        },
        getsalesdata: function getsalesdata() {
            var _this4 = this;

            return this.$salesdataDataRepository.find(this.$route.params._id).then(function (response) {
                console.log("saleeeeee", response);
                _this4.total_dispancer = response.data.dispenserData.length;
                console.log("total_dispancerrrrrrrrr", _this4.total_dispancer);
                _this4.salesdata = response.data;
                _this4.getSiteName();
            }).catch(function (error) {
                _this4.$snotify.error('Sales Data detail failed', 'Error!');
            });
        },
        updatesalesdata: function updatesalesdata() {
            var _this5 = this;

            this.loading = true;
            return __WEBPACK_IMPORTED_MODULE_1__services__["q" /* salesdataService */].updatesalesdata(this.salesdata).then(function (response) {
                _this5.loading = false;
                _this5.flash = false;
                _this5.$snotify.success('Data updated!', 'Success!');
                _this5.$router.push('/sales_settings');
            }).catch(function (error) {
                _this5.loading = false;
                _this5.$snotify.error('Data update failed!Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this5.flash = true;
                    _this5.flashType = 'error';
                    _this5.flashMessage = 'Data update is failed.Please try again!';
                }
            });
        },
        deletesalesdataModal: function deletesalesdataModal() {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                title: 'Are you sure?',
                text: 'This will permanently delete this Data!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    _this6.deletesalesdata();
                }
            });
        },
        deletesalesdata: function deletesalesdata() {
            var _this7 = this;

            this.loading = true;
            return this.$salesdataDataRepository.deleteOne(this.salesdata._id).then(function (response) {
                _this7.loading = false;
                return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('Deleted!', 'Data has been deleted.', 'success');
            }).then(function (response) {
                _this7.loading = false;
                _this7.$router.push('/sales_settings');
            }).catch(function (error) {
                _this7.loading = false;
                _this7.$snotify.error('Delete data failed', 'Error!');
            });
        }
    }, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    })
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'salesdata',
  data: function data() {
    var _this = this,
        _ref;

    return _ref = {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
      formstate: {},
      from: {},
      to: {},
      region_list: {},
      parameters: [],
      site_list: {},
      salesdata: {},

      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */]
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'salesdataTable', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'columns', ['reportedDate', 'totalValue', 'region', 'site', 'action']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'options', {
      highlightMatches: true,
      headings: {
        reportedDate: 'Date',
        totalValue: 'Total Quantity (kg)',
        region: 'Geographic Area',
        site: 'Location',
        action: 'Action'
      },
      filterable: false,
      templates: {
        reportedDate: function reportedDate(row, query) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(query.reportedDate).format('DD-MM-YYYY');
        },
        region: function region(row, query) {
          return '' + query.regionName;
        },
        site: function site(row, query) {
          return '' + query.siteSiteName;
        }
      },
      requestFunction: function requestFunction(request) {
        _this.parameters.$page = request.page;
        _this.parameters.$limit = request.limit;
        if (_this.user.roleName == "GA Head") {
          _this.parameters.regionRegionManager = _this.user._id;
        }
        _this.loading = true;
        return _this.$salesdataDataRepository.list(_this.parameters).catch(function (error) {
          console.error('salesdata.requestFunction-error:', error);
          _this.$snotify.error('Get Status', 'Error!');
        });
      },
      responseAdapter: function responseAdapter(response) {
        _this.loading = false;
        return {
          data: response.data.docs,
          count: response.data.items.total
        };
      }
    }), _ref;
  },

  mounted: function mounted() {
    this.getRegion();
    this.getSite();
  },
  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_4__services__["e" /* formService */].fieldClassName,
    clear: function clear() {
      this.salesdata.site = '', this.salesdata.region = '', this.salesdata.reportedDate = '', delete this.parameters['region'];
      delete this.parameters['site'];
      delete this.parameters['reportedDate'];
      this.$refs.salesdataTable.refresh();
    },
    getRegion: function getRegion() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          regionlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.name
            };
          });
        }
        _this2.region_list = regionlist;
      }).catch(function (error) {
        _this2.loading = false;
        console.error('Region.requestFunction-error:', error);
        _this2.$snotify.error('Get region list failed', 'Error!');
      });
    },
    salesdataDetails: function salesdataDetails(row) {
      this.$router.push({
        name: 'salesdataDetails',
        params: {
          _id: row._id
        },
        props: row
      });
    },
    fiteredResult: function fiteredResult(s, targetItem) {

      if (targetItem == 'region' && event.target.value) {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          region: event.target.value
        });
      }
      if (targetItem == 'site' && event.target.value) {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          site: event.target.value
        });
      }

      if (targetItem == 'startDate' && event.target.title) {
        console.log('event.target.title', this.from.toISOString());
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          reportedDate: this.from.toISOString()
        });
      }
      this.$refs.salesdataTable.refresh();
    },
    getSite: function getSite() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var sitelist = [];
      this.$siteDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          sitelist = res.data.docs;
        }
        _this3.site_list = sitelist;
        console.log('site_list', _this3.site_list);
        console.log('dhfgeugfs', _this3.site_list.map(function (item) {
          item._id;
        }));
      }).catch(function (error) {
        _this3.loading = false;
        console.error('Site.requestFunction-error:', error);
        _this3.$snotify.error('Get site list failed', 'Error!');
      });
    },
    action: function action(row) {

      this.$router.push({
        name: 'SalesdataDetails',
        params: {
          _id: row._id
        },
        props: row
      });
    },
    onLoaded: function onLoaded() {
      this.salesdataTable = this.$refs.salesdataTable;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(19);



var _name$data$created$cr;









/* harmony default export */ __webpack_exports__["default"] = (_name$data$created$cr = {
  name: 'VehicleStatus',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],
      parameters: '',
      regionValue: 'all',
      journey_managers: [],
      startLocation: {
        lat: '',
        lng: ''
      },
      mapMarkers: {},
      coordinates: {},
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {},
      pixelOffset: {
        width: 0,
        height: -35
      },
      timer: '',
      livedetails: {},
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_3__config__["h" /* USER_ROLES */],
      loading: null,
      livedetailsTable: null,
      columns: ['vehicleNumber', 'geographical_area_name', 'currentTrip', 'driverIdDriverName', 'address', 'transportSupervisorName', 'recordedTime', 'locationIdSiteName', 'description'],
      options: {
        highlightMatches: true,
        sortable: ['vehicleNumber', 'geographical_area_name', 'currentTrip', 'driverIdDriverName', 'address', 'transportSupervisorName', 'recordedTime', 'locationIdSiteName', 'description'],
        headings: {
          vehicleNumber: 'Vehicle',
          geographical_area_name: "Geographical Area",
          currentTrip: 'Current Trip',
          driverIdDriverName: 'Driver',
          address: 'Address',
          transportSupervisorName: 'Transport Supervisor Details',
          recordedTime: 'Recorded Time',
          description: 'Status',
          locationIdSiteName: 'Last Known Location',
          map: ''
        },
        templates: {
          recordedTime: function recordedTime(row, query) {
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()(query.recordedTime).format('DD-MM-YYYY hh:mm A');
          },
          transportSupervisorName: function transportSupervisorName(row, query) {
            if (query.transportSupervisorName && query.transportSupervisorContact) {
              return query.transportSupervisorName + ',' + query.transportSupervisorContact;
            }
            if (query.transportSupervisorName) {
              return '' + query.transportSupervisorName;
            }
            if (query.transportSupervisorContact) {
              return '' + query.transportSupervisorContact;
            }
          },
          address: function address(row, query) {
            if (query.address) {
              return '' + query.address;
            }
          },
          map: function map(row, query) {
            this.startLocation = {
              lat: query.latitude,
              lng: query.longitude
            };
            return this.startLocation;
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (_this.parameters != '') {
            console.log('this.parameters', _this.parameters);
            params.geographical_area = _this.parameters;
          }
          if (_this.regionManagersIdList.length !== 0) {
            params.geographical_area = _this.regionManagersIdList;
          }
          _this.loading = true;
          return _this.$livedetailsDataRepository.list(params).catch(function (error) {
            console.error('liveStatus.requestFunction-error:', error);
            _this.$snotify.error('Get Vehicle Status', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        }
      }
    };
  },
  created: function created() {
    this.timer = setInterval(this.onLoaded1, 60000);
    this.timer1 = setInterval(this.getVehicleStatus, 60000);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$created$cr, 'created', function created() {
  var regionDetails = this.$store.state.auth.userRegion.regionDetails;
  if (regionDetails.length !== 0) {
    this.regionManagersIdList = regionDetails.map(function (item) {
      return item.region;
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$created$cr, 'mounted', function mounted() {
  this.getGeographicalAreas();
  this.getVehicleStatus();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$created$cr, 'beforeDestroy', function beforeDestroy() {
  clearInterval(this.timer1);
  clearInterval(this.timer);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$created$cr, 'methods', {
  clearStatusGA: function clearStatusGA() {
    this.parameters = '';

    this.regionValue = 'all';
    this.$refs.livedetailsTable.refresh();
  },
  fiteredResultGA: function fiteredResultGA(e) {
    if (e.target.value === 'all') {
      this.parameters = '';
      this.regionValue = 'all';
    } else {
      this.parameters = e.target.value;
    }
    this.$refs.livedetailsTable.refresh();
  },
  getGeographicalAreas: function getGeographicalAreas() {
    var _this2 = this;

    this.loading = true;
    var params = {};
    params.$limit = 0;
    var journeyManagerList = [];

    this.$regionsDataRepository.list(params).then(function (res) {
      _this2.loading = false;
      if (res.data.docs) {
        if (_this2.user.roleName === 'Admin') {
          journeyManagerList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.name
            };
          });
          _this2.journey_managers = journeyManagerList;
        } else {
          journeyManagerList = res.data.docs.map(function (item) {
            if (_this2.regionManagersIdList.includes(item.regionManager)) {
              _this2.journey_managers.push({
                key: item._id,
                value: item.name
              });
            }
          });
        }
      }
    }).catch(function (error) {
      _this2.loading = false;
      console.error('journey Manager.requestFunction-error:', error);
      _this2.$snotify.error('Get journey manager list failed', 'Error!');
    });
  },
  exportData: function exportData() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_6_axios___default()({
      method: 'get',
      url: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI + '/v1/exportMaster?model=livedetails',
      responseType: 'arraybuffer'
    }).then(function (response) {
      console.log("response of download", response);
      var arrayBuffer = response.data;
      var filename = 'Vehicle_Status.xlsx';
      _this3.downloadFileFromArrayBuffer(arrayBuffer, filename);
    }).catch(function (err) {
      console.log("err", err);
    });
  },
  downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
    var url = URL.createObjectURL(new Blob([arrayBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

    }));
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  },
  onLoaded1: function onLoaded1() {
    this.livedetailsTable = this.$refs.livedetailsTable.refresh();
  },
  getstartLocation: function getstartLocation(row) {
    this.mapMarkers = {};
    if (row.latitude && row.longitude) {
      this.startLocation = {
        lat: row.latitude,
        lng: row.longitude
      };
      this.mapMarkers = row;
    } else {
      this.startLocation = {
        lat: 20.5937,
        lng: 78.9629
      };
    }
  },

  getPosition: function getPosition() {
    return {
      lat: parseFloat(this.mapMarkers.latitude),
      lng: parseFloat(this.mapMarkers.longitude)
    };
  },
  toggleInfo: function toggleInfo(marker, key) {
    this.infoPosition = this.getPosition();
    this.infoContent = this.mapMarkers.vehicleNumber;
    if (this.infoCurrentKey == key) {
      this.infoOpened = !this.infoOpened;
    } else {
      this.infoOpened = true;
      this.infoCurrentKey = key;
    }
  },
  getVehicleStatus: function getVehicleStatus() {
    var _this4 = this;

    return this.$livedetailsDataRepository.list({
      isDeleted: false
    }).then(function (response) {
      _this4.livedetails = response.data;
      _this4.coordinates = response.data.docs;
      console.log("response of trip", _this4.coordinates);
    }).catch(function (error) {
      _this4.$snotify.error('Trip detail failed', 'Error!');
    });
  },
  onLoaded: function onLoaded() {
    console.log("onloaded");
    this.livedetailsTable = this.$refs.livedetailsTable;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$data$created$cr, 'computed', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
  user: function user(state) {
    return state.auth.user;
  }
}), {
  addButtonClass: function addButtonClass() {

    if (this.livedetailsTable) {
      return this.livedetailsTable.count > this.livedetailsTable.limit || this.livedetailsTable.limit > 10 ? 'shift-add-left' : 'add-item';
    } else {
      return 'add-item';
    }
  }
})), _name$data$created$cr);

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'complianceReport',
  data: function data() {
    var _this = this;

    return {
      regionValue: 'all',
      journey_managers: [],
      dateCSV: {
        startDateCSV: "",
        endDateCSV: ""
      },
      startDateIsoCSV: "",
      endDateIsoCSV: "",
      selectedTab: 'Driver',
      loading: '',
      loadings: '',
      showDriverTable: true,
      showVehicleTable: false,
      driverActive: "",
      vehicleActive: "",
      driverTable: null,
      vehilceTable: null,
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      date: {
        startDate: "",
        endDate: ""
      },
      startDateIso: "",
      endDateIso: "",
      params: {},
      parameters: {},
      exportName: "",
      regionManagersIdList: [],
      parameterss: '',

      column: ['driverName', 'mobileNumber', 'lisenceNumber', 'licenseExpiryDate', 'ddtExpiryDate', 'hazExpiryDate', 'regionName', 'status'],
      option: {
        highlightMatches: true,
        headings: {
          driverName: 'Driver Name',
          mobileNumber: 'Contact Number',
          lisenceNumber: 'License Number',
          licenseExpiryDate: 'License Expiry Date',
          ddtExpiryDate: 'DDT Expiry Date',
          hazExpiryDate: 'HAZCAM Expiry Date',
          regionName: 'GA Name',
          status: 'Status'
        },
        perPage: 10,
        sortable: ['driverName', 'mobileNumber', 'lisenceNumber', 'licenseExpiryDate', 'ddtExpiryDate', 'hazExpiryDate', 'regionName', 'status'],
        templates: {
          licenseExpiryDate: function licenseExpiryDate(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.licenseExpiryDate).format('DD-MM-YYYY');
          },
          ddtExpiryDate: function ddtExpiryDate(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.ddtExpiryDate).format('DD-MM-YYYY');
          },
          hazExpiryDate: function hazExpiryDate(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.hazExpiryDate).format('DD-MM-YYYY');
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          }
        },
        requestFunction: function requestFunction(request) {
          _this.params.page = request.page;
          _this.params.limit = request.limit;
          if (request.orderBy) {
            _this.params.sortBy = request.orderBy;
            if (request.ascending == 1) {
              _this.params.sortOrder = "asc";
            } else {
              _this.params.sortOrder = "des";
            }
          }
          if (request.query !== '') {
            _this.params.searchString = request.query;
          } else {
            _this.params.searchString = '';
          }
          if (_this.parameterss != '') {
            _this.params.region = _this.parameterss;
          } else if (_this.regionManagersIdList.length !== 0) {
            _this.params.region = _this.regionManagersIdList;
          }
          _this.loading = true;
          return _this.$driverComplianceDataRepository.list(_this.params).catch(function (error) {
            console.error('driverCompliance.requestFunction-error:', error);
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.driverData,
            count: response.data.driversCount
          };
        }
      },

      columns: ['regNo', 'transportSupervisorName', 'rcValidity', 'insuranceValidity', 'pucValidity', 'fitCertValidity', 'gcpValidity'],
      options: {
        highlightMatches: true,
        headings: {
          regNo: 'Registration Number',
          transportSupervisorName: 'Transporter Name',
          rcValidity: 'RC Validity',
          insuranceValidity: 'Insurance Validity',
          pucValidity: 'PUC Validity',
          fitCertValidity: 'Fitness Validity',
          gcpValidity: 'Goods Carriage Permit Validity'
        },
        perPage: 10,
        sortable: ['regNo', 'transportSupervisorName', 'rcValidity', 'insuranceValidity', 'pucValidity', 'fitCertValidity', 'gcpValidity'],
        templates: {
          rcValidity: function rcValidity(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.rcValidity).format('DD-MM-YYYY');
          },
          insuranceValidity: function insuranceValidity(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.insuranceValidity).format('DD-MM-YYYY');
          },
          pucValidity: function pucValidity(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.pucValidity).format('DD-MM-YYYY');
          },
          fitCertValidity: function fitCertValidity(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.fitCertValidity).format('DD-MM-YYYY');
          },
          gcpValidity: function gcpValidity(row, query) {
            return '' + __WEBPACK_IMPORTED_MODULE_4_moment___default()('' + query.gcpValidity).format('DD-MM-YYYY');
          }
        },
        requestFunction: function requestFunction(request) {
          _this.parameters.page = request.page;
          _this.parameters.limit = request.limit;
          if (request.orderBy) {
            _this.parameters.sortBy = request.orderBy;
            if (request.ascending == 1) {
              _this.parameters.sortOrder = "asc";
            } else {
              _this.parameters.sortOrder = "des";
            }
          }
          if (request.query) {
            _this.parameters.searchString = request.query;
          } else {
            _this.params.searchString = '';
          }
          if (_this.parameterss != '') {
            _this.parameters.region = _this.parameterss;
          } else if (_this.regionManagersIdList.length !== 0) {
            _this.parameters.region = _this.regionManagersIdList;
          }
          _this.loadings = true;
          return _this.$vehicleComplianceDataRepository.list(_this.parameters).catch(function (error) {
            console.error('vehicleCompliance.requestFunction-error:', error);
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loadings = false;
          return {
            data: response.data.vehicleData,
            count: response.data.vehiclesCount
          };
        }
      }

    };
  },

  mounted: function mounted() {
    this.getGeographicalAreas();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.driverTable) {
        return this.driverTable.count > this.driverTable.limit || this.driverTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }

  })),
  methods: {
    clearFilterCSV: function clearFilterCSV() {
      this.dateCSV.startDateCSV = '';
      this.dateCSV.endDateCSV = '';
    },
    startDateCSV: function startDateCSV() {
      var eventDataCSV = this.dateCSV.startDateCSV.split("-");
      this.startDateIsoCSV = eventDataCSV[2] + "-" + eventDataCSV[1] + "-" + eventDataCSV[0];
    },
    endDateCSV: function endDateCSV() {
      var eventDataCSV = this.dateCSV.endDateCSV.split("-");
      this.endDateIsoCSV = eventDataCSV[2] + "-" + eventDataCSV[1] + "-" + eventDataCSV[0];
      console.log('end date', this.endDateIsoCSV);
    },
    exportCSV: function exportCSV() {
      var _this2 = this;

      this.exportName = this.selectedTab === 'Driver' ? 'driver' : 'vehicle';

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/export/' + this.exportName + '/compliance?startDate=' + this.startDateIsoCSV + '&endDate=' + this.endDateIsoCSV,
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.exportName = '';
        console.log("response of download", response);
        var arrayBuffer = response.data;
        var filename = 'Locations.xlsx';
        _this2.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    clearStatusGA: function clearStatusGA() {
      this.parameterss = '';
      delete this.parameters.region;
      delete this.params.region;

      this.regionValue = 'all';
      this.$refs.vehilceTable.refresh();
      this.$refs.driverTable.refresh();
    },
    fiteredResultGA: function fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameterss = '';
        this.regionValue = 'all';
        delete this.parameters.region;
        delete this.params.region;
      } else {
        this.parameterss = e.target.value;
      }
      this.$refs.vehilceTable.refresh();
      this.$refs.driverTable.refresh();
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var journeyManagerList = [];

      this.$regionsDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          if (_this3.user.roleName === 'Admin') {
            journeyManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this3.journey_managers = journeyManagerList;
          } else {
            journeyManagerList = res.data.docs.map(function (item) {
              if (_this3.regionManagersIdList.includes(item._id)) {
                _this3.journey_managers.push({
                  key: item._id,
                  value: item.name
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this3.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this3.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    dateFormatters: function dateFormatters(query) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(query).format("DD-MM-YYYY");
    },
    getDateClass: function getDateClass(expiryDate) {

      if (!expiryDate) {
        return 'na';
      }

      var today = new Date();
      var expiry = new Date(expiryDate);

      var daysRemaining = Math.floor((expiry - today) / (24 * 60 * 60 * 1000));

      if (daysRemaining < 0) {
        return 'expired';
      } else if (daysRemaining <= 90) {
        return 'expires-soon';
      } else {
        return 'valid';
      }
    },
    clearFilter: function clearFilter() {
      if (this.selectedTab === 'Driver') {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.params.startDate;
        delete this.params.endDate;
        this.$refs.driverTable.refresh();
      }

      if (this.selectedTab === 'Vehicle') {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.parameters.startDate;
        delete this.parameters.endDate;
        this.$refs.vehilceTable.refresh();
      }
    },
    startDate: function startDate() {
      var eventData = this.date.startDate.split("-");
      this.startDateIso = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
    },
    endDate: function endDate() {
      if (this.date.startDate != "" && this.date.endDate != "") {
        var eventData = this.date.endDate.split("-");
        var endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
        if (this.selectedTab === 'Driver') {
          this.params.endDate = endDate;
          this.params.startDate = this.startDateIso;
          this.$refs.driverTable.refresh();
        }
        if (this.selectedTab === 'Vehicle') {
          this.parameters.endDate = endDate;
          this.parameters.startDate = this.startDateIso;
          this.$refs.vehilceTable.refresh();
        }
      }
    },
    showDriver: function showDriver() {
      if (this.date.startDate || this.date.endDate) {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.params.startDate;
        delete this.params.endDate;
      }
      this.selectedTab = 'Driver';
      this.showDriverTable = true;
      this.showVehicleTable = false;
      this.clearFilterCSV();
    },
    showVehicle: function showVehicle() {
      if (this.date.startDate || this.date.endDate) {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.params.startDate;
        delete this.params.endDate;
      }
      this.selectedTab = 'Vehicle';
      this.showVehicleTable = true;
      this.showDriverTable = false;
      this.clearFilterCSV();
    },
    onLoaded: function onLoaded() {
      this.driverTable = this.$refs.driverTable;
    },
    onLoad: function onLoad() {
      this.vehilceTable = this.$refs.vehilceTable;
    }
  },
  created: function created() {
    this.driverActive = 'active';
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExpiringLicense',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
      loading: null,
      expiringLicenseTable: null,
      columns: ['driverName', 'mobileNumber', 'managerFullname', 'languageKnown', 'lisenceNumber', 'status', 'licenseExpiryDate'],

      options: {
        highlightMatches: true,
        sortable: ['driverName', 'mobileNumber', 'managerFirstName', 'languageKnown', 'lisenceNumber', 'status', 'licenseExpiryDate'],

        headings: {
          driverName: 'Name',
          mobileNumber: 'Contact',
          manager: 'Manager',
          languageKnown: 'Language',
          lisenceNumber: 'License',
          status: 'Status',
          managerFullname: 'Manager',
          licenseExpiryDate: "License Expired On"
        },
        templates: {
          managerFullname: function managerFullname(row, query) {
            return query.managerFirstName + ' ' + query.managerLastName;
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          licenseExpiryDate: function licenseExpiryDate(row, query) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(query.licenseExpiryDate).format('DD-MM-YYYY');
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$expiringLicenseDataRepository.list(params).catch(function (error) {
            console.error('driver.requestFunction-error:', error);
            _this.$snotify.error('Get Driver', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.docs.length
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: {
    addButtonClass: function addButtonClass() {
      if (this.expiringLicenseTable) {
        return this.expiringLicenseTable.count > this.expiringLicenseTable.limit || this.expiringLicenseTable.limit > 10;
      }
    }
  },
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'DriverDetail',
        params: {
          _id: data.row._id
        },
        props: data.row
      });
    },
    onLoaded: function onLoaded() {
      this.expiringLicenseTable = this.$refs.expiringLicenseTable;
    }
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SchedulesExpiry',
    data: function data() {
        var _this = this;

        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
            loading: null,
            schedulesExpiryTable: null,
            columns: ['reportType', 'reportFrequency', 'scheduleStartDate', 'scheduleEndDate', 'status'],
            options: {
                highlightMatches: true,
                sortable: ['reportType', 'reportFrequency', 'scheduleStartDate', 'scheduleEndDate', 'status'],

                headings: {
                    reportType: 'Report Type',
                    reportFrequency: 'Schedule Type',
                    scheduleStartDate: 'Schedule Start Date',
                    scheduleEndDate: 'Schedule End Date',
                    status: 'Status'
                },
                templates: {
                    scheduleStartDate: function scheduleStartDate(row, query) {
                        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(query.scheduleStartDate).format('DD-MM-YYYY');
                    },
                    scheduleEndDate: function scheduleEndDate(row, query) {
                        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(query.scheduleEndDate).format('DD-MM-YYYY');
                    },
                    status: function status(row, query) {
                        return query.status[0].toUpperCase() + query.status.slice(1);
                    }
                },

                requestFunction: function requestFunction(request) {
                    var params = {};
                    params.$page = request.page;
                    params.$limit = request.limit;
                    _this.loading = true;
                    return _this.$reportScheduleReminderDataRepository.list(params).catch(function (error) {
                        console.error('Report.requestFunction-error:', error);
                        _this.$snotify.error('Get Report Schedule History failed', 'Error!');
                    });
                },
                responseAdapter: function responseAdapter(response) {
                    _this.loading = false;
                    console.log("response", response);
                    console.log("end date ", response.data.docs.scheduleEndDate);
                    var endDate = new Date(response.data.docs.scheduleEndDate);
                    return {
                        data: response.data.docs,
                        count: response.data.docs.length
                    };
                },
                uniqueKey: '_id'
            }
        };
    },

    computed: {
        addButtonClass: function addButtonClass() {
            if (this.schedulesExpiryTable) {
                return this.schedulesExpiryTable.count > this.schedulesExpiryTable.limit || this.schedulesExpiryTable.limit > 10 ? 'shift-add-left' : 'add-item';
            } else {
                return 'add-item';
            }
        }
    },
    methods: {
        edit: function edit(data) {
            this.$router.push({
                name: 'ReportScheduleDetails',
                params: { _id: data.row._id },
                props: data.row
            });
        },
        onLoaded: function onLoaded() {
            this.schedulesExpiryTable = this.$refs.schedulesExpiryTable;
        }
    }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      trip: {},
      upComingTripCount: '',
      vehicleCount: '',
      driverCount: '',
      driversCount: '',
      routesCount: '',
      deviceCount: '',
      regionCount: '',
      onGoingTripCount: '',
      completedTripCount: '',
      generatedReportCount: '',
      scheduleReportCount: '',
      salesDataCount: '',
      schedulesExpiryCount: '',
      userCount: '',
      totalInvestmentAmount: '',
      investedAmount: '',
      netProfitAndLoss: '',
      currentValue: '',
      net_pnl: '',
      net_profit_percentage: '',
      userData: null,
      withdrawlAmount: '',
      historyTableData: [],
      history_table: []
    };
  },

  mounted: function mounted() {
    this.getUser();
  },
  methods: {
    getListPnL: function getListPnL() {
      var _this = this;

      this.loading = true;
      var data = this.user._id;
      return __WEBPACK_IMPORTED_MODULE_1__services__["n" /* investmentService */].getListPnLAll(data).then(function (response) {
        _this.history_table = [];
        if (response.data === []) {
          _this.history_table = [];
        } else {
          response.data.data.forEach(function (element) {
            _this.history_table.push({
              withdrawl_amount: element.withdrawl_amount ? element.withdrawl_amount.toFixed(2) : 0,
              createdAt: __WEBPACK_IMPORTED_MODULE_4_moment___default()(element.createdAt).format('DD-MM-YYYY '),
              current_investment_value: element.current_investment_value.toFixed(2),
              pnl_value: Number(element.pnl_value).toFixed(2),
              net_profit_percentage: element.net_profit_percentage.toFixed(2),
              net_pnl: element.net_pnl.toFixed(2)
            });
          });
        }
      }, function (err) {
        _this.loading = false;
      });
    },
    getData: function getData() {
      this.totalInvestmentAmount = this.userData.current_investment_value ? this.userData.current_investment_value.toFixed(2) : 'No data';
      this.netProfitAndLoss = this.userData.pnl_value ? Number(this.userData.pnl_value).toFixed(2) : 'No data';
      this.investedAmount = this.userData.invested_amount;
      this.withdrawlAmount = this.userData.withdrawl_amount !== undefined ? this.userData.withdrawl_amount : 0;
      this.net_pnl = this.userData.current_investment_value && this.userData.pnl_value && this.userData.invested_amount ? (this.userData.current_investment_value + this.withdrawlAmount + Number(this.userData.pnl_value) - this.userData.invested_amount).toFixed(2) : 'No data';
      this.net_profit_percentage = this.userData.current_investment_value && this.userData.pnl_value && this.userData.invested_amount ? ((this.userData.current_investment_value + this.withdrawlAmount + Number(this.userData.pnl_value) - this.userData.invested_amount) / this.userData.invested_amount * 100).toFixed(2) : 'No data';
      var intValue = parseInt(this.netProfitAndLoss, 10);
      if (0 > intValue) {
        this.currentValue = this.totalInvestmentAmount - this.investedAmount + intValue;
      } else {
        this.currentValue = this.totalInvestmentAmount - this.investedAmount + intValue;
      }
    },
    getUser: function getUser() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 9999999;
      params.$page = 1;
      params.invisible = false;
      if (this.user.roleName == 'Admin') {
        params._id = this.user._id;
      }
      var routesList = [];
      this.$userRepository.list(params).then(function (res) {
        _this2.loading = false;
        _this2.userData = res.data.docs[0];
        _this2.userCount = res.data.items.total;
        _this2.getData();
        _this2.getListPnL();
      }).catch(function (error) {
        _this2.loading = false;
        console.error('routes.requestFunction-error:', error);
      });
    },
    getLiveTrips: function getLiveTrips() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        console.log('partam', this.parameters);
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = this.user._id;
      }
      params.status = 'ongoing';
      var tripList = [];
      this.$tripDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        _this3.onGoingTripCount = res.data.items.total;
        console.log(_this3.onGoingTripCount);
      }).catch(function (error) {
        _this3.loading = false;
        console.error('vehicle.requestFunction-error:', error);
      });
    },
    getUpComingTrip: function getUpComingTrip() {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        console.log('partam', this.parameters);
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = this.user._id;
      }
      params.status = 'scheduled';
      var tripList = [];
      this.$tripDataRepository.list(params).then(function (res) {
        _this4.loading = false;
        _this4.upComingTripCount = res.data.items.total;
        console.log(_this4.upComingTripCount);
      }).catch(function (error) {
        _this4.loading = false;
        console.error('vehicle.requestFunction-error:', error);
      });
      console.log('------------');
      console.log(Date.now());
      console.log(__WEBPACK_IMPORTED_MODULE_4_moment___default()(Date.now()).format('hh:mm A'));
    },
    getCompletedTrips: function getCompletedTrips() {
      var _this5 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        console.log('partam', this.parameters);
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = this.user._id;
      }
      params.status = 'completed';
      var tripList = [];
      this.$tripDataRepository.list(params).then(function (res) {
        _this5.loading = false;
        _this5.completedTripCount = res.data.items.total;
      }).catch(function (error) {
        _this5.loading = false;
        console.error('vehicle.requestFunction-error:', error);
      });
    },
    getVehicle: function getVehicle() {
      var _this6 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      var vehicleList = [];
      this.$vehicleDataRepository.list(params).then(function (res) {
        _this6.loading = false;
        _this6.vehicleCount = res.data.items.total;
      }).catch(function (error) {
        _this6.loading = false;
        console.error('vehicle.requestFunction-error:', error);
      });
    },
    getDriver: function getDriver() {
      var _this7 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      var driverList = [];
      this.$expiringLicenseDataRepository.list(params).then(function (res) {
        _this7.loading = false;
        if (res.data.docs) {
          _this7.driverCount = res.data.expiringCount;
        }
      }).catch(function (error) {
        _this7.loading = false;
        console.error('driver.requestFunction-error:', error);
      });
    },
    getRoutes: function getRoutes() {
      var _this8 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      var routesList = [];
      this.$triprouteDataRepository.list(params).then(function (res) {
        _this8.loading = false;
        _this8.routesCount = res.data.items.total;
      }).catch(function (error) {
        _this8.loading = false;
        console.error('routes.requestFunction-error:', error);
      });
    },
    getDevices: function getDevices() {
      var _this9 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      this.$driverDataRepository.list(params).then(function (res) {
        _this9.loading = false;
        _this9.driversCount = res.data.items.total;
      }).catch(function (error) {
        _this9.loading = false;
        console.error('device.requestFunction-error:', error);
      });
    },
    getRegion: function getRegion() {
      var _this10 = this;

      this.loading = true;
      var params = {};
      params.$limit = 1;
      if (this.user.roleName == 'GA Head') {
        params.regionManager = this.user._id;
      }
      this.$regionDataRepository.list(params).then(function (res) {
        _this10.loading = false;
        _this10.regionCount = res.data.items.total;
      }).catch(function (error) {
        _this10.loading = false;
        console.error('region.requestFunction-error:', error);
      });
    },
    getGeneratedReports: function getGeneratedReports() {
      var _this11 = this;

      if (this.user.roleName == 'Sales Manager' || this.user.roleName == 'Report Staff') {
        console.log('entred');
        this.loading = true;
        var params = {};
        params.$limit = 1;
        if (this.user.roleName == 'GA Head') {
          params.regionRegionManager = this.user._id;
        }

        this.$reportgenerationDataRepository.list(params).then(function (res) {
          _this11.loading = false;
          if (res.data.docs) {
            _this11.generatedReportCount = res.data.docs.length;
          }
        }).catch(function (error) {
          _this11.loading = false;
          console.error('report.requestFunction-error:', error);
        });
      }
    },
    getScheduledReport: function getScheduledReport() {
      var _this12 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      this.$schedulereportDataRepository.list(params).then(function (res) {
        _this12.loading = false;
        if (res.data.docs) {
          _this12.scheduleReportCount = res.data.docs.length;
        }
      }).catch(function (error) {
        _this12.loading = false;
        console.error('report.requestFunction-error:', error);
      });
    },
    getSalesData: function getSalesData() {
      var _this13 = this;

      if (this.user.roleName == 'Sales Manager' || this.user.roleName == 'Report Staff' || this.user.roleName == 'Sales Representative') {
        this.loading = true;
        var params = {};
        params.$limit = 1;
        if (this.user.roleName == 'GA Head') {
          this.parameters.regionRegionManager = this.user._id;
        }
        this.$salesdataDataRepository.list(params).then(function (res) {
          _this13.loading = false;
          if (res.data.docs) {
            _this13.salesDataCount = res.data.docs.length;
          }
        }).catch(function (error) {
          _this13.loading = false;
          console.error('report.requestFunction-error:', error);
        });
      }
    },
    getSchedulesExpiry: function getSchedulesExpiry() {
      var _this14 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      this.$reportScheduleReminderDataRepository.list(params).then(function (res) {
        _this14.loading = false;
        if (res.data.docs) {
          _this14.schedulesExpiryCount = res.data.docs.length;
        }
      }).catch(function (error) {
        _this14.loading = false;
        console.error('report.requestFunction-error:', error);
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DeviceCreate',
  data: function data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
      formstate: {},
      dateAdded: '',
      device: {
        status: 'active'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,

    createDevice: function createDevice() {
      var _this = this;

      this.loading = true;
      console.log('hii', this.device);
      return __WEBPACK_IMPORTED_MODULE_1__services__["t" /* deviceService */].addDevice(this.device).then(function (response) {
        _this.loading = false;
        _this.flash = false;
        _this.$snotify.success('Device added!', 'Success!');
        _this.$router.push('/device');
      }).catch(function (error) {
        _this.loading = false;
        _this.$snotify.error('Device Add failed!Try Again', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this.flash = true;
          _this.flashType = 'error';
          _this.flashMessage = 'New device add is failed.Please try again!';
        }
      });
    }
  }, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  })
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DeviceDetail',
  data: function data() {
    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */],
      role: {},
      roles: [],
      permissions: [],
      formstate: {},
      device: {
        status: 'active'
      }
    };
  },

  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,
    getDevice: function getDevice() {
      var _this = this;

      return this.$deviceDataRepository.find(this.$route.params._id).then(function (response) {
        _this.device = response.data;
      }).catch(function (error) {
        _this.$snotify.error('Device detail failed', 'Error!');
      });
    },
    updateDevice: function updateDevice() {
      var _this2 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_2__services__["t" /* deviceService */].updateDevice(this.device).then(function (response) {
        _this2.loading = false;
        _this2.flash = false;
        _this2.$snotify.success('Device details updated!', 'Success!');
        _this2.$router.push('/device');
      }).catch(function (error) {
        _this2.loading = false;
        console.error('DeviceCreate.createDevice-error:', error);
        _this2.$snotify.error('Add Device failed', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this2.flash = true;
          _this2.flashType = 'error';
          _this2.flashMessage = 'Device is not updated due to some error. Please try again!.';
        }
      });
    },
    deleteDeviceModal: function deleteDeviceModal() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this Device!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this3.deleteDevice();
        }
      });
    },
    deleteDevice: function deleteDevice() {
      var _this4 = this;

      this.loading = true;
      return this.$deviceDataRepository.deleteOne(this.device._id).then(function (response) {
        _this4.loading = false;
        return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('Deleted!', 'Device has been deleted.', 'success');
      }).then(function (response) {
        _this4.loading = false;
        _this4.$router.push('/device');
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$snotify.error('Delete device failed', 'Error!');
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    }
  },
  created: function created() {
    var _this5 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getDevice());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this5.loading = false;
      _this5.ready = true;
    }).catch(function () {
      _this5.loading = false;
    });
  }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Device',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],

      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: null,
      deviceTable: null,
      columns: ['deviceId', 'device_model', 'imei', 'connectionId', 'dateAdded', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['deviceId', 'brand', 'deviceModel', 'imei', 'connectionId', 'dateAdded', 'status'],
        headings: {
          deviceId: 'Device Id',
          device_model: 'Device Model',
          imei: 'IMEI',
          connectionId: 'Connection ID',
          dateAdded: 'Registration Date',
          status: 'Status'
        },

        templates: {
          device_model: function device_model(row, query) {
            return query.brand.toUpperCase() + '\xA0-\xA0' + query.deviceModel.toUpperCase();
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          dateAdded: function dateAdded(row, query) {
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()(query.dateAdded).format('DD-MM-YYYY');
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          }

          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }

          _this.loading = true;
          return _this.$deviceDataRepository.list(params).catch(function (error) {
            console.error('Device.requestFunction-error:', error);
            _this.$snotify.error('Get Device', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item.regionManager;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.deviceTable) {
        return this.deviceTable.count > this.deviceTable.limit || this.deviceTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    edit: function edit(data) {
      if (this.user.roleName == 'Admin') {
        this.$router.push({
          name: 'DeviceDetail',
          params: { _id: data.row._id },
          props: data.row
        });
      }
    },
    exportData: function exportData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/v1/exportMaster?model=device',
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log('response of download', response);
        var arrayBuffer = response.data;
        var filename = 'Devices.xlsx';
        _this2.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    onLoaded: function onLoaded() {
      this.deviceTable = this.$refs.deviceTable;
    }
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Driver',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],
      regionValue: 'all',
      parameters: '',
      journey_managers: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: null,
      driverTable: null,
      columns: ['driverName', 'mobileNumber', 'regionName', 'languageKnown', 'lisenceNumber', 'status'],

      options: {
        highlightMatches: true,
        sortable: ['driverName', 'mobileNumber', 'regionName', 'languageKnown', 'lisenceNumber', 'status'],

        headings: {
          driverName: 'Name',
          mobileNumber: 'Contact',
          regionName: 'Geographical Area',

          languageKnown: 'Language',
          lisenceNumber: 'License',
          status: 'Status',
          managerFullname: 'Manager'
        },
        templates: {
          managerFullname: function managerFullname(row, query) {
            return query.managerFirstName + ' ' + query.managerLastName;
          },
          driverName: function driverName(row, query) {
            return query.driverLastName ? query.driverName + ' ' + query.driverLastName : '' + query.driverName;
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == 'GA Head') {
            params.regionRegionManager = _this.user._id;
          }
          if (_this.regionManagersIdList.length !== 0) {
            params.region = _this.regionManagersIdList;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (_this.parameters != '') {
            params.region = _this.parameters;
          }
          _this.loading = true;
          return _this.$driverDataRepository.list(params).catch(function (error) {
            console.error('driver.requestFunction-error:', error);
            _this.$snotify.error('Get Driver', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
    this.getGeographicalAreas();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.driverTable) {
        return this.driverTable.count > this.driverTable.limit || this.driverTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'DriverDetail',
        params: {
          _id: data.row._id
        },
        props: data.row
      });
    },
    clearStatusGA: function clearStatusGA() {
      this.parameters = '';

      this.regionValue = 'all';
      this.$refs.driverTable.refresh();
    },
    fiteredResultGA: function fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameters = '';
        this.regionValue = 'all';
      } else {
        this.parameters = e.target.value;
      }
      this.$refs.driverTable.refresh();
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var journeyManagerList = [];
      this.$regionsDataRepository.list(params).then(function (res) {
        _this2.loading = false;

        if (res.data.docs) {
          if (_this2.user.roleName === 'Admin') {
            journeyManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            console.log("heyy", journeyManagerList);
            _this2.journey_managers = journeyManagerList;
          } else {
            journeyManagerList = res.data.docs.map(function (item) {
              if (_this2.regionManagersIdList.includes(item._id)) {
                _this2.journey_managers.push({
                  key: item._id,
                  value: item.name
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this2.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this2.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/v1/exportMaster?model=driver',
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log('response of download', response);
        var arrayBuffer = response.data;
        var filename = 'Drivers.xlsx';
        _this3.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    onLoaded: function onLoaded() {
      this.driverTable = this.$refs.driverTable;
    }
  }
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);




var _methods;








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DriverCreate',
  data: function data() {
    return {
      formstatePhoto: false,
      formstateDocument: false,
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_3__config__["h" /* USER_ROLES */],
      loading: false,
      isDriverDisable: false,
      isDeviceDisable: false,
      isJourenyManagerDisable: false,
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
      formstate: {},
      manager: {},
      vehicle_no: {},
      region_list: {},
      device_id: {},
      minDate: '',
      docs: [],
      driver: {
        defaultLanguage: '',
        languageKnown: '',
        status: 'active'
      },
      language: [{
        key: 'Hindi',
        value: 'Hindi'
      }, {
        key: 'Punjabi',
        value: 'Punjabi'
      }, {
        key: 'English',
        value: 'English'
      }],
      regionManagersIdList: []
    };
    console.log('dateeee', Date.now());
  },

  mounted: function mounted() {
    this.getManagerList();
    this.getRegionList();
    this.getVehicle();
  },
  methods: (_methods = {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_4__services__["e" /* formService */].fieldClassName,
    getEligibleDate: function getEligibleDate(e) {
      var d = new Date();
      d.setMonth(d.getMonth() - 12 * 18);
      this.minDate = d;
    },
    highlight: function highlight(e) {
      console.log(e);
      Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      var date = new Date();
      var expiredDate = date.addDays(60);
      if (e.getTime() < expiredDate.getTime()) {
        console.log('e is less than 2 months');
        document.getElementById('licenseExpiryDiv').style.color = 'red';
      } else {
        document.getElementById('licenseExpiryDiv').style.color = 'black';
      }
    },
    onFilechanged: function onFilechanged(event) {
      this.formstatePhoto = false;
      var fileinput = document.getElementById('fileinput');
      if (event.target.files[0] != undefined) {
        if (['image/jpeg', 'image/jpg'].includes(event.target.files[0]['type'])) {
          this.photo = event.target.files[0];
          this.driver.driverImage = event.target.files[0]['name'];
          this.formstatePhoto = true;
        } else {
          this.$snotify.error('Upload jpeg,jpg files', 'Error!');
          fileinput.value = '';
          this.formstatePhoto = false;
        }
      }
    },
    onDocumentchanged: function onDocumentchanged(event) {
      this.formstateDocument = false;
      var fileinput = document.getElementById('fileinput1');
      if (event.target.files[0] != undefined) {
        if (['application/pdf'].includes(event.target.files[0]['type'])) {
          this.docs = event.target.files[0];
          this.driver.documents = event.target.files[0]['name'];
          this.formstateDocument = true;
        } else {
          this.$snotify.error('Upload pdf file', 'Error!');
          fileinput.value = '';
          this.formstateDocument = false;
        }
      }
    },
    uploadDocument: function uploadDocument(docId) {
      var formData = new FormData();
      if (this.photo) {
        formData.append('file', this.photo);
      }
      if (this.docs) {
        formData.append('file', this.docs);
      }
      formData.append('model', 'driver');
      formData.append('docId', docId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('fileUpload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        console.log(res);
        console.log('SUCCESS!!');
      }).catch(function () {
        console.log('FAILURE!!');
      });
    },
    getVehicle: function getVehicle() {
      var _this = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = '["' + this.user._id + '"]';
      }
      var vehicleList = [];
      this.$vehicleDataRepository.list(params).then(function (res) {
        _this.loading = false;
        if (res.data.docs) {
          vehicleList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.regNo,
              deviceId: item.deviceId
            };
          });
        }
        _this.vehicle_no = vehicleList;
      }).catch(function (error) {
        _this.loading = false;
        console.error('vehicle.requestFunction-error:', error);
        _this.$snotify.error('Get vehicle list failed', 'Error!');
      });
    },
    getDevice: function getDevice(e) {
      var _this2 = this;

      var _vehicle_no$filter = this.vehicle_no.filter(function (ele) {
        return ele.key == e.target.value;
      }),
          _vehicle_no$filter2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_vehicle_no$filter, 1),
          device = _vehicle_no$filter2[0];

      this.loading = true;
      var params = {};
      params.$limit = 0;

      if (device.deviceId) {
        params._id = device.deviceId;
        this.isDeviceDisable = true;
      }
      this.driver.deviceId = device.deviceId;
      var deviceList = [];
      this.$deviceDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          deviceList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.deviceId
            };
          });
        }
        _this2.device_id = deviceList;
      }).catch(function (error) {
        _this2.loading = false;
        console.error('device.requestFunction-error:', error);
        _this2.$snotify.error('Get device list failed', 'Error!');
      });
    },
    getRegionList: function getRegionList() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          if (_this3.user.roleName === 'Journey Manager' || _this3.user.roleName == 'GA Head') {
            regionlist = res.data.docs.map(function (item) {
              if (_this3.regionManagersIdList.includes(item._id)) {
                regionlist.push({
                  key: item._id,
                  value: item.name
                });
              }
              _this3.region_list = regionlist;
            });
          } else {
            regionlist = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this3.region_list = regionlist;
          }
          if (_this3.region_list.length === 1) {
            _this3.region_list ? _this3.driver.region = _this3.region_list[0].key : _this3.driver.region = '';;
          }
        }
      }).catch(function (error) {
        _this3.loading = false;
        console.error('Region.requestFunction-error:', error);
        _this3.$snotify.error('Get region list failed', 'Error!');
      });
    },
    getManagerList: function getManagerList() {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 3;
      var managerlist = [];
      if (this.user.roleName == 'Journey Manager') {
        params._id = '["' + this.user._id + '"]';
        this.isJourenyManagerDisable = true;
        this.driver.manager = this.user._id;
      }
      this.$userRepository.list(params).then(function (res) {
        _this4.loading = false;
        if (res.data.docs) {
          managerlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this4.manager = managerlist;
      }).catch(function (error) {
        _this4.loading = false;
        console.error('Manager.requestFunction-error:', error);
        _this4.$snotify.error('Get manager list failed', 'Error!');
      });
    },
    createDriver: function createDriver() {
      var _this5 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_4__services__["v" /* driverService */].addDriver(this.driver).then(function (response) {
        var docId = response._id;
        _this5.uploadDocument(docId);
        _this5.loading = false;
        _this5.flash = false;
        _this5.$snotify.success('Driver added!', 'Success!');
        _this5.$router.push('/driver');
      }, function (err) {
        _this5.loading = false;
        if (err.status === 409) {
          _this5.$snotify.error('Driver PIN already exists!', 'Failure!');
        }
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'validateRegistration', function validateRegistration(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 32) e.preventDefault();else this.vehicle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.vehicle, {
      regNo: e.target.value.toUpperCase()
    });
  }), _methods),

  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DriverDetail',
  data: function data() {
    return {
      regionManagersIdList: [],
      formstatePhoto: false,
      formstateDocument: false,
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_4__config__["h" /* USER_ROLES */],
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
      formstate: {},
      manager: {},
      vehicle_no: {},
      region_list: {},
      device_id: {},
      selectedFile: null,
      selectedDocument: null,
      form: new FormData(),
      expiryDate: '',
      minDate: '',
      driver: {},
      language: [{
        key: 'Hindi',
        value: 'Hindi'
      }, {
        key: 'Punjabi',
        value: 'Punjabi'
      }, {
        key: 'English',
        value: 'English'
      }]
    };
  },

  mounted: function mounted() {
    this.getManagerList();
    this.getRegionList();
    this.getVehicle();
    this.getDevice();
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,
    getEligibleDate: function getEligibleDate(e) {
      var d = new Date();
      d.setMonth(d.getMonth() - 12 * 18);
      this.minDate = d;
    },
    onFilechanged: function onFilechanged(event) {
      this.formstatePhoto = false;
      var fileinput = document.getElementById('fileinput');
      if (event.target.files[0] != undefined) {
        if (['image/jpeg', 'image/jpg'].includes(event.target.files[0]['type'])) {
          this.photo = event.target.files[0];
          this.driver.driverImage = event.target.files[0]['name'];
          this.formstatePhoto = true;
        } else {
          this.$snotify.error('Upload jpeg,jpg files', 'Error!');
          fileinput.value = '';
          this.formstatePhoto = false;
        }
      }
    },
    onDocumentchanged: function onDocumentchanged(event) {
      this.formstateDocument = false;
      var fileinput = document.getElementById('fileinput1');
      if (event.target.files[0] != undefined) {
        if (['application/pdf'].includes(event.target.files[0]['type'])) {
          this.docs = event.target.files[0];
          this.driver.documents = event.target.files[0]['name'];
          this.formstateDocument = true;
        } else {
          this.$snotify.error('Upload pdf file', 'Error!');
          fileinput.value = '';
          this.formstateDocument = false;
        }
      }
    },
    getManagerList: function getManagerList() {
      var _this = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 3;
      var managerlist = [];
      this.$userRepository.list(params).then(function (res) {
        _this.loading = false;
        if (res.data.docs) {
          managerlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this.manager = managerlist;
      }).catch(function (error) {
        _this.loading = false;
        console.error('Manager.requestFunction-error:', error);
        _this.$snotify.error('Get manager list failed', 'Error!');
      });
    },
    getDevice: function getDevice() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var deviceList = [];
      this.$deviceDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          deviceList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.deviceId
            };
          });
        }
        _this2.device_id = deviceList;
      }).catch(function (error) {
        _this2.loading = false;
        console.error('device.requestFunction-error:', error);
        _this2.$snotify.error('Get device list failed', 'Error!');
      });
    },
    onFileSelected: function onFileSelected(event) {
      this.selectedFile = event.target.files[0], console.log(this.selectedFile);
    },
    onDocumentSelected: function onDocumentSelected(event) {
      this.selectedDocument = event.target.files[0], console.log(this.selectedDocument);
    },
    onUploadPhoto: function onUploadPhoto() {
      this.form.append('driver.photo', this.selectedFile);
      var config = { headers: { 'Content-Type': 'multipart/form-data' } };
      axios.post('/backend/server/api/uploads/documents', this.form, config).then(function (response) {
        console.log(response);
      }).catch(function (err) {});
    },
    onUploadDocument: function onUploadDocument() {
      this.form.append('driver.otherInfo', this.selectedDocument);

      axios.post('/backend/server/api/uploads/documents', this.form).then(function (response) {
        console.log(response);
      }).catch(function (err) {});
    },
    getVehicle: function getVehicle() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      var vehicleList = [];
      this.$vehicleDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          vehicleList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.regNo
            };
          });
        }
        _this3.vehicle_no = vehicleList;
      }).catch(function (error) {
        _this3.loading = false;
        console.error('vehicle.requestFunction-error:', error);
        _this3.$snotify.error('Get vehicle list failed', 'Error!');
      });
    },
    getRegionList: function getRegionList() {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this4.loading = false;
        if (res.data.docs) {
          if (_this4.user.roleName === 'Journey Manager' || _this4.user.roleName == 'GA Head') {
            regionlist = res.data.docs.map(function (item) {
              if (_this4.regionManagersIdList.includes(item._id)) {
                regionlist.push({
                  key: item._id,
                  value: item.name
                });
              }
              _this4.region_list = regionlist;
            });
          } else {
            regionlist = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this4.region_list = regionlist;
          }
        }
      }).catch(function (error) {
        _this4.loading = false;
        console.error('Region.requestFunction-error:', error);
        _this4.$snotify.error('Get region list failed', 'Error!');
      });
    },
    getDriver: function getDriver() {
      var _this5 = this;

      this.$driverDataRepository.find(this.$route.params._id).then(function (response) {
        console.log('drive', response.data);
        _this5.driver = response.data;
        _this5.expiryDate = response.data.licenseExpiryDate;
        _this5.highlight(_this5.expiryDate);
      });
    },
    highlight: function highlight(expiryDate) {
      console.log('this.driver.licenseExpiryDate', this.expiryDate);
      var epochExpiryDate = new Date(this.expiryDate).getTime();
      console.log('epochExpiryDate', epochExpiryDate);
      Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      var date = new Date();
      var expiredDate = date.addDays(60);
      if (epochExpiryDate < expiredDate.getTime()) {
        console.log('e is less than 2 months');
        document.getElementById('licenseExpiryDiv').style.color = 'red';
      }
    },
    highlightAfterUpdate: function highlightAfterUpdate(e) {
      console.log(e);
      Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      var date = new Date();
      var expiredDate = date.addDays(60);
      if (e.getTime() < expiredDate.getTime()) {
        console.log('e is less than 2 months');
        document.getElementById('licenseExpiryDiv').style.color = 'red';
      } else {
        document.getElementById('licenseExpiryDiv').style.color = 'black';
      }
    },

    validateRegistration: function validateRegistration(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode == 32) e.preventDefault();else this.vehicle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.vehicle, {
        regNo: e.target.value.toUpperCase()
      });
    },
    updateDriver: function updateDriver() {
      var _this6 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_3__services__["v" /* driverService */].updateDriver(this.driver).then(function (response) {
        _this6.loading = false;
        _this6.flash = false;
        _this6.$snotify.success('Driver updated!', 'Success!');
        _this6.$router.push('/driver');
      }).catch(function (error) {
        _this6.loading = false;
        _this6.$snotify.error('Driver PIN already exists!', 'Failure!');
        if (error.data.message.includes('must be one of')) {
          _this6.flash = true;
          _this6.flashType = 'error';
          _this6.flashMessage = 'New driver add is failed.Please try again!';
        }
      });
    },
    deleteDriverModal: function deleteDriverModal() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this Driver!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        customClass: 'swal-modal2',
        width: '400px',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this7.deleteDriver();
        }
      });
    },
    deleteDriver: function deleteDriver() {
      var _this8 = this;

      this.loading = true;
      return this.$driverDataRepository.deleteOne(this.driver._id).then(function (response) {
        _this8.loading = false;
        return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Deleted!', 'Driver has been deleted.', 'success');
      }).then(function (response) {
        _this8.loading = false;
        _this8.$router.push('/driver');
      }).catch(function (error) {
        _this8.loading = false;
        _this8.$snotify.error('Delete driver failed', 'Error!');
      });
    }
  }, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }),
  created: function created() {
    var _this9 = this;

    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
    var promises = [];
    this.loading = true;
    promises.push(this.getDriver());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this9.loading = false;
      _this9.ready = true;
    }).catch(function () {
      _this9.loading = false;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ForgotPassword',
  data: function data() {
    return {
      loading: false,
      formstate: {},
      flash: false,
      flashType: null,
      flashMessage: '',
      accountActive: true,
      emailSent: false,
      email: '',
      password: ''
    };
  },

  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].fieldClassName,
    emailValidator: __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].emailValidator,
    sendResetLink: function sendResetLink() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].sendResetLink(this.email).then(function (response) {
        _this.loading = false;
        _this.emailSent = true;
        _this.flash = true;
        _this.flashType = 'success';
        _this.flashMessage = 'An email has been sent with further instructions.';
      }).catch(function (error) {
        _this.loading = false;
        console.error('ForgotPassword.sendResetLink-error:', error);
        _this.flash = true;
        _this.flashType = 'error';

        if (error.data.message === 'User not found.') {
          _this.flashMessage = 'No account was found with that email.';
        } else {
          _this.flashMessage = 'There was an error sending the email. ' + 'Please try again or contact us if you continue to have problems resetting your password.';
        }
      });
    }
  },
  created: function created() {
    this.flash = true;
    this.flashType = 'info';
    this.flashMessage = 'Please enter the email address for your account and click the button below to send ' + 'a reset password link.';
  }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_msal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_msal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_msal__ = __webpack_require__(308);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      loading: false,
      formstate: {},
      flash: false,
      flashType: null,
      user: null,
      flashMessage: '',
      accountActive: true,
      emailSent: false,
      email: '',
      reg: '^[A-Za-z0-9._%+-]+@think-gas.com$',
      password: '',
      entryPoint: "https://login.microsoftonline.com/1a63eded-aece-4b7f-a3d7-39828b274d9b/oauth2/v2.0/authorize?client_id=1b323a04-1682-4ec3-ae22-e39d3bf6f6ff&scope=openid%20profile&redirect_uri=https://jma-uat.think-gas.com&client-request-id=c6929d2d-b20e-421d-88f5-c7efb2183b9d&response_mode=fragment&response_type=code&x-client-SKU=msal.js.browser&x-client-VER=2.3.1&x-client-OS=&x-client-CPU=&client_info=1&code_challenge=XU0nWCx28IU6luV8FBTZP5jrmo_bJXviirh5c7d1fyg&code_challenge_method=S256&nonce=72c9b7f1-3d8a-4cf9-a62e-918faad8dc74&state=eyJpZCI6Ijk2ZDljNTgwLTM2NzYtNGNiMS05OTVjLTU0ZWVjZWJiMWRkYiIsInRzIjoxNjMzNDE3NzMyLCJtZXRhIjp7ImludGVyYWN0aW9uVHlwZSI6InBvcHVwIn19"

    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_msal__["msalMixin"]],
  computed: {
    loginFacebookURI: function loginFacebookURI() {
      return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/auth/facebook';
    }
  },
  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].fieldClassName,
    emailValidator: __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].emailValidator,
    login: function login() {
      var _this = this;

      var email = this.email,
          password = this.password;


      var string = this.email;

      var regexEmail = /^[A-Za-z0-9._%+-]+@think-gas.com$/;
      if (string.match(regexEmail)) {
        this.flash = true;
        this.flashType = 'error';
        this.flashMessage = "Already a think gas employee. Please click the button below to login.";
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].login({ email: email, password: password }).then(function (response) {
          _this.loading = false;
          _this.user = response;

          _this.$snotify.success('Login successful', 'Success!');
          _this.$router.push('/');
        }).catch(function (error) {
          _this.loading = false;
          console.error('Login.login-error:', error);
          _this.flash = true;
          _this.flashType = 'error';
          if (error.data.message === 'Invalid Email or Password.') {
            _this.flashMessage = error.data.message;
          } else if (error.data.message === 'Account is inactive.') {
            _this.accountActive = false;
            _this.flashType = 'info';
            _this.flashMessage = 'You need to activate your account. Please enter your email address and ' + 'click the link below to resend an activation email.';
          } else if (error.data.message === 'Account is disabled.') {
            _this.flashMessage = 'Your account has been disabled. Please contact the SuperAdmin ' + 'to enable your account.';
          } else if (error.data.message === 'Account is deleted.') {
            _this.flashMessage = 'This account has been deleted';
          } else if (error.data.message === 'Maximum number of auth attempts reached. Please try again later.') {
            _this.flashMessage = error.data.message;
          } else {
            _this.flashMessage = 'There was an error logging in, please try again.';
          }
        });
      }
    },
    getUserDetails: function getUserDetails(userId) {
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].getUserDetails(userId).then(function (response) {
        console.log("ress", response);
      }).catch(function (error) {
        console.error('Login.login-error:', error);
      });
    },
    sendActivationEmail: function sendActivationEmail() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].sendActivationEmail(this.email).then(function (response) {
        _this2.loading = false;
        _this2.emailSent = true;
        _this2.flash = true;
        _this2.flashType = 'success';
        _this2.flashMessage = 'Message sent. Please check your email for an account activation link.';
      }).catch(function (error) {
        console.error('Login.sendActivationEmail-error:', error);
        _this2.loading = false;
        _this2.flash = true;
        _this2.flashType = 'error';

        if (error.data.message === 'User not found.') {
          _this2.flashMessage = 'No account was found with that email.';
        } else {
          _this2.flashMessage = 'There was an error sending the email. ' + 'Please try again or contact us if you continue to have trouble creating an account.';
        }
      });
    }
  },
  created: function created() {
    this.email = this.$route.query.email || '';
    this.password = this.$route.query.password || '';
  }
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResetPassword',
  data: function data() {
    return {
      loading: false,
      error: false,
      formstate: {},
      flash: false,
      flashType: null,
      flashMessage: '',
      passwordReset: false,
      newPassword: '',
      confirmPassword: '',
      pin: null,
      pinRequired: true,
      passwordScore: 0,
      passwordScoreUpdating: false
    };
  },

  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].fieldClassName,
    emailValidator: __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].emailValidator,
    minlengthValidator: function minlengthValidator(minlength) {
      return function (input) {
        return __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].minlengthValidator(input.split('_')[0], minlength);
      };
    },
    passwordScoreValidator: function passwordScoreValidator() {
      return __WEBPACK_IMPORTED_MODULE_0__services__["e" /* formService */].passwordScoreValidator(this.passwordScore);
    },
    passwordConfirmValidator: function passwordConfirmValidator() {
      return true;
    },
    validateConfirm: function validateConfirm() {
      this.formstate.confirmPassword._validate();
    },
    resetPassword: function resetPassword() {
      var _this = this;

      console.log('this.$route.query.token', this.$route.query.token);
      var header = 'Authorization: Bearer ' + this.$route.query.token;
      if (this.newPassword != this.confirmPassword) {
        this.$snotify.error('Password do not match!');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        method: 'post',
        url: '/login/reset',
        headers: { Authorization: 'Bearer ' + this.$route.query.token },
        data: {
          token: this.$route.query.token,
          password: this.newPassword
        }
      }).then(function (res) {
        _this.passwordReset = true;
        _this.$snotify.success('Password reset done!');
      }).catch(function (e) {
        _this.$snotify.error('Try again.');
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.pinRequired = this.$route.query.pinRequired === 'true';
    if (!this.$route.query.token) {
      console.error('ResetPassword.init-error:', 'no token');
      this.flash = true;
      this.flashType = 'error';
      this.flashMessage = 'The link you used did not contain a token. Please click on the reset password link in your email ' + 'or proceed to the login page to request a new email.';
    }
    __WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].PASSWORD_SCORE_UPDATED, function (passwordScore) {
      _this2.passwordScoreUpdating = false;
      _this2.passwordScore = passwordScore;
    });
    __WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].UPDATING_PASSWORD_SCORE, function () {
      _this2.passwordScoreUpdating = true;
    });
  }
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentHeader',
  computed: {
    breadcrumbs: function breadcrumbs() {
      return this.$store.state.breadcrumbs;
    }
  },
  methods: {
    isActive: function isActive(index) {
      if (index === this.breadcrumbs.length - 1) {
        return 'active';
      } else {
        return 'not-active';
      }
    }
  }
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faker__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_vue__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentHeader_vue__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ContentHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sidebar_vue__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hideseek__);












/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Main',
	components: {
		MainHeader: __WEBPACK_IMPORTED_MODULE_4__MainHeader_vue___default.a,
		ContentHeader: __WEBPACK_IMPORTED_MODULE_5__ContentHeader_vue___default.a,
		Sidebar: __WEBPACK_IMPORTED_MODULE_6__Sidebar_vue___default.a
	},
	data: function data() {
		return {
			user: null,
			year: new Date().getFullYear(),
			classes: {
				fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
				hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
			},
			error: ''
		};
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userInfo']), {
		demo: function demo() {
			return {
				displayName: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.name.findName(),
				avatar: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.image.avatar(),
				email: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.internet.email(),
				randomCard: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.helpers.createCard()
			};
		},
		displayName: function displayName() {
			return this.user.firstName + ' ' + this.user.lastName;
		}
	}),
	methods: {
		changeloading: function changeloading() {
			this.$store.commit('TOGGLE_SEARCHING');
		}
	},
	created: function created() {
		this.user = this.$store.state.auth.user;
	}
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_Notifications_vue__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_Notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__utilities_Notifications_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainHeader',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_5__utilities_Notifications_vue___default.a
  },
  props: ['displayName', 'pictureUrl'],
  data: function data() {
    return {
      ready: false,
      loading: false,
      CHAT_TYPES: __WEBPACK_IMPORTED_MODULE_4__config__["i" /* CHAT_TYPES */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    conversations: function conversations(state) {
      return state.conversations;
    },
    notifications: function notifications(state) {
      return state.notifications;
    }
  }), {
    unreadConversationsCount: function unreadConversationsCount() {
      return this.conversations.reduce(function (count, conversation) {
        if (conversation.hasRead) {
          return count;
        } else {
          return count + 1;
        }
      }, 0);
    },
    unreadNotificationsCount: function unreadNotificationsCount() {
      return this.notifications.reduce(function (count, notification) {
        if (notification.hasRead) {
          return count;
        } else {
          return count + 1;
        }
      }, 0);
    }
  }),
  methods: {
    logout: function logout() {
      var _this = this;

      this.loading = true;
      localStorage.clear();
      sessionStorage.clear();
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var spcook = cookies[i].split("=");
        document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
      }
      this.$router.push('/login');
      this.$router.go();
      __WEBPACK_IMPORTED_MODULE_3__services__["d" /* authService */].logout().then(function (response) {
        _this.loading = false;
        _this.$snotify.success('Log Out successful', 'Success!');
      }).catch(function (error) {
        _this.loading = false;
        console.error('MainHeader.logout-error:', error);
      });
    },
    openNewGroupBox: function openNewGroupBox() {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].OPEN_CHAT_CREATE);
    },
    openNewMessageBox: function openNewMessageBox() {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].OPEN_CHAT, { new: true });
    },
    openChatBox: function openChatBox(conversation) {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].OPEN_CHAT, { conversation: conversation });
    },
    markConversationAsRead: function markConversationAsRead(conversation) {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].MARK_CONVERSATION_AS_READ, conversation);
    },
    markConversationAsUnread: function markConversationAsUnread(conversation) {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].MARK_CONVERSATION_AS_UNREAD, conversation);
    },
    markAllConversationsAsRead: function markAllConversationsAsRead() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.conversations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var conversation = _step.value;

          if (!conversation.hasRead) {
            this.markConversationAsRead(conversation);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    markNotificationAsRead: function markNotificationAsRead(notification) {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].MARK_NOTIFICATION_AS_READ, notification);
    },
    markNotificationAsUnread: function markNotificationAsUnread(notification) {
      __WEBPACK_IMPORTED_MODULE_3__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */].MARK_NOTIFICATION_AS_UNREAD, notification);
    },
    markAllNotificationsAsRead: function markAllNotificationsAsRead() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.notifications), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var notification = _step2.value;

          if (!notification.hasRead) {
            this.markNotificationAsRead(notification);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    userListTooltip: function userListTooltip(users) {
      var list = '';
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(users), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var user = _step3.value;

          if (list === '') {
            list = list + user.firstName + ' ' + user.lastName;
          } else {
            list = list + ', ' + user.firstName + ' ' + user.lastName;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return list;
    },
    goToProfile: function goToProfile(user) {
      this.$router.push({
        name: 'MemberProfile',
        params: { _id: user._id },
        props: user
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Sidebar',
	props: ['displayName', 'pictureUrl'],
	components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
	mounted: function mounted() {
		window.jQuery('[data-toggle="hideseek"]').off().hideseek();
	}
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarName',
  data: function data() {
    return {
      role: '',
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */]
    };
    console.log("userrrr", this.user);
  },
  created: function created() {
    this.user = this.$store.state.auth.user;
    this.role = this.$store.state.auth.user.roleName ? this.$store.state.auth.user.roleName.toUpperCase() : '';
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    user1: function user1(state) {
      return state.auth.user;
    }
  }))

});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OperatorReport',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
      loading: null,
      operatorReportTable: null,
      columns: ['siteCode', 'siteName', 'siteType', 'createdAt', 'shift', 'download'],
      options: {
        highlightMatches: true,
        sortable: ['siteName', 'siteType', 'siteCode', 'shift', 'createdAt'],

        headings: {
          siteName: 'Location',
          siteType: 'Location Type',
          siteCode: 'Location Code',
          createdAt: 'Date',
          shift: 'Shift',
          download: 'Download'
        },
        templates: {
          createdAt: function createdAt(row, query) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.createdAt).format('DD-MM-YYYY');
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;

          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$techchecklistDataRepository.list(params).catch(function (error) {
            console.error('techchecklist.requestFunction-error:', error);
            _this.$snotify.error('Get Checklist', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'ViewOperatorReport',
        params: {
          _id: data.row._id
        },
        props: data.row
      });
    },
    onLoaded: function onLoaded() {
      this.operatorReportTable = this.$refs.operatorReportTable;
    },
    download: function download(row) {
      var _this2 = this;

      var params = {};
      params.reportId = row._id;
      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].serverURI + '/checklistReport?reportId=' + row._id,
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log("response of download", response);
        _this2.forceFileDownload(response, row);
      }).catch(function (error) {
        _this2.$snotify.error('Report download failed', 'Error!');
      });
    },
    forceFileDownload: function forceFileDownload(response, row) {
      var url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'checklist.pdf');
      document.body.appendChild(link);
      link.click();
    }
  }

});

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ViewOperatorReport',
    data: function data() {
        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */],
            techchecklist: {},
            selectedDate: ''
        };
    },

    mounted: function mounted() {
        this.getReport();
    },
    methods: {
        getReport: function getReport() {
            var _this = this;

            this.$techchecklistDataRepository.find(this.$route.params._id).then(function (response) {
                _this.techchecklist = response.data;
                _this.selectedDate = response.data.selectedDate && __WEBPACK_IMPORTED_MODULE_4_moment___default()(response.data.selectedDate).format('DD-MM-YYYY hh:mm A');
            });
        }
    }

});

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfileImage_vue__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfileImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProfileImage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Profile',
  components: {
    ProfileImage: __WEBPACK_IMPORTED_MODULE_1__ProfileImage_vue___default.a
  },
  data: function data() {
    return {
      ready: false,
      loading: false,
      detailsActive: '',
      pictureActive: '',
      settingsActive: '',
      updateRequiredMessage: '',
      newProfile: {},
      oldProfile: {},
      passwordFormstate: {},
      formstate: {},
      pinFormstate: {},
      newPassword: '',
      confirmPassword: '',
      pin: null,
      passwordScore: 0,
      passwordScoreUpdating: false
    };
  },

  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,
    emailValidator: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].emailValidator,
    emailUniqueValidator: function emailUniqueValidator(email) {
      return __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].emailUniqueValidator(email, this.oldProfile.email);
    },
    minlengthValidator: function minlengthValidator(minlength) {
      return function (input) {
        return __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].minlengthValidator(input.split('_')[0], minlength);
      };
    },
    passwordScoreValidator: function passwordScoreValidator() {
      return __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].passwordScoreValidator(this.passwordScore);
    },
    passwordConfirmValidator: function passwordConfirmValidator(confirmPassword) {
      return __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].passwordConfirmValidator(this.newPassword, confirmPassword);
    },
    validateConfirm: function validateConfirm() {
      this.passwordFormstate.confirmPassword._validate();
    },
    clearChanges: function clearChanges() {
      this.newProfile = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(this.oldProfile);
      this.formstate._reset();
    },
    updateProfile: function updateProfile() {
      var _this = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].updateUserProfile(this.newProfile).then(function (response) {
        _this.loading = false;
        _this.formstate._reset();
        _this.oldProfile = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this.newProfile);

        var user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$store.state.auth.user, _this.newProfile);

        _this.$store.commit('auth/SET_USER', user);
        _this.$snotify.success('Profile updated', 'Success!');
      }).catch(function (error) {
        _this.loading = false;
        console.error('UserProfile.updateProfile-error:', error);
        _this.$snotify.error('Update profile failed', 'Error!');
      });
    },
    updatePassword: function updatePassword() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].updateUserPassword(this.newPassword).then(function (response) {
        _this2.loading = false;
        _this2.newPassword = '';
        _this2.confirmPassword = '';
        _this2.passwordFormstate._reset();

        var user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.$store.state.auth.user, { passwordUpdateRequired: false });
        _this2.$store.commit('auth/SET_USER', user);
        _this2.$snotify.success('Password updated', 'Success!');
      }).catch(function (error) {
        _this2.loading = false;
        console.error('UserProfile.updatePassword-error:', error);
        _this2.$snotify.error('Update password failed', 'Error!');
      });
    },
    updatePIN: function updatePIN() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].updateUserPIN(this.pin).then(function (response) {
        _this3.loading = false;
        _this3.pinFormstate._reset();

        var user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.$store.state.auth.user, { pinUpdateRequired: false });
        _this3.$store.commit('auth/SET_USER', user);
        _this3.$snotify.success('PIN updated', 'Success!');
      }).catch(function (error) {
        _this3.loading = false;
        console.error('UserProfile.updatePIN-error:', error);
        _this3.$snotify.error('Update pin failed', 'Error!');
      });
    },
    deleteUserModal: function deleteUserModal() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete your account!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this4.deleteUser();
        }
      });
    },
    deleteUser: function deleteUser() {
      var _this5 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].deleteCurrentAccount(this.newProfile._id).then(function (response) {
        _this5.loading = false;
        return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Deleted!', 'Your account has been deleted.', 'success');
      }).then(function (result) {
        __WEBPACK_IMPORTED_MODULE_2__services__["d" /* authService */].logout();
        _this5.$router.push('/login');
      }).catch(function (error) {
        _this5.loading = false;
        console.error('UserProfile.deleteUser-error:', error);
        _this5.$snotify.error('Delete account failed', 'Error!');
      });
    }
  },
  created: function created() {
    var _this6 = this;

    this.newProfile = function (_ref) {
      var email = _ref.email,
          firstName = _ref.firstName,
          lastName = _ref.lastName,
          title = _ref.title,
          education = _ref.education,
          location = _ref.location,
          bio = _ref.bio;

      return { email: email, firstName: firstName, lastName: lastName, title: title, education: education, location: location, bio: bio };
    }(this.$store.state.auth.user);

    this.oldProfile = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(this.newProfile);

    if (this.$route.query.settings) {
      this.settingsActive = 'active';
    } else {
      this.detailsActive = 'active';
    }

    if (this.$store.state.auth.user.passwordUpdateRequired && this.$store.state.auth.user.pinUpdateRequired) {
      this.updateRequiredMessage = 'You must update your password and PIN to continue.';
    } else if (this.$store.state.auth.user.passwordUpdateRequired) {
      this.updateRequiredMessage = 'You must update your password to continue.';
    } else if (this.$store.state.auth.user.pinUpdateRequired) {
      this.updateRequiredMessage = 'You must update your PIN to continue.';
    }

    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].PASSWORD_SCORE_UPDATED, function (passwordScore) {
      _this6.passwordScoreUpdating = false;
      _this6.passwordScore = passwordScore;
    });
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].UPDATING_PASSWORD_SCORE, function () {
      _this6.passwordScoreUpdating = true;
    });
  }
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileImage',
  data: function data() {
    return {
      ready: false,
      loading: false,
      profileloading: false,
      fileChosen: false,
      dirty: false,
      fileUploading: false,
      percentCompleted: 0,
      profileImage: null,
      profileImageName: '',
      profileImageType: '',
      profileImageUrl: null
    };
  },

  computed: {
    displayUrl: function displayUrl() {
      if (this.profileImageUrl.includes('gravatar')) {
        return this.profileImageUrl + '&s=256';
      } else {
        return this.profileImageUrl;
      }
    }
  },
  methods: {
    onReady: function onReady() {
      this.loading = false;
      this.ready = true;
    },
    onFileChoose: function onFileChoose(data) {
      this.dirty = true;
      this.fileChosen = true;
      this.profileImageName = data.name;
      this.profileImageType = data.type;
    },
    onImageRemove: function onImageRemove() {
      this.fileChosen = false;
    },
    onFileTypeMismatch: function onFileTypeMismatch() {
      this.$snotify.warning('File type must be png, jpg, or gif', 'Warning!');
    },
    onFileSizeExceed: function onFileSizeExceed() {
      this.$snotify.warning('Image size must be less than 100kb', 'Warning!');
    },
    setProfileImage: function setProfileImage() {
      var _this = this;

      this.fileUploading = true;
      this.profileloading = true;
      this.profileImage.generateBlob(function (blob) {
        return __WEBPACK_IMPORTED_MODULE_0__services__["l" /* fileService */].uploadProfileImage(_this.profileImageName, blob, {
          onUploadProgress: function onUploadProgress(progressEvent) {
            _this.percentCompleted = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
            console.log(_this.percentCompleted);
            if (_this.percentCompleted >= 100) {
              _this.fileUploading = false;
            }
          }
        }).then(function (response) {
          _this.profileImageUrl = response.data;
          return __WEBPACK_IMPORTED_MODULE_0__services__["k" /* userService */].updateUserProfile({ profileImageUrl: _this.profileImageUrl });
        }).then(function (response) {
          _this.profileloading = false;
          _this.fileChosen = false;
          _this.percentCompleted = 0;

          var user = _this.$store.state.auth.user;
          user.profileImageUrl = _this.profileImageUrl;
          _this.$store.commit('auth/SET_USER', user);
          _this.$snotify.success('Profile image updated', 'Success!');
        }).catch(function (error) {
          _this.loading = false;
          console.error('UserProfile.setProfileImage-error:', error);
          _this.$snotify.error('Update image failed', 'Error!');
        });
      }, this.profileImageType, 1);
    },
    removeProfileImage: function removeProfileImage() {
      var _this2 = this;

      this.loading = true;
      this.profileImageUrl = 'https://www.gravatar.com/avatar/' + this.$store.state.auth.user._id + '?r=PG&d=robohash';
      return __WEBPACK_IMPORTED_MODULE_0__services__["k" /* userService */].updateUserProfile({ profileImageUrl: this.profileImageUrl }).then(function (response) {
        _this2.loading = false;

        var user = _this2.$store.state.auth.user;
        user.profileImageUrl = _this2.profileImageUrl;
        _this2.$store.commit('auth/SET_USER', user);
        _this2.$snotify.success('Profile image removed', 'Success!');
      }).catch(function (error) {
        _this2.loading = false;
        console.error('UserProfile.removeProfileImage-error:', error);
        _this2.$snotify.error('Remove image failed', 'Error!');
      });
    }
  },
  created: function created() {
    this.profileImageUrl = this.$store.state.auth.user.profileImageUrl;
  }
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Region',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      regionManagersIdList: [],
      loading: null,
      regionsTable: null,
      columns: ['name', 'regionManagerFirstName', 'totalSite', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['name', 'regionManagerFirstName', 'totalSite', 'status'],
        headings: {
          name: 'Name',
          regionManagerFirstName: 'HCV Operation Manager',
          totalSite: 'Total Locations',
          status: 'Status'
        },
        templates: {
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          totalSite: function totalSite(row, query) {
            return query.siteCount;
          },
          regionManagerFirstName: function regionManagerFirstName(row, query) {
            return query.regionManagerFirstName + ' ' + query.regionManagerLastName;
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == 'GA Head') {
            params.regionManager = _this.user._id;
          }
          if (_this.user.roleName === 'Journey Manager') {
            params.journeyManager = _this.user._id;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$regionsDataRepository.list(params).catch(function (error) {
            _this.$snotify.error('Get Region', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.regionsTable) {
        return this.regionsTable.count > this.regionsTable.limit || this.regionsTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),

  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item.regionManager;
      });
    }
  },

  methods: {
    edit: function edit(data) {
      if (this.user.roleName === 'Admin') {
        this.$router.push({
          name: 'RegionDetail',
          params: { _id: data.row._id },
          props: data.row
        });
      }
    },
    exportData: function exportData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/v1/exportMaster?model=region',
        responseType: 'arraybuffer'
      }).then(function (response) {
        var arrayBuffer = response.data;
        var filename = 'Geographical_Areas.xlsx';
        _this2.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    onLoaded: function onLoaded() {
      this.regionsTable = this.$refs.regionsTable;
    }
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);


var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RegionCreate',
    data: function data() {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
            formstate: {},
            region: {
                status: 'active'
            },
            journey_managers: '',
            managers: '',
            jma_users: '',
            docsValid1: false,
            docsValid2: false,
            formValid: false,
            isJmaUserValid: true,
            isJourneyManagerUserValid: true
        };
    },

    mounted: function mounted() {
        this.getJourneyManager();
        this.getManager();
        this.getJmaUsers();
    },

    methods: (_methods = {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,
        updateFormValidity: function updateFormValidity() {
            this.formValid = this.docsValid1 && this.docsValid2;
        },
        onChanged1: function onChanged1() {
            this.docsValid1 = false;
            console.log('this.region.journeyManager', this.region.journeyManager);
            if (this.region.journeyManager.length > 0) {
                this.docsValid1 = true;
            }
            this.updateFormValidity();
        },
        onChanged2: function onChanged2() {
            this.docsValid2 = false;
            if (this.region.jmaUser.length > 0) {
                this.docsValid2 = true;
            }
            this.updateFormValidity();
        },
        createRegion: function createRegion() {
            var _this = this;

            this.loading = true;
            this.region.journeyManager = this.region.journeyManager.map(function (item) {
                return item.value;
            });
            this.region.jmaUser = this.region.jmaUser.map(function (item) {
                return item.value;
            });
            return __WEBPACK_IMPORTED_MODULE_1__services__["s" /* regionService */].addRegion(this.region).then(function (response) {
                _this.loading = false;
                _this.flash = false;
                _this.$snotify.success('G.A added!', 'Success!');
                _this.$router.push('/ga');
            }).catch(function (error) {
                _this.loading = false;
                _this.$snotify.error('Region Add failed!Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this.flash = true;
                    _this.flashType = 'error';
                    _this.flashMessage = 'New region add is failed.Please try again!';
                }
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getManager', function getManager() {
        var _this2 = this;

        this.loading = true;
        var params = {};
        params.$limit = 0;
        params.roleRank = 2;
        var managerlist = [];
        this.$userRepository.list(params).then(function (res) {
            _this2.loading = false;
            if (res.data.docs) {
                managerlist = res.data.docs.map(function (item) {
                    return {
                        key: item._id,
                        value: item.firstName + ' ' + item.lastName
                    };
                });
            }
            _this2.managers = managerlist;
        }).catch(function (error) {
            _this2.loading = false;
            console.error('Manager.requestFunction-error:', error);
            _this2.$snotify.error('Get manager list failed', 'Error!');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getJourneyManager', function getJourneyManager() {
        var _this3 = this;

        this.loading = true;
        var params = {};
        params.$limit = 0;
        params.roleRank = 3;
        var journeyManagerlist = [];
        this.$userRepository.list(params).then(function (res) {
            _this3.loading = false;

            if (res.data.docs) {
                journeyManagerlist = res.data.docs;
            }
            _this3.journey_managers = journeyManagerlist.map(function (item) {
                return {
                    value: item._id,
                    journeyManager: item.firstName + ' ' + item.lastName
                };
            });
        }).catch(function (error) {
            _this3.loading = false;
            console.error('Manager.requestFunction-error:', error);
            _this3.$snotify.error('Get Journey Manager list failed', 'Error!');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getJmaUsers', function getJmaUsers() {
        var _this4 = this;

        this.loading = true;
        var params = {};
        params.$limit = 0;
        params.roleRank = 10;
        params.isDeleted = false;
        params.isActive = true;
        var jmaUsersList = [];
        this.$userRepository.list(params).then(function (res) {
            _this4.loading = false;
            if (res.data.docs) {
                jmaUsersList = res.data.docs;
            }
            _this4.jma_users = jmaUsersList.map(function (item) {
                return {
                    value: item._id,
                    jmaUser: item.firstName + ' ' + item.lastName
                };
            });
        }).catch(function (error) {
            _this4.loading = false;
            console.error('Manager.requestFunction-error:', error);
            _this4.$snotify.error('Get Journey Manager list failed', 'Error!');
        });
    }), _methods)
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);



var _methods;





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RegionDetail',
  data: function data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
      formstate: {},
      region: {},
      journey_managers: '',
      journey: [],
      jmauser: [],
      managers: '',
      jma_users: '',
      flagButton: false,
      flagButton1: false
    };
  },

  mounted: function mounted() {
    this.getManager();
  },
  methods: (_methods = {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,

    flagButtonCheck: function flagButtonCheck() {
      if (this.region.journeyManager.length > 0) {
        this.flagButton = true;
        this.formstate.status.$dirty = true;
      } else {
        this.flagButton = false;
      }
    },
    flagButtonCheck1: function flagButtonCheck1() {
      if (this.region.jmaUser.length > 0) {
        this.flagButton1 = true;
        this.formstate.status.$dirty = true;
      } else {
        this.flagButton1 = false;
      }
    },
    getRegion: function getRegion() {
      var _this = this;

      return this.$regionDataRepository.find(this.$route.params._id).then(function (response) {
        _this.region = response.data;
        console.log('aaaaaaaaaaaaaaaaaaaaaaa', _this.region);
        if (_this.region.journeyManager.length > 0) {
          _this.flagButton = true;
        }
        if (_this.region.jmaUser && _this.region.jmaUser.length > 0) {
          _this.flagButton1 = true;
        }
        _this.getJourneyManager();
        _this.getJmaUsers();
      }).catch(function (error) {
        _this.$snotify.error('Region detail failed', 'Error!');
      });
    },
    updateRegion: function updateRegion() {
      var _this2 = this;

      this.loading = true;
      this.region.journeyManager = this.region.journeyManager.map(function (item) {
        return item.value;
      });
      this.region.jmaUser = this.region.jmaUser.map(function (item) {
        return item.value;
      });
      return __WEBPACK_IMPORTED_MODULE_2__services__["s" /* regionService */].updateRegion(this.region).then(function (response) {
        _this2.loading = false;
        _this2.flash = false;
        _this2.$snotify.success('Region updated!', 'Success!');
        _this2.$router.push('/ga');
      }).catch(function (error) {
        _this2.loading = false;
        _this2.$snotify.error('Region update failed!Try Again', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this2.flash = true;
          _this2.flashType = 'error';
          _this2.flashMessage = 'New region update is failed.Please try again!';
        }
      });
    },
    deleteRegionModal: function deleteRegionModal() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this Geographic Area!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this3.deleteRegion();
        }
      });
    },
    deleteRegion: function deleteRegion() {
      var _this4 = this;

      this.loading = true;
      return this.$regionDataRepository.deleteOne(this.region._id).then(function (response) {
        _this4.loading = false;
        return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Deleted!', 'Geographical Area has been deleted.', 'success');
      }).then(function (response) {
        _this4.loading = false;
        _this4.$router.push('/ga');
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$snotify.error('Delete region failed', 'Error!');
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'getManager', function getManager() {
    var _this5 = this;

    this.loading = true;
    var params = {};
    params.$limit = 0;
    params.roleRank = 2;
    var managerlist = [];
    this.$userRepository.list(params).then(function (res) {
      _this5.loading = false;
      if (res.data.docs) {
        managerlist = res.data.docs.map(function (item) {
          return {
            key: item._id,
            value: item.firstName + ' ' + item.lastName
          };
        });
      }
      _this5.managers = managerlist;
    }).catch(function (error) {
      _this5.loading = false;
      console.error('Manager.requestFunction-error:', error);
      _this5.$snotify.error('Get manager list failed', 'Error!');
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'getJourneyManager', function getJourneyManager() {
    var _this6 = this;

    this.loading = true;
    var params = {};
    params.$limit = 0;
    params.roleRank = 3;
    var journeyManagerlist = [];
    this.$userRepository.list(params).then(function (res) {
      _this6.loading = false;
      if (res.data.docs) {
        journeyManagerlist = res.data.docs;
      }
      _this6.journey_managers = journeyManagerlist.map(function (item) {
        return {
          value: item._id,
          journeyManager: item.firstName + ' ' + item.lastName
        };
      });

      journeyManagerlist.map(function (item) {
        if (_this6.region.journeyManager.includes(item._id)) {
          _this6.journey.push({
            value: item._id,
            journeyManager: item.firstName + ' ' + item.lastName
          });
        }
      });

      _this6.region.journeyManager = _this6.journey;
      console.log('this.region.journeyManager', _this6.region.journeyManager, _this6.journey);
    }).catch(function (error) {
      _this6.loading = false;
      console.error('Manager.requestFunction-error:', error);
      _this6.$snotify.error('Get Journey Manager list failed', 'Error!');
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'getJmaUsers', function getJmaUsers() {
    var _this7 = this;

    this.loading = true;
    var params = {};
    params.$limit = 0;
    params.roleRank = 10;
    params.isDeleted = false;
    params.isActive = true;
    var jmaUsersList = [];
    this.$userRepository.list(params).then(function (res) {
      _this7.loading = false;
      if (res.data.docs) {
        jmaUsersList = res.data.docs;
        _this7.jma_users = jmaUsersList.map(function (item) {
          return {
            value: item._id,
            jmaUser: item.firstName + ' ' + item.lastName
          };
        });

        jmaUsersList.map(function (item) {
          if (_this7.region.jmaUser && _this7.region.jmaUser.includes(item._id)) {
            _this7.jmauser.push({
              value: item._id,
              jmaUser: item.firstName + ' ' + item.lastName
            });
          }
        });
        _this7.region.jmaUser = _this7.jmauser;
      }
    }).catch(function (error) {
      _this7.loading = false;
      console.error('Manager.requestFunction-error:', error);
      _this7.$snotify.error('Get Journey Manager list failed', 'Error!');
    });
  }), _methods),

  created: function created() {
    var _this8 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getRegion());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this8.loading = false;
      _this8.ready = true;
    }).catch(function () {
      _this8.loading = false;
    });
  }
});

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActivateAccount',
  data: function data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      accountActive: true,
      emailSent: false,
      email: '',
      password: ''
    };
  },

  methods: {
    proceedToLogin: function proceedToLogin() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].logout().then(function (response) {
        _this.loading = false;

        _this.$router.push('/login');
      }).catch(function (error) {
        _this.loading = false;
        console.error('MainHeader.logout-error:', error);
      });
    },
    activateAccount: function activateAccount(token) {
      var _this2 = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].activateAccount(token).then(function (response) {
        _this2.loading = false;

        _this2.flash = true;
        _this2.flashType = 'success';
        console.log('ActivateAccount.activateAccount-success:\n', response);
        _this2.flashMessage = 'Congratulations! Your account has been activated. ' + 'Please proceed to the login page to sign in with your account.';
      }).catch(function (error) {
        _this2.loading = false;

        _this2.flash = true;
        _this2.flashType = 'error';
        console.error('ActivateAccount.activateAccount-error:\n', error);
        _this2.flashMessage = 'There was an error during the activation process. The token in your email link may be expired, ' + 'you can request a new activation email to be sent during your next login attempt.';
      });
    }
  },
  created: function created() {
    if (this.$route.query.token) {
      this.activateAccount(this.$route.query.token);
    } else {
      console.error('ActivateAccount.init-error:', 'no token');
      this.flash = true;
      this.flashType = 'error';
      this.flashMessage = 'The link you used did not contain a token. Please click on the activation link in your email ' + 'to activate your account, or proceed to login to request a new activation email.';
    }
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Report',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: null,
      report: {},
      forDelete: [],
      number: 0,
      reportgenerationTable: null,
      columns: ['checkbox', 'reportType', 'downloadType', 'reportCriterion', 'startDate', 'endDate', 'createdAt', 'generatedBy', 'vehicleNo', 'download', 'delete'],
      options: {
        highlightMatches: true,
        sortable: ['reportType', 'downloadType', 'startDate', 'endDate', 'createdAt', 'vehicleNo', 'generatedBy'],
        headings: {
          checkbox: '',
          reportType: 'Report Type',
          downloadType: 'Download Type',
          reportCriterion: 'Report Criterion',
          startDate: 'Report Start Date',
          endDate: 'Report End Date',
          createdAt: 'Generated At',
          generatedBy: 'Generated By',
          vehicleNo: 'Vehicle No.',
          download: 'Download',
          Delete: 'delete'
        },
        templates: {
          reportType: function reportType(row, query) {
            if (query.reportType == 'hcv_ms') {
              return "Data HCV Mother Station";
            } else if (query.reportType == 'hcv_dbs') {
              return "Data HCV Daughter Station";
            } else if (query.reportType == 'logbook') {
              return "Vehicle Log Book";
            } else if (query.reportType == 'dsr') {
              return "Data Sales Report";
            } else if (query.reportType == 'driver') {
              return "Driver Compliance Report";
            } else if (query.reportType == 'vehicle') {
              return "Vehicle Compliance Report";
            }
          },
          vehicleNo: function vehicleNo(row, query) {
            if (query.vehicleIdRegNo) {
              return query.vehicleIdRegNo;
            } else {
              return '--';
            }
          },
          reportCriterion: function reportCriterion(row, query) {
            if (query.regionName && query.stationSiteName) {
              return query.regionName + '-' + query.stationSiteName;
            } else if (query.regionName) {
              return '' + query.regionName;
            } else if (query.stationSiteName) {
              return '' + query.stationSiteName;
            }
          },
          startDate: function startDate(row, query) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.startDate).format('DD-MM-YYYY');
          },
          endDate: function endDate(row, query) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.endDate).format('DD-MM-YYYY');
          },
          createdAt: function createdAt(row, query) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.createdAt).format('DD-MM-YYYY');
          },
          generatedBy: function generatedBy(row, query) {
            return query.generatedByFirstName + ' ' + query.generatedByLastName;
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == "GA Head") {
            params.regionRegionManager = _this.user._id;
          }
          if (_this.regionManagersIdList.length !== 0) {
            params.region = _this.regionManagersIdList;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = '-createdAt';
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$reportgenerationDataRepository.list(params).catch(function (error) {
            _this.$snotify.error('Get Report Generation History failed', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          console.log("response.data", response.data);
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.reportgenerationTable) {
        return this.reportgenerationTable.count > this.reportgenerationTable.limit || this.reportgenerationTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },

  methods: {
    onLoaded: function onLoaded() {
      this.reportgenerationTable = this.$refs.reportgenerationTable;
    },
    multiDelete: function multiDelete(e, row) {
      if (e.target.checked) {
        this.forDelete.push(row);
        this.deleteIds = this.forDelete.map(function (i) {
          return i._id;
        });
      } else {
        this.forDelete = this.forDelete.filter(function (i) {
          return i._id != row._id;
        });
        this.deleteIds.filter(function (i) {
          i != row._id;
        });
      }
    },
    deleteMultiple: function deleteMultiple() {
      var _this2 = this;

      this.number = this.forDelete.length;

      this.deleteIds = this.forDelete.map(function (item) {
        return {
          _id: item._id,
          hardDelete: false
        };
      });

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this ' + this.number + ' Report!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this2.loading = true;
          return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete('/reportgeneration', {
            data: _this2.deleteIds
          }).then(function (response) {
            _this2.forDelete = [];
            _this2.deleteIds = [];
            _this2.$refs.reportgenerationTable.refresh();

            _this2.loading = false;
            return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('Deleted!', 'Report has been deleted.', 'success');
          }).catch(function (error) {
            _this2.loading = false;
            _this2.$snotify.error('Delete report failed', 'Error!');
          });
        }
      });
    },
    deleteReport: function deleteReport(row) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this Report!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this3.reportDelete(row);
        }
      });
    },
    reportDelete: function reportDelete(row) {
      var _this4 = this;

      this.loading = true;
      return this.$reportgenerationDataRepository.deleteOne(row._id).then(function (response) {
        _this4.$refs.reportgenerationTable.refresh();
        _this4.loading = false;
        return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('Deleted!', 'Report has been deleted.', 'success');
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$snotify.error('Delete report failed', 'Error!');
      });
    },
    download: function download(row) {
      var _this5 = this;

      if (row.reportType == 'hcv_ms' || row.reportType == 'hcv_dbs' || row.reportType == 'trip_analysis') {
        var params = {};
        params.reportType = row.reportType;
        params.downloadType = row.downloadType;
        params.startDate = row.startDate;
        params.endDate = row.endDate;
        params.region = row.region;
        params.station = row.station;
        params.reportCode = row.reportCode;
        __WEBPACK_IMPORTED_MODULE_5_axios___default()({
          method: 'get',
          url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/report?reportType=' + row.reportType + '&downloadType=' + row.downloadType + '&startDate=' + row.startDate + '&endDate=' + row.endDate + '&station=' + row.station + '&region=' + row.region + '&reportCode=' + row.reportCode,
          responseType: 'arraybuffer'
        }).then(function (response) {
          _this5.forceFileDownload(response, row);
        }).catch(function (error) {
          _this5.$snotify.error('Report download failed', 'Error!');
        });
      } else if (row.reportType == "logbook") {
        var _params = {};
        _params.reportType = row.reportType;
        _params.downloadType = row.downloadType;
        _params.startDate = row.startDate;
        _params.endDate = row.endDate;
        _params.region = row.region;
        _params.reportCode = row.reportCode;
        _params.vehicleId = row.vehicleId;
        _params.allVehicle = row.allVehicle;
        if (row.vehicleId) {
          __WEBPACK_IMPORTED_MODULE_5_axios___default()({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/report?reportType=' + row.reportType + '&downloadType=' + row.downloadType + '&startDate=' + row.startDate + '&endDate=' + row.endDate + '&region=' + row.region + '&reportCode=' + row.reportCode + '&vehicleId=' + row.vehicleId + '&allVehicle=' + row.allVehicle,
            responseType: 'arraybuffer'
          }).then(function (response) {
            _this5.forceFileDownload(response, row);
          }).catch(function (error) {
            _this5.$snotify.error('Report download failed', 'Error!');
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5_axios___default()({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/report?reportType=' + row.reportType + '&downloadType=' + row.downloadType + '&startDate=' + row.startDate + '&endDate=' + row.endDate + '&region=' + row.region + '&reportCode=' + row.reportCode + '&allVehicle=' + row.allVehicle,
            responseType: 'arraybuffer'
          }).then(function (response) {
            _this5.forceFileDownload(response, row);
          }).catch(function (error) {
            _this5.$snotify.error('Report download failed', 'Error!');
          });
        }
      } else if (row.reportType == "dsr") {
        var _params2 = {};
        _params2.reportType = row.reportType;
        _params2.downloadType = row.downloadType;
        _params2.startDate = row.startDate;
        _params2.endDate = row.endDate;
        _params2.region = row.region;
        _params2.station = row.station;
        _params2.reportCode = row.reportCode;
        __WEBPACK_IMPORTED_MODULE_5_axios___default()({
          method: 'get',
          url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/report?reportType=' + row.reportType + '&downloadType=' + row.downloadType + '&startDate=' + row.startDate + '&endDate=' + row.endDate + '&station=' + row.station + '&region=' + row.region + '&reportCode=' + row.reportCode,
          responseType: 'arraybuffer'
        }).then(function (response) {
          _this5.forceFileDownload(response, row);
        }).catch(function (error) {
          _this5.$snotify.error('Report download failed', 'Error!');
        });
      } else if (row.reportType == "driver" || row.reportType == "vehicle") {
        var _params3 = {};
        _params3.reportType = row.reportType;
        _params3.downloadType = row.downloadType;
        _params3.startDate = row.startDate;
        _params3.endDate = row.endDate;
        _params3.region = row.region;
        _params3.reportCode = row.reportCode;
        __WEBPACK_IMPORTED_MODULE_5_axios___default()({
          method: 'get',
          url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/report?reportType=' + row.reportType + '&downloadType=' + row.downloadType + '&startDate=' + row.startDate + '&endDate=' + row.endDate + '&region=' + row.region + '&reportCode=' + row.reportCode + '&allVehicle=' + row.allVehicle,
          responseType: 'arraybuffer'
        }).then(function (response) {
          _this5.forceFileDownload(response, row);
        }).catch(function (error) {
          _this5.$snotify.error('Report download failed', 'Error!');
        });
      }
    },
    forceFileDownload: function forceFileDownload(response, row) {
      if (row.downloadType == "XLSX") {
        var url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

        }));
        var link = document.createElement('a');
        link.href = url;
        if (row.reportType == "logbook") {
          link.setAttribute('download', row.reportCode + '.xlsx');
        } else {
          link.setAttribute('download', row.regionName + '-' + row.reportType + '.xlsx');
        }
        document.body.appendChild(link);
        link.click();
      } else {
        if (row.downloadType == "PDF") {
          var _url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/pdf'
          }));
          var _link = document.createElement('a');
          _link.href = _url;
          if (row.reportType == "logbook") {
            _link.setAttribute('download', row.reportCode + '.pdf');
          } else {
            _link.setAttribute('download', row.regionName + '-' + row.reportType + '.pdf');
          }
          document.body.appendChild(_link);
          _link.click();
        }
      }
    }
  }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportCreate',
  data: function data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
      formstate: {},
      station_list: {},
      region_list: {},
      ga_managers: {},
      vehicle_no: {},
      disabledInput: false,
      isGADisable: false,
      boolean: false,
      reportgeneration: {},
      generatedBy: '',
      regionManagersIdList: []
    };
  },

  mounted: function mounted() {
    this.getRegionList();
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,

    getGAHead: function getGAHead() {
      var _this = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 2;
      var gaHeadList = [];
      this.$userRepository.list(params).then(function (res) {
        _this.loading = false;
        if (res.data.docs) {
          gaHeadList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this.ga_managers = gaHeadList;
      }).catch(function (error) {
        _this.loading = false;
        _this.$snotify.error('Get GA Head list failed', 'Error!');
      });
    },
    getRegionList: function getRegionList() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      if (this.user.roleName === 'GA Head') {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = '["' + this.user._id + '"]';
      }
      params.$limit = 0;
      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          if (_this2.user.roleName === 'Journey Manager' || _this2.user.roleName == 'GA Head') {
            regionlist = res.data.docs.map(function (item) {
              if (_this2.regionManagersIdList.includes(item._id)) {
                regionlist.push({
                  key: item._id,
                  value: item.name
                });
              }
              _this2.region_list = regionlist;
            });
          } else {
            regionlist = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this2.region_list = regionlist;
          }
        }
      }).catch(function (error) {
        _this2.loading = false;
        console.error('Region.requestFunction-error:', error);
        _this2.$snotify.error('Get region list failed', 'Error!');
      });
    },
    getSelectiveStation: function getSelectiveStation(e) {
      var _this3 = this;

      var params = {};
      params.$limit = 0;
      if (this.reportgeneration.region) {
        params.region = this.reportgeneration.region;
      }
      if (e.target.value == 'hcv_ms') {
        params.siteType = 'MS';
      }
      if (e.target.value == 'hcv_dbs' || e.target.value == 'dsr') {
        params.siteType = 'DBS';
      }
      var stationlist = [];
      this.$siteDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          stationlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.siteName
            };
          });
        }
        _this3.station_list = stationlist;
        if (_this3.user.roleName == 'Journey Manager') {
          _this3.getStationList();
        }
      }).catch(function (error) {
        _this3.loading = false;
        console.error('Site.requestFunction-error:', error);
        _this3.$snotify.error('Get station list failed', 'Error!');
      });
    },
    getStationList: function getStationList(e) {
      var _this4 = this;

      if (this.reportgeneration.reportType !== 'driver' && this.reportgeneration.reportType !== 'vehicle') {
        var params = {};
        params.$limit = 0;
        this.user.roleName != 'Journey Manager' ? params.region = e.target.value : params.region = this.region_list[0].key;
        if (this.reportgeneration.reportType == 'hcv_ms') {
          params.siteType = 'MS';
        }
        if (this.reportgeneration.reportType == 'hcv_dbs' || this.reportgeneration.reportType == 'dsr') {
          params.siteType = 'DBS';
        }
        var stationlist = [];
        this.$siteDataRepository.list(params).then(function (res) {
          _this4.loading = false;
          if (res.data.docs) {
            stationlist = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.siteName
              };
            });
          }
          _this4.station_list = stationlist;
        }).catch(function (error) {
          _this4.loading = false;
          console.error('Site.requestFunction-error:', error);
          _this4.$snotify.error('Get station list failed', 'Error!');
        });
      }
      if (this.reportgeneration.reportType == 'logbook') {
        var vehicleList = [];
        var params1 = {};
        params1.$limit = 0;
        this.user.roleName == 'Journey Manager' ? params1.region = this.region_list[0].key : params1.region = e.target.value;
        this.$vehicleDataRepository.list(params1).then(function (res) {
          _this4.loading = false;
          if (res.data.docs) {
            vehicleList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.regNo
              };
            });
          }
          _this4.vehicle_no = vehicleList;
        }).catch(function (error) {
          _this4.loading = false;
          console.error('vehicle.requestFunction-error:', error);
          _this4.$snotify.error('Get vehicle list failed', 'Error!');
        });
      }
    },
    createReport: function createReport() {
      var _this5 = this;

      this.loading = true;
      if (this.reportgeneration.vehicleId == 'all') {
        this.boolean = true;
        delete this.reportgeneration.vehicleId;
      }
      this.reportgeneration.startDate = new Date(this.reportgeneration.startDate);
      this.reportgeneration.endDate = new Date(this.reportgeneration.endDate);

      this.reportgeneration = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.reportgeneration, {
        generatedBy: this.user._id,
        allVehicle: this.boolean
      });
      return __WEBPACK_IMPORTED_MODULE_3__services__["p" /* reportgenerationService */].addReport(this.reportgeneration).then(function (response) {
        _this5.loading = false;
        _this5.flash = false;
        _this5.$snotify.success('Report generated!', 'Success!');
        _this5.$router.push('/reports');
        if (response.reportType == 'hcv_ms' || response.reportType == 'hcv_dbs') {
          __WEBPACK_IMPORTED_MODULE_5_axios___default()({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/report?reportType=' + response.reportType + '&downloadType=' + response.downloadType + '&startDate=' + response.startDate + '&endDate=' + response.endDate + '&station=' + response.station + '&region=' + response.region + '&reportCode=' + response.reportCode,
            responseType: 'arraybuffer'
          }).then(function (response) {
            console.log('response of download', response);
          });
        } else if (response.reportType == 'dsr') {
          __WEBPACK_IMPORTED_MODULE_5_axios___default()({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/report?reportType=' + response.reportType + '&downloadType=' + response.downloadType + '&startDate=' + response.startDate + '&endDate=' + response.endDate + '&station=' + response.station + '&region=' + response.region + '&reportCode=' + response.reportCode,
            responseType: 'arraybuffer'
          }).then(function (response) {
            console.log('response of download', response);
          });
        } else if (response.reportType == 'logbook') {
          if (response.vehicleId) {
            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
              method: 'get',
              url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/report?reportType=' + response.reportType + '&downloadType=' + response.downloadType + '&startDate=' + response.startDate + '&endDate=' + response.endDate + '&region=' + response.region + '&reportCode=' + response.reportCode + '&vehicleId=' + response.vehicleId + '&allVehicle=' + response.allVehicle,
              responseType: 'arraybuffer'
            }).then(function (response) {
              console.log('response of download', response);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
              method: 'get',
              url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/report?reportType=' + response.reportType + '&downloadType=' + response.downloadType + '&startDate=' + response.startDate + '&endDate=' + response.endDate + '&region=' + response.region + '&reportCode=' + response.reportCode + '&allVehicle=' + response.allVehicle,
              responseType: 'arraybuffer'
            }).then(function (response) {
              console.log('response of download', response);
            });
          }
        } else if (response.reportType == 'vehicle' || response.reportType == 'driver') {
          __WEBPACK_IMPORTED_MODULE_5_axios___default()({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/report?reportType=' + response.reportType + '&downloadType=' + response.downloadType + '&startDate=' + response.startDate + '&endDate=' + response.endDate + '&region=' + response.region + '&reportCode=' + response.reportCode,
            responseType: 'arraybuffer'
          }).then(function (response) {
            console.log('response of download', response);
          });
        } else if (response.reportType == 'trip_analysis') {
          __WEBPACK_IMPORTED_MODULE_5_axios___default()({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/report?reportType=' + response.reportType + '&downloadType=' + response.downloadType + '&startDate=' + response.startDate + '&endDate=' + response.endDate + '&station=' + response.station + '&region=' + response.region + '&reportCode=' + response.reportCode,
            responseType: 'arraybuffer'
          }).then(function (response) {
            console.log('response of download', response);
          });
        }
      });
    }
  }, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportSchedule',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: null,
      schedulereportTable: null,
      columns: ['reportType', 'reportFrequency', 'vehicleNo', 'scheduleStartDate', 'scheduleEndDate', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['reportType', 'reportFrequency', 'vehicleNo', 'scheduleStartDate', 'scheduleEndDate', 'status'],
        headings: {
          reportType: 'Report Type',
          reportFrequency: 'Schedule Type',
          vehicleNo: 'Vehicle No',
          scheduleStartDate: 'Schedule Start Date',
          scheduleEndDate: 'Schedule End Date',
          status: 'Status'
        },
        templates: {
          vehicleNo: function vehicleNo(row, query) {
            if (query.vehicleIdRegNo) {
              return query.vehicleIdRegNo;
            }
          },
          reportType: function reportType(row, query) {
            if (query.reportType == 'hcv_ms') {
              return "Data HCV Mother Station";
            } else if (query.reportType == 'hcv_dbs') {
              return "Data HCV Daughter Station";
            } else if (query.reportType == 'logbook') {
              return "Vehicle Log Book";
            } else if (query.reportType == 'dsr') {
              return "Data Sales Report";
            }
          },
          scheduleStartDate: function scheduleStartDate(row, query) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.scheduleStartDate).format('DD-MM-YYYY');
          },
          scheduleEndDate: function scheduleEndDate(row, query) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.scheduleEndDate).format('DD-MM-YYYY');
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          reportFrequency: function reportFrequency(row, query) {
            return query.reportFrequency[0].toUpperCase() + query.reportFrequency.slice(1);
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == "GA Head") {
            params.regionRegionManager = _this.user._id;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$schedulereportDataRepository.list(params).catch(function (error) {
            console.error('Report.requestFunction-error:', error);
            _this.$snotify.error('Get Report Schedule History failed', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          console.log("response", response);
          console.log("end date ", response.data.docs.scheduleEndDate);
          var endDate = new Date(response.data.docs.scheduleEndDate);
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.schedulereportTable) {
        return this.schedulereportTable.count > this.schedulereportTable.limit || this.schedulereportTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'ReportScheduleDetails',
        params: { _id: data.row._id },
        props: data.row
      });
    },
    onLoaded: function onLoaded() {
      this.schedulereportTable = this.$refs.schedulereportTable;
    },
    download: function download() {}
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ReportScheduleCreate',
    data: function data() {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
            formstate: {},
            station_list: {},
            region_list: {},
            user_list: {},
            disabledInput: true,
            disabledVehicleInput: true,
            vehicle_no: {},
            first: [],
            scheduledTime: '',
            last: [],
            boolean: false,
            disabledDates: {
                to: new Date(Date.now() - 8640000)
            },
            schedulereport: {
                status: 'active',
                emailTo: [],
                emailCc: [],
                lastDays: 1
            }

        };
    },

    mounted: function mounted() {
        this.getRegionList();
        this.getUserList();
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,
        getName: function getName(e) {
            this.first = event.target.options[event.target.selectedIndex].getAttribute('first');
            console.log("this.first", this.first);
        },
        validateReportFrequency: function validateReportFrequency(event) {
            if (event.target.value == 'weekly') {
                this.disabledInput = false;
            } else {
                this.disabledInput = true;
                delete this.schedulereport.scheduleDay;
            }
        },
        getRegionList: function getRegionList() {
            var _this = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this.region_list = regionlist;
            }).catch(function (error) {
                _this.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getSelectiveStation: function getSelectiveStation(e) {
            var _this2 = this;

            var params = {};
            params.$limit = 0;
            if (this.schedulereport.region) {
                params.region = this.schedulereport.region;
            }
            if (e.target.value == "hcv_ms") {
                params.siteType = "MS";
            }
            if (e.target.value == "hcv_dbs" || e.target.value == "dsr") {
                params.siteType = "DBS";
            }
            var stationlist = [];
            this.$siteDataRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    stationlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.siteName
                        };
                    });
                }
                _this2.station_list = stationlist;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('Site.requestFunction-error:', error);
                _this2.$snotify.error('Get station list failed', 'Error!');
            });
        },
        getStationList: function getStationList(e) {
            var _this3 = this;

            var params = {};
            params.$limit = 0;
            params.region = e.target.value;
            if (this.schedulereport.reportType == "hcv_ms") {
                params.siteType = "MS";
            }
            if (this.schedulereport.reportType == "hcv_dbs" || e.target.value == "dsr") {
                params.siteType = "DBS";
            }
            var stationlist = [];
            this.$siteDataRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    stationlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.siteName
                        };
                    });
                }
                _this3.station_list = stationlist;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('Site.requestFunction-error:', error);
                _this3.$snotify.error('Get station list failed', 'Error!');
            });
            this.disabledVehicleInput = false;
            var vehicleList = [];
            var params1 = {};
            params1.$limit = 0;
            params1.region = e.target.value;
            this.$vehicleDataRepository.list(params1).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    vehicleList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.regNo

                        };
                    });
                }
                _this3.vehicle_no = vehicleList;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('vehicle.requestFunction-error:', error);
                _this3.$snotify.error('Get vehicle list failed', 'Error!');
            });
        },
        getUserList: function getUserList() {
            var _this4 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var userlist = [];
            this.$userRepository.list(params).then(function (res) {
                _this4.loading = false;
                if (res.data.docs) {
                    userlist = res.data.docs;
                }
                _this4.user_list = userlist.map(function (item) {
                    return {
                        value: item.email,
                        user: item.firstName + ' ' + item.lastName
                    };
                });
            }).catch(function (error) {
                _this4.loading = false;
                console.error('User.requestFunction-error:', error);
                _this4.$snotify.error('Get user list failed', 'Error!');
            });
        },
        createSchedule: function createSchedule() {
            var _this5 = this;

            this.loading = true;
            if (this.schedulereport.vehicleId == 'all') {
                this.boolean = true, delete this.schedulereport.vehicleId;
            }
            this.schedulereport = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.schedulereport, {
                allVehicle: this.boolean,
                reportGenerationTime: this.scheduledTime
            });
            return __WEBPACK_IMPORTED_MODULE_2__services__["o" /* schedulereportService */].addReport(this.schedulereport).then(function (response) {
                _this5.loading = false;
                _this5.flash = false;
                _this5.$snotify.success('Report Scheduled!', 'Success!');
                _this5.$router.push('/report_settings');
            }).catch(function (error) {
                _this5.loading = false;
                console.log("error", error);
                _this5.$snotify.error('report schedulereport failed!Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this5.flash = true;
                    _this5.flashType = 'error';
                    _this5.flashMessage = 'report schedule is failed.Please try again!';
                }
                _this5.$router.push('/report_settings');
            });
        }
    }, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    })

});

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);



var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ReportScheduleDetails',
    data: function data() {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
            formstate: {},
            station_list: {},
            region_list: {},
            user_list: {},
            disabledInput: false,
            disabledVehicleInput: false,
            boolean: false,
            emailTo: [],
            vehicle_no: {},
            emailCc: [],
            schedulereport: {
                emailTo: [],
                emailCc: []
            }
        };
    },

    mounted: function mounted() {
        this.getRegionList();
        this.getStationList();
        this.getUserList();
        this.getSchedule();
    },
    methods: (_methods = {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,

        validateReportFrequency: function validateReportFrequency() {
            if (event.target.value == 'weekly') {
                this.disabledInput = false;
            } else {
                this.disabledInput = true;
                delete this.schedulereport.scheduleDay;
            }
        },
        getSchedule: function getSchedule() {
            var _this = this;

            return this.$schedulereportDataRepository.find(this.$route.params._id).then(function (response) {
                console.log("response", response);
                _this.schedulereport = response.data;
                if (_this.schedulereport.allVehicle == true) {
                    _this.schedulereport.vehicleId == 'all';
                }
                if (response.data.scheduleDay) {
                    _this.disabledInput = false;
                } else {
                    _this.disabledInput = true;
                }
                if (response.data.vehicleId || response.data.allVehicle == true) {
                    _this.disabledVehicleInput = false;
                } else {
                    _this.disabledVehicleInput = true;
                }
            }).catch(function (error) {
                console.error("error", error);
                _this.$snotify.error('Report Schedule detail failed', 'Error!');
            });
        },
        updateSchedule: function updateSchedule() {
            var _this2 = this;

            this.loading = true;
            if (this.schedulereport.reportType == 'logbook') {
                delete this.schedulereport.station;
            }
            if (this.schedulereport.vehicleId == 'all') {
                this.boolean = true, delete this.schedulereport.vehicleId;
            }
            this.schedulereport = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.schedulereport, {
                allVehicle: this.boolean
            });
            return __WEBPACK_IMPORTED_MODULE_2__services__["o" /* schedulereportService */].updateSchedule(this.schedulereport).then(function (response) {
                _this2.loading = false;
                _this2.flash = false;
                _this2.$snotify.success('Schedule updated!', 'Success!');
                _this2.$router.push('/report_settings');
            }).catch(function (error) {
                _this2.loading = false;
                _this2.$snotify.error('Schedule update failed!Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this2.flash = true;
                    _this2.flashType = 'error';
                    _this2.flashMessage = 'Schedule update failed.Please try again!';
                }
                _this2.$router.push('/report_settings');
            });
        },
        deleteschedulereportModal: function deleteschedulereportModal() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                title: 'Are you sure?',
                text: 'This will permanently delete this Schedule!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    _this3.deleteSchedule();
                }
            });
        },
        deleteSchedule: function deleteSchedule() {
            var _this4 = this;

            this.loading = true;
            return this.$schedulereportDataRepository.deleteOne(this.schedulereport._id).then(function (response) {
                _this4.loading = false;
                return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Deleted!', 'Schedule has been deleted.', 'success');
            }).then(function (response) {
                _this4.loading = false;
                _this4.$router.push('/report_settings');
            }).catch(function (error) {
                _this4.loading = false;
                _this4.$snotify.error('Delete Schedule failed', 'Error!');
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getRegionList', function getRegionList() {
        var _this5 = this;

        this.loading = true;
        var params = {};
        params.$limit = 0;
        var regionlist = [];
        this.$regionDataRepository.list(params).then(function (res) {
            _this5.loading = false;
            if (res.data.docs) {
                regionlist = res.data.docs.map(function (item) {
                    return {
                        key: item._id,
                        value: item.name
                    };
                });
            }
            _this5.region_list = regionlist;
        }).catch(function (error) {
            _this5.loading = false;
            console.error('Region.requestFunction-error:', error);
            _this5.$snotify.error('Get region list failed', 'Error!');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getSelectiveStation', function getSelectiveStation(e) {
        var _this6 = this;

        var params = {};
        params.$limit = 0;
        if (this.schedulereport.region) {
            params.region = this.schedulereport.region;
        }
        if (e.target.value == "hcv_ms") {
            params.siteType = "MS";
        }
        if (e.target.value == "hcv_dbs" || e.target.value == "dsr") {
            params.siteType = "DBS";
        }
        var stationlist = [];
        this.$siteDataRepository.list(params).then(function (res) {
            _this6.loading = false;
            if (res.data.docs) {
                stationlist = res.data.docs.map(function (item) {
                    return {
                        key: item._id,
                        value: item.siteName
                    };
                });
            }
            _this6.station_list = stationlist;
        }).catch(function (error) {
            _this6.loading = false;
            console.error('Site.requestFunction-error:', error);
            _this6.$snotify.error('Get station list failed', 'Error!');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getSites', function getSites(e) {
        var _this7 = this;

        var params = {};
        params.$limit = 0;
        this.schedulereport.station = '';
        params.region = e.target.value;
        if (this.schedulereport.reportType == 'hcv_ms') {
            params.siteType = 'MS';
        }
        if (this.schedulereport.reportType == 'hcv_dbs' || e.target.value == "dsr") {
            params.siteType = 'DBS';
        }
        var stationlist = [];
        this.$siteDataRepository.list(params).then(function (res) {
            _this7.loading = false;
            if (res.data.docs) {
                stationlist = res.data.docs.map(function (item) {
                    return {
                        key: item._id,
                        value: item.siteName
                    };
                });
            }
            _this7.station_list = stationlist;
        }).catch(function (error) {
            _this7.loading = false;
            console.error('Site.requestFunction-error:', error);
            _this7.$snotify.error('Get station list failed', 'Error!');
        });
        var vehicleList = [];
        var params1 = {};
        params1.$limit = 0;
        params1.region = e.target.value;
        this.$vehicleDataRepository.list(params1).then(function (res) {
            _this7.loading = false;
            if (res.data.docs) {
                vehicleList = res.data.docs.map(function (item) {
                    return {
                        key: item._id,
                        value: item.regNo

                    };
                });
            }
            _this7.vehicle_no = vehicleList;
        }).catch(function (error) {
            _this7.loading = false;
            console.error('vehicle.requestFunction-error:', error);
            _this7.$snotify.error('Get vehicle list failed', 'Error!');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getStationList', function getStationList() {
        var _this8 = this;

        this.loading = true;
        var params = {};
        params.$limit = 0;
        var stationlist = [];
        this.$siteDataRepository.list(params).then(function (res) {
            _this8.loading = false;
            if (res.data.docs) {
                stationlist = res.data.docs.map(function (item) {
                    return {
                        key: item._id,
                        value: item.siteName
                    };
                });
            }
            _this8.station_list = stationlist;
        }).catch(function (error) {
            _this8.loading = false;
            console.error('Site.requestFunction-error:', error);
            _this8.$snotify.error('Get station list failed', 'Error!');
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getUserList', function getUserList() {
        var _this9 = this;

        this.loading = true;
        var params = {};
        params.$limit = 0;
        var userlist = [];
        this.$userRepository.list(params).then(function (res) {
            _this9.loading = false;
            if (res.data.docs) {
                userlist = res.data.docs;
            }
            _this9.user_list = userlist.map(function (item) {
                return {
                    value: item.email,
                    user: item.firstName + ' ' + item.lastName
                };
            });
        }).catch(function (error) {
            _this9.loading = false;
            console.error('User.requestFunction-error:', error);
            _this9.$snotify.error('Get user list failed', 'Error!');
        });
    }), _methods)
});

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RolePermissions_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RolePermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RolePermissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RoleCreate',
  components: {
    RolePermissions: __WEBPACK_IMPORTED_MODULE_0__RolePermissions_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
      role: {},
      roles: [],
      permissions: [],
      formstate: {}
    };
  },

  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,
    createRole: function createRole() {
      var _this = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_1__services__["r" /* roleService */].createRole(this.role).then(function (response) {
        _this.loading = false;
        _this.flash = false;
        _this.$snotify.success('Role created', 'Success!');
        _this.$router.push('/roles');
      }).catch(function (error) {
        _this.loading = false;
        console.error('RoleCreate.createRole-error:', error);
        _this.$snotify.error('Create role failed', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this.flash = true;
          _this.flashType = 'error';
          _this.flashMessage = 'That role name is not allowed. You must first update the list of allowed role names' + ' in the thinkGas server config.';
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].PERMISSIONS_UPDATED, function (newPermissions) {
      _this2.role.permissions = newPermissions;
    });
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RolePermissions_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RolePermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RolePermissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RoleDetails',
  components: {
    RolePermissions: __WEBPACK_IMPORTED_MODULE_1__RolePermissions_vue___default.a
  },
  data: function data() {
    return {
      ready: false,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      roleUpdated: null,
      EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
      newRole: {},
      oldRole: {},
      roles: [],
      permissions: [],
      formstate: {}
    };
  },

  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,
    getRole: function getRole() {
      var _this = this;

      var params = {
        $embed: ['permissions']
      };

      return this.$roleRepository.find(this.$route.params._id, params).then(function (response) {
        _this.newRole = response.data;
        _this.oldRole = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this.newRole);
        _this.$store.dispatch('setBreadcrumbTitle', _this.newRole.name);
      }).catch(function (error) {
        console.error('RoleDetails.getRole-error:', error);
        _this.$snotify.error('Get role failed', 'Error!');
      });
    },
    clearChanges: function clearChanges() {
      this.newRole = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.oldRole);
      this.formstate._reset();
    },
    updateRole: function updateRole() {
      var _this2 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_2__services__["r" /* roleService */].updateRole(this.newRole, this.oldRole).then(function (response) {
        _this2.loading = false;
        _this2.flash = false;
        _this2.formstate._reset();
        _this2.oldRole = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this2.newRole);
        _this2.$snotify.success('Role updated', 'Success!');
      }).catch(function (error) {
        _this2.loading = false;
        console.error('RoleDetails.updateRole-error:', error);
        _this2.$snotify.error('Update role failed', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this2.flash = true;
          _this2.flashType = 'error';
          _this2.flashMessage = 'That role name is not allowed. You must first update the list of allowed role names' + ' in the appy client and server config.';
        }
      });
    },
    deleteRoleModal: function deleteRoleModal() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this role!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this3.deleteRole();
        }
      });
    },
    deleteRole: function deleteRole() {
      var _this4 = this;

      this.loading = true;
      return this.$roleRepository.deleteOne(this.newRole._id).then(function (response) {
        _this4.loading = false;
        return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Deleted!', 'Role has been deleted.', 'success');
      }).then(function (response) {
        _this4.loading = false;
        _this4.$router.push('/roles');
      }).catch(function (error) {
        _this4.loading = false;
        console.error('RoleDetails.deleteRole-error:', error);
        _this4.$snotify.error('Delete role failed', 'Error!');
      });
    },
    updatePermissions: function updatePermissions(newPermissions) {
      this.newRole.permissions = newPermissions;
      this.formstate.roleUpdated._setDirty();
    }
  },
  created: function created() {
    var _this5 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getRole());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this5.loading = false;
      _this5.ready = true;
    }).catch(function () {
      _this5.loading = false;
    });
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].PERMISSIONS_UPDATED, this.updatePermissions);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].PERMISSIONS_UPDATED, this.updatePermissions);
  }
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RolePermissions',
  props: ['role'],
  data: function data() {
    return {
      lodash: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a,
      loading: null,
      dirty: false,
      newRole: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.role),
      oldRole: null,
      PERMISSION_STATES: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */],
      permissionSearchText: null,
      availablePermissions: [],
      selectedAvailablePermissions: [],
      selectedRolePermissions: [],
      selectedIncludedPermissions: [],
      selectedExcludedPermissions: [],
      selectedForbiddenPermissions: [],
      includedToState: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].INCLUDED,
      excludedToState: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].EXCLUDED,
      forbiddenToState: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].FORBIDDEN
    };
  },

  watch: {
    selectedIncludedPermissions: function selectedIncludedPermissions(val) {
      this.selectedRolePermissions = [].concat(val, this.selectedExcludedPermissions, this.selectedForbiddenPermissions);
    },
    selectedExcludedPermissions: function selectedExcludedPermissions(val) {
      this.selectedRolePermissions = [].concat(val, this.selectedIncludedPermissions, this.selectedForbiddenPermissions);
    },
    selectedForbiddenPermissions: function selectedForbiddenPermissions(val) {
      this.selectedRolePermissions = [].concat(val, this.selectedExcludedPermissions, this.selectedIncludedPermissions);
    },
    role: function role(val) {
      this.newRole = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(val);
      this.newRole.permissions = this.newRole.permissions || [];
      this.getAvailablePermissions();
      this.dirty = false;
    }
  },
  computed: {
    permissionDescription: function permissionDescription() {
      var permission = (this.selectedAvailablePermissions[0] || {}).permission || (this.selectedRolePermissions[0] || {}).permission;
      if (permission) {
        return permission.name + ': ' + permission.description;
      }

      return 'Select a permission to see its description.';
    },
    includedPermissions: function includedPermissions() {
      return this.newRole.permissions.filter(function (permission) {
        return permission.state === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].INCLUDED;
      });
    },
    excludedPermissions: function excludedPermissions() {
      return this.newRole.permissions.filter(function (permission) {
        return permission.state === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].EXCLUDED;
      });
    },
    forbiddenPermissions: function forbiddenPermissions() {
      return this.newRole.permissions.filter(function (permission) {
        return permission.state === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].FORBIDDEN;
      });
    }
  },
  methods: {
    getAvailablePermissions: function getAvailablePermissions() {
      var _this = this;

      this.loading = true;
      var rolePermissionIds = this.newRole.permissions.map(function (object) {
        return object.permission._id;
      });
      var params = {};
      if (this.permissionSearchText) {
        params.$term = this.permissionSearchText;
        params.$searchFields = ['name'];
      }
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(rolePermissionIds)) {
        params.$exclude = rolePermissionIds;
      }
      return __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].getAvailablePermissions(params).then(function (response) {
        _this.loading = false;
        _this.availablePermissions = response.data.docs.map(function (permission) {
          return { permission: permission, state: _this.PERMISSION_STATES.INCLUDED };
        });
        _this.sortLists();
      }).catch(function (error) {
        _this.loading = false;
        console.error('RolePermissions.getAvailablePermissions-error:\n', error);
        _this.$snotify.error('There was an error loading the permissions', 'Error!');
      });
    },
    addPermissions: function addPermissions() {
      var _this2 = this;

      this.dirty = true;
      this.newRole.permissions = this.newRole.permissions.concat(this.selectedAvailablePermissions);

      this.availablePermissions = this.availablePermissions.filter(function (object) {
        return !_this2.selectedAvailablePermissions.find(function (selectedObject) {
          return selectedObject.permission._id === object.permission._id;
        });
      });

      this.selectedAvailablePermissions = [];
      this.sortLists();
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newRole.permissions);
    },
    removePermissions: function removePermissions() {
      var _this3 = this;

      this.dirty = true;
      this.availablePermissions = this.availablePermissions.concat(this.selectedRolePermissions);

      this.newRole.permissions = this.newRole.permissions.filter(function (object) {
        return !_this3.selectedRolePermissions.find(function (selectedObject) {
          return selectedObject.permission._id === object.permission._id;
        });
      });

      this.selectedRolePermissions = [];
      this.sortLists();
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newRole.permissions);
    },
    sortLists: function sortLists() {
      this.newRole.permissions.sort(function (a, b) {
        return a.permission.name.localeCompare(b.permission.name);
      });

      this.availablePermissions.sort(function (a, b) {
        return a.permission.name.localeCompare(b.permission.name);
      });
    },
    applyStateToIncluded: function applyStateToIncluded() {
      this.dirty = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedIncludedPermissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var permission = _step.value;

          permission.state = this.includedToState;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.selectedIncludedPermissions = [];
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newRole.permissions);
    },
    applyStateToExcluded: function applyStateToExcluded() {
      this.dirty = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedExcludedPermissions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var permission = _step2.value;

          permission.state = this.excludedToState;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.selectedExcludedPermissions = [];
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newRole.permissions);
    },
    applyStateToForbidden: function applyStateToForbidden() {
      this.dirty = true;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedForbiddenPermissions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var permission = _step3.value;

          permission.state = this.forbiddenToState;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.selectedForbiddenPermissions = [];
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newRole.permissions);
    },
    updateRolePermissions: function updateRolePermissions() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__services__["r" /* roleService */].updateRolePermissions(this.newRole._id, this.newRole.permissions, this.oldRole.permissions).then(function (response) {
        _this4.loading = false;
        _this4.dirty = false;
        _this4.oldRole = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this4.newRole);
        __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_SAVED);
        _this4.$snotify.success('Role permissions updated', 'Success!');
      }).catch(function (error) {
        _this4.loading = false;
        console.error('RolePermissions.updateRolePermissions-error:', error);
        _this4.$snotify.error('Update role permissions failed', 'Error!');
      });
    }
  },
  created: function created() {
    this.newRole.permissions = this.newRole.permissions || [];
    this.oldRole = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.newRole);
    this.getAvailablePermissions();
  }
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Roles',
  data: function data() {
    var _this = this;

    return {
      loading: null,
      roleTable: null,
      columns: ['name', 'description', 'edit'],
      options: {
        highlightMatches: true,
        sortable: ['name', 'description'],
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = '-rank';
          }
          if (request.query) {
            params.$term = request.query;
          }
          _this.loading = true;
          return _this.$roleRepository.list(params).catch(function (error) {
            console.error('Roles.requestFunction-error:', error);
            _this.$snotify.error('Get roles failed', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: {
    addButtonClass: function addButtonClass() {
      if (this.documentTable) {
        return this.documentTable.count > this.documentTable.limit ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  },
  methods: {
    edit: function edit(row) {
      this.$router.push({
        name: 'RoleDetails',
        params: {
          _id: row._id
        },
        props: row
      });
    },
    rowClick: function rowClick(data) {
      this.$refs.roleTable.toggleChildRow(data.row._id);
    },
    onLoaded: function onLoaded() {
      this.roleTable = this.$refs.roleTable;
    }
  }
});

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SiteCreate',
    data: function data() {
        return {
            loading: false,
            isGeographicalAreaDisable: false,
            isGAHeadDisable: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
            formstate: {},
            sales_managers: {},
            region_list: {},
            ga_managers: {},
            device_id: {},
            maxAddress: 150,
            max: 20,
            photo: {},
            mother_station_name: {},
            strUser: '',
            site: {
                region: '',
                salesManager: '',
                customerName: '',
                supervisor: '',
                siteType: '',
                status: 'active',
                siteInfoImage: ''
            }
        };
    },

    mounted: function mounted() {
        this.getRegionList();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        selectGA: function selectGA(e) {
            var region = this.site.region;
            var regionData = this.region_list.filter(function (el) {
                return el.key === region;
            });
            this.getMotherStation(region);
            this.getGAHead(regionData);
        },
        onFilechanged: function onFilechanged(event) {
            this.photo = event.target.files[0];
            this.site.siteInfoImage = event.target.files[0]['name'];
        },

        fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,
        createSite: function createSite() {
            var _this = this;

            this.loading = true;
            this.site = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.site, {
                siteInfoImage: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.site.siteInfoImage)
            });
            return __WEBPACK_IMPORTED_MODULE_3__services__["g" /* siteService */].addSite(this.site).then(function (response) {
                var docId = response._id;
                _this.uploadDocument(docId);
                _this.loading = false;
                _this.flash = false;
                _this.$snotify.success('Location added!', 'Success!');
                _this.$router.push('/location');
            }).catch(function (error) {
                _this.loading = false;
                _this.$snotify.error('Location Add failed!Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this.flash = true;
                    _this.flashType = 'error';
                    _this.flashMessage = 'New Location add is failed.Please try again!';
                }
            });
        },
        getMotherStation: function getMotherStation(region) {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var motherStationList = [];
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/motherStations?regionName=' + region).then(function (res) {
                _this2.loading = false;
                if (res.data.docs && res.data.docs) {
                    motherStationList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.siteName

                        };
                    });
                }
                console.log('motherStationList', motherStationList);
                _this2.mother_station_name = motherStationList;
                console.log('motherStationList', _this2.mother_station_name);
            }).catch(function (error) {
                _this2.loading = false;
                console.error('driver.requestFunction-error:', error);
                _this2.$snotify.error('Get driver list failed', 'Error!');
            });
        },
        uploadDocument: function uploadDocument(docId) {
            var formData = new FormData();
            formData.append('file', this.photo);
            formData.append('model', "location");
            formData.append("docId", docId);
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('fileUpload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                console.log(res);
                console.log('SUCCESS!!');
            }).catch(function () {
                console.log('FAILURE!!');
            });
        },
        getRegionList: function getRegionList() {
            var _this3 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            if (this.user.roleName == "GA Head") {
                params.regionManager = this.user._id;
            }
            if (this.user.roleName === "Journey Manager") {
                params.journeyManager = '["' + this.user._id + '"]';
                this.isGeographicalAreaDisable = true;
                this.isGAHeadDisable = true;
            }
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name,
                            gaKey: item.regionManager,
                            gaValue: item.regionManagerFirstName + ' ' + item.regionManagerLastName
                        };
                    });
                }
                _this3.region_list = regionlist;
                if (_this3.region_list.length === 1) {
                    _this3.region_list ? _this3.site.region = _this3.region_list[0].key : _this3.site.region = '';
                }
            }).catch(function (error) {
                _this3.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this3.$snotify.error('Get Geographic Areas list failed', 'Error!');
            });
        },
        getSalesManager: function getSalesManager() {
            var _this4 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 4;
            var salesManagerList = [];
            this.$userRepository.list(params).then(function (res) {
                _this4.loading = false;
                if (res.data.docs) {
                    salesManagerList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this4.sales_managers = salesManagerList;
            }).catch(function (error) {
                _this4.loading = false;
                console.error('Sales Manager.requestFunction-error:', error);
                _this4.$snotify.error('Get Sales manager list failed', 'Error!');
            });
        },
        getGAHead: function getGAHead(regionData) {
            var _this5 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 2;
            params._id = regionData[0].gaKey;
            var gaHeadList = [];
            this.$userRepository.list(params).then(function (res) {
                _this5.loading = false;
                if (res.data.docs) {
                    gaHeadList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this5.ga_managers = gaHeadList;
            }).catch(function (error) {
                _this5.loading = false;
                console.error('Sales Manager.requestFunction-error:', error);
                _this5.$snotify.error('Get Sales manager list failed', 'Error!');
            });
        }
    }, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SiteDetail',
  data: function data() {
    return {
      regionManagersIdList: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_5__config__["h" /* USER_ROLES */],
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */],
      formstate: {},
      sales_managers: {},
      region_list: {},
      device_id: {},
      ga_managers: {},
      photo: {},
      maxAddress: 150,
      max: 20,
      mother_station_name: {},
      strUser: '',
      site: {},
      photoSiteInfoImae: false
    };
  },

  mounted: function mounted() {
    this.getRegionList();
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
    onFilechanged: function onFilechanged(event) {
      this.photoSiteInfoImae = true;
      this.photo = event.target.files[0];
      this.site.siteInfoImage = event.target.files[0]['name'];
    },

    fieldClassName: __WEBPACK_IMPORTED_MODULE_4__services__["e" /* formService */].fieldClassName,

    getSite: function getSite() {
      var _this = this;

      return this.$siteDataRepository.find(this.$route.params._id).then(function (response) {
        _this.site = response.data;
        _this.getMotherStation(_this.site.region);
        _this.getGAHead(_this.site.supervisor);
      }).catch(function (error) {
        _this.$snotify.error('Location detail failed', 'Error!');
      });
    },
    getMotherStation: function getMotherStation(region) {
      var _this2 = this;

      this.loading = true;
      var motherStationList = [];
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].serverURI + '/motherStations?regionName=' + region).then(function (res) {
        _this2.loading = false;
        if (res.data.docs && res.data.docs) {
          motherStationList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.siteName
            };
          });
        }
        _this2.mother_station_name = motherStationList;
      }).catch(function (error) {
        _this2.loading = false;
        _this2.$snotify.error('Get driver list failed', 'Error!');
      });
    },
    updateSite: function updateSite() {
      var _this3 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_4__services__["g" /* siteService */].updateSite(this.site).then(function (response) {

        var docId = response._id;

        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this3.photo).length !== 0) {
          console.log('this.photo', _this3.photo);
          _this3.uploadDocument(docId);
        }
        _this3.loading = false;
        _this3.flash = false;
        _this3.$snotify.success('Location updated!', 'Success!');
        _this3.$router.push('/location');
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$snotify.error('Location Add failed! Try Again', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this3.flash = true;
          _this3.flashType = 'error';
          _this3.flashMessage = 'New Location add is failed.Please try again!';
        }
      });
    },
    getGAHead: function getGAHead(regionManager) {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 2;
      params._id = regionManager;
      var gaHeadList = [];
      this.$userRepository.list(params).then(function (res) {
        _this4.loading = false;
        if (res.data.docs) {
          gaHeadList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this4.ga_managers = gaHeadList;
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$snotify.error('Get Sales manager list failed', 'Error!');
      });
    },
    uploadDocument: function uploadDocument(docId) {
      var formData = new FormData();
      formData.append('file', this.photo);
      formData.append('model', 'location');
      formData.append('docId', docId);
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('fileUpload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        console.log(res);
        console.log('SUCCESS!!');
      }).catch(function () {
        console.log('FAILURE!!');
      });
    },
    selectGA: function selectGA(e) {
      var region = this.site.region;
      var regionData = this.region_list.filter(function (el) {
        return el.key === region;
      });
      this.getMotherStation(region);
      this.getGAHead(regionData[0].gaKey);
    },
    deleteSiteModal: function deleteSiteModal() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this Location!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this5.deleteSite();
        }
      });
    },
    deleteSite: function deleteSite() {
      var _this6 = this;

      this.loading = true;
      return this.$siteDataRepository.deleteOne(this.site._id).then(function (response) {
        _this6.loading = false;
        return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('Deleted!', 'Location has been deleted.', 'success');
      }).then(function (response) {
        _this6.loading = false;
        _this6.$router.push('/location');
      }).catch(function (error) {
        _this6.loading = false;
        _this6.$snotify.error('Delete Location failed', 'Error!');
      });
    },
    getRegionList: function getRegionList() {
      var _this7 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName === 'Journey Manager') {
        params.journeyManager = '["' + this.user._id + '"]';
        this.isGeographicalAreaDisable = true;
        this.isGAHeadDisable = true;
      }
      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this7.loading = false;
        if (res.data.docs) {
          regionlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.name,
              gaKey: item.regionManager,
              gaValue: item.regionManagerFirstName + ' ' + item.regionManagerLastName
            };
          });
        }
        _this7.region_list = regionlist;
      }).catch(function (error) {
        _this7.loading = false;
        _this7.$snotify.error('Get Geographic Areas list failed', 'Error!');
      });
    }
  }, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }),
  created: function created() {
    var _this8 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getSite());
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this8.loading = false;
      _this8.ready = true;
    }).catch(function () {
      _this8.loading = false;
    });
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item.regionManager;
      });
    }
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sites',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],
      parameters: '',
      journey_managers: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      loading: null,
      siteTable: null,
      regionValue: 'all',

      columns: ['siteCode', 'siteName', 'supervisor', 'siteType', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['siteCode', 'siteName', 'supervisor', 'regionName', 'siteType', 'status'],
        headings: {
          siteCode: 'Location Code',
          siteName: 'Location Name',
          supervisor: 'HCV Operation Manager',
          regionName: 'Geographic Area',
          siteType: 'Type',
          status: 'Status'
        },
        templates: {
          supervisor: function supervisor(row, query) {
            if (query.supervisorFirstName && query.supervisorLastName) {
              return query.supervisorFirstName + ' ' + query.supervisorLastName;
            }
            if (query.supervisorFirstName) {
              return '' + query.supervisorFirstName;
            }
            if (query.supervisorLastName) {
              return '' + query.supervisorLastName;
            }
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          siteType: function siteType(row, query) {
            return query.siteType[0].toUpperCase() + query.siteType.slice(1);
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;

          if (_this.user.roleName == "Sales Manager") {
            params.salesManager = _this.user._id;
          }

          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'dateAdded';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (_this.regionManagersIdList.length !== 0) {
            params.region = _this.regionManagersIdList;
          }
          if (_this.parameters != '') {
            params.region = _this.parameters;
          }
          _this.loading = true;
          return _this.$siteDataRepository.list(params).catch(function (error) {
            console.error('Site.requestFunction-error:', error);
            _this.$snotify.error('Get Location', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  mounted: function mounted() {
    this.getGeographicalAreas();
    console.log('this.user', this.user.roleName);
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    console.log('regionManagersIdList', regionDetails);
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.siteTable) {
        return this.siteTable.count > this.siteTable.limit || this.siteTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }

  })),
  methods: {
    edit: function edit(data) {
      if (this.user.roleName === 'Admin') {
        this.$router.push({
          name: 'SiteDetail',
          params: { _id: data.row._id },
          props: data.row
        });
      }
    },
    clearStatusGA: function clearStatusGA() {
      this.parameters = '';
      this.regionValue = 'all';
      this.$refs.siteTable.refresh();
    },
    fiteredResultGA: function fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameters = '';
        this.regionValue = 'all';
      } else {
        this.parameters = e.target.value;
      }
      this.$refs.siteTable.refresh();
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var journeyManagerList = [];

      this.$regionsDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          if (_this2.user.roleName === 'Admin') {
            journeyManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this2.journey_managers = journeyManagerList;
          } else {
            journeyManagerList = res.data.docs.map(function (item) {
              if (_this2.regionManagersIdList.includes(item._id)) {
                _this2.journey_managers.push({
                  key: item._id,
                  value: item.name
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this2.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this2.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/v1/exportMaster?model=site',
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log("response of download", response);
        var arrayBuffer = response.data;
        var filename = 'Locations.xlsx';
        _this3.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    getTitle: function getTitle(str) {
      return str[0].toUpperCase() + str.slice(1);
    },
    onLoaded: function onLoaded() {
      this.siteTable = this.$refs.siteTable;
    }
  }
});

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Technician',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: null,
      tempuserTable: null,
      columns: ['name', 'mobileNumber', 'regionName', 'managerFirstname', 'languageKnown', 'status'],

      options: {
        highlightMatches: true,
        sortable: ['name', 'mobileNumber', 'regionName', 'managerFirstName', 'languageKnown', 'status'],

        headings: {
          name: 'Name',
          mobileNumber: 'Contact',
          regionName: 'Geographical Area',
          languageKnown: 'Language',
          status: 'Status',
          managerFirstname: 'Journey Manager'
        },
        templates: {
          managerFirstname: function managerFirstname(row, query) {
            return query.managerFirstName + ' ' + query.managerLastName;
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == "GA Head") {
            params.regionRegionManager = _this.user._id;
          }
          if (_this.user.roleName == "Journey Manager") {
            params.manager = _this.user._id;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$tempuserDataRepository.list(params).catch(function (error) {
            console.error('technician.requestFunction-error:', error);
            _this.$snotify.error('Get Technician', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.tempuserTable) {
        return this.tempuserTable.count > this.tempuserTable.limit || this.tempuserTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }

  })),
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'TechnicianDetails',
        params: {
          _id: data.row._id
        },
        props: data.row
      });
    },
    onLoaded: function onLoaded() {
      this.tempuserTable = this.$refs.tempuserTable;
    }
  }
});

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TechnicianCreate",
  data: function data() {
    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      loading: false,
      flash: false,
      isGADisable: false,
      isJourenyManagerDisable: false,
      flashType: null,
      flashMessage: "",
      EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
      formstate: {},
      manager: {},
      region_list: {},
      device_id: {},
      site_name: {},
      minDate: "",
      tempuser: {
        site: '',
        userType: "",
        manager: '',
        deviceId: '',
        languageKnown: '',
        defaultLanguage: '',
        status: "active"
      },
      language: [{
        key: "Hindi",
        value: "Hindi"
      }, {
        key: "Punjabi",
        value: "Punjabi"
      }, {
        key: "English",
        value: "English"
      }]
    };
  },

  mounted: function mounted() {
    this.getManagerList();
    this.getRegionList();
    this.getDevice();
    this.getSite();
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,
    getEligibleDate: function getEligibleDate(e) {
      var d = new Date();
      d.setMonth(d.getMonth() - 12 * 18);
      this.minDate = d;
    },
    getSite: function getSite() {
      var _this = this;

      this.loading = true;
      var params = {};
      if (this.user.roleName == "Journey Manager") {
        params.regionJourneyManager = "[\"" + this.user._id + "\"]";
      }
      params.$limit = 0;

      var siteList = [];
      this.$siteDataRepository.list(params).then(function (res) {
        _this.loading = false;
        if (res.data.docs) {
          siteList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.siteName
            };
          });
        }
        _this.site_name = siteList;
      }).catch(function (error) {
        _this.loading = false;
        console.error("site.requestFunction-error:", error);
        _this.$snotify.error("Get site list failed", "Error!");
      });
    },
    getDevice: function getDevice() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var deviceList = [];
      this.$deviceDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          deviceList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.deviceId
            };
          });
        }
        _this2.device_id = deviceList;
      }).catch(function (error) {
        _this2.loading = false;
        console.error("device.requestFunction-error:", error);
        _this2.$snotify.error("Get device list failed", "Error!");
      });
    },
    getRegionList: function getRegionList() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == "GA Head") {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName == "Journey Manager") {
        params.journeyManager = "[\"" + this.user._id + "\"]";
        this.isGADisable = true;
      }
      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          regionlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.name
            };
          });
        }
        _this3.region_list = regionlist;
        _this3.user.roleName == "Journey Manager" ? _this3.tempuser.region = _this3.region_list[0].key : _this3.tempuser.region = "";
      }).catch(function (error) {
        _this3.loading = false;
        console.error("Region.requestFunction-error:", error);
        _this3.$snotify.error("Get region list failed", "Error!");
      });
    },
    getManagerList: function getManagerList() {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 3;
      var managerlist = [];
      if (this.user.roleName == "Journey Manager") {
        params._id = "[\"" + this.user._id + "\"]";
        this.isJourenyManagerDisable = true;
        this.tempuser.manager = this.user._id;
      }
      this.$userRepository.list(params).then(function (res) {
        _this4.loading = false;
        if (res.data.docs) {
          managerlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + " " + item.lastName
            };
          });
        }
        _this4.manager = managerlist;
      }).catch(function (error) {
        _this4.loading = false;
        console.error("Manager.requestFunction-error:", error);
        _this4.$snotify.error("Get manager list failed", "Error!");
      });
    },
    createTechnician: function createTechnician() {
      var _this5 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_3__services__["m" /* technicianService */].addTechnician(this.tempuser).then(function (response) {
        _this5.loading = false;
        _this5.flash = false;
        _this5.$snotify.success("Technician added!", "Success!");
        _this5.$router.push("/operator");
      }).catch(function (error) {
        _this5.loading = false;
        _this5.$snotify.error("Technician Add failed! Try Again", "Error!");
        console.log("error", error);
        if (error.data.message.includes("must be one of")) {
          _this5.flash = true;
          _this5.flashType = "error";
          _this5.flashMessage = "New Technician add is failed.Please try again!";
        }
      });
    }
  }, "fieldClassName", function fieldClassName(field) {
    if (!field) {
      return "";
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return "has-success";
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return "has-danger";
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TechnicianDetails',
    data: function data() {
        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
            formstate: {},
            manager: {},
            region_list: {},
            device_id: {},
            site_name: {},
            minDate: '',
            tempuser: {},
            language: [{
                key: 'Hindi',
                value: 'Hindi'
            }, {
                key: 'Punjabi',
                value: 'Punjabi'
            }, {
                key: 'English',
                value: 'English'
            }]
        };
    },

    mounted: function mounted() {
        this.getManagerList();
        this.getRegionList();
        this.getDevice();
        this.getSite();
        this.getTechnician();
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,
        getEligibleDate: function getEligibleDate(e) {
            var d = new Date();
            d.setMonth(d.getMonth() - 12 * 18);
            this.minDate = d;
        },
        getSite: function getSite() {
            var _this = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            var siteList = [];
            this.$siteDataRepository.list(params).then(function (res) {
                _this.loading = false;
                if (res.data.docs) {
                    siteList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.siteName

                        };
                    });
                }
                _this.site_name = siteList;
            }).catch(function (error) {
                _this.loading = false;
                console.error('site.requestFunction-error:', error);
                _this.$snotify.error('Get site list failed', 'Error!');
            });
        },
        getTechnician: function getTechnician() {
            var _this2 = this;

            return this.$tempuserDataRepository.find(this.$route.params._id).then(function (response) {
                _this2.tempuser = response.data;
            }).catch(function (error) {
                _this2.$snotify.error('Technician detail failed', 'Error!');
            });
        },
        getDevice: function getDevice() {
            var _this3 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            var deviceList = [];
            this.$deviceDataRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    deviceList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.deviceId

                        };
                    });
                }
                _this3.device_id = deviceList;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('device.requestFunction-error:', error);
                _this3.$snotify.error('Get device list failed', 'Error!');
            });
        },
        getRegionList: function getRegionList() {
            var _this4 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this4.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this4.region_list = regionlist;
            }).catch(function (error) {
                _this4.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this4.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getManagerList: function getManagerList() {
            var _this5 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 3;
            var managerlist = [];
            this.$userRepository.list(params).then(function (res) {
                _this5.loading = false;
                if (res.data.docs) {
                    managerlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this5.manager = managerlist;
            }).catch(function (error) {
                _this5.loading = false;
                console.error('Manager.requestFunction-error:', error);
                _this5.$snotify.error('Get manager list failed', 'Error!');
            });
        },
        updateTechnician: function updateTechnician() {
            var _this6 = this;

            this.loading = true;
            return __WEBPACK_IMPORTED_MODULE_1__services__["m" /* technicianService */].updateTechnician(this.tempuser).then(function (response) {
                _this6.loading = false;
                _this6.flash = false;
                _this6.$snotify.success('Operator updated!', 'Success!');
                _this6.$router.push('/operator');
            }).catch(function (error) {
                _this6.loading = false;
                _this6.$snotify.error('Operator Update failed! Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this6.flash = true;
                    _this6.flashType = 'error';
                    _this6.flashMessage = 'New Operator add is failed.Please try again!';
                }
            });
        },
        deleteTechnicianModal: function deleteTechnicianModal() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                title: 'Are you sure?',
                text: 'This will permanently delete this Operator !',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                customClass: 'swal-modal2',
                width: '400px',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    _this7.deleteTechnician();
                }
            });
        },
        deleteTechnician: function deleteTechnician() {
            var _this8 = this;

            this.loading = true;
            return this.$tempuserDataRepository.deleteOne(this.tempuser._id).then(function (response) {
                _this8.loading = false;
                return __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('Deleted!', 'Operator has been deleted.', 'success');
            }).then(function (response) {
                _this8.loading = false;
                _this8.$router.push('/operator');
            }).catch(function (error) {
                _this8.loading = false;
                _this8.$snotify.error('Delete Operator failed', 'Error!');
            });
        }
    }, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    })
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TripLocationLog_vue__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TripLocationLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TripLocationLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_datetime_dist_vue_datetime_css__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TripActivity',
    data: function data() {
        return {
            driverDetailss: {},
            statusValue: '',
            isAreaTable: false,
            activeIndex: null,
            odometerVisible: [],
            gasFlowVisible: [],
            edit: {},
            editSubTrip: {},
            editGasFlow: {},
            trip_id: '',
            img_url: '',
            challan_img_url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/getMedia?path=trips',
            i_url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/getMedia?path=trips/',
            challanImage: '',
            urlId: '',
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
            loading: null,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
            originReached: '',
            destinationReached: '',
            startedDate: '',
            endedDate: '',
            reportData: [{
                reading_1: '',
                reading_2: '',
                reading_3: '',
                reading_4: '',
                reading_5: ''
            }],
            initialPressure: '',
            finalPressure: '',
            endFinalPressure: '',
            endInitialPressure: '',
            initialGas: '',
            finalGas: '',
            endFinalGas: '',
            endInitialGas: '',
            initialStartPressure: '',
            finalStartPressure: '',
            initialEndPressure: '',
            finalEndPressure: '',
            preStartGas: '',
            postStartGas: '',
            preEndGas: '',
            postEndGas: '',
            startOdoMeterReading: '',
            endOdoMeterReading: '',
            startRecordedTime: '',
            endRecordedTime: '',
            startTripTime: '',
            endTripTime: '',
            timeDifference: '',
            scheduledDate: '',
            tripExceptionTable: null,
            changedStatus: null,
            columns: ['recordedTime', 'prevDestination', 'divertedDestination', 'originLocationDetails'],

            options: {
                highlightMatches: true,
                sortable: [],
                headings: {
                    recordedTime: 'Recorded Time',

                    divertedDestination: 'Destination Change ',
                    originLocationDetails: 'Original Location'
                },
                templates: {
                    prevDestination: function prevDestination(row, query) {
                        if (query.prevDestinationDetails.length > 0 && query.prevDestinationDetails[0]['siteName']) {
                            return '' + query.prevDestinationDetails[0]['siteName'];
                        }
                    },
                    divertedDestination: function divertedDestination(row, query) {
                        if (query.divertedDestinationDetails.length > 0 && query.divertedDestinationDetails[0]['siteName']) {
                            return '' + query.divertedDestinationDetails[0]['siteName'];
                        }
                    },
                    originLocationDetails: function originLocationDetails(row, query) {
                        if (query.originLocationDetails.length > 0 && query.originLocationDetails[0]['siteName']) {
                            return '' + query.originLocationDetails[0]['siteName'];
                        }
                    },
                    recordedTime: function recordedTime(row, query) {
                        if (query.recordedTime) {
                            return __WEBPACK_IMPORTED_MODULE_5_moment___default()(query.recordedTime).format('DD-MM-YYYY HH:mm:ss');
                        }
                    }
                }
            },
            trip: {},

            tripdetails: [],
            imageurls: [],
            challanImageUrls: [],
            odometer: [],
            gasfilling: [],
            pressure: [],
            subTripList: [],
            subTripdetailsId: {},
            challanDetailss: [],
            driverDetailsList: [],
            subTripDetailsSiteSiteType: []

        };
    },
    mounted: function mounted() {
        this.getTrip();
    },

    components: {
        TripLocationLog: __WEBPACK_IMPORTED_MODULE_3__TripLocationLog_vue___default.a
    },

    filters: {
        capitalize: function capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    methods: {
        closeAreaTableModal: function closeAreaTableModal() {
            if (this.isAreaTable) {
                this.isAreaTable = !this.isAreaTable;
            }
        },
        driverDetails: function driverDetails(id) {
            var _this = this;

            this.isAreaTable = true;

            return __WEBPACK_IMPORTED_MODULE_1__services__["j" /* tripService */].tripGroupDriverDetails(id).then(function (response) {
                _this.driverDetailss = {};
                _this.driverDetailsList = [];
                var obj = {};
                response.data.data.forEach(function (el) {
                    obj = {
                        driverName: el.driverName ? el.driverName : 'NA',
                        checkIn: el.checkIn ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(el.checkIn).format('DD-MM-YYYY hh:mm A') : 'NA',
                        checkOut: el.checkOut ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(el.checkOut).format('DD-MM-YYYY hh:mm A') : 'NA'
                    };
                    _this.driverDetailsList.push(obj);
                });
            }).catch(function (error) {

                _this.$snotify.error('Driver Details failed', 'Error!');
            });
        },
        showDetails: function showDetails(index) {
            this.activeIndex = index;
        },
        toggleOdometerDetails: function toggleOdometerDetails(tripsId, index) {
            if (this.subTripdetailsId != tripsId) {
                this.subTripdetailsId = tripsId;
                this.getChallanTripsData(tripsId, index);
            }
        },
        toggleGasFlowDetails: function toggleGasFlowDetails(tripsId, index) {
            if (this.subTripdetailsId != tripsId) {
                this.subTripdetailsId = tripsId;
                this.getChallanTripsData(tripsId, index);
            }
        },
        getChallanTripsData: function getChallanTripsData(subTripId, index) {
            var _this2 = this;

            this.odometer = [];
            this.tripdetails = [];
            this.challanDetails = [];
            this.challanDetails = {};
            this.reportData = [{
                reading_1: '',
                reading_2: '',
                reading_3: '',
                reading_4: '',
                reading_5: ''
            }];
            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                method: 'get',
                url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/challandetails?tripID=' + subTripId,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                _this2.challanDetails = response.data && response.data.docs && response.data.docs.length > 0 && response.data.docs[response.data.docs.length - 1];
                _this2.challanImage = _this2.challanDetails.image;
                _this2.urlId = _this2.challanDetails.tripID;
                response.data.docs.forEach(function (element) {
                    element.image.forEach(function (imgUrl) {
                        _this2.challanImageUrls.push(imgUrl);
                    });
                });
            }).catch(function (e) {});
            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                method: 'get',
                url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tripdetails?tripID=' + subTripId,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                _this2.tripdetails = response.data.docs;
                _this2.odometer = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.isDeleted == false) {
                        response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                        return true;
                    }
                });
                _this2.startRecordedTime = response.data.docs.filter(function (obj) {
                    return obj.tripType === 'startTrip' && obj.imageType === 'odometer';
                });
                _this2.endRecordedTime = response.data.docs.filter(function (obj) {
                    return obj.tripType === 'endTrip' && obj.imageType === 'odometer';
                });
                _this2.initialPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
                });
                _this2.finalPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
                });
                _this2.endInitialPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
                });
                _this2.endFinalPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
                });
                _this2.initialGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
                });
                _this2.finalGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
                });
                _this2.endInitialGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
                });
                _this2.endFinalGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
                });

                if (_this2.initialPressure && _this2.initialPressure.length && _this2.initialGas && _this2.initialGas.length) {
                    var iPressure = _this2.initialPressure[_this2.initialPressure.length - 1];
                    var iGas = _this2.initialGas[_this2.initialGas.length - 1];
                    _this2.reportData.splice(0, 1, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                if (_this2.finalPressure && _this2.finalPressure.length && _this2.finalGas && _this2.finalGas.length) {
                    var iPressure = _this2.finalPressure[_this2.finalPressure.length - 1];
                    var iGas = _this2.finalGas[_this2.finalGas.length - 1];
                    _this2.reportData.splice(1, 0, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                if (_this2.endInitialPressure && _this2.endInitialPressure.length && _this2.endInitialGas && _this2.endInitialGas.length) {
                    var iPressure = _this2.endInitialPressure[_this2.endInitialPressure.length - 1];
                    var iGas = _this2.endInitialGas[_this2.endInitialGas.length - 1];
                    _this2.reportData.splice(2, 0, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                if (_this2.endFinalPressure && _this2.endFinalPressure.length && _this2.endFinalGas && _this2.endFinalGas.length) {
                    var iPressure = _this2.endFinalPressure[_this2.endFinalPressure.length - 1];
                    var iGas = _this2.endFinalGas[_this2.endFinalGas.length - 1];
                    _this2.reportData.splice(3, 0, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                _this2.startOdoMeterReading = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this2.endOdoMeterReading = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this2.gasfilling = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' || re.imageType === 'pressureMeter') {
                        if (re.imageType === 'gasFilling') {
                            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                            return true;
                        }
                        if (re.imageType === 'pressureMeter') {
                            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                            return true;
                        }
                    }
                });
                _this2.postStartGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'startTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this2.preStartGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'startTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this2.postEndGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'endTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this2.preEndGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'endTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                response.data.docs.forEach(function (element) {
                    element.image.forEach(function (imgUrl) {
                        _this2.imageurls.push(imgUrl);
                    });
                });

                _this2.img_url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/getMedia?path=/trip/' + _this2.$route.params._id + '/';
            }).catch(function (e) {
                console.log(e);
            });
        },
        getChallanData: function getChallanData() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                method: 'get',
                url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/challandetails?tripID=' + this.subTripdetailsId,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                _this3.challanDetailss = response.data.docs;
                _this3.challanDetails = response.data && response.data.docs && response.data.docs.length > 0 && response.data.docs[response.data.docs.length - 1];
                _this3.challanImage = _this3.challanDetails.image;
                _this3.urlId = _this3.challanDetails.tripID;
                response.data.docs.forEach(function (element) {
                    element.image.forEach(function (imgUrl) {
                        _this3.challanImageUrls.push(imgUrl);
                    });
                });
            }).catch(function (e) {});
        },
        refreshTab: function refreshTab() {
            this.odometer = [];
            this.tripdetails = [];
            this.challanDetails = [];
            this.challanDetails = {};
            this.reportData = [{
                reading_1: '',
                reading_2: '',
                reading_3: '',
                reading_4: '',
                reading_5: ''
            }];
            this.getChallanData();
            this.getTripDetails();
        },
        getTripDetails: function getTripDetails() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                method: 'get',
                url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tripdetails?tripID=' + this.subTripdetailsId,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                _this4.tripdetails = response.data.docs;

                _this4.tripdetails = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.isDeleted == false) {
                        response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                        return true;
                    }
                });

                _this4.startRecordedTime = response.data.docs.filter(function (obj) {
                    return obj.tripType === 'startTrip' && obj.imageType === 'odometer';
                });
                _this4.endRecordedTime = response.data.docs.filter(function (obj) {
                    return obj.tripType === 'endTrip' && obj.imageType === 'odometer';
                });
                _this4.initialPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
                });
                _this4.finalPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
                });
                _this4.endInitialPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
                });
                _this4.endFinalPressure = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
                });
                _this4.initialGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
                });
                _this4.finalGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
                });
                _this4.endInitialGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
                });
                _this4.endFinalGas = response.data.docs.filter(function (obj) {
                    return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
                });

                if (_this4.initialPressure && _this4.initialPressure.length && _this4.initialGas && _this4.initialGas.length) {
                    var iPressure = _this4.initialPressure[_this4.initialPressure.length - 1];
                    var iGas = _this4.initialGas[_this4.initialGas.length - 1];
                    _this4.reportData.splice(0, 1, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                if (_this4.finalPressure && _this4.finalPressure.length && _this4.finalGas && _this4.finalGas.length) {
                    var iPressure = _this4.finalPressure[_this4.finalPressure.length - 1];
                    var iGas = _this4.finalGas[_this4.finalGas.length - 1];
                    _this4.reportData.splice(1, 0, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                if (_this4.endInitialPressure && _this4.endInitialPressure.length && _this4.endInitialGas && _this4.endInitialGas.length) {
                    var iPressure = _this4.endInitialPressure[_this4.endInitialPressure.length - 1];
                    var iGas = _this4.endInitialGas[_this4.endInitialGas.length - 1];
                    _this4.reportData.splice(2, 0, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                if (_this4.endFinalPressure && _this4.endFinalPressure.length && _this4.endFinalGas && _this4.endFinalGas.length) {
                    var iPressure = _this4.endFinalPressure[_this4.endFinalPressure.length - 1];
                    var iGas = _this4.endFinalGas[_this4.endFinalGas.length - 1];
                    _this4.reportData.splice(3, 0, {
                        reading_1: iPressure.tripType,
                        reading_2: iPressure.captureType,
                        reading_3: iPressure.meterReading,
                        reading_4: iGas.meterReading,
                        reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                    });
                }
                _this4.odometer = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.isDeleted == false) {
                        response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                        return true;
                    }
                });
                _this4.startOdoMeterReading = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this4.endOdoMeterReading = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this4.gasfilling = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' || re.imageType === 'pressureMeter') {
                        if (re.imageType === 'gasFilling') {
                            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                            return true;
                        }
                        if (re.imageType === 'pressureMeter') {
                            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                            return true;
                        }
                    }
                });
                _this4.postStartGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'startTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this4.preStartGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'startTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this4.postEndGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'endTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                _this4.preEndGas = response.data.docs.filter(function (re, index) {
                    if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'endTrip') {
                        response.data.docs[index];
                        return true;
                    }
                });
                response.data.docs.forEach(function (element) {
                    element.image.forEach(function (imgUrl) {
                        _this4.imageurls.push(imgUrl);
                    });
                });

                _this4.img_url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/getMedia?path=/trip/' + _this4.$route.params._id + '/';
            }).catch(function (e) {
                console.log(e);
            });
        },
        onFilechanged: function onFilechanged(event) {
            this.edit.image = event.target.files[0];
        },
        onFilechanged1: function onFilechanged1(event) {
            this.editGasFlow.image = event.target.files[0];
        },
        openNewTripDia: function openNewTripDia(subTripId) {
            this.edit = {};
            this.edit.tripID = subTripId;
            this.edit.title = 'Create trip';
            this.$modal.show('tripDialog');
        },
        openEditTripDia: function openEditTripDia(subTrip) {
            console.log("sub", subTrip);

            this.editSubTrip = subTrip;
            this.editSubTrip.title = 'Update trip';
            this.$modal.show('tripEditDialog');
        },
        createTrip: function createTrip() {
            var _this5 = this;

            this.edit.captureType = this.edit.tripType === 'startTrip' ? 'post' : 'pre';
            var formData = new FormData();
            formData.append('captureType', this.edit.captureType);
            formData.append('imageType', 'odometer');
            formData.append('tripID', this.edit.tripID);
            formData.append('latitude', this.edit.latitude);
            formData.append('longitude', this.edit.longitude);
            formData.append('meterReading', this.edit.meterReading);
            formData.append('recordedTime', this.edit.recordedTime);
            formData.append('tripType', this.edit.tripType);
            formData.append('file', this.edit.image);
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {
                _this5.odometer = [];
                _this5.$modal.hide('tripDialog');
                _this5.$snotify.success('Trip created!', 'Success!');
                _this5.getChallanTripsData(_this5.edit.tripID, _this5.activeIndex);
            }).catch(function (err) {
                console.log('errorrrrr', err);
            });
        },
        openUpdateTripDia: function openUpdateTripDia(o) {
            this.edit = {};
            this.edit = o;
            this.edit.title = 'Update trip';
            this.$modal.show('tripDialog');
        },
        updateTrip: function updateTrip() {
            var _this6 = this;

            this.edit.image = document.getElementById('myfile');
            this.edit.captureType = this.edit.tripType === 'startTrip' ? 'post' : 'pre';
            var formData = new FormData();
            formData.append('captureType', this.edit.captureType);
            formData.append('imageType', 'odometer');
            formData.append('tripID', this.edit.tripID);
            formData.append('latitude', this.edit.latitude);
            formData.append('longitude', this.edit.longitude);
            formData.append('meterReading', this.edit.meterReading);
            formData.append('recordedTime', this.edit.recordedTime);
            formData.append('tripType', this.edit.tripType);
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {
                _this6.$modal.hide('tripDialog');
                _this6.$snotify.success('Trip updated!', 'Success!');
                _this6.getChallanTripsData(_this6.edit.tripID, _this6.activeIndex);
            }).catch(function (err) {
                console.log('errorrrrr', err);
            });
        },
        deleteTripDetail: function deleteTripDetail(data) {
            var _this7 = this;

            var body = { "hardDelete": true };
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('/tripdetails/' + data._id, body).then(function (res) {
                _this7.$snotify.success('Trip deleted!', 'Success!');
                _this7.getChallanTripsData(data._id, _this7.activeIndex);
            }).catch(function (err) {
                console.log('errorrrrrr', err);
            });
        },
        openNewGasFlowDia: function openNewGasFlowDia(subTripId) {
            this.editGasFlow = {};
            this.editGasFlow.tripID = subTripId;
            this.editGasFlow.title = 'Add Gas Flow Details';
            this.$modal.show('gasFlowDia');
        },
        createGasFlowDetails: function createGasFlowDetails() {
            var _this8 = this;

            var formData = new FormData();
            formData.append('captureType', this.editGasFlow.reading_2);
            formData.append('tripID', this.editGasFlow.tripID);
            formData.append('latitude', 7);
            formData.append('longitude', 7);
            formData.append('recordedTime', this.editGasFlow.reading_5);
            formData.append('tripType', this.editGasFlow.reading_1);

            formData.append('meterReading', this.editGasFlow.reading_3);
            formData.append('imageType', 'pressureMeter');

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {
                formData.set('meterReading', _this8.editGasFlow.reading_4);
                formData.set('imageType', 'gasFilling');
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {
                    formData.append('file', _this8.editGasFlow.image);

                    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {}).catch(function (err) {
                        console.log('errorrrrr', err);
                    });

                    _this8.$modal.hide('gasFlowDia');
                    _this8.$snotify.success('created!', 'Success!');
                    _this8.tripdetails = [];
                    _this8.challanDetails = [];
                    _this8.challanDetails = {};
                    _this8.reportData = [{
                        reading_1: '',
                        reading_2: '',
                        reading_3: '',
                        reading_4: '',
                        reading_5: ''
                    }];
                    _this8.refreshTab();
                }).catch(function (err) {
                    console.log('errorrrrr', err);
                });
            }).catch(function (err) {
                console.log('errorrrrr', err);
            });
        },
        openUpdateGasFlowDia: function openUpdateGasFlowDia(data, subTripId) {
            this.ids = null;
            this.editGasFlow = {};
            this.editGasFlow = data;
            this.editGasFlow.tripID = subTripId;
            this.editGasFlow.title = 'Update Gas Flow Details';
            this.ids = this.tripdetails.filter(function (element) {
                return element.captureType === data.reading_2 && element.tripType === data.reading_1 && (element.imageType === 'gasFilling' || element.imageType === 'pressureMeter');
            });
            this.$modal.show('gasFlowDia');
        },
        updateGasFlowDetails: function updateGasFlowDetails() {
            var _this9 = this;

            var formData = new FormData();
            formData.append('captureType', this.editGasFlow.reading_2);
            formData.append('tripID', this.editGasFlow.tripID);
            formData.append('latitude', 7);
            formData.append('longitude', 7);
            formData.append('recordedTime', this.editGasFlow.reading_5);
            formData.append('tripType', this.editGasFlow.reading_1);

            formData.append('meterReading', this.editGasFlow.reading_3);
            formData.append('imageType', 'pressureMeter');

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {
                formData.set('meterReading', _this9.editGasFlow.reading_4);
                formData.set('imageType', 'gasFilling');
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/meterCapture', formData).then(function (res) {
                    _this9.$modal.hide('gasFlowDia');
                    _this9.$snotify.success('created!', 'Success!');
                    _this9.tripdetails = [];
                    _this9.challanDetails = [];
                    _this9.challanDetails = {};
                    _this9.reportData = [{
                        reading_1: '',
                        reading_2: '',
                        reading_3: '',
                        reading_4: '',
                        reading_5: ''
                    }];
                    _this9.getChallanTripsData(_this9.editGasFlow.tripID, _this9.activeIndex);
                }).catch(function (err) {
                    console.log('errorrrrr', err);
                });
            }).catch(function (err) {
                console.log('errorrrrr', err);
            });
        },
        changeStatus: function changeStatus(e) {
            this.changedStatus = e.target.value;
        },
        deleteopenUpdateGasFlowDia: function deleteopenUpdateGasFlowDia(data) {
            var _this10 = this;

            var ids = this.tripdetails.filter(function (element) {
                return element.captureType === data.reading_2 && element.tripType === data.reading_1 && (element.imageType === 'gasFilling' || element.imageType === 'pressureMeter');
            });
            var subtripId = ids[0].tripID;

            ids.forEach(function (i, ind) {
                var body = { "hardDelete": true };
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('/tripdetails/' + i._id, body).then(function (res) {
                    if (ind === ids.length - 1) {
                        _this10.tripdetails = [];
                        _this10.challanDetails = [];
                        _this10.challanDetails = {};
                        _this10.reportData = [{
                            reading_1: '',
                            reading_2: '',
                            reading_3: '',
                            reading_4: '',
                            reading_5: ''
                        }];
                        __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                            method: 'get',
                            url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/tripdetails?tripID=' + subtripId,
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }).then(function (response) {
                            _this10.$snotify.success('Trip deleted!', 'Success!');
                            _this10.tripdetails = response.data.docs;
                            _this10.startRecordedTime = response.data.docs.filter(function (obj) {
                                return obj.tripType === 'startTrip' && obj.imageType === 'odometer';
                            });
                            _this10.endRecordedTime = response.data.docs.filter(function (obj) {
                                return obj.tripType === 'endTrip' && obj.imageType === 'odometer';
                            });
                            _this10.initialPressure = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
                            });
                            _this10.finalPressure = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
                            });
                            _this10.endInitialPressure = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
                            });
                            _this10.endFinalPressure = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
                            });
                            _this10.initialGas = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
                            });
                            _this10.finalGas = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
                            });
                            _this10.endInitialGas = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
                            });
                            _this10.endFinalGas = response.data.docs.filter(function (obj) {
                                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
                            });

                            if (_this10.initialPressure && _this10.initialPressure.length && _this10.initialGas && _this10.initialGas.length) {
                                var iPressure = _this10.initialPressure[_this10.initialPressure.length - 1];
                                var iGas = _this10.initialGas[_this10.initialGas.length - 1];
                                _this10.reportData = [{
                                    reading_1: '',
                                    reading_2: '',
                                    reading_3: '',
                                    reading_4: '',
                                    reading_5: ''
                                }];
                                _this10.reportData.splice(0, 1, {
                                    reading_1: iPressure.tripType,
                                    reading_2: iPressure.captureType,
                                    reading_3: iPressure.meterReading,
                                    reading_4: iGas.meterReading,
                                    reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                                });
                            }
                            if (_this10.finalPressure && _this10.finalPressure.length && _this10.finalGas && _this10.finalGas.length) {
                                var iPressure = _this10.finalPressure[_this10.finalPressure.length - 1];
                                var iGas = _this10.finalGas[_this10.finalGas.length - 1];
                                _this10.reportData.splice(1, 0, {
                                    reading_1: iPressure.tripType,
                                    reading_2: iPressure.captureType,
                                    reading_3: iPressure.meterReading,
                                    reading_4: iGas.meterReading,
                                    reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                                });
                            }
                            if (_this10.endInitialPressure && _this10.endInitialPressure.length && _this10.endInitialGas && _this10.endInitialGas.length) {
                                var iPressure = _this10.endInitialPressure[_this10.endInitialPressure.length - 1];
                                var iGas = _this10.endInitialGas[_this10.endInitialGas.length - 1];
                                _this10.reportData.splice(2, 0, {
                                    reading_1: iPressure.tripType,
                                    reading_2: iPressure.captureType,
                                    reading_3: iPressure.meterReading,
                                    reading_4: iGas.meterReading,
                                    reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                                });
                            }
                            if (_this10.endFinalPressure && _this10.endFinalPressure.length && _this10.endFinalGas && _this10.endFinalGas.length) {
                                var iPressure = _this10.endFinalPressure[_this10.endFinalPressure.length - 1];
                                var iGas = _this10.endFinalGas[_this10.endFinalGas.length - 1];
                                _this10.reportData.splice(3, 0, {
                                    reading_1: iPressure.tripType,
                                    reading_2: iPressure.captureType,
                                    reading_3: iPressure.meterReading,
                                    reading_4: iGas.meterReading,
                                    reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_5_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                                });
                            }
                            _this10.odometer = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'odometer' && re.isDeleted == false) {
                                    response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                                    return true;
                                }
                            });
                            _this10.startOdoMeterReading = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
                                    response.data.docs[index];
                                    return true;
                                }
                            });
                            _this10.endOdoMeterReading = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
                                    response.data.docs[index];
                                    return true;
                                }
                            });
                            _this10.gasfilling = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'gasFilling' || re.imageType === 'pressureMeter') {
                                    if (re.imageType === 'gasFilling') {
                                        response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                                        return true;
                                    }
                                    if (re.imageType === 'pressureMeter') {
                                        response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                                        return true;
                                    }
                                }
                            });
                            _this10.postStartGas = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'startTrip') {
                                    response.data.docs[index];
                                    return true;
                                }
                            });
                            _this10.preStartGas = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'startTrip') {
                                    response.data.docs[index];
                                    return true;
                                }
                            });
                            _this10.postEndGas = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'endTrip') {
                                    response.data.docs[index];
                                    return true;
                                }
                            });
                            _this10.preEndGas = response.data.docs.filter(function (re, index) {
                                if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'endTrip') {
                                    response.data.docs[index];
                                    return true;
                                }
                            });
                            response.data.docs.forEach(function (element) {
                                element.image.forEach(function (imgUrl) {
                                    _this10.imageurls.push(imgUrl);
                                });
                            });

                            _this10.img_url = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/getMedia?path=/trip/' + subtripId + '/';
                        }).catch(function (e) {
                            console.log(e);
                        });
                    }
                }).catch(function (err) {
                    console.log('errorrrrr', err);
                });
            });
        },
        tripEnd: function tripEnd(action, trips) {
            var _this11 = this;

            if (trips.title) {
                delete trips.title;
            }
            var trip = trips;
            if (action == 'end') {
                trip.status = 'completed';
                trip.endDate = new Date(Date.now()).toISOString();
            } else if (action == 'cancel') {
                trip.status = 'completed';
            }
            if (this.changedStatus != null) {
                trip.status = this.changedStatus;
            }

            this.loading = true;
            return __WEBPACK_IMPORTED_MODULE_1__services__["j" /* tripService */].updateTrip(trip).then(function (response) {
                _this11.loading = false;
                _this11.flash = false;
                if (action == 'end') {
                    _this11.$snotify.success('Trip is ended!', 'Success!');
                    _this11.$router.push('/trip-group');
                } else if (action == 'cancel') {
                    _this11.$snotify.success('Trip is cancelled!', 'Success!');
                    _this11.$router.push('/trip-group');
                } else if (_this11.changeStatus != null && action == 'update') {
                    window.location.reload();
                    _this11.$snotify.success('Trip updated!', 'Success!');
                    _this11.$router.push('/trip-group');
                } else if (action == 'update' && _this11.changeStatus == null) {
                    _this11.$snotify.success('Trip timings are updated!', 'Success!');
                }
            }).catch(function (error) {
                _this11.loading = false;
                _this11.$snotify.error('Trip end failed', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this11.flash = true;
                    _this11.flashType = 'error';
                    _this11.flashMessage = 'Trip is not updated due to some error. Please try again!.';
                }
            });
        },
        convertMS: function convertMS(ms) {
            var d, h, m, s;
            s = Math.floor(ms / 1000);
            m = Math.floor(s / 60);
            s = s % 60;
            h = Math.floor(m / 60);
            m = m % 60;
            d = Math.floor(h / 24);
            h = h % 24;
            h += d * 24;
            if (this.trip.destinationReachedAt < this.trip.startDate) {
                return ('-'(h + '').length === 1 ? '0' + h : h) + ' h ' + ('0' + m).substr(-2) + ' min ' + ('0' + s).substr(-2);
            } else {
                return ((h + '').length === 1 ? '0' + h : h) + ' h ' + ('0' + m).substr(-2) + ' min ' + ('0' + s).substr(-2);
            }
        },
        getTrip: function getTrip() {
            var _this12 = this;

            return this.$tripGroupDataRepository.getIndividualGroupTrip(this.$route.params._id).then(function (response) {
                _this12.trip = response.data.data[0];
                _this12.subTripList = response.data.data[0].subTripDetails;
                var subTripDetailsList = [];
                for (var i = 0; i < _this12.subTripList.length; i++) {
                    if (i === 0) {
                        subTripDetailsList.push(_this12.subTripList[i].startSiteSiteName);
                        subTripDetailsList.push(_this12.subTripList[i].endSiteSiteName);
                    } else {
                        subTripDetailsList.push(_this12.subTripList[i].endSiteSiteName);
                    }
                }
                _this12.subTripDetailsSiteSiteType = subTripDetailsList;
            }).catch(function (error) {
                _this12.$snotify.error(' OnGoing Trip detail failed', 'Error!');
            });
        },
        locationLogTable: function locationLogTable() {
            var x = document.getElementById('tripLocationLogTable');
            if (x.style.display === 'none') {
                x.style.display = 'block';
            } else {
                x.style.display = 'none';
            }
        },
        exceptionTable: function exceptionTable() {
            var y = document.getElementById('exceptionTable');
            if (y.style.display === 'none') {
                y.style.display = 'block';
            } else {
                y.style.display = 'none';
            }
        },
        onLoaded: function onLoaded() {
            this.tripExceptionTable = this.$refs.tripExceptionTable;
        },
        getTripSchedule: function getTripSchedule(trip) {
            if (trip.scheduleTime) {
                var _trip$scheduleTime$sp = trip.scheduleTime.split(':'),
                    _trip$scheduleTime$sp2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_trip$scheduleTime$sp, 2),
                    h = _trip$scheduleTime$sp2[0],
                    m = _trip$scheduleTime$sp2[1];

                var time = h % 12 + 12 * (h % 12 == 0) + ':' + m + ' ' + (h >= 12 ? 'PM' : 'AM');
            }
            return __WEBPACK_IMPORTED_MODULE_5_moment___default()('' + trip.scheduleDate).format('DD-MM-YYYY') + ' ' + time;
        },
        getTimeDifference: function getTimeDifference(end, start) {
            return this.convertMS(Math.abs(__WEBPACK_IMPORTED_MODULE_5_moment___default()(end) - __WEBPACK_IMPORTED_MODULE_5_moment___default()(start)));
        }
    },
    computed: {
        concatenatedData: function concatenatedData() {
            return this.subTripDetailsSiteSiteType.join(" -> ");
        },
        addButtonClass: function addButtonClass() {
            if (this.tripExceptionTable) {
                return this.tripExceptionTable.count > this.tripExceptionTable.limit || this.tripExceptionTable.limit > 10 ? 'shift-add-left' : 'add-item';
            } else {
                return 'add-item';
            }
        }
    }
});

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_timepicker_dist_VueTimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TripGroupCreate',
  data: function data() {
    var _ref;

    return _ref = {
      regionManagersIdList: [],

      clearIndex: null,
      startLocation: null,
      intermediateLocations: [{
        locationId: ''
      }],
      endLocation: null,
      tripLocationList: [],
      loading: false,
      disabledBefore: new Date(),
      isDeviceDisable: false,
      isJourenyManagerDisable: false,
      isGAHeadDisable: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */],
      formstate: {},
      region_list: {},
      region_managers: {},
      start_site: {},
      end_site: {},
      vehicle_no: {},
      route_list: {},
      driver_name: [],
      device_name: {},
      journey_managers: {},
      projectFormat: 'hh:mm',
      status: 'scheduled',
      sourceSite: '',
      destinationSite: '',
      device: {
        status: 'active'
      },
      trip: {
        vehicleId: '',
        deviceId: '',
        journeyManager: '',
        regionManager: '',
        driverId: '',
        subTrips: [],
        remark: '',
        region: ''
      },

      routeData: {
        startLocation: '',
        endLocation: '',
        time: '',
        distance: '',
        startLocId: '',
        endLocId: '',
        routeMarkers: [{
          latitude: '',
          longitude: '',
          message: ''
        }, {
          latitude: '',
          longitude: '',
          message: ''
        }]
      },
      driver: [],
      locationList: [],
      locations: [{
        locationId: ''
      }, {
        locationId: ''
      }, {
        locationId: ''
      }],
      list: [],
      params: {},
      selectedDeviceId: '',
      journeyManagerId: [],
      gAId: '',
      regionListFilter: [],
      regionManagerId: ''
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'journeyManagerId', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'matchingRoutes', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid1', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid2', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid3', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid4', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid5', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid6', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid7', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formValid', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'routeMarkers', []), _ref;
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item.regionManager;
      });
    }
  },

  mounted: function mounted() {
    this.trip.scheduleDate = new Date().toISOString().split('T')[0], this.scheduledTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(new Date()).format('H:mm');

    if (this.user.roleName == 'Admin') {
      this.getRegionList();
      this.getRouteName();
    }
    if (this.user.roleName !== 'Admin') {
      this.getRouteName();

      this.getRegionList();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
    getFilteredLocationList: function getFilteredLocationList(index) {
      var stations = [];
      if (this.locations[0] && this.locations[0].locationId.siteType === 'LNGT') {
        if (index === 0) {
          stations = this.locationList.filter(function (el) {
            return el.siteType === 'MS' || el.siteType === 'LNGT';
          });
        } else {
          stations = this.locationList.filter(function (el) {
            return el.siteType === 'LNGT';
          });
        }
      } else if ((index === 0 || index === this.locations.length - 1) && this.locations[0].locationId.siteType !== 'LNGT') {
        stations = this.locationList.filter(function (el) {
          return el.siteType === 'MS' || el.siteType === 'LNGT';
        });
      } else {
        stations = this.locationList.filter(function (el) {
          return el.siteType === 'DBS' || el.siteType === 'DCU' || el.siteType === 'DS';
        });
      }

      return stations;
    },
    updateFormValidity: function updateFormValidity() {
      this.formValid = this.inputValid1 && this.inputValid2 && this.inputValid3 && this.inputValid4 && this.inputValid5 && this.inputValid6;
    },
    updateFormFalse: function updateFormFalse() {
      if (this.inputValid1 || this.inputValid2 || this.inputValid3 || this.inputValid4 || this.inputValid5 || this.inputValid6) {
        this.formValid = false;
      }
    },
    driverStatus: function driverStatus() {
      if (this.trip.driverId.length > 0) {
        this.inputValid3 = true;
        this.updateFormValidity();
      } else {
        this.inputValid3 = false;
        this.updateFormFalse();
      }
    },
    HCVOperationStatus: function HCVOperationStatus() {
      if (this.trip.regionManager !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.trip.regionManager) === 'object' && this.trip.regionManager.key !== '') {
        this.inputValid4 = true;
        this.updateFormValidity();
      } else {
        this.inputValid4 = false;
        this.updateFormFalse();
      }
    },
    journeyManagerStatus: function journeyManagerStatus() {
      if (this.trip.journeyManager !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.trip.journeyManager) === 'object' && this.trip.journeyManager.key !== '') {
        this.inputValid5 = true;
        this.updateFormValidity();
      } else {
        this.inputValid5 = false;
        this.updateFormFalse();
      }
    },
    selectGA: function selectGA(e) {
      var _this = this;

      if (this.trip.region !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.trip.region) === 'object' && this.trip.region.key !== '') {
        this.inputValid1 = true;
        this.updateFormValidity();
      } else {
        this.inputValid1 = false;
        this.updateFormFalse();
      }
      this.gAId = e.key;
      this.getDriverName();
      this.getVehicle();
      var filteredRegion = this.regionListFilter.find(function (item) {
        return item._id === _this.gAId;
      });
      this.regionManagerId = filteredRegion ? filteredRegion.regionManager : null;
      this.journeyManagerId = filteredRegion ? filteredRegion.journeyManager : null;
      this.getRegionManager();
      this.getJourneyManager();
      this.getLocations();
    },


    fieldClassName: __WEBPACK_IMPORTED_MODULE_4__services__["e" /* formService */].fieldClassName,
    createTrip: function createTrip() {
      var _this2 = this;

      this.loading = true;

      var _loop = function _loop(indexx) {
        var el = _this2.route_list.find(function (el) {
          return _this2.locations[indexx - 1].locationId._id === el.startSite && _this2.locations[indexx].locationId._id === el.endSite;
        });

        if (el) {
          var val = {
            routeId: el._id,
            startSite: el.startSite,
            endSite: el.endSite
          };
          _this2.matchingRoutes.push(val);
        }
      };

      for (var indexx = 1; indexx < this.locations.length; indexx++) {
        _loop(indexx);
      }


      this.driver = this.trip.driverId.map(function (el) {
        return el.value;
      });
      console.log('createTrip1', this.trip);

      var trip = {
        driverId: this.driver,
        status: this.status,
        scheduleTime: this.scheduledTime,
        deviceId: this.selectedDeviceId,
        journeyManager: this.trip.journeyManager.key,
        regionManager: this.trip.regionManager.key,
        scheduleDate: this.trip.scheduleDate,
        vehicleId: this.trip.vehicleId.key,
        subTrips: this.matchingRoutes,
        remark: this.trip.remark,
        geographical_area: this.trip.region.key
      };
      console.log('createTrip', this.trip);
      return __WEBPACK_IMPORTED_MODULE_4__services__["j" /* tripService */].tripGroupAdd(trip).then(function (response) {
        _this2.loading = false;
        _this2.flash = false;
        _this2.$snotify.success('TripGroup added!', 'Success!');
        _this2.$router.push('/trip-group');
      }).catch(function (error) {
        _this2.loading = false;
        _this2.$snotify.error('TripGroup Add failed! Try Again', 'Error!');
        if (error.data.message == 'dvgdxfv') {
          _this2.$snotify.success('TripGroup added!', 'Success!');
          _this2.$router.push('/trip-group');
        }
      });
    },
    getRegionManager: function getRegionManager() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params._id = this.regionManagerId;
      }
      var regionManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        this.$userRepository.list(params).then(function (res) {
          _this3.loading = false;
          if (res.data.docs) {
            regionManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName
              };
            });
          }
          _this3.region_managers = regionManagerList;
        }).catch(function (error) {
          _this3.loading = false;
          _this3.$snotify.error('Get region manager list failed', 'Error!');
        });
      } else {
        params.roleRank = 2;
        this.$userRepository.list(params).then(function (res) {
          _this3.loading = false;

          if (res.data.docs) {
            regionManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName
              };
            });
          }
          _this3.region_managers = regionManagerList;
        }).catch(function (error) {
          _this3.loading = false;
          _this3.$snotify.error('Get region manager list failed', 'Error!');
        });
      }
    },
    getJourneyManager: function getJourneyManager() {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 3;
      if (this.gAId !== '') {
        params._id = this.journeyManagerId;
      }
      var journeyManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        var bAsString = this.journeyManagerId.map(function (value) {
          return String(value);
        });
        var jsonString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(bAsString);
        params._id = jsonString;
      }
      this.$userRepository.list(params).then(function (res) {
        _this4.loading = false;
        if (res.data.docs) {
          journeyManagerList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this4.journey_managers = journeyManagerList;
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    getSites: function getSites(e) {
      this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute('sourceSite');
      this.destinationSite = e.target.options[e.target.selectedIndex].getAttribute('destinationSite');
    },
    getVehicle: function getVehicle() {
      var _this5 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = '["' + this.user._id + '"]';
      }
      console.log('vehicle');
      var vehicleList = [];
      this.$vehicleDataRepository.list(params).then(function (res) {
        _this5.loading = false;
        if (res.data.docs) {
          vehicleList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.regNo,
              deviceId: item.deviceId
            };
          });
        }
        _this5.vehicle_no = vehicleList;
      }).catch(function (error) {
        _this5.loading = false;
        _this5.$snotify.error('Get vehicle list failed', 'Error!');
      });
    },
    getDriverName: function getDriverName() {
      var _this6 = this;

      this.loading = true;
      var params = {};
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      params.$limit = 0;
      var driverList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = '["' + this.user._id + '"]';
      }


      this.$driverDataRepository.list(params).then(function (res) {
        _this6.loading = false;
        if (res.data.docs) {
          _this6.driver_name = res.data.docs.map(function (item) {
            return {
              value: item._id,
              drivers: item.driverName
            };
          });
        }
      }).catch(function (error) {
        _this6.loading = false;
        _this6.$snotify.error('Get driver list failed', 'Error!');
      });
    },
    getDeviceName: function getDeviceName(e) {
      var _this7 = this;

      if (this.trip.vehicleId !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.trip.vehicleId) === 'object' && this.trip.vehicleId.key !== '') {
        this.inputValid2 = true;
        this.updateFormValidity();
      } else {
        this.inputValid2 = false;
        this.updateFormFalse();
      }
      var params = {};
      if (this.trip.vehicleId.deviceId) {
        params._id = this.trip.vehicleId.deviceId;
        this.loading = true;
        params.$limit = 0;
        var deviceList = [];
        this.$deviceDataRepository.list(params).then(function (res) {
          _this7.loading = false;
          if (res.data.docs) {
            deviceList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.deviceId
              };
            });
          }
          _this7.trip.deviceId = deviceList[0].value;
          _this7.selectedDeviceId = deviceList[0].key;
        }).catch(function (error) {
          _this7.loading = false;
          _this7.$snotify.error('Get device list failed', 'Error!');
        });
      } else {
        this.loading = false;
        this.$snotify.error('Vehicle not connected to any device .', 'Error!');
      }
    },
    getRouteName: function getRouteName() {
      var _this8 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var routeList = [];
      params.$select = ['name', '_id', 'startSite', 'endSite'];
      this.$triprouteDataRepository.list(params).then(function (res) {
        _this8.loading = false;
        if (res.data.docs) {
          routeList = res.data.docs;
        }
        _this8.route_list = routeList;
      }).catch(function (error) {
        _this8.loading = false;
        _this8.$snotify.error('Get route list failed', 'Error!');
      });
    },
    getLocations: function getLocations() {
      var _this9 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.gAId != '') {
        params.region = this.gAId;
      }
      params.status = 'active';
      params.$select = ['siteName', 'siteType', '_id', 'regionName', 'region', 'latitude', 'longitude'];
      this.$siteDataRepository.list(params).then(function (res) {
        _this9.locationList = res.data.docs;
      }).catch(function (error) {
        _this9.loading = false;
        _this9.$snotify.error('Get route list failed', 'Error!');
      });
    },
    addField: function addField(fieldType) {
      this[fieldType].splice(-1, 0, { locationId: null });
    },
    removeField: function removeField(index, fieldType) {
      console.log('index', index);
      console.log('fieldType', fieldType);
      this[fieldType].splice(index, 1);
    },
    handleChange: function handleChange(event, index) {

      if (this.locations.length >= 3 && this.locations[2].locationId && this.locations[2].locationId._id !== '') {
        this.inputValid6 = true;
        this.updateFormValidity();
      } else {
        this.inputValid6 = false;
        this.updateFormFalse();
      }

      this.clearIndex = index;
      var locations = this.locations;
      console.log('handleChange', this.locations);
      if (index > 0) {
        this.checkRoute(index);
      }
    },
    closeRoute: function closeRoute() {
      this.$modal.hide('gasFlowDia');
      this.locations[this.clearIndex].locationId = '';
      this.clearRoute();
    },
    checkRoute: function checkRoute(index) {
      var _this10 = this;

      var route = this.route_list.find(function (el) {
        return _this10.locations[index - 1].locationId._id === el.startSite && _this10.locations[index].locationId._id === el.endSite;
      });

      if (route) {
        var val = {
          routeId: route._id,
          startSite: route.startSite,
          endSite: route.endSite
        };
        this.list.push(val);
      } else {
        this.$modal.show('gasFlowDia');

        this.routeData.startLocation = this.locations[index - 1].locationId.siteName;
        this.routeData.endLocation = this.locations[index].locationId.siteName;
        this.routeData.startLocId = this.locations[index - 1].locationId._id;
        this.routeData.endLocId = this.locations[index].locationId._id;
        this.routeData.routeMarkers[0].latitude = String(this.locations[index - 1].locationId.latitude);
        this.routeData.routeMarkers[0].longitude = String(this.locations[index - 1].locationId.longitude);
        this.routeData.routeMarkers[0].message = this.locations[index - 1].locationId.siteName;
        this.routeData.routeMarkers[1].latitude = String(this.locations[index].locationId.latitude);
        this.routeData.routeMarkers[1].longitude = String(this.locations[index].locationId.longitude);
        this.routeData.routeMarkers[1].message = this.locations[index].locationId.siteName;
      }
    },
    clearRoute: function clearRoute() {
      this.routeData.startLocation = '';
      this.routeData.endLocation = '';
      this.routeData.time = '';
      this.routeData.distance = '';
      this.routeData.routeMarkers[0].latitude = '';
      this.routeData.routeMarkers[0].longitude = '';
      this.routeData.routeMarkers[0].message = '';
      this.routeData.routeMarkers[1].latitude = '';
      this.routeData.routeMarkers[1].longitude = '';
      this.routeData.routeMarkers[1].message = '';
    },
    createRoute: function createRoute() {
      var _this11 = this;

      this.loading = true;
      this.tripRoute = {
        approxDistance: this.routeData.distance,
        approxTime: this.routeData.time,
        status: 'active',
        startSite: this.routeData.startLocId,
        endSite: this.routeData.endLocId,
        region: this.gAId,
        reportAssessment: '',
        routeMarkers: this.routeData.routeMarkers
      };
      console.log('hii there', this.tripRoute);
      return __WEBPACK_IMPORTED_MODULE_4__services__["h" /* tripRouteService */].addtripRoute(this.tripRoute).then(function (response) {

        _this11.loading = false;
        _this11.flash = false;
        _this11.$snotify.success('route added!', 'Success!');
        _this11.clearRoute();
        _this11.getRouteName();
        _this11.checkRoute(_this11.clearIndex);

        _this11.$modal.hide('gasFlowDia');
      }).catch(function (error) {
        _this11.loading = false;
        _this11.$snotify.error('trip Add failed! Try Again', 'Error!');
      });
    },
    getRegionList: function getRegionList() {
      var _this12 = this;

      this.loading = true;
      this.params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        this.params.regionManager = this.regionManagersIdList;
      }
      if (this.user.roleName === 'Journey Manager') {
        this.isGeographicalAreaDisable = true;
        this.params.journeyManager = '["' + this.user._id + '"]';
      }
      var regionlist = [];
      this.$regionDataRepository.list(this.params).then(function (res) {
        _this12.loading = false;
        _this12.regionListFilter = res.data.docs;
        if (res.data.docs) {
          regionlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.name
            };
          });
        }
        _this12.region_list = regionlist;

        if (_this12.region_list.length === 1) {
          _this12.region_list ? _this12.trip.region = _this12.region_list[0] : _this12.trip.region = '';
          _this12.selectGA(_this12.region_list[0]);
        }
      }).catch(function (error) {
        _this12.loading = false;
        console.error('Region.requestFunction-error:', error);
        _this12.$snotify.error('Get region list failed', 'Error!');
      });
    }
  }, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TripGroup',
  data: function data() {
    var _templates,
        _this = this;

    return {
      dateFilter: {
        startDateFilter: "",
        endDateFilter: ""

      },
      startDateIsoFilter: "",
      endDateIsoFilter: "",
      date: {
        startDate: "",
        endDate: ""
      },
      startDateIso: "",
      endDateIso: "",
      regionManagersIdList: [],
      tripDetailsList: [],
      isAreaTable: false,
      regionValue: 'all',
      journey_managers: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_4__config__["h" /* USER_ROLES */],
      loading: null,
      tripTable: null,
      parameters: {},
      statusValue: '',
      parameterss: '',
      columns: ['tripGroupCode', 'startSiteSiteName', 'firstHalt', 'driverName', 'vehicle', 'scheduleDate', 'haltsCount', 'status', 'edit'],
      options: {
        highlightMatches: true,
        sortable: ['tripGroupCode', 'driverName', 'vehicle', 'startSiteSiteName', 'firstHalt'],
        headings: {
          tripGroupCode: 'Group Trip Code',
          driverName: 'Drivers',
          vehicle: 'Vehicle',
          startSiteSiteName: 'Source',
          firstHalt: 'First Halt',
          scheduleDate: 'Schedule Date',
          status: 'Status',
          haltsCount: 'No. of Halts'
        },
        templates: (_templates = {
          scheduleDate: function scheduleDate(row, query) {
            if (query.scheduleTime) {
              var _query$scheduleTime$s = query.scheduleTime.split(':'),
                  _query$scheduleTime$s2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_query$scheduleTime$s, 2),
                  h = _query$scheduleTime$s2[0],
                  m = _query$scheduleTime$s2[1];

              var time = h % 12 + 12 * (h % 12 == 0) + ':' + m + ' ' + (h >= 12 ? 'PM' : 'AM');
            }
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()('' + query.scheduleDate).format('DD-MM-YYYY') + ' ' + time;
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          }
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'status', function status(row, query) {
          return query.status[0].toUpperCase() + query.status.slice(1);
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'driverName', function driverName(row, query) {
          var drivers = [];
          query.driverId.map(function (el) {
            drivers.push(el.driverName);
          });
          return drivers.join(', ');
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'device', function device(row, query) {
          return query.deviceId.deviceId;
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'vehicle', function vehicle(row, query) {
          return query.vehicleId.regNo;
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'createdAt', function createdAt(row, query) {
          return __WEBPACK_IMPORTED_MODULE_6_moment___default()('' + new Date()).format('hh:mm A');
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'scheduleTime', function scheduleTime(row, query) {
          return '' + __WEBPACK_IMPORTED_MODULE_6_moment___default()('' + query.scheduleDate).format('DD-MM-YYYY');
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'firstHalt', function firstHalt(row, query) {
          return query.subTripDetails.length > 0 ? query.subTripDetails[0].endSiteSiteName : 'NA';
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_templates, 'haltsCount', function haltsCount(row, query) {
          console.log("query.subTripDetails.length -1", query.subTripDetails.length - 1);
          return query.subTripDetails.length - 1;
        }), _templates),
        requestFunction: function requestFunction(request) {
          _this.parameters.page = request.page;
          _this.parameters.limit = request.limit;
          if (request.query) {
            _this.parameters.searchString = request.query;
          } else {
            delete _this.parameters.searchString;
          }
          if (request.orderBy) {
            _this.parameters.sortBy = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            _this.parameters.sortBy = '-scheduleDate';
          }

          _this.loading = true;
          if (_this.regionManagersIdList.length !== 0) {
            _this.parameters.region = _this.regionManagersIdList;
          }
          if (_this.parameterss != '') {
            _this.parameters.region = _this.parameterss;
          }
          return _this.$tripGroupDataRepository.groupTripApi(_this.parameters).catch(function (error) {
            console.error('trip.requestFunction-error:', error);
            _this.$snotify.error('Get Trip', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          console.log('ress', response);
          _this.loading = false;
          return {
            data: response.data.data,
            count: response.data.totalCount
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  mounted: function mounted() {
    this.getGeographicalAreas();
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit || this.tripTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    clearFilterFilter: function clearFilterFilter() {

      this.dateFilter.startDateFilter = '';
      this.dateFilter.endDateFilter = '';
      delete this.parameters.startDate;
      delete this.parameters.endDate;
      this.$refs.tripTable.refresh();
    },
    startDateFilter: function startDateFilter() {
      var eventData = this.dateFilter.startDateFilter.split("-");
      this.startDateIsoFilter = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
    },
    endDateFilter: function endDateFilter() {
      if (this.dateFilter.startDateFilter != "" && this.dateFilter.endDateFilter != "") {
        var eventData = this.dateFilter.endDateFilter.split("-");
        var endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];

        this.parameters.startDate = this.startDateIsoFilter;
        this.parameters.endDate = endDate;
        this.$refs.tripTable.refresh();
      }
    },
    clearFilter: function clearFilter() {
      this.date.startDate = '';
      this.date.endDate = '';
    },
    startDate: function startDate() {
      var eventData = this.date.startDate.split("-");
      this.startDateIso = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
    },
    endDate: function endDate() {
      var eventData = this.date.endDate.split("-");
      this.endDateIso = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
      console.log('end date', this.endDateIso);
    },
    exportCSV: function exportCSV() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].serverURI + '/v1/exportMaster?startDate=' + this.startDateIso + '&model=tripgroup&endDate=' + this.endDateIso,
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log("response of download", response);
        var arrayBuffer = response.data;
        var filename = 'Group_Trip.xlsx';
        _this2.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    closeAreaTableModal: function closeAreaTableModal() {
      if (this.isAreaTable) {
        this.isAreaTable = !this.isAreaTable;
      }
    },
    showArea: function showArea(row) {
      this.isAreaTable = true;
      this.tripDetailsList = row.subTripDetails;
    },
    clearStatusGA: function clearStatusGA() {
      this.parameterss = '';
      delete this.parameters['region'];
      this.regionValue = 'all';
      this.$refs.tripTable.refresh();
    },
    fiteredResultGA: function fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameterss = '';
        delete this.parameters['region'];
        this.regionValue = 'all';
      } else {
        this.parameterss = e.target.value;
      }

      this.$refs.tripTable.refresh();
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var journeyManagerList = [];

      this.$regionsDataRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          if (_this3.user.roleName === 'Admin') {
            journeyManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this3.journey_managers = journeyManagerList;
          } else {
            journeyManagerList = res.data.docs.map(function (item) {
              if (_this3.regionManagersIdList.includes(item._id)) {
                _this3.journey_managers.push({
                  key: item._id,
                  value: item.name
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this3.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this3.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    clearStatus: function clearStatus() {
      delete this.parameters['tripStatus'];
      this.statusValue = '';
      this.$refs.tripTable.refresh();
    },
    fiteredResult: function fiteredResult(e) {
      if (e.target.value == 'ongoing') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          tripStatus: 'ongoing'
        });
      }
      if (e.target.value == 'scheduled') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          tripStatus: 'scheduled'
        });
      }
      if (e.target.value == 'completed') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          tripStatus: 'completed'
        });
      }
      if (e.target.value == 'cancelled') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          tripStatus: 'cancelled'
        });
      }
      this.$refs.tripTable.refresh();
    },
    UpdateDestination: function UpdateDestination(row) {
      if (row.status == 'ongoing' || row.status === 'scheduled') {
        this.$router.push({
          name: 'UpdateLocations',
          params: {
            _id: row._id
          },
          props: row
        });
      }
    },
    edit: function edit(data) {
      if (data.row.status == 'ongoing' || data.row.status == 'completed') {
        this.$router.push({
          name: 'Trip-Group-Activity',
          params: { _id: data.row._id },
          props: data.row
        });
      } else if (data.row.status == 'scheduled') {
        this.$router.push({
          name: 'TripGroupDetail',
          params: { _id: data.row._id },
          props: data.row
        });
      }
    },
    onLoaded: function onLoaded() {
      this.tripTable = this.$refs.tripTable;
    }
  }

});

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tripGroupDetail',
  data: function data() {
    var _ref;

    return _ref = {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_6__config__["h" /* USER_ROLES */],
      loading: false,
      flash: false,
      flashType: null,
      disabledBefore: new Date(),
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_6__config__["g" /* EVENTS */],
      role: {},
      roles: [],
      permissions: [],
      formstate: {},
      region_managers: {},
      vehicle_no: {},
      route_name: {},
      driver_name: {},
      device_name: {},
      journey_managers: {},
      status: 'scheduled',
      sourceSite: '',
      destinationSite: '',
      trip: {},
      locationList: [],
      locations: [{
        locationId: ''
      }, {
        locationId: ''
      }, {
        locationId: ''
      }],
      list: [],
      routeData: {
        startLocation: '',
        endLocation: '',
        time: '',
        distance: '',
        startLocId: '',
        endLocId: ''
      },
      region_list: {},
      journeyManagerId: [],
      gAId: '',
      regionListFilter: [],
      regionManagerId: ''
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'journeyManagerId', []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid1', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid2', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid3', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid4', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid5', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid6', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'inputValid7', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'formValid', false), _ref;
  },

  mounted: function mounted() {

    if (this.user.roleName == 'Admin') {
      this.getRegionList();
      this.getLocations();
      this.getRouteName();
    }
    if (this.user.roleName !== 'Admin') {
      this.getDeviceName();

      this.getRegionList();
    }
  },

  methods: {
    getFilteredLocationList: function getFilteredLocationList(index) {
      var stations = [];
      if (this.locations[0] && this.locations[0].locationId.siteType === 'LNGT') {
        if (index === 0) {
          stations = this.locationList.filter(function (el) {
            return el.siteType === 'MS' || el.siteType === 'LNGT';
          });
        } else {
          stations = this.locationList.filter(function (el) {
            return el.siteType === 'LNGT';
          });
        }
      } else if ((index === 0 || index === this.locations.length - 1) && this.locations[0].locationId.siteType !== 'LNGT') {
        stations = this.locationList.filter(function (el) {
          return el.siteType === 'MS' || el.siteType === 'LNGT';
        });
      } else {
        stations = this.locationList.filter(function (el) {
          return el.siteType === 'DBS' || el.siteType === 'DCU' || el.siteType === 'DS';
        });
      }

      return stations;
    },
    updateFormValidity: function updateFormValidity() {
      this.formValid = this.inputValid1 && this.inputValid2 && this.inputValid3 && this.inputValid4 && this.inputValid5;
    },
    updateFormFalse: function updateFormFalse() {
      if (this.inputValid1 || this.inputValid2 || this.inputValid3 || this.inputValid4 || this.inputValid5) {
        this.formValid = false;
      }
    },
    flagTrue: function flagTrue() {
      this.driverStatus();
      this.HCVOperationStatus();
      this.journeyManagerStatus();
      this.selectedGAFlag();
      this.getDeviceFlag();
    },
    selectedGAFlag: function selectedGAFlag() {
      if (this.trip.region !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.trip.region) === 'object' && this.trip.region.key !== '') {
        this.inputValid1 = true;
        this.updateFormValidity();
      } else {
        this.inputValid1 = false;
        this.updateFormFalse();
      }
    },
    driverStatus: function driverStatus() {
      if (this.trip.driverId.length > 0) {
        this.inputValid3 = true;
        this.updateFormValidity();
      } else {
        this.inputValid3 = false;
        this.updateFormFalse();
      }
    },
    HCVOperationStatus: function HCVOperationStatus() {

      if (this.trip.regionManager !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.trip.regionManager) === 'object' && this.trip.regionManager.key !== '') {
        this.inputValid4 = true;
        this.updateFormValidity();
      } else {
        this.inputValid4 = false;
        this.updateFormFalse();
      }
    },
    journeyManagerStatus: function journeyManagerStatus() {

      if (this.trip.journeyManager !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.trip.journeyManager) === 'object' && this.trip.journeyManager.key !== '') {
        this.inputValid5 = true;
        this.updateFormValidity();
      } else {
        this.inputValid5 = false;
        this.updateFormFalse();
      }
    },
    getDeviceFlag: function getDeviceFlag() {

      if (this.trip.vehicleId !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.trip.vehicleId) === 'object' && this.trip.vehicleId.key !== '') {
        this.inputValid2 = true;
        this.updateFormValidity();
      } else {
        this.inputValid2 = false;
        this.updateFormFalse();
      }
    },
    updateTripGroupDetails: function updateTripGroupDetails() {
      var _this = this;

      var device_id = this.trip.driverId.map(function (item) {
        return item.key;
      });

      this.loading = true;
      var details = {
        driverId: device_id,
        status: 'scheduled',
        scheduleTime: this.trip.scheduleTime,
        deviceId: this.trip.deviceId,
        journeyManager: this.trip.journeyManager.key,
        regionManager: this.trip.regionManager.key,
        scheduleDate: this.trip.scheduleDate,
        geographical_area: this.trip.geographical_area,
        vehicleId: this.trip.vehicleId.key,
        _id: this.trip._id
      };
      return __WEBPACK_IMPORTED_MODULE_5__services__["h" /* tripRouteService */].updatetripRouteDetails(details).then(function (response) {
        _this.loading = false;
        _this.flash = false;
        _this.$snotify.success('Trip Group Details update!', 'Success!');
        _this.$router.push('/trip-group');
      }).catch(function (error) {
        _this.loading = false;
        _this.$snotify.error('trip update failed! Try Again', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this.flash = true;
          _this.flashType = 'error';
          _this.flashMessage = 'Update route update is failed.Please try again!';
        }
      });
    },
    selectGA: function selectGA(e) {
      var _this2 = this;

      if (this.trip.region !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.trip.region) === 'object' && this.trip.region.key !== '') {
        this.inputValid1 = true;
        this.updateFormValidity();
      } else {
        this.inputValid1 = false;
        this.updateFormFalse();
      }
      this.gAId = e.key;
      this.getDriverName();
      this.getRouteName();
      this.getVehicle();
      var filteredRegion = this.regionListFilter.find(function (item) {
        return item._id === _this2.gAId;
      });
      this.regionManagerId = filteredRegion ? filteredRegion.regionManager : null;
      this.journeyManagerId = filteredRegion ? filteredRegion.journeyManager : null;
      this.getRegionManager();
      this.getJourneyManager();
    },
    getAllData: function getAllData(regionId) {
      var _this3 = this;

      this.gAId = regionId;
      this.getDriverName();
      this.getRouteName();
      this.getVehicle();
      var filteredRegion = this.regionListFilter.find(function (item) {
        return item._id === _this3.gAId;
      });
      this.regionManagerId = filteredRegion ? filteredRegion.regionManager : null;
      this.journeyManagerId = filteredRegion ? filteredRegion.journeyManager : null;
      this.getRegionManager();
      this.getJourneyManager();
      this.getLocations();
      this.setAllData();
      this.getDeviceName();
    },
    setAllData: function setAllData() {
      var _this4 = this;

      var driverArray = [];
      this.trip.driverId.forEach(function (element) {
        var dri = {
          key: element._id,
          value: element.driverName
        };

        driverArray.push(dri);
      });
      this.trip['driverId'] = driverArray;

      var data = this.trip.subTripDetails;
      var myData = [];
      var requiredList = [];

      data.forEach(function (element, index) {
        if (index === 0) {
          myData.push(element.startSite);
          myData.push(element.endSite);
        } else {
          myData.push(element.endSite);
        }
      });

      myData.forEach(function (element) {
        var locationData = [];
        var obj = {};
        locationData = _this4.locationList.filter(function (el) {
          return el._id === element;
        });
        obj['_id'] = locationData[0]._id;
        obj['siteName'] = locationData[0].siteName, obj['siteType'] = locationData[0].siteType, obj['regionName'] = locationData[0].regionName, obj['region'] = locationData[0].region, requiredList.push(obj);
      });
      while (this.locations.length < requiredList.length) {
        this.locations.push({ locationId: '' });
      }
      for (var i = 0; i < requiredList.length; i++) {
        if (requiredList[i] && requiredList[i]._id) {
          this.locations[i].locationId = {
            _id: requiredList[i]._id,
            siteName: requiredList[i].siteName,
            siteType: requiredList[i].siteType,
            regionName: requiredList[i].regionName,
            region: requiredList[i].region
          };
        } else {
          this.locations[i].locationId = '';
        }
      }

      this.trip['vehicleId'] = {
        key: this.trip.vehicleId._id,
        value: this.trip.vehicleId.regNo
      };
      this.trip['deviceId'] = this.trip.deviceId._id;

      this.trip['scheduleDate'] = this.trip.scheduleDate;
      this.trip['scheduleTime'] = this.trip.scheduleTime;
      this.trip['regionManager'] = {
        key: this.trip.regionManager._id,
        value: this.trip.regionManager.firstName + ' ' + this.trip.regionManager.lastName
      };
      this.trip['journeyManager'] = {
        key: this.trip.journeyManager._id,
        value: this.trip.journeyManager.firstName + ' ' + this.trip.journeyManager.lastName
      };

      var subTripsId = this.trip.subTrips;
      var filteredLocations = this.locationList.filter(function (location) {
        return subTripsId.includes(location._id);
      });
      this.locations['locationId'] = filteredLocations;

      var regionData = this.region_list.filter(function (el) {
        return el.key == _this4.trip.geographical_area;
      });
      this.trip['region'] = {
        key: regionData[0].key,
        value: regionData[0].value
      };
      this.flagTrue();
    },
    getRegionManagerGetingJM: function getRegionManagerGetingJM() {
      var _this5 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var regionManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = '["' + this.user._id + '"]';
        this.isGAHeadDisable = true;
        this.$regionDataRepository.list(params).then(function (res) {
          if (res.data.docs[0].journeyManager) {
            res.data.docs.forEach(function (el) {
              _this5.journeyManagerId = el.journeyManager;
            });
            _this5.getJourneyManager();
          }
        });
      }
    },
    getRegionList: function getRegionList() {
      var _this6 = this;

      var params = {};
      this.loading = true;
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName === 'Journey Manager') {
        this.isGeographicalAreaDisable = true;
        params.journeyManager = '["' + this.user._id + '"]';
      }
      var regionlist = [];
      this.$regionDataRepository.list(params).then(function (res) {
        _this6.loading = false;
        _this6.regionListFilter = res.data.docs;
        if (res.data.docs) {
          regionlist = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.name
            };
          });
        }
        _this6.region_list = regionlist;
        _this6.getTrip();
      }).catch(function (error) {
        _this6.loading = false;
        _this6.$snotify.error('Get region list failed', 'Error!');
      });
    },
    getLocations: function getLocations() {
      var _this7 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.status = 'active';

      if (this.gAId != '') {
        params.region = this.gAId;
      }
      params.$select = ['siteName', 'siteType', '_id', 'regionName', 'region'];
      this.$siteDataRepository.list(params).then(function (res) {
        _this7.locationList = res.data.docs;
      }).catch(function (error) {
        _this7.loading = false;
        _this7.$snotify.error('Get route list failed', 'Error!');
      });
    },
    addField: function addField(fieldType) {
      this[fieldType].splice(-1, 0, { locationId: null });
    },
    removeField: function removeField(index, fieldType) {
      this[fieldType].splice(index, 1);
    },
    handleChange: function handleChange(event, index) {
      this.clearIndex = index;
      var locations = this.locations;
      if (index > 0) {
        this.checkRoute(index);
      }
    },
    closeRoute: function closeRoute() {
      this.$modal.hide('gasFlowDia');
      this.locations[this.clearIndex].locationId = '';
    },
    checkRoute: function checkRoute(index) {
      var _this8 = this;

      var route = this.route_name.find(function (el) {
        return _this8.locations[index - 1].locationId._id === el.startSite && _this8.locations[index].locationId._id === el.endSite;
      });
      if (route) {
        var val = {
          routeId: route._id,
          startSite: route.startSite,
          endSite: route.endSite
        };
        this.list.push(val);
      } else {
        this.$modal.show('gasFlowDia');
        this.routeData.startLocation = this.locations[index - 1].locationId.siteName;
        this.routeData.endLocation = this.locations[index].locationId.siteName;
        this.routeData.startLocId = this.locations[index - 1].locationId._id;
        this.routeData.endLocId = this.locations[index].locationId._id;
      }
    },


    fieldClassName: __WEBPACK_IMPORTED_MODULE_5__services__["e" /* formService */].fieldClassName,
    getTrip: function getTrip() {
      var _this9 = this;

      return this.$tripGroupDataRepository.getIndividualGroupTrip(this.$route.params._id).then(function (response) {
        _this9.trip = response.data.data[0];
        _this9.getAllData(_this9.trip.geographical_area);
      }).catch(function (error) {
        _this9.$snotify.error('Trip detail failed', 'Error!');
      });
    },
    getSites: function getSites(e) {
      this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute('sourceSite');
      this.destinationSite = e.target.options[e.target.selectedIndex].getAttribute('destinationSite');
    },
    getRegionManager: function getRegionManager() {
      var _this10 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 2;
      if (this.gAId !== '') {
        params._id = this.regionManagerId;
      }
      var regionManagerList = [];
      this.$userRepository.list(params).then(function (res) {
        _this10.loading = false;
        if (res.data.docs) {
          regionManagerList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this10.region_managers = regionManagerList;
      }).catch(function (error) {
        _this10.loading = false;
        _this10.$snotify.error('Get region manager list failed', 'Error!');
      });
    },
    getJourneyManager: function getJourneyManager() {
      var _this11 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 3;
      if (this.gAId !== '') {
        params._id = this.journeyManagerId;
      }

      if (this.user.roleName == 'Journey Manager') {
        var bAsString = this.journeyManagerId.map(function (value) {
          return String(value);
        });
        var jsonString = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(bAsString);
        params._id = jsonString;
      }

      var journeyManagerList = [];
      this.$userRepository.list(params).then(function (res) {
        _this11.loading = false;
        if (res.data.docs) {
          journeyManagerList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this11.journey_managers = journeyManagerList;
      }).catch(function (error) {
        _this11.loading = false;
        _this11.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    getVehicle: function getVehicle() {
      var _this12 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      var vehicleList = [];
      this.$vehicleDataRepository.list(params).then(function (res) {
        _this12.loading = false;
        if (res.data.docs) {
          vehicleList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.regNo
            };
          });
        }
        _this12.vehicle_no = vehicleList;
      }).catch(function (error) {
        _this12.loading = false;
        _this12.$snotify.error('Get vehicle list failed', 'Error!');
      });
    },
    getDriverName: function getDriverName() {
      var _this13 = this;

      this.loading = true;
      var params = {};
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      params.$limit = 0;
      var driverList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = '["' + this.user._id + '"]';
      }


      this.$driverDataRepository.list(params).then(function (res) {
        _this13.loading = false;
        if (res.data.docs) {
          _this13.driver_name = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.driverName
            };
          });
        }
      }).catch(function (error) {
        _this13.loading = false;
        _this13.$snotify.error('Get driver list failed', 'Error!');
      });
    },
    getDeviceName: function getDeviceName() {
      var _this14 = this;

      if (this.trip.vehicleId !== null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.trip.vehicleId) === 'object' && this.trip.vehicleId.key !== '') {
        this.inputValid2 = true;
        this.updateFormValidity();
      } else {
        this.inputValid2 = false;
        this.updateFormFalse();
      }

      this.loading = true;
      var params = {};
      params.$limit = 0;

      console.log('qqqqqqqqqqqqqqqqqqqqqqqqqqqqqq');
      var deviceList = [];
      this.$deviceDataRepository.list(params).then(function (res) {
        _this14.loading = false;
        if (res.data.docs) {
          deviceList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.deviceId
            };
          });
        }
        _this14.device_name = deviceList;
      }).catch(function (error) {
        _this14.loading = false;
        _this14.$snotify.error('Get device list failed', 'Error!');
      });
    },
    getRouteName: function getRouteName() {
      var _this15 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      var routeList = [];
      this.$triprouteDataRepository.list(params).then(function (res) {
        _this15.loading = false;
        if (res.data.docs) {
          routeList = res.data.docs;
        }
        _this15.route_name = routeList;
      }).catch(function (error) {
        _this15.loading = false;
        _this15.$snotify.error('Get route list failed', 'Error!');
      });
    },
    updateTrip: function updateTrip() {
      var _this16 = this;

      this.loading = true;
      var device_id = this.trip.driverId.map(function (item) {
        return item.key;
      });
      var trip = {
        driverId: device_id,
        status: this.status,
        scheduleTime: this.scheduledTime,
        deviceId: this.selectedDeviceId,
        journeyManager: this.trip.journeyManager.key,
        regionManager: this.trip.regionManager.key,
        scheduleDate: this.trip.scheduleDate,
        vehicleId: this.trip.vehicleId.key,
        subTrips: this.list,
        remark: this.trip.remark,
        _id: this.trip._id
      };

      return __WEBPACK_IMPORTED_MODULE_5__services__["j" /* tripService */].updateTrip(trip).then(function (response) {
        _this16.loading = false;
        _this16.flash = false;
        _this16.$snotify.success('Trip details updated!', 'Success!');
        _this16.$router.push('/trip-group');
      }).catch(function (error) {
        _this16.loading = false;
        _this16.$snotify.error('Add Trip failed', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this16.flash = true;
          _this16.flashType = 'error';
          _this16.flashMessage = 'Trip is not updated due to some error. Please try again!.';
        }
      });
    },
    deleteTripModal: function deleteTripModal() {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this Trip!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this17.deleteTrip();
        }
      });
    },
    deleteTrip: function deleteTrip() {
      var _this18 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_5__services__["j" /* tripService */].tripGroupDelete(this.trip._id).then(function (response) {
        _this18.loading = false;
        return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('Deleted!', 'Trip has been deleted.', 'success');
      }).then(function (response) {
        _this18.loading = false;
        _this18.$router.push('/trip-group');
      }).catch(function (error) {
        _this18.loading = false;
        _this18.$snotify.error('Delete trip failed', 'Error!');
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  created: function created() {
    var _this19 = this;

    var promises = [];
    this.loading = true;

    promises.push(this.getLocations());

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this19.loading = false;
      _this19.ready = true;
    }).catch(function () {
      _this19.loading = false;
    });
  }
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(19);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TripLocationLog',
    data: function data() {
        var _this = this;

        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
            loading: null,
            triplocationTable: null,
            addressData: [],
            columns: ['recordedTime', 'latitude', 'longitude', 'batteryStatus', 'address'],

            options: {
                highlightMatches: true,
                sortable: ['recordedTime', 'longitude', 'latitude', 'batteryStatus'],
                headings: {
                    latitude: 'Latitude',
                    longitude: 'Longitude',
                    recordedTime: 'Recorded Time ',
                    batteryStatus: 'Battery',
                    address: 'Address'
                },
                templates: {
                    recordedTime: function recordedTime(row, query) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.recordedTime, __WEBPACK_IMPORTED_MODULE_3_moment___default.a.ISO_8601).format('DD-MM-YY hh:mm:ss');
                    }
                },
                requestFunction: function requestFunction(request) {
                    var params = {};
                    params.$page = request.page;
                    params.$limit = request.limit;
                    params.tripID = _this.$route.params._id;
                    _this.loading = true;
                    return _this.$triplocationDataRepository.list(params).catch(function (error) {
                        console.error('tripException.requestFunction-error:', error);
                        _this.$snotify.error('Get Location', 'Error!');
                    });
                },
                responseAdapter: function responseAdapter(response) {
                    _this.loading = false;
                    console.log("triplog response", response);
                    return {
                        data: response.data.docs,
                        count: response.data.items.total
                    };
                }
            },
            triplocation: {}
        };
    },

    methods: {
        onLoaded: function onLoaded() {
            this.triplocationTable = this.$refs.triplocationTable;
        },
        refresh: function refresh() {
            this.$refs.triplocationTable.refresh();
        }
    },
    computed: {
        addButtonClass: function addButtonClass() {
            if (this.triplocationTable) {
                return this.triplocationTable.count > this.triplocationTable.limit || this.triplocationTable.limit > 10 ? 'shift-add-left' : 'add-item';
            } else {
                return 'add-item';
            }
        }
    }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);




var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdateLocations',
  data: function data() {
    var _ref;

    return _ref = {
      clearIndex: null,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
      formstate: {},
      site_name: '',
      trip: {
        status: 'active'
      },
      locations: [{
        locationId: ''
      }, {
        locationId: ''
      }, {
        locationId: ''
      }],
      locationList: [],

      tripException: {
        prevDestination: '',
        docId: ''
      }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'trip', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'routeData', {
      startLocation: '',
      endLocation: '',
      time: '',
      distance: '',
      startLocId: '',
      endLocId: '',
      routeMarkers: [{
        latitude: '',
        longitude: '',
        message: ''
      }, {
        latitude: '',
        longitude: '',
        message: ''
      }]

    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'list', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'route_name', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'matchingRoutes', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'regionId', ''), _ref;
  },
  mounted: function mounted() {
    this.getTrip();

    this.getRouteName();
  },

  methods: (_methods = {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,

    getTrip: function getTrip() {
      var _this = this;

      return this.$tripGroupDataRepository.getIndividualGroupTrip(this.$route.params._id).then(function (response) {
        _this.trip = response.data.data[0];
        _this.regionId = _this.trip.geographical_area;

        _this.getLocations();
      }).catch(function (error) {
        _this.$snotify.error('Trip detail failed', 'Error!');
      });
    },
    getFilteredLocationList: function getFilteredLocationList(index) {
      var stations = [];
      if (this.locations[0] && this.locations[0].locationId.siteType === 'LNGT') {
        if (index === 0) {
          stations = this.locationList.filter(function (el) {
            return el.siteType === 'MS' || el.siteType === 'LNGT';
          });
        } else {
          stations = this.locationList.filter(function (el) {
            return el.siteType === 'LNGT';
          });
        }
      } else if ((index === 0 || index === this.locations.length - 1) && this.locations[0].locationId.siteType !== 'LNGT') {
        stations = this.locationList.filter(function (el) {
          return el.siteType === 'MS' || el.siteType === 'LNGT';
        });
      } else {
        stations = this.locationList.filter(function (el) {
          return el.siteType === 'DBS' || el.siteType === 'DCU' || el.siteType === 'DS';
        });
      }

      return stations;
    },
    getLocations: function getLocations() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.region = this.regionId;
      params.status = 'active';
      params.$select = ['siteName', 'siteType', '_id', 'regionName', 'region', 'latitude', 'longitude'];
      this.$siteDataRepository.list(params).then(function (res) {
        _this2.locationList = res.data.docs;
        _this2.setLocationsData();
      }).catch(function (error) {
        _this2.loading = false;
        _this2.$snotify.error('Get route list failed', 'Error!');
      });
    },
    setLocationsData: function setLocationsData() {
      var _this3 = this;

      var data = this.trip.subTripDetails;
      var myData = [];
      var requiredList = [];

      data.forEach(function (element, index) {
        if (index === 0) {
          myData.push(element.startSite);
          myData.push(element.endSite);
        } else {
          myData.push(element.endSite);
        }
      });
      myData.forEach(function (element) {
        var locationData = [];
        var obj = {};
        locationData = _this3.locationList.filter(function (el) {
          return el._id === element;
        });
        obj['_id'] = locationData[0]._id, obj['siteName'] = locationData[0].siteName, obj['siteType'] = locationData[0].siteType, obj['regionName'] = locationData[0].regionName, obj['region'] = locationData[0].region, obj['latitude'] = locationData[0].latitude, obj['longitude'] = locationData[0].longitude, requiredList.push(obj);
      });

      while (this.locations.length < requiredList.length) {
        this.locations.push({
          locationId: ''
        });
      }
      for (var i = 0; i < requiredList.length; i++) {
        if (requiredList[i] && requiredList[i]._id) {
          this.locations[i].locationId = {
            _id: requiredList[i]._id,
            siteName: requiredList[i].siteName,
            siteType: requiredList[i].siteType,
            regionName: requiredList[i].regionName,
            region: requiredList[i].region,
            latitude: requiredList[i].latitude,
            longitude: requiredList[i].longitude
          };
        } else {
          this.locations[i].locationId = '';
        }
      }
    },
    updateSubTrips: function updateSubTrips() {
      var _this4 = this;

      this.loading = true;

      var _loop = function _loop(indexx) {
        var el = _this4.route_name.find(function (el) {
          return _this4.locations[indexx - 1].locationId._id === el.startSite && _this4.locations[indexx].locationId._id === el.endSite;
        });
        if (el) {
          var val = {
            routeId: el._id,
            startSite: el.startSite,
            endSite: el.endSite
          };
          _this4.matchingRoutes.push(val);
        }
      };

      for (var indexx = 1; indexx < this.locations.length; indexx++) {
        _loop(indexx);
      }
      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', this.matchingRoutes);
      var subTripDetails = {
        subtrips: this.matchingRoutes,
        _id: this.$route.params._id
      };

      return __WEBPACK_IMPORTED_MODULE_3__services__["h" /* tripRouteService */].updatesubTripRouteDetails(subTripDetails).then(function (response) {
        _this4.loading = false;
        _this4.flash = false;
        _this4.$snotify.success('route added!', 'Success!');
        _this4.$router.push('/trip-group');
      }).catch(function (error) {
        _this4.loading = false;
        _this4.$snotify.error('trip Add failed! Try Again', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this4.flash = true;
          _this4.flashType = 'error';
          _this4.flashMessage = 'New route add is failed.Please try again!';
        }
      });
    },
    getSite: function getSite() {
      var _this5 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;

      var siteList = [];
      this.$siteDataRepository.list(params).then(function (res) {
        _this5.loading = false;
        if (res.data.docs) {
          siteList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.siteName
            };
          });
        }
        _this5.site_name = siteList;
      }).catch(function (error) {
        _this5.loading = false;
        console.error('site.requestFunction-error:', error);
        _this5.$snotify.error('Get site list failed', 'Error!');
      });
    },
    updateTrip: function updateTrip() {
      var _this6 = this;

      this.loading = true;
      this.tripException = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.tripException, {
        recordedTime: new Date().toISOString()
      });
      return __WEBPACK_IMPORTED_MODULE_3__services__["i" /* tripExceptionService */].addtripException(this.tripException).then(function (response) {
        console.log('responseeeee', response);
        _this6.loading = false;
        _this6.flash = false;
        _this6.tripUpdateDone();
      }).catch(function (error) {
        _this6.loading = false;
        _this6.$snotify.error('Destination update failed', 'Error!');
      });
    },
    tripUpdateDone: function tripUpdateDone() {
      var _this7 = this;

      this.trip.endSite = this.tripException.divertedDestination;
      this.loading = true;
      this.trip = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.trip, {
        endSite: this.tripException.divertedDestination
      });
      return __WEBPACK_IMPORTED_MODULE_3__services__["j" /* tripService */].updateTrip(this.trip).then(function (response) {
        _this7.loading = false;
        _this7.flash = false;
        _this7.$snotify.success('Destination has been updated!', 'Success!');
        _this7.$router.push('/trip-group');
      });
    },
    addField: function addField(fieldType) {
      this[fieldType].splice(-1, 0, { locationId: null });
    },
    removeField: function removeField(index, fieldType) {
      console.log('index', index);
      console.log('fieldType', fieldType);
      this[fieldType].splice(index, 1);
    },
    handleChange: function handleChange(event, index) {
      this.clearIndex = index;
      var locations = this.locations;

      console.log('handleChange', this.locations);
      if (index > 0) {
        this.checkRoute(index);
      }
    },
    closeRoute: function closeRoute() {
      this.$modal.hide('gasFlowDia');
      this.locations[this.clearIndex].locationId = '';
      this.clearRoute();
    },
    checkRoute: function checkRoute(index) {
      var _this8 = this;

      var route = this.route_name.find(function (el) {
        return _this8.locations[index - 1].locationId._id === el.startSite && _this8.locations[index].locationId._id === el.endSite;
      });

      if (route) {
        var val = {
          routeId: route._id,
          startSite: route.startSite,
          endSite: route.endSite
        };
        this.list.push(val);
      } else {
        this.$modal.show('gasFlowDia');
        this.routeData.startLocation = this.locations[index - 1].locationId.siteName;
        this.routeData.endLocation = this.locations[index].locationId.siteName;
        this.routeData.startLocId = this.locations[index - 1].locationId._id;
        this.routeData.endLocId = this.locations[index].locationId._id;
        this.routeData.routeMarkers[0].latitude = this.locations[index - 1].locationId.latitude;
        this.routeData.routeMarkers[0].longitude = this.locations[index - 1].locationId.longitude;
        this.routeData.routeMarkers[0].message = this.locations[index - 1].locationId.siteName;
        this.routeData.routeMarkers[1].latitude = this.locations[index].locationId.latitude;
        this.routeData.routeMarkers[1].longitude = this.locations[index].locationId.longitude;
        this.routeData.routeMarkers[1].message = this.locations[index].locationId.siteName;
      }
    },
    clearRoute: function clearRoute() {
      this.routeData.startLocation = '';
      this.routeData.endLocation = '';
      this.routeData.time = '';
      this.routeData.distance = '';
      this.routeData.routeMarkers[0].latitude = '';
      this.routeData.routeMarkers[0].longitude = '';
      this.routeData.routeMarkers[0].message = '';
      this.routeData.routeMarkers[1].latitude = '';
      this.routeData.routeMarkers[1].longitude = '';
      this.routeData.routeMarkers[1].message = '';
    },
    createRoute: function createRoute() {
      var _this9 = this;

      this.loading = true;
      var tripRoute = {
        approxDistance: this.routeData.distance,
        approxTime: this.routeData.time,
        status: 'active',
        startSite: this.routeData.startLocId,
        endSite: this.routeData.endLocId,
        region: this.regionId,
        reportAssessment: '',
        routeMarkers: this.routeData.routeMarkers
      };

      return __WEBPACK_IMPORTED_MODULE_3__services__["h" /* tripRouteService */].addtripRoute(tripRoute).then(function (response) {

        _this9.loading = false;
        _this9.flash = false;
        _this9.$snotify.success('route added!', 'Success!');
        _this9.clearRoute();

        _this9.getRouteName();
        _this9.checkRoute(_this9.clearIndex);
        _this9.$modal.hide('gasFlowDia');
      }).catch(function (error) {
        _this9.loading = false;
        _this9.$snotify.error('trip Add failed! Try Again', 'Error!');
      });
    },
    getRouteName: function getRouteName() {
      var _this10 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var routeList = [];
      this.$triprouteDataRepository.list(params).then(function (res) {
        _this10.loading = false;
        if (res.data.docs) {
          routeList = res.data.docs;
        }
        _this10.route_name = routeList;
      }).catch(function (error) {
        _this10.loading = false;
        _this10.$snotify.error('Get route list failed', 'Error!');
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'created', function created() {
    var _this11 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getLocations());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this11.loading = false;
      _this11.ready = true;
    }).catch(function () {
      _this11.loading = false;
    });
  }), _methods)
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_capsMixins__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'demo5',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
      loading: null,
      tripTable: null,
      columns: ['tripCode', 'routeIdName', 'driverIdDriverName', 'deviceIdImei', 'vehicleIdRegNo', 'startSiteSiteName', 'scheduleDate'],
      customFilters: [status == 'Halt'],
      options: {
        highlightMatches: true,
        sortable: ['tripCode', 'routeIdName', 'driverIdDriverName', 'deviceIdImei', 'vehicleIdRegNo', 'startSiteSiteName', 'scheduleDate'],
        headings: {
          tripCode: 'Trip Id',
          routeIdName: 'Route',
          driverIdDriverName: 'Driver',
          deviceIdImei: 'Device',
          vehicleIdRegNo: 'Vehicle',
          startSiteSiteName: 'From-To',
          scheduleDate: 'Schedule Date'
        },
        templates: {
          startSiteSiteName: function startSiteSiteName(row, query) {
            return query.startSiteSiteName + ' - ' + query.endSiteSiteName;
          },
          scheduleDate: function scheduleDate(row, query) {
            console.log('schedule function');
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()('' + query.scheduleDate).format('DD-MM-YYYY');
          },
          _id: function _id(row, query) {
            return '' + query._id;
          }
        },

        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.status = 'completed';
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$tripDataRepository.list(params).catch(function (error) {
            console.error('Trip.requestFunction-error:', error);
            _this.$snotify.error('Get Trip', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: {
    addButtonClass: function addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit || this.tripTable.limit > 5 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  },
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'TripActivity',
        params: { _id: data.row._id, status: 'Completed' },
        props: data.row
      });
    },
    onLoaded: function onLoaded() {
      this.tripTable = this.$refs.tripTable;
    }
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_capsMixins__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'onGoing',
  data: function data() {
    var _this = this;

    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
      loading: null,
      tripTable: null,
      columns: ['tripCode', 'routeIdName', 'driverIdDriverName', 'deviceIdImei', 'vehicleIdRegNo', 'startSiteSiteName', 'scheduleDate', 'edit'],

      options: {
        highlightMatches: true,
        sortable: ['tripCode', 'routeIdName', 'driverIdDriverName', 'deviceIdImei', 'vehicleIdRegNo', 'startSiteSiteName', 'endSiteSiteName', 'scheduleDate'],
        headings: {
          tripCode: 'Trip Id',
          routeIdName: 'Route',
          driverIdDriverName: 'Driver',
          deviceIdImei: 'Device',
          vehicleIdRegNo: 'Vehicle',
          startSiteSiteName: 'From-To',
          scheduleDate: 'Schedule Date'
        },
        templates: {
          startSiteSiteName: function startSiteSiteName(row, query) {
            return query.startSiteSiteName + ' - ' + query.endSiteSiteName;
          },
          scheduleDate: function scheduleDate(row, query) {
            console.log('schedule function');
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()('' + query.scheduleDate).format('DD-MM-YYYY');
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.status = 'ongoing';
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {}
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          _this.loading = true;
          return _this.$tripDataRepository.list(params).catch(function (error) {
            console.error('Trip.requestFunction-error:', error);
            _this.$snotify.error('Get Trip', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  computed: {
    addButtonClass: function addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit || this.tripTable.limit > 2 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  },
  methods: {
    UpdateDestination: function UpdateDestination(row) {
      this.$router.push({
        name: 'UpdateDestination',
        params: {
          _id: row._id
        },
        props: row
      });
    },
    edit: function edit(data) {
      this.$router.push({
        name: 'TripActivity',
        params: { _id: data.row._id, status: 'OnGoing' },
        props: data.row
      });
    },
    onLoaded: function onLoaded() {
      this.tripTable = this.$refs.tripTable;
    }
  }
});

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Trip',
  data: function data() {
    var _this = this,
        _ref;

    return _ref = {
      regionManagersIdList: [],
      regionValue: '',
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_3__config__["h" /* USER_ROLES */],
      loading: null,
      tripTable: null,
      parameters: {},
      journey_managers: [],
      statusValue: ''
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'regionValue', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'columns', ['tripCode', 'routeIdName', 'driverIdDriverName', 'vehicleIdRegNo', 'startSiteSiteName', 'endSiteSiteName', 'scheduleDate', 'scheduleTime', 'createdAt', 'status', 'edit']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'options', {
      highlightMatches: true,
      sortable: ['tripCode', 'routeIdName', 'driverIdDriverName', 'vehicleIdRegNo', 'startSiteSiteName', 'endSiteSiteName', 'scheduleDate', 'createdAt', 'scheduleTime', 'status'],
      headings: {
        tripCode: 'Trip Id',
        routeIdName: 'Route',
        driverIdDriverName: 'Driver',
        vehicleIdRegNo: 'Vehicle',
        startSiteSiteName: 'Source',
        endSiteSiteName: 'Destination',
        scheduleDate: 'Schedule Date',
        scheduleTime: 'Schedule Time',
        createdAt: 'Schedule At(JM)',
        status: 'Status'
      },

      templates: {
        scheduleDate: function scheduleDate(row, query) {
          return '' + __WEBPACK_IMPORTED_MODULE_5_moment___default()('' + query.scheduleDate).format('DD-MM-YYYY');
        },
        status: function status(row, query) {
          return query.status[0].toUpperCase() + query.status.slice(1);
        },
        createdAt: function createdAt(row, query) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()('' + query.createdAt).format('hh:mm A');
        },
        scheduleTime: function scheduleTime(row, query) {
          if (query.scheduleTime) {
            var _query$scheduleTime$s = query.scheduleTime.split(':'),
                _query$scheduleTime$s2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_query$scheduleTime$s, 2),
                h = _query$scheduleTime$s2[0],
                m = _query$scheduleTime$s2[1];

            return h % 12 + 12 * (h % 12 == 0) + ':' + m + ' ' + (h >= 12 ? 'PM' : 'AM');
          }
        }
      },
      requestFunction: function requestFunction(request) {
        _this.parameters.$page = request.page;
        _this.parameters.$limit = request.limit;
        if (_this.user.roleName == 'GA Head') {
          console.log('partam', _this.parameters);
          _this.parameters.regionManager = _this.user._id;
        }
        if (_this.user.roleName == 'Journey Manager') {
          _this.parameters.journeyManager = _this.user._id;
        }
        if (request.orderBy) {
          _this.parameters.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
        } else {
          _this.parameters.$sort = '-createdAt';
        }
        if (request.query) {
          _this.parameters.$term = request.query;
        } else {
          delete _this.parameters.$term;
        }

        if (request.query.status) {
          _this.parameters.status = request.query.status;
        }
        _this.loading = true;
        return _this.$tripDataRepository.list(_this.parameters).catch(function (error) {
          console.error('trip.requestFunction-error:', error);
          _this.$snotify.error('Get Trip', 'Error!');
        });
      },
      responseAdapter: function responseAdapter(response) {
        _this.loading = false;
        return {
          data: response.data.docs,
          count: response.data.items.total
        };
      },
      uniqueKey: '_id'
    }), _ref;
  },

  mounted: function mounted() {
    this.getGeographicalAreas();
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item.regionManager;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit || this.tripTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    clearStatus: function clearStatus() {
      delete this.parameters['status'];
      this.statusValue = '';
      this.$refs.tripTable.refresh();
    },
    clearStatusGA: function clearStatusGA() {
      delete this.parameters['regionManager'];
      this.regionValue = '';
      this.$refs.tripTable.refresh();
    },
    fiteredResult: function fiteredResult(e) {
      if (e.target.value == 'ongoing') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          status: 'ongoing'
        });
      }
      if (e.target.value == 'scheduled') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          status: 'scheduled'
        });
      }
      if (e.target.value == 'completed') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          status: 'completed'
        });
      }
      if (e.target.value == 'cancelled') {
        this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
          status: 'cancelled'
        });
      }
      this.$refs.tripTable.refresh();
    },
    UpdateDestination: function UpdateDestination(row) {
      if (row.status == 'ongoing') {
        this.$router.push({
          name: 'UpdateDestination',
          params: {
            _id: row._id
          },
          props: row
        });
      }
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this2 = this;

      console.log("heeer");
      this.loading = true;
      var params = {};
      params.$limit = 0;

      var journeyManagerList = [];

      this.$regionsDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          journeyManagerList = res.data.docs.map(function (item) {
            return {
              key: item.regionManager,
              value: item.name
            };
          });
        }
        _this2.journey_managers = journeyManagerList;
      }).catch(function (error) {
        _this2.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this2.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    edit: function edit(data) {
      if (data.row.status == 'ongoing' || data.row.status == 'completed') {
        this.$router.push({
          name: 'TripActivity',
          params: { _id: data.row._id },
          props: data.row
        });
      } else if (data.row.status == 'scheduled') {
        this.$router.push({
          name: 'TripDetail',
          params: { _id: data.row._id },
          props: data.row
        });
      }
    },
    fiteredResultGA: function fiteredResultGA(e) {
      this.parameters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.parameters, {
        regionManager: e.target.value
      });
      this.$refs.tripTable.refresh();
    },
    onLoaded: function onLoaded() {
      this.tripTable = this.$refs.tripTable;
    }
  }
});

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TripLocationLog_vue__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TripLocationLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TripLocationLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datetime_dist_vue_datetime_css__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TripActivity',
  data: function data() {
    var _this = this;

    return {
      edit: {},
      editGasFlow: {},
      trip_id: '',
      img_url: '',
      challan_img_url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/getMedia?path=trips',
      i_url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/getMedia?path=trips/',
      challanImage: '',
      urlId: '',
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_1__config__["h" /* USER_ROLES */],
      loading: null,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */],
      originReached: '',
      destinationReached: '',
      startedDate: '',
      endedDate: '',
      reportData: [{
        reading_1: '',
        reading_2: '',
        reading_3: '',
        reading_4: '',
        reading_5: ''
      }],
      initialPressure: '',
      finalPressure: '',
      endFinalPressure: '',
      endInitialPressure: '',
      initialGas: '',
      finalGas: '',
      endFinalGas: '',
      endInitialGas: '',
      initialStartPressure: '',
      finalStartPressure: '',
      initialEndPressure: '',
      finalEndPressure: '',
      preStartGas: '',
      postStartGas: '',
      preEndGas: '',
      postEndGas: '',
      startOdoMeterReading: '',
      endOdoMeterReading: '',
      startRecordedTime: '',
      endRecordedTime: '',
      startTripTime: '',
      endTripTime: '',
      timeDifference: '',
      scheduledDate: '',
      tripExceptionTable: null,
      changedStatus: null,
      columns: ['recordedTime', 'prevDestination', 'divertedDestination', 'originLocationDetails'],
      options: {
        highlightMatches: true,
        sortable: [],
        headings: {
          recordedTime: 'Recorded Time',

          divertedDestination: 'Destination Change ',
          originLocationDetails: 'Original Location'
        },
        templates: {
          prevDestination: function prevDestination(row, query) {
            if (query.prevDestinationDetails.length > 0 && query.prevDestinationDetails[0]['siteName']) {
              return '' + query.prevDestinationDetails[0]['siteName'];
            }
          },
          divertedDestination: function divertedDestination(row, query) {
            if (query.divertedDestinationDetails.length > 0 && query.divertedDestinationDetails[0]['siteName']) {
              return '' + query.divertedDestinationDetails[0]['siteName'];
            }
          },
          originLocationDetails: function originLocationDetails(row, query) {
            if (query.originLocationDetails.length > 0 && query.originLocationDetails[0]['siteName']) {
              return '' + query.originLocationDetails[0]['siteName'];
            }
          },
          recordedTime: function recordedTime(row, query) {
            if (query.recordedTime) {
              return __WEBPACK_IMPORTED_MODULE_4_moment___default()(query.recordedTime).format('DD-MM-YYYY HH:mm:ss');
            }
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.docId = _this.$route.params._id;
          _this.loading = true;
          return _this.$tripExceptionDataRepository.list(params).catch(function (error) {
            console.error('tripException.requestFunction-error:', error);
            _this.$snotify.error('Get Exception', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.result,
            count: response.data.result.length
          };
        }
      },
      trip: {},

      tripdetails: [],
      imageurls: [],
      challanImageUrls: [],
      odometer: [],
      gasfilling: [],
      pressure: []
    };
  },
  mounted: function mounted() {
    this.getTrip();
  },

  components: {
    TripLocationLog: __WEBPACK_IMPORTED_MODULE_2__TripLocationLog_vue___default.a
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      method: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/challandetails?tripID=' + this.$route.params._id,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      console.log('response of challan', response);
      _this2.challanDetails = response.data && response.data.docs && response.data.docs.length > 0 && response.data.docs[response.data.docs.length - 1];
      _this2.challanImage = _this2.challanDetails.image;
      _this2.urlId = _this2.challanDetails.tripID;
      response.data.docs.forEach(function (element) {
        element.image.forEach(function (imgUrl) {
          _this2.challanImageUrls.push(imgUrl);
        });
      });
    }).catch(function (e) {});
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      method: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/tripdetails?tripID=' + this.$route.params._id,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      _this2.tripdetails = response.data.docs;

      _this2.startRecordedTime = response.data.docs.filter(function (obj) {
        return obj.tripType === 'startTrip' && obj.imageType === 'odometer';
      });
      _this2.endRecordedTime = response.data.docs.filter(function (obj) {
        return obj.tripType === 'endTrip' && obj.imageType === 'odometer';
      });
      _this2.initialPressure = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
      });
      _this2.finalPressure = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
      });
      _this2.endInitialPressure = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
      });
      _this2.endFinalPressure = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
      });
      _this2.initialGas = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
      });
      _this2.finalGas = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
      });
      _this2.endInitialGas = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
      });
      _this2.endFinalGas = response.data.docs.filter(function (obj) {
        return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
      });

      if (_this2.initialPressure && _this2.initialPressure.length && _this2.initialGas && _this2.initialGas.length) {
        var iPressure = _this2.initialPressure[_this2.initialPressure.length - 1];
        var iGas = _this2.initialGas[_this2.initialGas.length - 1];
        _this2.reportData.splice(0, 1, {
          reading_1: iPressure.tripType,
          reading_2: iPressure.captureType,
          reading_3: iPressure.meterReading,
          reading_4: iGas.meterReading,
          reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
        });
      }
      if (_this2.finalPressure && _this2.finalPressure.length && _this2.finalGas && _this2.finalGas.length) {
        var iPressure = _this2.finalPressure[_this2.finalPressure.length - 1];
        var iGas = _this2.finalGas[_this2.finalGas.length - 1];
        _this2.reportData.splice(1, 0, {
          reading_1: iPressure.tripType,
          reading_2: iPressure.captureType,
          reading_3: iPressure.meterReading,
          reading_4: iGas.meterReading,
          reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
        });
      }
      if (_this2.endInitialPressure && _this2.endInitialPressure.length && _this2.endInitialGas && _this2.endInitialGas.length) {
        var iPressure = _this2.endInitialPressure[_this2.endInitialPressure.length - 1];
        var iGas = _this2.endInitialGas[_this2.endInitialGas.length - 1];
        _this2.reportData.splice(2, 0, {
          reading_1: iPressure.tripType,
          reading_2: iPressure.captureType,
          reading_3: iPressure.meterReading,
          reading_4: iGas.meterReading,
          reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
        });
      }
      if (_this2.endFinalPressure && _this2.endFinalPressure.length && _this2.endFinalGas && _this2.endFinalGas.length) {
        var iPressure = _this2.endFinalPressure[_this2.endFinalPressure.length - 1];
        var iGas = _this2.endFinalGas[_this2.endFinalGas.length - 1];
        _this2.reportData.splice(3, 0, {
          reading_1: iPressure.tripType,
          reading_2: iPressure.captureType,
          reading_3: iPressure.meterReading,
          reading_4: iGas.meterReading,
          reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
        });
      }
      _this2.odometer = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'odometer' && re.isDeleted == false) {
          response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
          return true;
        }
      });
      _this2.startOdoMeterReading = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
          response.data.docs[index];
          return true;
        }
      });
      _this2.endOdoMeterReading = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
          response.data.docs[index];
          return true;
        }
      });
      _this2.gasfilling = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'gasFilling' || re.imageType === 'pressureMeter') {
          if (re.imageType === 'gasFilling') {
            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
            return true;
          }
          if (re.imageType === 'pressureMeter') {
            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
            return true;
          }
        }
      });
      _this2.postStartGas = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'startTrip') {
          response.data.docs[index];
          return true;
        }
      });
      _this2.preStartGas = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'startTrip') {
          response.data.docs[index];
          return true;
        }
      });
      _this2.postEndGas = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'endTrip') {
          response.data.docs[index];
          return true;
        }
      });
      _this2.preEndGas = response.data.docs.filter(function (re, index) {
        if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'endTrip') {
          response.data.docs[index];
          return true;
        }
      });
      response.data.docs.forEach(function (element) {
        element.image.forEach(function (imgUrl) {
          _this2.imageurls.push(imgUrl);
        });
      });

      _this2.img_url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/getMedia?path=/trip/' + _this2.$route.params._id + '/';
    }).catch(function (e) {
      console.log(e);
    });
  },

  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  methods: {
    refreshTab: function refreshTab() {
      var _this3 = this;

      this.odometer = [];
      this.tripdetails = [];
      this.challanDetails = [];
      this.challanDetails = {};
      this.reportData = [{
        reading_1: '',
        reading_2: '',
        reading_3: '',
        reading_4: '',
        reading_5: ''
      }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/tripdetails?tripID=' + this.$route.params._id,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        _this3.tripdetails = response.data.docs;

        _this3.startRecordedTime = response.data.docs.filter(function (obj) {
          return obj.tripType === 'startTrip' && obj.imageType === 'odometer';
        });
        _this3.endRecordedTime = response.data.docs.filter(function (obj) {
          return obj.tripType === 'endTrip' && obj.imageType === 'odometer';
        });
        _this3.initialPressure = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
        });
        _this3.finalPressure = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
        });
        _this3.endInitialPressure = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
        });
        _this3.endFinalPressure = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
        });
        _this3.initialGas = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
        });
        _this3.finalGas = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
        });
        _this3.endInitialGas = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
        });
        _this3.endFinalGas = response.data.docs.filter(function (obj) {
          return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
        });

        if (_this3.initialPressure && _this3.initialPressure.length && _this3.initialGas && _this3.initialGas.length) {
          var iPressure = _this3.initialPressure[_this3.initialPressure.length - 1];
          var iGas = _this3.initialGas[_this3.initialGas.length - 1];
          _this3.reportData.splice(0, 1, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
          });
        }
        if (_this3.finalPressure && _this3.finalPressure.length && _this3.finalGas && _this3.finalGas.length) {
          var iPressure = _this3.finalPressure[_this3.finalPressure.length - 1];
          var iGas = _this3.finalGas[_this3.finalGas.length - 1];
          _this3.reportData.splice(1, 0, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
          });
        }
        if (_this3.endInitialPressure && _this3.endInitialPressure.length && _this3.endInitialGas && _this3.endInitialGas.length) {
          var iPressure = _this3.endInitialPressure[_this3.endInitialPressure.length - 1];
          var iGas = _this3.endInitialGas[_this3.endInitialGas.length - 1];
          _this3.reportData.splice(2, 0, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
          });
        }
        if (_this3.endFinalPressure && _this3.endFinalPressure.length && _this3.endFinalGas && _this3.endFinalGas.length) {
          var iPressure = _this3.endFinalPressure[_this3.endFinalPressure.length - 1];
          var iGas = _this3.endFinalGas[_this3.endFinalGas.length - 1];
          _this3.reportData.splice(3, 0, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
          });
        }
        _this3.odometer = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'odometer' && re.isDeleted == false) {
            response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
            return true;
          }
        });
        _this3.startOdoMeterReading = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
            response.data.docs[index];
            return true;
          }
        });
        _this3.endOdoMeterReading = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
            response.data.docs[index];
            return true;
          }
        });
        _this3.gasfilling = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'gasFilling' || re.imageType === 'pressureMeter') {
            if (re.imageType === 'gasFilling') {
              response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
              return true;
            }
            if (re.imageType === 'pressureMeter') {
              response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
              return true;
            }
          }
        });
        _this3.postStartGas = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'startTrip') {
            response.data.docs[index];
            return true;
          }
        });
        _this3.preStartGas = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'startTrip') {
            response.data.docs[index];
            return true;
          }
        });
        _this3.postEndGas = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'endTrip') {
            response.data.docs[index];
            return true;
          }
        });
        _this3.preEndGas = response.data.docs.filter(function (re, index) {
          if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'endTrip') {
            response.data.docs[index];
            return true;
          }
        });
        response.data.docs.forEach(function (element) {
          element.image.forEach(function (imgUrl) {
            _this3.imageurls.push(imgUrl);
          });
        });

        _this3.img_url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/getMedia?path=/trip/' + _this3.$route.params._id + '/';
      }).catch(function (e) {
        console.log(e);
      });
    },
    onFilechanged: function onFilechanged(event) {
      this.edit.image = event.target.files[0];
    },
    onFilechanged1: function onFilechanged1(event) {
      this.editGasFlow.image = event.target.files[0];
    },
    openNewTripDia: function openNewTripDia() {
      this.edit = {};
      this.edit.title = 'Create trip';
      this.$modal.show('tripDialog');
    },
    createTrip: function createTrip() {
      var _this4 = this;

      this.edit.captureType = this.edit.tripType === 'startTrip' ? 'post' : 'pre';

      this.edit.tripID = this.trip._id;

      var formData = new FormData();
      formData.append('captureType', this.edit.captureType);
      formData.append('imageType', 'odometer');
      formData.append('tripID', this.trip._id);
      formData.append('latitude', this.edit.latitude);
      formData.append('longitude', this.edit.longitude);
      formData.append('meterReading', this.edit.meterReading);
      formData.append('recordedTime', this.edit.recordedTime);
      formData.append('tripType', this.edit.tripType);
      formData.append('file', this.edit.image);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {
        _this4.odometer = [];
        _this4.$modal.hide('tripDialog');
        _this4.$snotify.success('Trip created!', 'Success!');
        _this4.refreshTab();
      }).catch(function (err) {
        console.log('errorrrrr', err);
      });
    },
    openUpdateTripDia: function openUpdateTripDia(o) {
      this.edit = {};
      this.edit = o;
      this.edit.title = 'Update trip';
      this.$modal.show('tripDialog');
    },
    updateTrip: function updateTrip() {
      var _this5 = this;

      this.edit.image = document.getElementById('myfile');
      this.edit.captureType = this.edit.tripType === 'startTrip' ? 'post' : 'pre';
      this.edit.tripID = this.trip._id;

      var formData = new FormData();
      formData.append('captureType', this.edit.captureType);
      formData.append('imageType', 'odometer');
      formData.append('tripID', this.trip._id);
      formData.append('latitude', this.edit.latitude);
      formData.append('longitude', this.edit.longitude);
      formData.append('meterReading', this.edit.meterReading);
      formData.append('recordedTime', this.edit.recordedTime);
      formData.append('tripType', this.edit.tripType);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {
        _this5.$modal.hide('tripDialog');
        _this5.$snotify.success('Trip updated!', 'Success!');
        _this5.refreshTab();
      }).catch(function (err) {
        console.log('errorrrrr', err);
      });
    },
    deleteTripDetail: function deleteTripDetail(data) {
      var _this6 = this;

      var body = { "hardDelete": true };
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/tripdetails/' + data._id, body).then(function (res) {
        console.log('88888', res);
        _this6.$snotify.success('Trip deleted!', 'Success!');
        _this6.refreshTab();
      }).catch(function (err) {
        console.log('errorrrrrr', err);
      });
    },
    openNewGasFlowDia: function openNewGasFlowDia() {
      this.editGasFlow = {};
      this.editGasFlow.title = 'Add Gas Flow Details';
      this.$modal.show('gasFlowDia');
    },
    createGasFlowDetails: function createGasFlowDetails() {
      var _this7 = this;

      var formData = new FormData();
      formData.append('captureType', this.editGasFlow.reading_2);
      formData.append('tripID', this.trip._id);
      formData.append('latitude', 7);
      formData.append('longitude', 7);
      formData.append('recordedTime', this.editGasFlow.reading_5);
      formData.append('tripType', this.editGasFlow.reading_1);

      formData.append('meterReading', this.editGasFlow.reading_3);
      formData.append('imageType', 'pressureMeter');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {
        formData.set('meterReading', _this7.editGasFlow.reading_4);
        formData.set('imageType', 'gasFilling');
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {
          formData.append('file', _this7.editGasFlow.image);

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {}).catch(function (err) {
            console.log('errorrrrr', err);
          });

          _this7.$modal.hide('gasFlowDia');
          _this7.$snotify.success('created!', 'Success!');
          _this7.tripdetails = [];
          _this7.challanDetails = [];
          _this7.challanDetails = {};
          _this7.reportData = [{
            reading_1: '',
            reading_2: '',
            reading_3: '',
            reading_4: '',
            reading_5: ''
          }];
          _this7.refreshTab();
        }).catch(function (err) {
          console.log('errorrrrr', err);
        });
      }).catch(function (err) {
        console.log('errorrrrr', err);
      });
    },
    openUpdateGasFlowDia: function openUpdateGasFlowDia(data) {
      this.ids = null;
      this.editGasFlow = {};
      this.editGasFlow = data;
      this.editGasFlow.title = 'Update Gas Flow Details';
      this.ids = this.tripdetails.filter(function (element) {
        return element.captureType === data.reading_2 && element.tripType === data.reading_1 && (element.imageType === 'gasFilling' || element.imageType === 'pressureMeter');
      });
      this.$modal.show('gasFlowDia');
    },
    updateGasFlowDetails: function updateGasFlowDetails() {
      var _this8 = this;

      var formData = new FormData();
      formData.append('captureType', this.editGasFlow.reading_2);
      formData.append('tripID', this.trip._id);
      formData.append('latitude', 7);
      formData.append('longitude', 7);
      formData.append('recordedTime', this.editGasFlow.reading_5);
      formData.append('tripType', this.editGasFlow.reading_1);

      formData.append('meterReading', this.editGasFlow.reading_3);
      formData.append('imageType', 'pressureMeter');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {
        formData.set('meterReading', _this8.editGasFlow.reading_4);
        formData.set('imageType', 'gasFilling');
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/meterCapture', formData).then(function (res) {
          _this8.$modal.hide('gasFlowDia');
          _this8.$snotify.success('created!', 'Success!');
          _this8.tripdetails = [];
          _this8.challanDetails = [];
          _this8.challanDetails = {};
          _this8.reportData = [{
            reading_1: '',
            reading_2: '',
            reading_3: '',
            reading_4: '',
            reading_5: ''
          }];
          _this8.refreshTab();
        }).catch(function (err) {
          console.log('errorrrrr', err);
        });
      }).catch(function (err) {
        console.log('errorrrrr', err);
      });
    },
    changeStatus: function changeStatus(e) {
      this.changedStatus = e.target.value;
    },
    deleteopenUpdateGasFlowDia: function deleteopenUpdateGasFlowDia(data) {
      var _this9 = this;

      var ids = this.tripdetails.filter(function (element) {
        return element.captureType === data.reading_2 && element.tripType === data.reading_1 && (element.imageType === 'gasFilling' || element.imageType === 'pressureMeter');
      });
      ids.forEach(function (i, ind) {
        var body = { "hardDelete": true };
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/tripdetails/' + i._id, body).then(function (res) {
          if (ind === ids.length - 1) {
            _this9.tripdetails = [];
            _this9.challanDetails = [];
            _this9.challanDetails = {};
            _this9.reportData = [{
              reading_1: '',
              reading_2: '',
              reading_3: '',
              reading_4: '',
              reading_5: ''
            }];
            __WEBPACK_IMPORTED_MODULE_3_axios___default()({
              method: 'get',
              url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/tripdetails?tripID=' + _this9.$route.params._id,
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(function (response) {
              _this9.$snotify.success('Trip deleted!', 'Success!');
              _this9.tripdetails = response.data.docs;

              _this9.startRecordedTime = response.data.docs.filter(function (obj) {
                return obj.tripType === 'startTrip' && obj.imageType === 'odometer';
              });
              _this9.endRecordedTime = response.data.docs.filter(function (obj) {
                return obj.tripType === 'endTrip' && obj.imageType === 'odometer';
              });
              _this9.initialPressure = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
              });
              _this9.finalPressure = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'pressureMeter';
              });
              _this9.endInitialPressure = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
              });
              _this9.endFinalPressure = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'pressureMeter';
              });
              _this9.initialGas = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
              });
              _this9.finalGas = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'startTrip' && obj.imageType === 'gasFilling';
              });
              _this9.endInitialGas = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'pre' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
              });
              _this9.endFinalGas = response.data.docs.filter(function (obj) {
                return obj.isDeleted === false && obj.captureType === 'post' && obj.tripType === 'endTrip' && obj.imageType === 'gasFilling';
              });

              if (_this9.initialPressure && _this9.initialPressure.length && _this9.initialGas && _this9.initialGas.length) {
                var iPressure = _this9.initialPressure[_this9.initialPressure.length - 1];
                var iGas = _this9.initialGas[_this9.initialGas.length - 1];
                _this9.reportData = [{
                  reading_1: '',
                  reading_2: '',
                  reading_3: '',
                  reading_4: '',
                  reading_5: ''
                }];
                _this9.reportData.splice(0, 1, {
                  reading_1: iPressure.tripType,
                  reading_2: iPressure.captureType,
                  reading_3: iPressure.meterReading,
                  reading_4: iGas.meterReading,
                  reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                });
              }
              if (_this9.finalPressure && _this9.finalPressure.length && _this9.finalGas && _this9.finalGas.length) {
                var iPressure = _this9.finalPressure[_this9.finalPressure.length - 1];
                var iGas = _this9.finalGas[_this9.finalGas.length - 1];
                _this9.reportData.splice(1, 0, {
                  reading_1: iPressure.tripType,
                  reading_2: iPressure.captureType,
                  reading_3: iPressure.meterReading,
                  reading_4: iGas.meterReading,
                  reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                });
              }
              if (_this9.endInitialPressure && _this9.endInitialPressure.length && _this9.endInitialGas && _this9.endInitialGas.length) {
                var iPressure = _this9.endInitialPressure[_this9.endInitialPressure.length - 1];
                var iGas = _this9.endInitialGas[_this9.endInitialGas.length - 1];
                _this9.reportData.splice(2, 0, {
                  reading_1: iPressure.tripType,
                  reading_2: iPressure.captureType,
                  reading_3: iPressure.meterReading,
                  reading_4: iGas.meterReading,
                  reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                });
              }
              if (_this9.endFinalPressure && _this9.endFinalPressure.length && _this9.endFinalGas && _this9.endFinalGas.length) {
                var iPressure = _this9.endFinalPressure[_this9.endFinalPressure.length - 1];
                var iGas = _this9.endFinalGas[_this9.endFinalGas.length - 1];
                _this9.reportData.splice(3, 0, {
                  reading_1: iPressure.tripType,
                  reading_2: iPressure.captureType,
                  reading_3: iPressure.meterReading,
                  reading_4: iGas.meterReading,
                  reading_5: iGas.recordedTime && __WEBPACK_IMPORTED_MODULE_4_moment___default()(iGas.recordedTime).format('DD-MM-YYYY hh:mm A')
                });
              }
              _this9.odometer = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'odometer' && re.isDeleted == false) {
                  response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                  return true;
                }
              });
              _this9.startOdoMeterReading = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
                  response.data.docs[index];
                  return true;
                }
              });
              _this9.endOdoMeterReading = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
                  response.data.docs[index];
                  return true;
                }
              });
              _this9.gasfilling = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'gasFilling' || re.imageType === 'pressureMeter') {
                  if (re.imageType === 'gasFilling') {
                    response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                    return true;
                  }
                  if (re.imageType === 'pressureMeter') {
                    response.data.docs[index]['recordedTime'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(re['recordedTime']).format('DD-MM-YYYY hh:mm A');
                    return true;
                  }
                }
              });
              _this9.postStartGas = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'startTrip') {
                  response.data.docs[index];
                  return true;
                }
              });
              _this9.preStartGas = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'startTrip') {
                  response.data.docs[index];
                  return true;
                }
              });
              _this9.postEndGas = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'gasFilling' && re.captureType === 'post' && re.tripType === 'endTrip') {
                  response.data.docs[index];
                  return true;
                }
              });
              _this9.preEndGas = response.data.docs.filter(function (re, index) {
                if (re.imageType === 'gasFilling' && re.captureType === 'pre' && re.tripType === 'endTrip') {
                  response.data.docs[index];
                  return true;
                }
              });
              response.data.docs.forEach(function (element) {
                element.image.forEach(function (imgUrl) {
                  _this9.imageurls.push(imgUrl);
                });
              });

              _this9.img_url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + '/getMedia?path=/trip/' + _this9.$route.params._id + '/';
            }).catch(function (e) {
              console.log(e);
            });
          }
        }).catch(function (err) {
          console.log('errorrrrr', err);
        });
      });
    },
    tripEnd: function tripEnd(action) {
      var _this10 = this;

      if (action == 'end') {
        this.trip.status = 'completed', this.trip.endDate = new Date(Date.now()).toISOString();
        console.log('trip trip triup', this.trip);
      } else if (action == 'cancel') {
        this.trip.status = 'cancelled';
      }
      if (this.changedStatus != null) {
        this.trip.status = this.changedStatus;
      }

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_0__services__["j" /* tripService */].updateTrip(this.trip).then(function (response) {
        _this10.loading = false;
        _this10.flash = false;
        if (action == 'end') {
          _this10.$snotify.success('Trip is ended!', 'Success!');
          _this10.$router.push('/trip');
        } else if (action == 'cancel') {
          _this10.$snotify.success('Trip is cancelled!', 'Success!');
          _this10.$router.push('/trip');
        } else if (_this10.changeStatus != null && action == 'update') {
          window.location.reload();
          _this10.$snotify.success('Trip updated!', 'Success!');
          _this10.$router.push('/trip');
        } else if (action == 'update' && _this10.changeStatus == null) {
          _this10.$snotify.success('Trip timings are updated!', 'Success!');
        }
      }).catch(function (error) {
        _this10.loading = false;
        _this10.$snotify.error('Trip end failed', 'Error!');
        if (error.data.message.includes('must be one of')) {
          _this10.flash = true;
          _this10.flashType = 'error';
          _this10.flashMessage = 'Trip is not updated due to some error. Please try again!.';
        }
      });
    },
    convertMS: function convertMS(ms) {
      var d, h, m, s;
      s = Math.floor(ms / 1000);
      m = Math.floor(s / 60);
      s = s % 60;
      h = Math.floor(m / 60);
      m = m % 60;
      d = Math.floor(h / 24);
      h = h % 24;
      h += d * 24;
      if (this.trip.destinationReachedAt < this.trip.startDate) {
        return ('-'(h + '').length === 1 ? '0' + h : h) + ' h ' + ('0' + m).substr(-2) + ' min ' + ('0' + s).substr(-2);
      } else {
        return ((h + '').length === 1 ? '0' + h : h) + ' h ' + ('0' + m).substr(-2) + ' min ' + ('0' + s).substr(-2);
      }
    },
    getTrip: function getTrip() {
      var _this11 = this;

      return this.$tripDataRepository.find(this.$route.params._id).then(function (response) {
        console.log('this.trip', response);
        _this11.trip = response.data;
        _this11.scheduledDate = _this11.trip.scheduleDate && __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.scheduleDate).format('DD-MM-YYYY');
        _this11.endedDate = _this11.trip.endDate && __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.endDate).format('DD-MM-YYYY hh:mm A');
        _this11.startedDate = _this11.trip.startDate && __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.startDate).format('DD-MM-YYYY hh:mm A');
        _this11.destinationReached = _this11.trip.destinationReachedAt && __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.destinationReachedAt).format('DD-MM-YYYY hh:mm A');
        _this11.originReached = _this11.trip.originReachedAt && __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.originReachedAt).format('DD-MM-YYYY hh:mm A');
        if (_this11.trip.startDate && _this11.trip.destinationReachedAt) {
          _this11.timeDifference = _this11.convertMS(Math.abs(__WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.destinationReachedAt) - __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this11.trip.startDate)));
        }
      }).catch(function (error) {
        _this11.$snotify.error(' OnGoing Trip detail failed', 'Error!');
      });
    },
    locationLogTable: function locationLogTable() {
      var x = document.getElementById('tripLocationLogTable');
      if (x.style.display === 'none') {
        x.style.display = 'block';
      } else {
        x.style.display = 'none';
      }
    },
    exceptionTable: function exceptionTable() {
      var y = document.getElementById('exceptionTable');
      if (y.style.display === 'none') {
        y.style.display = 'block';
      } else {
        y.style.display = 'none';
      }
    },
    onLoaded: function onLoaded() {
      this.tripExceptionTable = this.$refs.tripExceptionTable;
    }
  },
  computed: {
    addButtonClass: function addButtonClass() {
      if (this.tripExceptionTable) {
        return this.tripExceptionTable.count > this.tripExceptionTable.limit || this.tripExceptionTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_timepicker_dist_VueTimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TripCreate',
  data: function data() {
    return {
      loading: false,
      disabledBefore: new Date(),
      isDeviceDisable: false,
      isJourenyManagerDisable: false,
      isGAHeadDisable: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
      formstate: {},
      region_list: {},
      region_managers: {},
      start_site: {},
      end_site: {},
      vehicle_no: {},
      route_list: {},
      driver_name: [],
      device_name: {},
      journey_managers: {},
      scheduledTime: '',
      projectFormat: 'hh:mm',
      status: 'scheduled',
      sourceSite: '',
      destinationSite: '',
      device: {
        status: 'active'
      },
      trip: {
        vehicleId: '',
        deviceId: '',
        journeyManager: '',
        regionManager: '',
        driverId: '',
        subTrips: []
      },
      driver: [],
      locationList: [],
      locations: [{ locationId: '' }, { locationId: '' }],
      list: []
    };
  },

  mounted: function mounted() {
    this.getRegionManager();
    this.getDriverName();

    this.getRouteName();
    this.getVehicle();
    this.getJourneyManager();
    this.getLocations();
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,
    createTrip: function createTrip() {
      var _this = this;

      this.loading = true;
      this.driver = this.trip.drivers.map(function (el) {
        return el.value;
      });

      this.trip = {
        driverId: this.driver,
        status: this.status,
        scheduleTime: this.scheduledTime,
        deviceId: this.trip.deviceId,
        journeyManager: this.trip.journeyManager,
        regionManager: this.trip.regionManager,
        scheduleDate: this.trip.scheduleDate,
        vehicleId: this.trip.vehicleId,
        subTrips: this.list
      };
      console.log("llllist", this.list);
      return __WEBPACK_IMPORTED_MODULE_3__services__["j" /* tripService */].tripGroupAdd(this.trip).then(function (response) {
        _this.loading = false;
        _this.flash = false;
        _this.$snotify.success('Trip added!', 'Success!');
        _this.$router.push('/trip');
      }).catch(function (error) {
        _this.loading = false;
        _this.$snotify.error('trip Add failed! Try Again', 'Error!');
        if (error.data.message == 'dvgdxfv') {
          _this.$snotify.success('Trip added!', 'Success!');
          _this.$router.push('/trip');
        }
      });
    },
    getRegionManager: function getRegionManager() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var regionManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = '["' + this.user._id + '"]';
        this.isGAHeadDisable = true;
        this.$regionDataRepository.list(params).then(function (res) {
          _this2.loading = false;
          if (res.data.docs) {
            regionManagerList = res.data.docs.map(function (item) {
              _this2.trip.regionManager = item.regionManager;
              return {
                key: item.regionManager,
                value: item.regionManagerFirstName + ' ' + item.regionManagerLastName
              };
            });
          }
          _this2.region_managers = regionManagerList;
        });
      } else {
        params.roleRank = 2;
        this.$userRepository.list(params).then(function (res) {
          _this2.loading = false;
          if (res.data.docs) {
            regionManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName
              };
            });
          }
          _this2.region_managers = regionManagerList;
        }).catch(function (error) {
          _this2.loading = false;
          console.error('Region Manager.requestFunction-error:', error);
          _this2.$snotify.error('Get region manager list failed', 'Error!');
        });
      }
    },
    getJourneyManager: function getJourneyManager() {
      var _this3 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.roleRank = 3;
      var journeyManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        params._id = '["' + this.user._id + '"]';
        this.isJourenyManagerDisable = true;
        this.trip.journeyManager = this.user._id;
      }
      this.$userRepository.list(params).then(function (res) {
        _this3.loading = false;
        if (res.data.docs) {
          journeyManagerList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.firstName + ' ' + item.lastName
            };
          });
        }
        _this3.journey_managers = journeyManagerList;
      }).catch(function (error) {
        _this3.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this3.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    getSites: function getSites(e) {
      this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute('sourceSite');
      this.destinationSite = e.target.options[e.target.selectedIndex].getAttribute('destinationSite');
    },
    getVehicle: function getVehicle() {
      var _this4 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = '["' + this.user._id + '"]';
      }
      var vehicleList = [];
      this.$vehicleDataRepository.list(params).then(function (res) {
        _this4.loading = false;
        if (res.data.docs) {
          vehicleList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.regNo,
              deviceId: item.deviceId
            };
          });
        }
        _this4.vehicle_no = vehicleList;
      }).catch(function (error) {
        _this4.loading = false;
        console.error('vehicle.requestFunction-error:', error);
        _this4.$snotify.error('Get vehicle list failed', 'Error!');
      });
    },
    getDriverName: function getDriverName() {
      var _this5 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var driverList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = '["' + this.user._id + '"]';
      }
      this.$driverDataRepository.list(params).then(function (res) {
        _this5.loading = false;
        if (res.data.docs) {
          _this5.driver_name = res.data.docs.map(function (item) {
            return {
              value: item._id,
              drivers: item.driverName
            };
          });
        }
        console.log('driverlist', _this5.driver_name);
      }).catch(function (error) {
        _this5.loading = false;
        console.error('driver.requestFunction-error:', error);
        _this5.$snotify.error('Get driver list failed', 'Error!');
      });
    },
    getDeviceName: function getDeviceName(e) {
      var _this6 = this;

      var params = {};

      var _vehicle_no$filter = this.vehicle_no.filter(function (ele) {
        return ele.key == e.target.value;
      }),
          _vehicle_no$filter2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_vehicle_no$filter, 1),
          device = _vehicle_no$filter2[0];

      this.loading = true;
      params.$limit = 0;
      if (device.deviceId) {
        params._id = device.deviceId;
        this.isDeviceDisable = true;
      }
      this.trip.deviceId = device.deviceId;

      var deviceList = [];
      this.$deviceDataRepository.list(params).then(function (res) {
        _this6.loading = false;
        if (res.data.docs) {
          deviceList = res.data.docs.map(function (item) {
            return {
              key: item._id,
              value: item.deviceId
            };
          });
        }
        _this6.device_name = deviceList;
      }).catch(function (error) {
        _this6.loading = false;
        console.error('device.requestFunction-error:', error);
        _this6.$snotify.error('Get device list failed', 'Error!');
      });
    },
    getRouteName: function getRouteName() {
      var _this7 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var routeList = [];
      params.$select = ['name', '_id', 'startSite', 'endSite'];
      this.$triprouteDataRepository.list(params).then(function (res) {
        _this7.loading = false;
        if (res.data.docs) {
          routeList = res.data.docs;
        }
        _this7.route_list = routeList;
      }).catch(function (error) {
        _this7.loading = false;
        console.error('triproute.requestFunction-error:', error);
        _this7.$snotify.error('Get route list failed', 'Error!');
      });
    },
    getLocations: function getLocations() {
      var _this8 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      params.status = 'active';
      params.$select = ['siteName', 'siteType', '_id', 'regionName'];
      this.$siteDataRepository.list(params).then(function (res) {
        _this8.locationList = res.data.docs;
      }).catch(function (error) {
        _this8.loading = false;
        console.error('triproute.requestFunction-error:', error);
        _this8.$snotify.error('Get route list failed', 'Error!');
      });
    },
    addField: function addField(value, fieldType) {
      console.log('value', value, fieldType);
      fieldType.push({ value: '' });
      console.log("ll", this.locations);
    },
    removeField: function removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },
    handleChange: function handleChange(event, index) {
      var locations = this.locations;
      if (index > 0) {
        this.checkRoute(index);
      }
    },
    checkRoute: function checkRoute(index) {
      var _this9 = this;

      var route = this.route_list.find(function (el) {
        return _this9.locations[index - 1].locationId === el.startSite && _this9.locations[index].locationId === el.endSite;
      });
      var val = {
        routeId: route._id,
        startSite: route.startSite,
        endSite: route.endSite
      };
      this.list.push(val);
    }
  }, 'fieldClassName', function fieldClassName(field) {
    if (!field) {
      return '';
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return 'has-success';
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return 'has-danger';
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }))
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tripDetail',
    data: function data() {
        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_3__config__["h" /* USER_ROLES */],
            loading: false,
            flash: false,
            flashType: null,
            disabledBefore: new Date(),
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
            role: {},
            roles: [],
            permissions: [],
            formstate: {},
            region_managers: {},
            vehicle_no: {},
            route_name: {},
            driver_name: {},
            device_name: {},
            journey_managers: {},
            status: 'scheduled',
            sourceSite: '',
            destinationSite: '',
            trip: {}
        };
    },

    mounted: function mounted() {
        this.getTrip();
        this.getRegionManager();
        this.getDriverName();
        this.getDeviceName();
        this.getRouteName();
        this.getVehicle();
        this.getJourneyManager();
    },
    methods: {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,
        getTrip: function getTrip() {
            var _this = this;

            return this.$tripDataRepository.find(this.$route.params._id).then(function (response) {
                _this.trip = response.data;
                console.log("response of trip", response);
            }).catch(function (error) {
                _this.$snotify.error('Trip detail failed', 'Error!');
            });
        },
        getSites: function getSites(e) {
            this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute('sourceSite');
            this.destinationSite = e.target.options[e.target.selectedIndex].getAttribute('destinationSite');
        },
        getRegionManager: function getRegionManager() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 2;
            var regionManagerList = [];
            this.$userRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    regionManagerList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this2.region_managers = regionManagerList;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('Region Manager.requestFunction-error:', error);
                _this2.$snotify.error('Get region manager list failed', 'Error!');
            });
        },
        getJourneyManager: function getJourneyManager() {
            var _this3 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 3;
            var journeyManagerList = [];
            this.$userRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    journeyManagerList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this3.journey_managers = journeyManagerList;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('journey Manager.requestFunction-error:', error);
                _this3.$snotify.error('Get journey manager list failed', 'Error!');
            });
        },
        getVehicle: function getVehicle() {
            var _this4 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var vehicleList = [];
            this.$vehicleDataRepository.list(params).then(function (res) {
                _this4.loading = false;
                if (res.data.docs) {
                    vehicleList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.regNo

                        };
                    });
                }
                _this4.vehicle_no = vehicleList;
            }).catch(function (error) {
                _this4.loading = false;
                console.error('vehicle.requestFunction-error:', error);
                _this4.$snotify.error('Get vehicle list failed', 'Error!');
            });
        },
        getDriverName: function getDriverName() {
            var _this5 = this;

            console.log('hiii', this.user.roleName == 'Journey Manager');
            this.loading = true;
            var params = {};
            params.$limit = 0;
            var driverList = [];
            if (this.user.roleName == 'Journey Manager') {
                __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI + '/regions-drivers?manager=' + this.user._id).then(function (res) {
                    console.log('hiii 2', res);
                    _this5.loading = false;
                    if (res.data.drivers && res.data.drivers) {
                        driverList = res.data.drivers.map(function (item) {
                            return {
                                key: item._id,
                                value: item.driverName

                            };
                        });
                    }
                    console.log('driverList', driverList);
                    _this5.driver_name = driverList;
                    console.log('driverList', _this5.driver_name);
                }).catch(function (error) {
                    _this5.loading = false;
                    console.error('driver.requestFunction-error:', error);
                    _this5.$snotify.error('Get driver list failed', 'Error!');
                });
            } else {

                this.$driverDataRepository.list(params).then(function (res) {
                    _this5.loading = false;
                    if (res.data.docs) {
                        driverList = res.data.docs.map(function (item) {
                            return {
                                key: item._id,
                                value: item.driverName

                            };
                        });
                    }
                    _this5.driver_name = driverList;
                }).catch(function (error) {
                    _this5.loading = false;
                    console.error('driver.requestFunction-error:', error);
                    _this5.$snotify.error('Get driver list failed', 'Error!');
                });
            }
        },
        getDeviceName: function getDeviceName() {
            var _this6 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            var deviceList = [];
            this.$deviceDataRepository.list(params).then(function (res) {
                _this6.loading = false;
                if (res.data.docs) {
                    deviceList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.deviceId

                        };
                    });
                }
                _this6.device_name = deviceList;
            }).catch(function (error) {
                _this6.loading = false;
                console.error('device.requestFunction-error:', error);
                _this6.$snotify.error('Get device list failed', 'Error!');
            });
        },
        getRouteName: function getRouteName() {
            var _this7 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            var routeList = [];
            this.$triprouteDataRepository.list(params).then(function (res) {
                _this7.loading = false;
                if (res.data.docs) {
                    routeList = res.data.docs;
                }
                _this7.route_name = routeList;
            }).catch(function (error) {
                _this7.loading = false;
                console.error('triproute.requestFunction-error:', error);
                _this7.$snotify.error('Get route list failed', 'Error!');
            });
        },
        updateTrip: function updateTrip() {
            var _this8 = this;

            this.loading = true;
            return __WEBPACK_IMPORTED_MODULE_2__services__["j" /* tripService */].updateTrip(this.trip).then(function (response) {
                _this8.loading = false;
                _this8.flash = false;
                _this8.$snotify.success('Trip details updated!', 'Success!');
                _this8.$router.push('/trip');
            }).catch(function (error) {
                _this8.loading = false;

                _this8.$snotify.error('Add Trip failed', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this8.flash = true;
                    _this8.flashType = 'error';
                    _this8.flashMessage = 'Trip is not updated due to some error. Please try again!.';
                }
            });
        },
        deleteTripModal: function deleteTripModal() {
            var _this9 = this;

            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                title: 'Are you sure?',
                text: 'This will permanently delete this Trip!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    _this9.deleteTrip();
                }
            });
        },
        deleteTrip: function deleteTrip() {
            var _this10 = this;

            this.loading = true;
            return this.$tripDataRepository.deleteOne(this.trip._id).then(function (response) {
                _this10.loading = false;
                return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Deleted!', 'Trip has been deleted.', 'success');
            }).then(function (response) {
                _this10.loading = false;
                _this10.$router.push('/trip');
            }).catch(function (error) {
                _this10.loading = false;
                _this10.$snotify.error('Delete trip failed', 'Error!');
            });
        },
        formatDate: function formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    })),
    created: function created() {
        var _this11 = this;

        var promises = [];
        this.loading = true;
        promises.push(this.getTrip());
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            _this11.loading = false;
            _this11.ready = true;
        }).catch(function () {
            _this11.loading = false;
        });
    }
});

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(19);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TripLocationLog',
    data: function data() {
        var _this = this;

        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
            loading: null,
            triplocationTable: null,
            addressData: [],
            columns: ['recordedTime', 'latitude', 'longitude', 'batteryStatus', 'address'],

            options: {
                highlightMatches: true,
                sortable: ['recordedTime', 'longitude', 'latitude', 'batteryStatus'],
                headings: {
                    latitude: 'Latitude',
                    longitude: 'Longitude',
                    recordedTime: 'Recorded Time ',
                    batteryStatus: 'Battery',
                    address: 'Address'
                },
                templates: {
                    recordedTime: function recordedTime(row, query) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(query.recordedTime, __WEBPACK_IMPORTED_MODULE_3_moment___default.a.ISO_8601).format('DD-MM-YY hh:mm:ss');
                    }
                },
                requestFunction: function requestFunction(request) {
                    var params = {};
                    params.$page = request.page;
                    params.$limit = request.limit;
                    params.tripID = _this.$route.params._id;
                    _this.loading = true;
                    return _this.$triplocationDataRepository.list(params).catch(function (error) {
                        console.error('tripException.requestFunction-error:', error);
                        _this.$snotify.error('Get Location', 'Error!');
                    });
                },
                responseAdapter: function responseAdapter(response) {
                    _this.loading = false;
                    console.log("triplog response", response);
                    return {
                        data: response.data.docs,
                        count: response.data.items.total
                    };
                }
            },
            triplocation: {}
        };
    },

    methods: {
        onLoaded: function onLoaded() {
            this.triplocationTable = this.$refs.triplocationTable;
        },
        refresh: function refresh() {
            this.$refs.triplocationTable.refresh();
        }
    },
    computed: {
        addButtonClass: function addButtonClass() {
            if (this.triplocationTable) {
                return this.triplocationTable.count > this.triplocationTable.limit || this.triplocationTable.limit > 10 ? 'shift-add-left' : 'add-item';
            } else {
                return 'add-item';
            }
        }
    }
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_capsMixins__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'demo2',
	data: function data() {
		var _this = this;

		return {
			USER_ROLES: __WEBPACK_IMPORTED_MODULE_0__config__["h" /* USER_ROLES */],
			loading: null,
			tripTable: null,
			columns: ['tripCode', 'routeIdName', 'driverIdDriverName', 'deviceIdImei', 'vehicleIdRegNo', 'startSiteSiteName', 'scheduleDate'],

			options: {
				highlightMatches: true,
				sortable: ['tripCode', 'routeIdName', 'driverIdDriverName', 'deviceIdImei', 'vehicleIdRegNo', 'startSiteSiteName', 'scheduleDate'],
				headings: {
					tripCode: 'Trip Id',
					routeIdName: 'Route',
					driverIdDriverName: 'Driver',
					deviceIdImei: 'Device',
					vehicleIdRegNo: 'Vehicle',
					startSiteSiteName: 'From-To',

					scheduleDate: 'Schedule Date'
				},
				templates: {
					startSiteSiteName: function startSiteSiteName(row, query) {
						return query.startSiteSiteName + ' - ' + query.endSiteSiteName;
					},
					scheduleDate: function scheduleDate(row, query) {
						console.log('schedule function');
						return __WEBPACK_IMPORTED_MODULE_3_moment___default()('' + query.scheduleDate).format('DD-MM-YYYY');
					}
				},
				requestFunction: function requestFunction(request) {
					var params = {};
					params.$page = request.page;
					params.$limit = request.limit;
					params.status = 'scheduled';
					if (request.orderBy) {
						params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
					} else {
						params.$sort = 'createdAt';
					}
					if (request.query) {
						params.$term = request.query;
					}
					if (request.query.status) {
						params.status = request.query.status;
					}
					_this.loading = true;
					return _this.$tripDataRepository.list(params).catch(function (error) {
						console.error('Trip.requestFunction-error:', error);
						_this.$snotify.error('Get Trip', 'Error!');
					});
				},
				responseAdapter: function responseAdapter(response) {
					_this.loading = false;
					return {
						data: response.data.docs,
						count: response.data.items.total
					};
				},
				uniqueKey: '_id'
			}
		};
	},

	computed: {
		addButtonClass: function addButtonClass() {
			if (this.tripTable) {
				return this.tripTable.count > this.tripTable.limit || this.tripTable.limit > 5 ? 'shift-add-left' : 'add-item';
			} else {
				return 'add-item';
			}
		}
	},
	methods: {
		edit: function edit(data) {
			this.$router.push({ name: 'TripDetail', params: { _id: data.row._id, status: 'UpComing' }, props: data.row });
		},
		onLoaded: function onLoaded() {
			this.tripTable = this.$refs.tripTable;
		}
	}
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);




var _methods;




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'UpdateDestination',
    data: function data() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
            formstate: {},
            site_name: '',
            trip: {
                status: 'active'
            },
            tripException: {
                prevDestination: '',
                docId: ''
            }
        }, 'trip', {});
    },
    mounted: function mounted() {
        this.getTrip();
        this.getSite();
    },

    methods: (_methods = {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,
        getTrip: function getTrip() {
            var _this = this;

            return this.$tripDataRepository.find(this.$route.params._id).then(function (response) {
                _this.tripException.prevDestination = response.data.endSite;
                _this.endSite = response.data.endSite;
                _this.tripException.docId = response.data._id;
                console.log("prevDestination", _this.tripException.prevDestination);
                console.log("id is ", _this.tripException.docId);
                _this.trip = response.data;
                console.log("...", _this.trip);
            }).catch(function (error) {
                _this.$snotify.error(' OnGoing Trip detail failed', 'Error!');
            });
        },
        getSite: function getSite() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            var siteList = [];
            this.$siteDataRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    siteList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.siteName

                        };
                    });
                }
                _this2.site_name = siteList;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('site.requestFunction-error:', error);
                _this2.$snotify.error('Get site list failed', 'Error!');
            });
        },
        updateTrip: function updateTrip() {
            var _this3 = this;

            this.loading = true;
            this.tripException = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.tripException, {
                recordedTime: new Date().toISOString()
            });
            return __WEBPACK_IMPORTED_MODULE_3__services__["i" /* tripExceptionService */].addtripException(this.tripException).then(function (response) {
                console.log("responseeeee", response);
                _this3.loading = false;
                _this3.flash = false;
                _this3.tripUpdateDone();
            }).catch(function (error) {
                _this3.loading = false;
                _this3.$snotify.error('Destination update failed', 'Error!');
            });
        },
        tripUpdateDone: function tripUpdateDone() {
            var _this4 = this;

            this.trip.endSite = this.tripException.divertedDestination;
            this.loading = true;
            this.trip = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.trip, {
                endSite: this.tripException.divertedDestination
            });
            return __WEBPACK_IMPORTED_MODULE_3__services__["j" /* tripService */].updateTrip(this.trip).then(function (response) {
                _this4.loading = false;
                _this4.flash = false;
                _this4.$snotify.success('Destination has been updated!', 'Success!');
                _this4.$router.push('/trip');
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'created', function created() {
        var _this5 = this;

        var promises = [];
        this.loading = true;
        promises.push(this.getTrip());
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            _this5.loading = false;
            _this5.ready = true;
        }).catch(function () {
            _this5.loading = false;
        });
    }), _methods)

});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RouteCreate',
    data: function data() {
        return {
            loading: false,
            isGeographicalAreaDisable: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
            formstate: {},
            region_list: {},
            region_managers: {},
            start_site: {},
            end_site: {},
            r_id: {},
            paramValue: [],
            params: {},
            journeyManager: [],
            a: [],
            tripRoute: {
                region: '',
                startSite: '',
                endSite: '',
                reportAssessment: '',
                status: 'active',
                routeMarkers: [{
                    latitude: '',
                    longitude: '',
                    message: ''
                }, {
                    latitude: '',
                    longitude: '',
                    message: ''
                }]

            },
            routeMarkers: [{
                latitude: '',
                longitude: '',
                message: ''
            }],
            photo: {},
            regionManagersIdList: []

        };
    },

    mounted: function mounted() {
        this.getRegionList();
        this.getSalesManager();
    },
    created: function created() {
        var regionDetails = this.$store.state.auth.userRegion.regionDetails;
        if (regionDetails && regionDetails.length !== 0) {
            this.regionManagersIdList = regionDetails.map(function (item) {
                return item.regionManager;
            });
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,

        selectGA: function selectGA() {
            this.getSiteName(this.tripRoute.region);
        },
        addLatLng: function addLatLng(event) {

            this.lat = event.target.options[event.target.selectedIndex].getAttribute('lat');
            this.long = event.target.options[event.target.selectedIndex].getAttribute('long');
            console.log(event.target.options[event.target.selectedIndex].getAttribute('startmessageMarker'));
            this.tripRoute.routeMarkers.splice(0, 1, { latitude: this.lat, longitude: this.long, message: event.target.options[event.target.selectedIndex].getAttribute('startmessageMarker') });
            console.log("this.tripRoute.routeMarkers", this.tripRoute.routeMarkers);
        },
        addEndLatLng: function addEndLatLng(event) {
            this.endLat = event.target.options[event.target.selectedIndex].getAttribute('endLat');
            this.endLong = event.target.options[event.target.selectedIndex].getAttribute('endLong');
            this.endmessageMarker = event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker');
            this.tripRoute.routeMarkers.splice(this.tripRoute.routeMarkers.length - 1, 1, { latitude: this.endLat, longitude: this.endLong, message: event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker') });
        },
        onFilechanged: function onFilechanged(event) {
            this.photo = event.target.files[0];
            this.tripRoute.reportAssessment = event.target.files[0]['name'];
        },
        add: function add(index) {
            var markerLength = this.tripRoute.routeMarkers.length;
            this.tripRoute.routeMarkers.splice(markerLength - 1, 0, {});

            console.log('added');
        },
        remove: function remove(index) {
            console.log('remove function called');
            if (this.tripRoute.routeMarkers.length > 1) {
                this.tripRoute.routeMarkers.splice(index, 1);
                console.log('removed');
            }
        },
        getSiteName: function getSiteName(id) {
            var _this = this;

            var params = {};
            params.$limit = 0;
            var siteList = [];

            params.region = id;
            this.$siteDataRepository.list(params).then(function (res) {
                _this.loading = false;

                if (res.data.docs) {
                    siteList = res.data.docs;
                }
                _this.start_site = siteList;
                _this.end_site = siteList;
            }).catch(function (error) {
                _this.loading = false;
                console.error('site.requestFunction-error:', error);
                _this.$snotify.error('Get site list failed', 'Error!');
            });
        },
        getRegionList: function getRegionList() {
            var _this2 = this;

            this.loading = true;
            this.params.$limit = 0;
            if (this.user.roleName == "GA Head") {
                this.params.regionManager = this.regionManagersIdList;
            }
            if (this.user.roleName === "Journey Manager") {
                this.isGeographicalAreaDisable = true;
                this.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.params, {
                    journeyManager: this.a.splice(0, 1, [this.user._id])
                });
                this.params.journeyManager = '["' + this.user._id + '"]';
            }
            var regionlist = [];
            this.$regionDataRepository.list(this.params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this2.region_list = regionlist;
                if (_this2.region_list.length === 1) {
                    _this2.region_list ? _this2.tripRoute.region = _this2.region_list[0].key : _this2.tripRoute.region = '';
                    _this2.selectGA();
                }
            }).catch(function (error) {
                _this2.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this2.$snotify.error('Get region list failed', 'Error!');
            });
        },
        createRoute: function createRoute() {
            var _this3 = this;

            this.loading = true;
            this.tripRoute = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.tripRoute);
            console.log("hii there", this.tripRoute);
            return __WEBPACK_IMPORTED_MODULE_2__services__["h" /* tripRouteService */].addtripRoute(this.tripRoute).then(function (response) {
                var docId = response._id;
                _this3.uploadDocument(docId);
                _this3.loading = false;
                _this3.flash = false;
                _this3.$snotify.success('route added!', 'Success!');
                _this3.$router.push('/routes');
            }).catch(function (error) {
                _this3.loading = false;
                _this3.$snotify.error('trip Add failed! Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this3.flash = true;
                    _this3.flashType = 'error';
                    _this3.flashMessage = 'New route add is failed.Please try again!';
                }
            });
        },
        uploadDocument: function uploadDocument(docId) {
            var formData = new FormData();
            formData.append('file', this.photo);
            formData.append('model', "driver");
            formData.append("docId", docId);
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('fileUpload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                console.log(res);
                console.log('SUCCESS!!');
            }).catch(function () {
                console.log('FAILURE!!');
            });
        },
        getSalesManager: function getSalesManager() {
            var _this4 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 4;
            var regionManagerList = [];
            this.$userRepository.list(params).then(function (res) {
                _this4.loading = false;
                if (res.data.docs) {
                    regionManagerList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this4.region_managers = regionManagerList;
            }).catch(function (error) {
                _this4.loading = false;
                console.error('Region Manager.requestFunction-error:', error);
                _this4.$snotify.error('Get region manager list failed', 'Error!');
            });
        },
        validateLatitude: function validateLatitude(e) {
            var reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}");
            if (reg.exec(e.target.value)) {
                this.tripRoute = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.tripRoute, {
                    latitude: e.target.value
                });
            } else {
                e.preventDefault();
            }
        },
        validateLongitude: function validateLongitude(e) {
            var reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}");
            if (reg.exec(e.target.value)) {
                this.tripRoute = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.tripRoute, {
                    longitude: e.target.value
                });
            } else {}
        }
    }, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }

    }))
});

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);




var _methods;







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RouteDetail',
    data: function data() {
        return {
            photoRepoertAssessment: false,
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_4__config__["h" /* USER_ROLES */],
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
            formstate: {},
            region_list: {},
            region_managers: {},
            start_site: {},
            end_site: {},
            r_id: {},
            photo: '',
            tripRoute: {
                routeMarkers: [{
                    latitude: '',
                    longitude: '',
                    message: 'Start Location'
                }, {
                    latitude: '',
                    longitude: '',
                    message: 'End Location'
                }]
            },
            regionManagersIdList: []
        };
    },

    mounted: function mounted() {
        this.getRegionList();
        this.getSalesManager();

        this.getRoute();
    },
    created: function created() {
        var regionDetails = this.$store.state.auth.userRegion.regionDetails;
        if (regionDetails && regionDetails.length !== 0) {
            this.regionManagersIdList = regionDetails.map(function (item) {
                return item.regionManager;
            });
        }
    },

    methods: (_methods = {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,

        selectGA: function selectGA() {
            this.getSite(this.tripRoute.region);
        },
        addLatLng: function addLatLng(event) {
            this.lat = event.target.options[event.target.selectedIndex].getAttribute('lat');
            this.long = event.target.options[event.target.selectedIndex].getAttribute('long');
            this.tripRoute.routeMarkers.splice(0, 1, { latitude: this.lat, longitude: this.long, message: event.target.options[event.target.selectedIndex].getAttribute('startmessageMarker') });
            console.log("this.tripRoute.routeMarkers", this.tripRoute.routeMarkers);
        },
        addEndLatLng: function addEndLatLng(event) {
            this.endLat = event.target.options[event.target.selectedIndex].getAttribute('endLat');
            this.endLong = event.target.options[event.target.selectedIndex].getAttribute('endLong');
            this.endmessageMarker = event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker');
            this.tripRoute.routeMarkers.splice(this.tripRoute.routeMarkers.length - 1, 1, { latitude: this.endLat, longitude: this.endLong, message: event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker') });
        },
        getRoute: function getRoute() {
            var _this = this;

            console.log("hiiiiiii");
            return this.$triprouteDataRepository.find(this.$route.params._id).then(function (response) {
                _this.tripRoute = response.data;
                _this.getSite(_this.tripRoute.region);
            }).catch(function (error) {
                _this.$snotify.error('Route detail failed', 'Error!');
            });
        },
        add: function add(index) {
            var markerLength = this.tripRoute.routeMarkers.length;
            this.tripRoute.routeMarkers.splice(markerLength - 1, 0, {});
            console.log('added');
        },
        remove: function remove(index) {
            console.log('remove function called');
            if (this.tripRoute.routeMarkers.length > 1) {
                this.tripRoute.routeMarkers.splice(index, 1);
                console.log('removed');
            }
        },
        onFilechanged: function onFilechanged(event) {
            this.photoRepoertAssessment = true;
            this.photo = event.target.files[0];
            this.tripRoute.reportAssessment = event.target.files[0]['name'];
        },
        getSite: function getSite(id) {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.region = id;
            var siteList = [];
            this.$siteDataRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    siteList = res.data.docs;
                }
                _this2.start_site = siteList;
                _this2.end_site = siteList;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('site.requestFunction-error:', error);
                _this2.$snotify.error('Get site list failed', 'Error!');
            });
        },
        getRegionList: function getRegionList() {
            var _this3 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            if (this.user.roleName == "GA Head") {
                params.regionManager = this.regionManagersIdList;
            }
            if (this.user.roleName === "Journey Manager") {
                params.journeyManager = '["' + this.user._id + '"]';
            }
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this3.region_list = regionlist;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this3.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getSalesManager: function getSalesManager() {
            var _this4 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            params.roleRank = 4;
            var regionManagerList = [];
            this.$userRepository.list(params).then(function (res) {
                _this4.loading = false;
                if (res.data.docs) {
                    regionManagerList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.firstName + ' ' + item.lastName
                        };
                    });
                }
                _this4.region_managers = regionManagerList;
            }).catch(function (error) {
                _this4.loading = false;
                console.error('Region Manager.requestFunction-error:', error);
                _this4.$snotify.error('Get region manager list failed', 'Error!');
            });
        },
        updateRoute: function updateRoute() {
            var _this5 = this;

            this.loading = true;
            return __WEBPACK_IMPORTED_MODULE_3__services__["h" /* tripRouteService */].updatetripRoute(this.tripRoute).then(function (response) {
                var docId = response._id;
                _this5.uploadDocument(docId);
                _this5.loading = false;
                _this5.flash = false;
                _this5.$snotify.success('Route details updated!', 'Success!');
                _this5.$router.push('/routes');
            }).catch(function (error) {
                _this5.loading = false;
                console.error('RouteCreate.createDevice-error:', error);
                _this5.$snotify.error('Add Route failed', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this5.flash = true;
                    _this5.flashType = 'error';
                    _this5.flashMessage = 'Route is not updated due to some error. Please try again!.';
                }
            });
        },
        uploadDocument: function uploadDocument(docId) {
            var formData = new FormData();
            formData.append('file', this.photo);
            formData.append('model', "driver");
            formData.append("docId", docId);
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('fileUpload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                console.log(res);
                console.log('SUCCESS!!');
            }).catch(function () {
                console.log('FAILURE!!');
            });
        },
        deleteRouteModal: function deleteRouteModal() {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                title: 'Are you sure?',
                text: 'This will permanently delete this Route!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    _this6.deleteRoute();
                }
            });
        },
        deleteRoute: function deleteRoute() {
            var _this7 = this;

            this.loading = true;
            return this.$triprouteDataRepository.deleteOne(this.tripRoute._id).then(function (response) {
                _this7.loading = false;
                return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Deleted!', 'Route has been deleted.', 'success');
            }).then(function (response) {
                _this7.loading = false;
                _this7.$router.push('/routes');
            }).catch(function (error) {
                _this7.loading = false;
                _this7.$snotify.error('Delete route failed', 'Error!');
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'formatDate', function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'created', function created() {
        var _this8 = this;

        var promises = [];
        this.loading = true;
        promises.push(this.getRoute());
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            _this8.loading = false;
            _this8.ready = true;
        }).catch(function () {
            _this8.loading = false;
        });
    }), _methods),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tripRoute',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],
      regionValue: 'all',
      parameters: '',
      journey_managers: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      loading: null,
      tripRouteTable: null,
      columns: ['name', 'region', 'approxDistance', 'startSite', 'endSite', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['name', 'region', 'approxDistance', 'startSite', 'endSite', 'status'],
        headings: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
          name: 'Route',
          region: 'Geographic Area',
          approxDistance: 'Length (km)',
          startSite: 'Start Location',
          endSite: 'End Location',
          status: 'Status'
        }, 'region', 'Geographical Area'),

        templates: {
          region: function region(row, query) {
            return '' + query.regionName;
          },
          startSite: function startSite(row, query) {
            return '' + query.startSiteSiteName;
          },
          endSite: function endSite(row, query) {
            return '' + query.endSiteSiteName;
          },
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == "GA Head") {
            params.regionRegionManager = _this.user._id;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (_this.regionManagersIdList.length !== 0) {
            params.region = _this.regionManagersIdList;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (_this.parameters != '') {
            console.log('this.parameters', _this.parameters);
            params.region = _this.parameters;
          }
          _this.loading = true;
          return _this.$triprouteDataRepository.list(params).catch(function (error) {
            _this.$snotify.error('Get Routes', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  mounted: function mounted() {
    this.getGeographicalAreas();
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.tripRouteTable) {
        return this.tripRouteTable.count > this.tripRouteTable.limit || this.tripRouteTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }

  })),
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'RouteDetail',
        params: { _id: data.row._id },
        props: data.row
      });
    },
    clearStatusGA: function clearStatusGA() {
      this.parameters = '';

      this.regionValue = 'all';
      this.$refs.tripRouteTable.refresh();
    },
    fiteredResultGA: function fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameters = '';
        this.regionValue = 'all';
      } else {
        this.parameters = e.target.value;
      }
      this.$refs.tripRouteTable.refresh();
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var journeyManagerList = [];

      this.$regionsDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          if (_this2.user.roleName === 'Admin') {
            journeyManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this2.journey_managers = journeyManagerList;
          } else {
            journeyManagerList = res.data.docs.map(function (item) {
              if (_this2.regionManagersIdList.includes(item._id)) {
                _this2.journey_managers.push({
                  key: item._id,
                  value: item.name
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this2.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this2.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/v1/exportMaster?model=triproute',
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log("response of download", response);
        var arrayBuffer = response.data;
        var filename = 'Routes.xlsx';
        _this3.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    onLoaded: function onLoaded() {
      this.tripRouteTable = this.$refs.tripRouteTable;
    }
  }
});

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserGroups_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserGroups_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserGroups_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserPermissions_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserPermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserPermissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserCreate',
  components: {
    UserGroups: __WEBPACK_IMPORTED_MODULE_2__UserGroups_vue___default.a,
    UserPermissions: __WEBPACK_IMPORTED_MODULE_3__UserPermissions_vue___default.a
  },
  data: function data() {
    return {
      ready: false,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: __WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_5__config__["h" /* USER_ROLES */],
      max: 20,
      user: {
        invested_amount: ''
      },
      password: '',
      confirmPassword: '',
      showPassword: false,
      roles: [],
      permissions: [],
      formstate: {},
      passwordValidtion: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    passwordValidation: function passwordValidation() {
      return this.password !== this.confirmPassword;
    },
    computedUserScope: function computedUserScope() {
      return __WEBPACK_IMPORTED_MODULE_4__services__["k" /* userService */].computeUserScope(this.user);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    user1: function user1(state) {
      return state.auth.user;
    }

  })),
  methods: {
    emailValidator: __WEBPACK_IMPORTED_MODULE_4__services__["e" /* formService */].emailValidator,
    fieldClassName: __WEBPACK_IMPORTED_MODULE_4__services__["e" /* formService */].fieldClassName,

    togglePasswordVisibility: function togglePasswordVisibility(field) {
      this.showPassword = !this.showPassword;
      var inputField = document.querySelector('input[name=' + field + ']');
      if (inputField) {
        inputField.type = this.showPassword ? 'text' : 'password';
      }
    },
    getRoles: function getRoles() {
      var _this = this;

      return this.$roleRepository.list({
        $embed: ['permissions']
      }).then(function (response) {
        console.log('user role response', response);
        var updateRoles = response.data.docs.filter(function (item) {
          return item.name === 'Admin' || item.name === 'Journey Manager' || item.name === 'GA Head' || item.name === 'JMA User';
        });
        _this.roles = updateRoles;
      }).catch(function (error) {
        console.error('UserCreate.getRoles-error:', error);
        _this.$snotify.error('Get roles failed', 'Error!');
      });
    },
    createUser: function createUser() {
      var _this2 = this;

      this.loading = true;
      this.user['password'] = this.confirmPassword;
      var role = {
        name: 'Admin',
        rank: 2

      };
      this.user['withdrawl_amount'] = 0;

      this.user['role'] = role;
      console.log('createUser', this.user);
      return __WEBPACK_IMPORTED_MODULE_4__services__["d" /* authService */].inviteUser(this.user).then(function (response) {
        console.log('User Successfully Created!');
        _this2.loading = false;
        _this2.$snotify.success('User created', 'Success!');
        _this2.disabled = true;
        _this2.$router.push('/users');
      }).catch(function (error) {
        _this2.loading = false;
        console.error('UserCreate.createUser-error:', error);

        if (error.statusText == "Conflict") {
          _this2.$snotify.error('Email already in use!!', 'Error!');
        } else if (error.statusText == "Internal Server Error") {
          _this2.$snotify.success('User is created', 'Success!');
        } else {
          _this2.$snotify.error('Create user failed', 'Error!');
        }
      });
    },
    updateGroups: function updateGroups(groups) {
      this.user.groups = groups;
    },
    updatePermissions: function updatePermissions(permissions) {
      this.user.permissions = permissions;
    }
  },
  created: function created() {
    var _this3 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getRoles());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this3.loading = false;
      _this3.ready = true;
      _this3.user = {
        isActive: false,
        isEnabled: true,
        role: _this3.roles.find(function (role) {
          return role.name === __WEBPACK_IMPORTED_MODULE_5__config__["h" /* USER_ROLES */].USER;
        }),
        groups: [],
        permissions: []
      };
    }).catch(function () {
      _this3.loading = false;
    });
    __WEBPACK_IMPORTED_MODULE_4__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */].USER_GROUPS_UPDATED, this.updateGroups);
    __WEBPACK_IMPORTED_MODULE_4__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.updatePermissions);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */].USER_GROUPS_UPDATED, this.updateGroups);
    __WEBPACK_IMPORTED_MODULE_4__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_5__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.updatePermissions);
  }
});

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserGroups_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserGroups_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserGroups_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserPermissions_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserPermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserPermissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPassword_vue__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(6);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserDetails',
  components: {
    UserGroups: __WEBPACK_IMPORTED_MODULE_3__UserGroups_vue___default.a,
    UserPermissions: __WEBPACK_IMPORTED_MODULE_4__UserPermissions_vue___default.a,
    UserPassword: __WEBPACK_IMPORTED_MODULE_5__UserPassword_vue___default.a
  },
  data: function data() {
    return {
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      ready: false,
      loading: false,
      userGroupsUpdated: null,
      userPermissionsUpdated: null,
      EVENTS: __WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */],
      newUser: {},
      oldUser: {},
      roles: [],
      permissions: [],
      formstate: {},
      max: 20,
      detailsActive: '',
      roleId: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    computedUserScope: function computedUserScope() {
      return __WEBPACK_IMPORTED_MODULE_6__services__["k" /* userService */].computeUserScope(this.newUser);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    user1: function user1(state) {
      return state.auth.user;
    }
  })),
  methods: {
    fieldClassName: __WEBPACK_IMPORTED_MODULE_6__services__["e" /* formService */].fieldClassName,
    emailValidator: __WEBPACK_IMPORTED_MODULE_6__services__["e" /* formService */].emailValidator,
    emailUniqueValidator: function emailUniqueValidator(email) {
      return __WEBPACK_IMPORTED_MODULE_6__services__["e" /* formService */].emailUniqueValidator(email, this.oldUser.email);
    },
    getUser: function getUser() {
      var _this = this;

      var params = {
        $embed: ['role.permissions', 'groups.permissions', 'permissions']
      };

      return this.$userRepository.find(this.$route.params._id, params).then(function (response) {
        _this.newUser = response.data;
        _this.roleId = response.data.role._id;
        _this.oldUser = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this.newUser);
        _this.$store.dispatch('setBreadcrumbTitle', _this.newUser.firstName + ' ' + _this.newUser.lastName);
      }).catch(function (error) {
        console.error('UserDetails.getUser-error:', error);
        _this.$snotify.error('Get user failed', 'Error!');
      });
    },
    getRoles: function getRoles() {
      var _this2 = this;

      return this.$roleRepository.list({
        $embed: ['permissions'],
        $sort: '-rank'
      }).then(function (response) {
        var updateRoles = response.data.docs.filter(function (item) {
          return item.name === 'Admin' || item.name === 'Journey Manager' || item.name === 'GA Head' || item.name === 'JMA User';
        });
        _this2.roles = updateRoles;
      }).catch(function (error) {
        console.error('UserDetails.getRoles-error:', error);
        _this2.$snotify.error('Get roles failed', 'Error!');
      });
    },
    clearChanges: function clearChanges() {
      this.newUser = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(this.oldUser);
      this.formstate._reset();
    },
    updateUser: function updateUser() {
      var _this3 = this;

      console.log("newUser", this.newUser);
      this.loading = true;
      this.newUser['role'] = this.roleId;
      this.newUser['invested_amount'] = this.newUser.invested_amount;
      this.newUser['startDate'] = this.newUser.startDate;
      return __WEBPACK_IMPORTED_MODULE_6__services__["k" /* userService */].updateUser(this.newUser, this.oldUser).then(function (response) {
        _this3.loading = false;
        _this3.formstate._reset();
        _this3.oldUser = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this3.newUser);
        _this3.$snotify.success('User updated', 'Success!');
        _this3.$router.push('/users');
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$snotify.error('Update user failed', 'Error!');
      });
    },
    deleteUserModal: function deleteUserModal() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        title: 'Are you sure?',
        text: 'This will permanently delete this User!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          _this4.deleteUser();
        }
      });
    },
    deleteUser: function deleteUser() {
      var _this5 = this;

      this.loading = true;
      return this.$userRepository.deleteOne(this.newUser._id).then(function (response) {
        _this5.loading = false;
        return __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('Deleted!', 'User account has been deleted.', 'success');
      }).then(function (response) {
        _this5.loading = false;
        _this5.$router.push('/users');
      }).catch(function (error) {
        _this5.loading = false;
        console.error('UserDetails.deleteUser-error:', error);
        _this5.$snotify.error('Delete user failed', 'Error!');
      });
    },
    disableUser: function disableUser() {
      var _this6 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_6__services__["k" /* userService */].disableUser(this.newUser._id).then(function (response) {
        _this6.newUser.isEnabled = false;
        _this6.loading = false;
        _this6.$snotify.success('User disabled', 'Success!');
      }).catch(function (error) {
        _this6.loading = false;
        console.error('UserDetails.disableUser-error:', error);
        _this6.$snotify.error('Disable user failed', 'Error!');
      });
    },
    enableUser: function enableUser() {
      var _this7 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_6__services__["k" /* userService */].enableUser(this.newUser._id).then(function (response) {
        _this7.newUser.isEnabled = true;
        _this7.loading = false;
        _this7.$snotify.success('User enabled', 'Success!');
      }).catch(function (error) {
        _this7.loading = false;
        console.error('UserDetails.enableUser-error:', error);
        _this7.$snotify.error('Enable user failed', 'Error!');
      });
    },
    deactivateUser: function deactivateUser() {
      var _this8 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_6__services__["k" /* userService */].deactivateUser(this.newUser._id).then(function (response) {
        _this8.newUser.isActive = false;
        _this8.loading = false;
        _this8.$snotify.success('User deactivated', 'Success!');
      }).catch(function (error) {
        _this8.loading = false;
        console.error('UserDetails.deactivateUser-error:', error);
        _this8.$snotify.error('Deactivate user failed', 'Error!');
      });
    },
    activateUser: function activateUser() {
      var _this9 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_6__services__["k" /* userService */].activateUser(this.newUser._id).then(function (response) {
        _this9.newUser.isActive = true;
        _this9.loading = false;
        _this9.$snotify.success('User activated', 'Success!');
      }).catch(function (error) {
        _this9.loading = false;
        console.error('UserDetails.activateUser-error:', error);
        _this9.$snotify.error('Activate user failed', 'Error!');
      });
    },
    updateGroups: function updateGroups(newGroups) {
      this.newUser.groups = newGroups;
      this.formstate.userGroupsUpdated._setDirty();
    },
    clearGroups: function clearGroups() {
      this.formstate.userGroupsUpdated._setPristine();
    },
    updatePermissions: function updatePermissions(newPermissions) {
      this.newUser.permissions = newPermissions;
      this.formstate.userPermissionsUpdated._setDirty();
    },
    clearPermissions: function clearPermissions() {
      this.formstate.userPermissionsUpdated._setPristine();
    }
  },
  created: function created() {
    var _this10 = this;

    var promises = [];
    this.loading = true;
    promises.push(this.getUser());
    promises.push(this.getRoles());
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      _this10.loading = false;
      _this10.ready = true;
    }).catch(function () {
      _this10.loading = false;
    });
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_GROUPS_UPDATED, this.updateGroups);
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_GROUPS_SAVED, this.clearGroups);
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.updatePermissions);
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$on(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_PERMISSIONS_SAVED, this.clearPermissions);

    if (this.$route.query.details) {
      this.detailsActive = 'active';
    } else {
      this.detailsActive = 'active';
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_GROUPS_UPDATED, this.updateGroups);
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_GROUPS_SAVED, this.clearGroups);
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.updatePermissions);
    __WEBPACK_IMPORTED_MODULE_6__services__["f" /* eventBus */].$off(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* EVENTS */].USER_PERMISSIONS_SAVED, this.clearPermissions);
  }
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserGroups',
  props: ['user'],
  data: function data() {
    return {
      loading: null,
      dirty: false,
      newUser: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.user),
      oldUser: null,
      groupSearchText: null,
      availableGroups: [],
      selectedAvailableGroups: [],
      selectedUserGroups: []
    };
  },

  watch: {
    user: function user(val) {
      this.newUser = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(val);
      this.newUser.groups = this.newUser.groups || [];
      this.getAvailableGroups();
      this.dirty = false;
    }
  },
  computed: {
    groupDescription: function groupDescription() {
      var group = (this.selectedAvailableGroups[0] || {}).group || (this.selectedUserGroups[0] || {}).group;
      if (group) {
        return group.name + ': ' + group.description;
      }

      return 'Select a group to see its description.';
    }
  },
  methods: {
    getAvailableGroups: function getAvailableGroups() {
      var _this = this;

      this.loading = true;
      var userGroupIds = this.newUser.groups.map(function (object) {
        return object.group._id;
      });
      var params = {};
      if (this.groupSearchText) {
        params.$term = this.groupSearchText;
        params.$searchFields = ['name'];
      }
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(userGroupIds)) {
        params.$exclude = userGroupIds;
      }
      params.$embed = ['permissions'];
      return this.$groupRepository.list(params).then(function (response) {
        _this.loading = false;
        _this.availableGroups = response.data.docs.map(function (group) {
          return { group: group };
        });
        _this.sortLists();
      }).catch(function (error) {
        _this.loading = false;
        console.error('UserGroups.getAvailableGroups-error:\n', error);
        _this.$snotify.error('There was an error loading the groups', 'Error!');
      });
    },
    addGroups: function addGroups() {
      var _this2 = this;

      this.dirty = true;
      this.newUser.groups = this.newUser.groups.concat(this.selectedAvailableGroups);

      this.availableGroups = this.availableGroups.filter(function (object) {
        return !_this2.selectedAvailableGroups.find(function (selectedObject) {
          return selectedObject.group._id === object.group._id;
        });
      });

      this.selectedAvailableGroups = [];
      this.sortLists();
      __WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].USER_GROUPS_UPDATED, this.newUser.groups);
    },
    removeGroups: function removeGroups() {
      var _this3 = this;

      this.dirty = true;
      this.availableGroups = this.availableGroups.concat(this.selectedUserGroups);

      this.newUser.groups = this.newUser.groups.filter(function (object) {
        return !_this3.selectedUserGroups.find(function (selectedObject) {
          return selectedObject.group._id === object.group._id;
        });
      });

      this.selectedUserGroups = [];
      this.sortLists();
      __WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].USER_GROUPS_UPDATED, this.newUser.groups);
    },
    sortLists: function sortLists() {
      this.newUser.groups.sort(function (a, b) {
        return a.group.name.localeCompare(b.group.name);
      });

      this.availableGroups.sort(function (a, b) {
        return a.group.name.localeCompare(b.group.name);
      });
    },
    updateUserGroups: function updateUserGroups() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__services__["k" /* userService */].updateUserGroups(this.newUser._id, this.newUser.groups, this.oldUser.groups).then(function (response) {
        _this4.loading = false;
        _this4.dirty = false;
        _this4.oldUser = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this4.newUser);
        __WEBPACK_IMPORTED_MODULE_0__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* EVENTS */].USER_GROUPS_SAVED);
        _this4.$snotify.success('User groups updated', 'Success!');
      }).catch(function (error) {
        _this4.loading = false;
        console.error('UserGroups.updateUserGroups-error:', error);
        _this4.$snotify.error('Update user groups failed', 'Error!');
      });
    }
  },
  created: function created() {
    this.newUser.groups = this.newUser.groups || [];
    this.oldUser = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.newUser);
    this.getAvailableGroups();
  }
});

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserPassword',
  props: ['user'],
  data: function data() {
    return {
      loading: null,
      emailSent: false
    };
  },

  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_0__services__["d" /* authService */].sendResetLink(this.user.email).then(function (response) {
        _this.loading = false;
        _this.emailSent = true;
        _this.$snotify.success('Email sent', 'Success!');
      }).catch(function (error) {
        _this.loading = false;
        console.error('UserPassword.resetPassword-error:', error);
        _this.$snotify.error('Reset password failed', 'Error!');
      });
    }
  }
});

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserPermissions',
  props: ['user'],
  data: function data() {
    return {
      lodash: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a,
      loading: null,
      dirty: false,
      newUser: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.user),
      oldUser: null,
      PERMISSION_STATES: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */],
      permissionSearchText: null,
      availablePermissions: [],
      selectedAvailablePermissions: [],
      selectedUserPermissions: [],
      selectedIncludedPermissions: [],
      selectedExcludedPermissions: [],
      selectedForbiddenPermissions: [],
      includedToState: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].INCLUDED,
      excludedToState: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].EXCLUDED,
      forbiddenToState: __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].FORBIDDEN
    };
  },

  watch: {
    selectedIncludedPermissions: function selectedIncludedPermissions(val) {
      this.selectedUserPermissions = [].concat(val, this.selectedExcludedPermissions, this.selectedForbiddenPermissions);
    },
    selectedExcludedPermissions: function selectedExcludedPermissions(val) {
      this.selectedUserPermissions = [].concat(val, this.selectedIncludedPermissions, this.selectedForbiddenPermissions);
    },
    selectedForbiddenPermissions: function selectedForbiddenPermissions(val) {
      this.selectedUserPermissions = [].concat(val, this.selectedExcludedPermissions, this.selectedIncludedPermissions);
    },
    user: function user(val) {
      this.newUser = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(val);
      this.newUser.permissions = this.newUser.permissions || [];
      this.getAvailablePermissions();
      this.dirty = false;
    }
  },
  computed: {
    permissionDescription: function permissionDescription() {
      var permission = (this.selectedAvailablePermissions[0] || {}).permission || (this.selectedUserPermissions[0] || {}).permission;
      if (permission) {
        return permission.name + ': ' + permission.description;
      }

      return 'Select a permission to see its description.';
    },
    includedPermissions: function includedPermissions() {
      return this.newUser.permissions.filter(function (permission) {
        return permission.state === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].INCLUDED;
      });
    },
    excludedPermissions: function excludedPermissions() {
      return this.newUser.permissions.filter(function (permission) {
        return permission.state === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].EXCLUDED;
      });
    },
    forbiddenPermissions: function forbiddenPermissions() {
      return this.newUser.permissions.filter(function (permission) {
        return permission.state === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* PERMISSION_STATES */].FORBIDDEN;
      });
    }
  },
  methods: {
    getAvailablePermissions: function getAvailablePermissions() {
      var _this = this;

      this.loading = true;
      var userPermissionIds = this.newUser.permissions.map(function (object) {
        return object.permission._id;
      });
      var params = {};
      if (this.permissionSearchText) {
        params.$term = this.permissionSearchText;
        params.$searchFields = ['name'];
      }
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(userPermissionIds)) {
        params.$exclude = userPermissionIds;
      }
      return __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].getAvailablePermissions(params).then(function (response) {
        _this.loading = false;
        _this.availablePermissions = response.data.docs.map(function (permission) {
          return { permission: permission, state: _this.PERMISSION_STATES.INCLUDED };
        });
        _this.sortLists();
      }).catch(function (error) {
        _this.loading = false;
        console.error('UserPermissions.getAvailablePermissions-error:\n', error);
        _this.$snotify.error('There was an error loading the permissions', 'Error!');
      });
    },
    addPermissions: function addPermissions() {
      var _this2 = this;

      this.dirty = true;
      this.newUser.permissions = this.newUser.permissions.concat(this.selectedAvailablePermissions);

      this.availablePermissions = this.availablePermissions.filter(function (object) {
        return !_this2.selectedAvailablePermissions.find(function (selectedObject) {
          return selectedObject.permission._id === object.permission._id;
        });
      });

      this.selectedAvailablePermissions = [];
      this.sortLists();
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newUser.permissions);
    },
    removePermissions: function removePermissions() {
      var _this3 = this;

      this.dirty = true;
      this.availablePermissions = this.availablePermissions.concat(this.selectedUserPermissions);

      this.newUser.permissions = this.newUser.permissions.filter(function (object) {
        return !_this3.selectedUserPermissions.find(function (selectedObject) {
          return selectedObject.permission._id === object.permission._id;
        });
      });

      this.selectedUserPermissions = [];
      this.sortLists();
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newUser.permissions);
    },
    sortLists: function sortLists() {
      this.newUser.permissions.sort(function (a, b) {
        return a.permission.name.localeCompare(b.permission.name);
      });

      this.availablePermissions.sort(function (a, b) {
        return a.permission.name.localeCompare(b.permission.name);
      });
    },
    applyStateToIncluded: function applyStateToIncluded() {
      this.dirty = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedIncludedPermissions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var permission = _step.value;

          permission.state = this.includedToState;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.selectedIncludedPermissions = [];
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newUser.permissions);
    },
    applyStateToExcluded: function applyStateToExcluded() {
      this.dirty = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedExcludedPermissions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var permission = _step2.value;

          permission.state = this.excludedToState;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.selectedExcludedPermissions = [];
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newUser.permissions);
    },
    applyStateToForbidden: function applyStateToForbidden() {
      this.dirty = true;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedForbiddenPermissions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var permission = _step3.value;

          permission.state = this.forbiddenToState;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.selectedForbiddenPermissions = [];
      __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_UPDATED, this.newUser.permissions);
    },
    updateUserPermissions: function updateUserPermissions() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__services__["k" /* userService */].updateUserPermissions(this.newUser._id, this.newUser.permissions, this.oldUser.permissions).then(function (response) {
        _this4.loading = false;
        _this4.dirty = false;
        _this4.oldUser = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this4.newUser);
        __WEBPACK_IMPORTED_MODULE_2__services__["f" /* eventBus */].$emit(__WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */].USER_PERMISSIONS_SAVED);
        _this4.$snotify.success('User permissions updated', 'Success!');
      }).catch(function (error) {
        _this4.loading = false;
        console.error('UserPermissions.updateUserPermissions-error:', error);
        _this4.$snotify.error('Update user permissions failed', 'Error!');
      });
    }
  },
  created: function created() {
    this.newUser.permissions = this.newUser.permissions || [];
    this.oldUser = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.newUser);
    this.getAvailablePermissions();
  }
});

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',
  data: function data() {
    var _this = this;

    return {
      userName: '',
      net_pnl: '',
      withdrawlAmount: '',
      net_profit_percentage: '',
      totalInvestmentAmount: '',
      investedAmount: '',
      netProfitAndLoss: '',
      currentValue: '',
      history_table: [],
      formstate: {},
      password: '',
      confirmPassword: '',
      showPassword: false,
      passwordValidtion: false,
      isAreaTable: false,
      isUserDashBoard: false,
      loading: null,
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      totalPnL: 0,
      userTable: null,
      columns: ['firstName', 'lastName', 'invested_amount', 'current_investment_value', 'startDate', 'pnl_value', 'net_profile', 'net_pnl', 'withdrawl_amount', 'action'],
      options: {
        highlightMatches: true,
        headings: {
          firstName: 'First Name',
          lastName: 'Last Name',
          invested_amount: 'Invested Amount ($)',
          current_investment_value: 'Current Investment Value ($)',
          startDate: 'Start Date',
          pnl_value: 'Unrealised Profit/Loss ($)',
          net_pnl: 'Net Profilt/Loss ($)',
          net_profile: 'Net Profile (%)',
          withdrawl_amount: 'Withdrawl Amount',
          actions: 'Action'
        },
        templates: {
          status: function status(row, query) {
            if (query.isActive == true) {
              return query.status = 'Active';
            } else {
              return query.status = 'Inactive';
            }
          }
        },
        perPage: 10,
        sortable: ['firstName', 'lastName', 'email', 'invested_amount', 'current_investment_value', 'pnl_value', 'net_pnl', 'withdrawl_amount'],
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.invisible = false;
          if (_this.user.roleName == 'Super Admin') {} else {
            params.invisible = false;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          } else {
            params.$sort = '-isActive';
          }
          if (request.query) {
            params.$term = request.query;
          }
          _this.loading = true;
          console.log('Param', params, 'userRepository', _this.$userRepository);
          return _this.$userRepository.list(params).catch(function (error) {
            console.error('Users.requestFunction-error:', error);
          });
        },
        responseAdapter: function responseAdapter(response) {
          var data = [];
          response.data.docs.forEach(function (element) {
            var details = element;
            var withdrawl_amount = element.withdrawl_amount !== undefined ? element.withdrawl_amount : 0;
            details['net_pnl'] = element.current_investment_value !== undefined && element.pnl_value !== undefined && element.invested_amount !== undefined ? (element.current_investment_value + withdrawl_amount + Number(element.pnl_value) - element.invested_amount).toFixed(2) : 'NA';
            details['net_profile'] = element.current_investment_value !== undefined && element.pnl_value !== undefined && element.invested_amount !== undefined ? ((element.current_investment_value + withdrawl_amount + Number(element.pnl_value) - element.invested_amount) / element.invested_amount * 100).toFixed(2) : 'NA';
            details['invested_amount'] = element.invested_amount !== undefined ? element.invested_amount : 'NA';
            details['withdrawl_amount'] = element.withdrawl_amount !== undefined ? element.withdrawl_amount : 0;
            details['current_investment_value'] = element.current_investment_value !== undefined ? element.current_investment_value : 'NA';
            details['pnl_value'] = element.pnl_value !== undefined ? element.pnl_value : 'NA';
            details['startDate'] = element.startDate ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(element.startDate).format('DD-MM-YYYY') : 'NA';
            data.push(details);
          });
          _this.loading = false;
          console.log(data);
          return {
            data: data,
            count: response.data.items.total
          };
        },
        customFilters: [{
          name: 'custom_filter',
          callback: function callback(row, query) {
            console.log('sssssss', query);
          }
        }],
        uniqueKey: '_id'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    passwordValidation: function passwordValidation() {
      return this.password !== this.confirmPassword;
    },
    addButtonClass: function addButtonClass() {
      if (this.userTable) {
        return this.userTable.count > this.userTable.limit || this.userTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    emailValidator: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].emailValidator,
    fieldClassName: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* formService */].fieldClassName,

    getTotalAmount: function getTotalAmount() {
      var _this2 = this;

      var data = void 0;
      return __WEBPACK_IMPORTED_MODULE_1__services__["n" /* investmentService */].getTotalAmountAll(data).then(function (response) {
        console.log('getTotalAmount', response);
        _this2.totalPnL = response.data.total_pnl;
      }, function (err) {
        console.log(err);
      });
    },
    chnagePassword: function (_chnagePassword) {
      function chnagePassword() {
        return _chnagePassword.apply(this, arguments);
      }

      chnagePassword.toString = function () {
        return _chnagePassword.toString();
      };

      return chnagePassword;
    }(function () {
      console.log('🚀 ~ file: Users.vue:229 ~ chnagePassword ~ chnagePassword:', chnagePassword);
    }),
    togglePasswordVisibility: function togglePasswordVisibility(field) {
      this.showPassword = !this.showPassword;
      var inputField = document.querySelector('input[name=' + field + ']');
      if (inputField) {
        inputField.type = this.showPassword ? 'text' : 'password';
      }
    },
    closeAreaTableModal: function closeAreaTableModal() {
      this.password = '';
      this.confirmPassword = '';
      if (this.isAreaTable) {
        this.isAreaTable = !this.isAreaTable;
      }
    },
    UpdatePassword: function UpdatePassword(data) {
      this.isAreaTable = true;
      console.log('UpdatePassword', data);
    },
    getListPnL: function getListPnL(data) {
      var _this3 = this;

      var id = data.row._id;
      return __WEBPACK_IMPORTED_MODULE_1__services__["n" /* investmentService */].getListPnLAll(id).then(function (response) {
        _this3.history_table = [];
        if (response.data === []) {
          _this3.history_table = [];
        } else {
          response.data.data.forEach(function (element) {
            _this3.history_table.push({
              withdrawl_amount: element.withdrawl_amount ? element.withdrawl_amount.toFixed(2) : 0,
              createdAt: __WEBPACK_IMPORTED_MODULE_5_moment___default()(element.createdAt).format('DD-MM-YYYY '),
              current_investment_value: element.current_investment_value.toFixed(2),
              pnl_value: Number(element.pnl_value).toFixed(2),
              net_profit_percentage: element.net_profit_percentage.toFixed(2),
              net_pnl: element.net_pnl.toFixed(2)
            });
          });
        }
      }, function (err) {
        _this3.loading = false;
      });
    },
    getData: function getData(data) {
      this.totalInvestmentAmount = '';
      this.netProfitAndLoss = '';
      this.investedAmount = '';
      this.withdrawlAmount = '';
      this.net_pnl = '';
      this.net_profit_percentage = '';
      this.currentValue = '';

      this.totalInvestmentAmount = data.row.current_investment_value ? data.row.current_investment_value.toFixed(2) : 'No data';
      this.netProfitAndLoss = data.row.pnl_value ? Number(data.row.pnl_value).toFixed(2) : 'No data';
      this.investedAmount = data.row.invested_amount;
      this.withdrawlAmount = data.row.withdrawl_amount !== undefined ? data.row.withdrawl_amount : 0;
      this.net_pnl = data.row.current_investment_value && data.row.pnl_value && data.row.invested_amount ? (data.row.current_investment_value + this.withdrawlAmount + Number(data.row.pnl_value) - data.row.invested_amount).toFixed(2) : 'No data';
      this.net_profit_percentage = data.row.current_investment_value && data.row.pnl_value && data.row.invested_amount ? ((data.row.current_investment_value + this.withdrawlAmount + Number(data.row.pnl_value) - data.row.invested_amount) / data.row.invested_amount * 100).toFixed(2) : 'No data';
      var intValue = parseInt(this.netProfitAndLoss, 10);
      if (0 > intValue) {
        this.currentValue = this.totalInvestmentAmount - this.investedAmount + intValue;
      } else {
        this.currentValue = this.totalInvestmentAmount - this.investedAmount + intValue;
      }
    },
    closeUserDashBoard: function closeUserDashBoard() {
      this.isUserDashBoard = false;
    },
    rowClick: function rowClick(data) {
      console.log('rowclick', data);
      this.userName = data.row.firstName + ' ' + data.row.lastName;
      this.isUserDashBoard = true;
      this.getListPnL(data);
      this.getData(data);
    },
    action: function action(data) {
      this.$router.push({
        name: 'UserDetails',
        params: { _id: data._id },
        props: data
      });
    },
    onLoaded: function onLoaded() {
      this.userTable = this.$refs.userTable;
    },
    clearFilter: function clearFilter() {
      this.custom_filter_select = '';
    },
    applyFilter: function applyFilter(filter_val) {
      __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__["Event"].$emit('vue-tables.customFilters::custom_filter', filter_val);
    },
    exportData: function exportData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/v1/exportMaster?model=user',
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log('response of download', response);
        var arrayBuffer = response.data;
        var filename = 'Users.xlsx';
        _this4.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services__["f" /* eventBus */].$on('DATA_PUBLISHED', function (payload) {
      console.log('askjdajsdh', payload);
    });
    this.getTotalAmount();
  }
});

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);



var _methods;







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VehicleCreate',
    data: function data() {
        return {
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_3__config__["h" /* USER_ROLES */],
            loading: false,
            isVehicleDisable: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_3__config__["g" /* EVENTS */],
            formstate: {},
            region_list: {},
            device_name: {},
            vehicle: {
                deviceId: '',
                region: '',
                status: 'active'
            },
            docsValid1: false,
            docsValid2: false,
            docsValid3: false,
            docsValid4: false,
            docsValid5: false,
            docsValid6: false,
            docsValid7: false,
            formValid: false
        };
    },


    mounted: function mounted() {
        this.getRegionList();
        this.getDeviceName();
    },
    methods: (_methods = {
        fieldClassName: __WEBPACK_IMPORTED_MODULE_2__services__["e" /* formService */].fieldClassName,

        updateFormValidity: function updateFormValidity() {
            this.formValid = this.docsValid1 && this.docsValid2 && this.docsValid3 && this.docsValid4 && this.docsValid5 && this.docsValid6 && this.docsValid7;
        },
        onFilechanged1: function onFilechanged1(event) {
            this.docsValid1 = false;
            var fileinput = document.getElementById("fileinput1");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs1 = event.target.files[0];
                    this.vehicle.rcDoc = event.target.files[0]['name'];
                    this.docsValid1 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid1 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged2: function onFilechanged2(event) {
            this.docsValid2 = false;
            var fileinput = document.getElementById("fileinput2");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs2 = event.target.files[0];
                    this.vehicle.insuranceDoc = event.target.files[0]['name'];
                    this.docsValid2 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid2 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged3: function onFilechanged3(event) {
            this.docsValid3 = false;
            var fileinput = document.getElementById("fileinput3");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs3 = event.target.files[0];
                    this.vehicle.pucDoc = event.target.files[0]['name'];
                    this.docsValid3 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid3 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged4: function onFilechanged4(event) {
            this.docsValid4 = false;
            var fileinput = document.getElementById("fileinput4");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs4 = event.target.files[0];
                    this.vehicle.fitCertDoc = event.target.files[0]['name'];
                    this.docsValid4 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid4 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged5: function onFilechanged5(event) {
            this.docsValid5 = false;
            var fileinput = document.getElementById("fileinput5");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs5 = event.target.files[0];
                    this.vehicle.gcpDoc = event.target.files[0]['name'];
                    this.docsValid5 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid5 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged6: function onFilechanged6(event) {
            this.docsValid6 = false;
            var fileinput = document.getElementById("fileinput6");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs6 = event.target.files[0];
                    this.vehicle.hCVCommissioningCumAuditReport = event.target.files[0]['name'];
                    this.docsValid6 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid6 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged7: function onFilechanged7(event) {
            this.docsValid7 = false;
            var fileinput = document.getElementById("fileinput7");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs7 = event.target.files[0];
                    this.vehicle.vehicleImage = event.target.files[0]['name'];
                    this.docsValid7 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid7 = false;
                }
            }
            this.updateFormValidity();
        },
        uploadDocument: function uploadDocument(docId) {
            console.log('uploadDocument', docId);
            var formData = new FormData();
            if (this.docs1) {
                formData.append("file", this.docs1);
            }
            if (this.docs2) {
                formData.append("file", this.docs2);
            }
            if (this.docs3) {
                formData.append("file", this.docs3);
            }
            if (this.docs4) {
                formData.append("file", this.docs4);
            }
            if (this.docs5) {
                formData.append("file", this.docs5);
            }
            if (this.docs6) {
                formData.append("file", this.docs6);
            }
            if (this.docs7) {
                formData.append("file", this.docs7);
            }

            formData.append("model", "vehicle");
            formData.append("docId", docId);
            console.log('formData', formData);
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("fileUpload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(function (res) {
                console.log(res);
                console.log("SUCCESS!!");
            }).catch(function () {
                console.log("FAILURE!!");
            });
        },
        getRegionList: function getRegionList() {
            var _this = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;
            if (this.user.roleName == "GA Head") {
                params.regionManager = this.user._id;
            }
            if (this.user.roleName === "Journey Manager") {
                params.journeyManager = '["' + this.user._id + '"]';
                this.isVehicleDisable = true;
            }
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this.region_list = regionlist;
                if (_this.region_list.length === 1) {
                    _this.region_list ? _this.vehicle.region = _this.region_list[0].key : _this.vehicle.region = '';
                }
            }).catch(function (error) {
                _this.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getDeviceName: function getDeviceName() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            var deviceList = [];

            console.log('getDeviceName', params);
            this.$deviceDataRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    deviceList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.deviceId

                        };
                    });
                }
                _this2.device_name = deviceList;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('device.requestFunction-error:', error);
                _this2.$snotify.error('Get device list failed', 'Error!');
            });
        },
        createVehicle: function createVehicle() {
            var _this3 = this;

            this.loading = true;
            console.log("vehicle", this.vehicle);
            return __WEBPACK_IMPORTED_MODULE_2__services__["u" /* vehicleService */].addVehicle(this.vehicle).then(function (response) {
                console.log('createVehicle', response);
                var docId = response._id;
                _this3.uploadDocument(docId);
                _this3.loading = false;
                _this3.flash = false;
                _this3.$snotify.success('Vehicle added!', 'Success!');
                _this3.$router.push('/vehicle');
            }).catch(function (error) {
                _this3.loading = false;
                _this3.$snotify.error('vehicle Add failed! Try Again', 'Error!');
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'validateRegistration', function validateRegistration(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode == 32) e.preventDefault();else this.vehicle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.vehicle, {
            regNo: e.target.value.toUpperCase()
        });
    }), _methods),
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VehicleDetail',
    data: function data() {
        return {
            regionManagersIdList: [],
            USER_ROLES: __WEBPACK_IMPORTED_MODULE_4__config__["h" /* USER_ROLES */],
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: __WEBPACK_IMPORTED_MODULE_4__config__["g" /* EVENTS */],
            formstate: {},
            region_list: {},
            device_name: {},
            vehicle: {
                status: 'active'
            },
            docsValid1: false,
            docsValid2: false,
            docsValid3: false,
            docsValid4: false,
            docsValid5: false,
            docsValid6: false,
            docsValid7: false,
            formValid: false

        };
    },


    mounted: function mounted() {
        this.getRegionList();
        this.getDeviceName();
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        fieldClassName: __WEBPACK_IMPORTED_MODULE_3__services__["e" /* formService */].fieldClassName,

        getVehicle: function getVehicle() {
            var _this = this;

            return this.$vehicleDataRepository.find(this.$route.params._id).then(function (response) {
                _this.vehicle = response.data;
            }).catch(function (error) {
                _this.$snotify.error('Region detail failed', 'Error!');
            });
        },

        validateRegistration: function validateRegistration(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode == 32) e.preventDefault();else this.vehicle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.vehicle, {
                regNo: e.target.value.toUpperCase()
            });
        },

        updateFormValidity: function updateFormValidity() {
            this.formValid = this.docsValid1 && this.docsValid2 && this.docsValid3 && this.docsValid4 && this.docsValid5 && this.docsValid6 && this.docsValid7;
        },
        onFilechanged1: function onFilechanged1(event) {
            this.docsValid1 = false;
            var fileinput = document.getElementById("fileinput1");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs1 = event.target.files[0];
                    this.vehicle.rcDoc = event.target.files[0]['name'];
                    this.docsValid1 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid1 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged2: function onFilechanged2(event) {
            this.docsValid2 = false;
            if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                this.docs2 = event.target.files[0];
                this.vehicle.insuranceDoc = event.target.files[0]['name'];
                this.docsValid2 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid2 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged3: function onFilechanged3(event) {
            this.docsValid3 = false;
            var fileinput = document.getElementById("fileinput3");
            if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                this.docs3 = event.target.files[0];
                this.vehicle.pucDoc = event.target.files[0]['name'];
                this.docsValid3 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid3 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged4: function onFilechanged4(event) {
            this.docsValid4 = false;
            var fileinput = document.getElementById("fileinput4");
            if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                this.docs4 = event.target.files[0];
                this.vehicle.fitCertDoc = event.target.files[0]['name'];
                this.docsValid4 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid4 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged5: function onFilechanged5(event) {
            this.docsValid5 = false;
            var fileinput = document.getElementById("fileinput5");
            if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                this.docs5 = event.target.files[0];
                this.vehicle.gcpDoc = event.target.files[0]['name'];
                this.docsValid5 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid5 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged6: function onFilechanged6(event) {
            this.docsValid6 = false;
            var fileinput = document.getElementById("fileinput6");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
                    this.docs6 = event.target.files[0];
                    this.vehicle.hCVCommissioningCumAuditReport = event.target.files[0]['name'];
                    this.docsValid6 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid6 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged7: function onFilechanged7(event) {
            this.docsValid7 = false;
            var fileinput = document.getElementById("fileinput7");
            if (event.target.files[0] != undefined) {
                if (["image/jpeg", "image/jpg"].includes(event.target.files[0]["type"])) {
                    this.docs7 = event.target.files[0];
                    this.vehicle.vehicleImage = event.target.files[0]['name'];
                    this.docsValid7 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg files", "Error!");
                    fileinput.value = "";
                    this.docsValid7 = false;
                }
            }
            this.updateFormValidity();
        },
        uploadDocument: function uploadDocument(docId) {
            var formData = new FormData();
            if (this.docs1) {
                formData.append("file", this.docs1);
            }
            if (this.docs2) {
                formData.append("file", this.docs2);
            }
            if (this.docs3) {
                formData.append("file", this.docs3);
            }
            if (this.docs4) {
                formData.append("file", this.docs4);
            }
            if (this.docs5) {
                formData.append("file", this.docs5);
            }
            if (this.docs6) {
                formData.append("file", this.docs6);
            }
            if (this.docs7) {
                formData.append("file", this.docs7);
            }

            formData.append("model", "vehicle");
            formData.append("docId", docId);
            axios.post("fileUpload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(function (res) {
                console.log(res);
                console.log("SUCCESS!!");
            }).catch(function () {
                console.log("FAILURE!!");
            });
        },
        getRegionList: function getRegionList() {
            var _this2 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            if (this.regionManagersIdList.length !== 0) {
                params.regionManager = this.regionManagersIdList;
            }
            var regionlist = [];
            this.$regionDataRepository.list(params).then(function (res) {
                _this2.loading = false;
                if (res.data.docs) {
                    regionlist = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.name
                        };
                    });
                }
                _this2.region_list = regionlist;
            }).catch(function (error) {
                _this2.loading = false;
                console.error('Region.requestFunction-error:', error);
                _this2.$snotify.error('Get region list failed', 'Error!');
            });
        },
        getDeviceName: function getDeviceName() {
            var _this3 = this;

            this.loading = true;
            var params = {};
            params.$limit = 0;

            var deviceList = [];
            this.$deviceDataRepository.list(params).then(function (res) {
                _this3.loading = false;
                if (res.data.docs) {
                    deviceList = res.data.docs.map(function (item) {
                        return {
                            key: item._id,
                            value: item.deviceId

                        };
                    });
                }
                _this3.device_name = deviceList;
            }).catch(function (error) {
                _this3.loading = false;
                console.error('device.requestFunction-error:', error);
                _this3.$snotify.error('Get device list failed', 'Error!');
            });
        },
        updateVehicle: function updateVehicle() {
            var _this4 = this;

            this.loading = true;
            return __WEBPACK_IMPORTED_MODULE_3__services__["u" /* vehicleService */].updateVehicle(this.vehicle).then(function (response) {
                var docId = response._id;
                if (_this4.docsValid1 || _this4.docsValid2 || _this4.docsValid3 || _this4.docsValid4 || _this4.docsValid5 || _this4.docsValid6 || _this4.docsValid7) {
                    _this4.uploadDocument(docId);
                }
                _this4.loading = false;
                _this4.flash = false;
                _this4.$snotify.success('Vehicle updated!', 'Success!');
                _this4.$router.push('/vehicle');
            }).catch(function (error) {
                _this4.loading = false;
                _this4.$snotify.error('vehicle Add failed! Try Again', 'Error!');
                if (error.data.message.includes('must be one of')) {
                    _this4.flash = true;
                    _this4.flashType = 'error';
                    _this4.flashMessage = 'New vehicle add is failed.Please try again!';
                }
            });
        },
        deleteVehicleModal: function deleteVehicleModal() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                title: 'Are you sure?',
                text: 'This will permanently delete this Vehicle!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                customClass: 'swal-modal2',
                width: '400px',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    _this5.deleteVehicle();
                }
            });
        },
        deleteVehicle: function deleteVehicle() {
            var _this6 = this;

            this.loading = true;
            return this.$vehicleDataRepository.deleteOne(this.vehicle._id).then(function (response) {
                _this6.loading = false;
                return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Deleted!', 'Vehicle has been deleted.', 'success');
            }).then(function (response) {
                _this6.loading = false;
                _this6.$router.push('/vehicle');
            }).catch(function (error) {
                _this6.loading = false;
                _this6.$snotify.error('Delete vehicle failed', 'Error!');
            });
        }
    }, 'fieldClassName', function fieldClassName(field) {
        if (!field) {
            return '';
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return 'has-success';
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return 'has-danger';
        }
    }),
    created: function created() {
        var _this7 = this;

        var promises = [];
        this.loading = true;
        promises.push(this.getVehicle());
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            _this7.loading = false;
            _this7.ready = true;
        }).catch(function () {
            _this7.loading = false;
        });
        var regionDetails = this.$store.state.auth.userRegion.regionDetails;
        if (regionDetails && regionDetails.length !== 0) {
            this.regionManagersIdList = regionDetails.map(function (item) {
                return item.regionManager;
            });
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    }))
});

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Vehicle',
  data: function data() {
    var _this = this;

    return {
      regionManagersIdList: [],
      regionValue: 'all',
      parameters: '',
      journey_managers: [],
      USER_ROLES: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* USER_ROLES */],
      loading: null,
      vehicleTable: null,
      regionData: '',
      region: {},
      params: {},
      columns: ['regNo', 'capacity', 'ownerName', 'transportSupervisorContact', 'transportSupervisorName', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['regNo', 'capacity', 'ownerName', 'transportSupervisorContact', 'transportSupervisorName', 'status'],
        headings: {
          regNo: 'Registration No',
          capacity: 'Capacity (WL)',
          ownerName: 'Transporter Name',
          transportSupervisorContact: 'Transport Supervisor Contact',
          transportSupervisorName: 'Transport Supervisor Name',
          status: 'Status'
        },

        templates: {
          status: function status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          }
        },
        requestFunction: function requestFunction(request) {
          var params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (_this.user.roleName == 'GA Head') {
            params.regionRegionManager = _this.user._id;
          }
          if (_this.regionManagersIdList.length !== 0) {
            params.region = _this.regionManagersIdList;
          }
          if (request.orderBy) {
            params.$sort = request.ascending ? '-' + request.orderBy : request.orderBy;
          }
          if (request.query) {
            params.$term = request.query;
          } else {
            delete params.$term;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (_this.parameters != '') {
            params.region = _this.parameters;
          }
          _this.loading = true;
          return _this.$vehicleDataRepository.list(params).catch(function (error) {
            console.error('Vehicle.requestFunction-error:', error);
            _this.$snotify.error('Get Vehicle', 'Error!');
          });
        },
        responseAdapter: function responseAdapter(response) {
          _this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total
          };
        },
        uniqueKey: '_id'
      }
    };
  },

  mounted: function mounted() {
    this.getGeographicalAreas();
  },
  created: function created() {
    var regionDetails = this.$store.state.auth.userRegion.regionDetails;
    console.log('re', regionDetails);
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(function (item) {
        return item._id;
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addButtonClass: function addButtonClass() {
      if (this.vehicleTable) {
        return this.vehicleTable.count > this.vehicleTable.limit || this.vehicleTable.limit > 10 ? 'shift-add-left' : 'add-item';
      } else {
        return 'add-item';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),
  methods: {
    edit: function edit(data) {
      this.$router.push({
        name: 'VehicleDetail',
        params: { _id: data.row._id },
        props: data.row
      });
    },
    clearStatusGA: function clearStatusGA() {
      this.parameters = '';
      this.regionValue = 'all';
      this.$refs.vehicleTable.refresh();
    },
    fiteredResultGA: function fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameters = '';
        this.regionValue = 'all';
      } else {
        this.parameters = e.target.value;
      }
      this.$refs.vehicleTable.refresh();
    },
    getGeographicalAreas: function getGeographicalAreas() {
      var _this2 = this;

      this.loading = true;
      var params = {};
      params.$limit = 0;
      var journeyManagerList = [];

      this.$regionsDataRepository.list(params).then(function (res) {
        _this2.loading = false;
        if (res.data.docs) {
          if (_this2.user.roleName === 'Admin') {
            journeyManagerList = res.data.docs.map(function (item) {
              return {
                key: item._id,
                value: item.name
              };
            });
            _this2.journey_managers = journeyManagerList;
          } else {
            journeyManagerList = res.data.docs.map(function (item) {
              if (_this2.regionManagersIdList.includes(item._id)) {
                _this2.journey_managers.push({
                  key: item._id,
                  value: item.name
                });
              }
            });
          }
        }
      }).catch(function (error) {
        _this2.loading = false;
        console.error('journey Manager.requestFunction-error:', error);
        _this2.$snotify.error('Get journey manager list failed', 'Error!');
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        method: 'get',
        url: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + '/v1/exportMaster?model=vehicle',
        responseType: 'arraybuffer'
      }).then(function (response) {
        console.log('response of download', response);
        var arrayBuffer = response.data;
        var filename = 'Vehicle.xlsx';
        _this3.downloadFileFromArrayBuffer(arrayBuffer, filename);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    downloadFileFromArrayBuffer: function downloadFileFromArrayBuffer(arrayBuffer, filename) {
      var url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    onLoaded: function onLoaded() {
      this.vehicleTable = this.$refs.vehicleTable;
    }
  }
});

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ResourceHelper = function ResourceHelper(httpClient, logger) {
  return {
    generateCrudCallers: function generateCrudCallers(resourceRoute, options) {
      options = options || {};
      return {
        list: this.generateListCaller(resourceRoute, options),
        find: this.generateFindCaller(resourceRoute, options),
        update: this.generateUpdateCaller(resourceRoute, options),
        create: this.generateCreateCaller(resourceRoute, options),
        deleteOne: this.generateDeleteOneCaller(resourceRoute, options),
        deleteMany: this.generateDeleteManyCaller(resourceRoute, options),
        groupTripApi: this.generateGroupTripListCaller(resourceRoute, options),
        getIndividualGroupTrip: this.generateIndividualGroupTripCaller(resourceRoute, options)
      };
    },
    generateListCaller: function generateListCaller(resourceRoute, options) {
      return function (params) {
        logger.debug(resourceRoute + '.list + params: ', params);

        if (!params) {
          params = { isDeleted: false };
        } else if (!params.isDeleted) {
          params.isDeleted = false;
        }

        if (options.filterDeleted === false) {
          delete params.isDeleted;
        }

        return httpClient.get(resourceRoute, params).then(function (response) {
          logger.debug(resourceRoute + '.list response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(resourceRoute + '.list error:\n', error);
          throw error;
        });
      };
    },
    generateFindCaller: function generateFindCaller(resourceRoute, options) {
      return function (_id, params) {
        logger.debug(resourceRoute + '.find + _id: ', _id, ', params: ', params);

        return httpClient.get(resourceRoute + '/' + _id, params).then(function (response) {
          logger.debug(resourceRoute + '.find response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(resourceRoute + '.find error:\n', error);
          throw error;
        });
      };
    },
    generateUpdateCaller: function generateUpdateCaller(resourceRoute, options) {
      return function (_id, payload) {
        delete payload.createdAt;
        delete payload.updatedAt;
        delete payload.isDeleted;
        logger.debug(resourceRoute + '.update + _id: ', _id, ', payload: ', payload);

        return httpClient.put(resourceRoute + '/' + _id, payload).then(function (response) {
          logger.debug(resourceRoute + '.update response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(resourceRoute + '.update error:\n', error);
          throw error;
        });
      };
    },
    generateCreateCaller: function generateCreateCaller(resourceRoute, options) {
      return function (payload) {
        logger.debug(resourceRoute + '.create + payload: ', payload);

        return httpClient.post(resourceRoute, payload).then(function (response) {
          logger.debug(resourceRoute + '.create response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(resourceRoute + '.create error:\n', error);
          throw error;
        });
      };
    },
    generateDeleteOneCaller: function generateDeleteOneCaller(resourceRoute, options) {
      return function (_id, hardDelete) {
        hardDelete = hardDelete || false;
        logger.debug(resourceRoute + '.deleteOne + _id: ', _id, ', hardDelete: ', hardDelete);

        return httpClient.delete(resourceRoute + '/' + _id, { hardDelete: hardDelete }).then(function (response) {
          logger.debug(resourceRoute + '.delete response:\n', response);
          return response;
        }).catch(function (error) {
          logger.debug(resourceRoute + '.delete error:\n', error);
          throw error;
        });
      };
    },
    generateDeleteManyCaller: function generateDeleteManyCaller(resourceRoute, options) {
      return function (payload) {
        logger.debug(resourceRoute + '.deleteMany + payload', payload);

        return httpClient.delete(resourceRoute, payload).then(function (response) {
          logger.debug(resourceRoute + '.delete response:\n', response);
          return response;
        }).catch(function (error) {
          logger.debug(resourceRoute + '.delete error:\n', error);
          throw error;
        });
      };
    },
    generateGroupTripListCaller: function generateGroupTripListCaller(resourceRoute, options) {
      return function (params) {
        logger.debug(resourceRoute + '.list + params: ', params);

        if (!params) {
          params = { isDeleted: false };
        } else if (!params.isDeleted) {
          params.isDeleted = false;
        }

        if (options.filterDeleted === false) {
          delete params.isDeleted;
        }

        return httpClient.get('v1/getTripgroupList', params).then(function (response) {
          logger.debug(resourceRoute + '.list response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(resourceRoute + '.list error:\n', error);
          throw error;
        });
      };
    },
    generateIndividualGroupTripCaller: function generateIndividualGroupTripCaller(resourceRoute, options) {
      return function (tripId) {
        return httpClient.get('v1/getTripgroupById/' + tripId).then(function (response) {
          logger.debug(resourceRoute + '.list response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(resourceRoute + '.list error:\n', error);
          throw error;
        });
      };
    },

    generateAssociationCallers: function generateAssociationCallers(ownerRoute, associationName, associationRoute, options) {
      options = options || {};
      var resourceMethodName = associationName[0].toUpperCase() + associationName.slice(1);
      var callers = {};
      callers['get' + resourceMethodName] = this.generateGetAssociationsAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options);
      callers['addOne' + resourceMethodName] = this.generateAddOneAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options);
      callers['removeOne' + resourceMethodName] = this.generateRemoveOneAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options);
      callers['addMany' + resourceMethodName] = this.generateAddManyAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options);
      callers['removeMany' + resourceMethodName] = this.generateRemoveManyAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options);

      return callers;
    },
    generateGetAssociationsAssociationCaller: function generateGetAssociationsAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options) {
      return function (ownerId, params) {
        var methodName = ownerRoute + '.get' + resourceMethodName;
        logger.debug(methodName + ' + ownerId: ', ownerId, ', params: ', params);

        if (!params) {
          params = { isDeleted: false };
        } else if (!params.isDeleted) {
          params.isDeleted = false;
        }

        if (options.filterDeleted === false) {
          delete params.isDeleted;
        }

        return httpClient.get(ownerRoute + '/' + ownerId + '/' + associationRoute, params).then(function (response) {
          logger.debug(methodName + ' response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(methodName + ' error:\n', error);
          throw error;
        });
      };
    },
    generateAddOneAssociationCaller: function generateAddOneAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options) {
      return function (ownerId, childId, payload) {
        var methodName = ownerRoute + '.addOne' + resourceMethodName;
        logger.debug(methodName + ' + ownerId: ', ownerId, 'childId: ', childId, ', payload: ', payload);

        return httpClient.put(ownerRoute + '/' + ownerId + '/' + associationRoute + '/' + childId, payload).then(function (response) {
          logger.debug(methodName + ' response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(methodName + ' error:\n', error);
          throw error;
        });
      };
    },
    generateRemoveOneAssociationCaller: function generateRemoveOneAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options) {
      return function (ownerId, childId) {
        var methodName = ownerRoute + '.removeOne' + resourceMethodName;
        logger.debug(methodName + ' + ownerId: ', ownerId, 'childResource: ', associationRoute, 'childId: ', childId);

        return httpClient.delete(ownerRoute + '/' + ownerId + '/' + associationRoute + '/' + childId).then(function (response) {
          logger.debug(methodName + ' response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(methodName + ' error:\n', error);
          throw error;
        });
      };
    },
    generateAddManyAssociationCaller: function generateAddManyAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options) {
      return function (ownerId, payload) {
        var methodName = ownerRoute + '.addMany' + resourceMethodName;
        logger.debug(methodName + ' + ownerId: ', ownerId, ', payload: ', payload);

        return httpClient.post(ownerRoute + '/' + ownerId + '/' + associationRoute, payload).then(function (response) {
          logger.debug(methodName + ' response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(methodName + ' error:\n', error);
          throw error;
        });
      };
    },
    generateRemoveManyAssociationCaller: function generateRemoveManyAssociationCaller(ownerRoute, associationRoute, resourceMethodName, options) {
      return function (ownerId, payload) {
        var methodName = ownerRoute + '.removeMany' + resourceMethodName;
        logger.debug(methodName + ' + ownerId: ', ownerId, ', payload: ', payload);

        return httpClient.delete(ownerRoute + '/' + ownerId + '/' + associationRoute, payload).then(function (response) {
          logger.debug(methodName + ' response:\n', response);
          return response;
        }).catch(function (error) {
          logger.error(methodName + ' error:\n', error);
          throw error;
        });
      };
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ResourceHelper);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_VehicleStatus_VehicleStatus_vue__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_VehicleStatus_VehicleStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_VehicleStatus_VehicleStatus_vue__);


var routes = [{
    path: 'vehicle_status',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_VehicleStatus_VehicleStatus_vue___default.a,
    name: 'VehicleStatus',
    meta: {
        title: 'Vehicles Status'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_complianceReport_complianceReport_vue__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_complianceReport_complianceReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_complianceReport_complianceReport_vue__);

var routes = [{
    path: '/complianceReport',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_complianceReport_complianceReport_vue___default.a,
    name: 'complianceReport',
    meta: {
        title: 'Compliance Report'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_dashboard_dashboard_vue__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_dashboard_dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_dashboard_dashboard_vue__);


var routes = [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_dashboard_dashboard_vue___default.a,
    name: 'dashboard',
    meta: {
        title: 'Dashboard'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_device_Devices_vue__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_device_Devices_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_device_Devices_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_device_DeviceCreate_vue__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_device_DeviceCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_device_DeviceCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_device_DeviceDetail_vue__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_device_DeviceDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_device_DeviceDetail_vue__);




var routes = [{
    path: 'device',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_device_Devices_vue___default.a,
    name: 'Devices',
    meta: {
        description: 'List of Think Gas Devices',
        title: 'Devices',
        requiresAuth: true
    }
}, {
    path: 'device/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_device_DeviceCreate_vue___default.a,
    name: 'DeviceCreate',
    meta: {
        description: 'Add a new device',
        title: 'Add Device',
        requiresAuth: true
    }
}, {
    path: '/device/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'DeviceCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_device_DeviceDetail_vue___default.a,
    name: 'DeviceDetail',
    meta: {
        description: 'Details for the selected device',
        title: 'Update Device',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_driver_Driver_vue__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_driver_Driver_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_driver_Driver_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_driver_DriverCreate_vue__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_driver_DriverCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_driver_DriverCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_driver_DriverDetail_vue__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_driver_DriverDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_driver_DriverDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_ExpiringLicense_vue__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_ExpiringLicense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_ExpiringLicense_vue__);





var routes = [{
    path: 'driver',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_driver_Driver_vue___default.a,
    name: 'Driver',
    meta: {
        description: 'List of Think Gas Drivers',
        title: 'Drivers',
        requiresAuth: true
    }
}, {
    path: '/driver/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_driver_DriverCreate_vue___default.a,
    name: 'DriverCreate',
    meta: {
        description: 'Add a new Driver',
        title: 'Add Driver',
        requiresAuth: true
    }
}, {
    path: '/driver/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'DriverCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_driver_DriverDetail_vue___default.a,
    name: 'DriverDetail',
    meta: {
        description: 'Details for the selected driver',
        title: 'Update Driver',
        requiresAuth: true
    }
}, {
    path: 'expiringLicense',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_ExpiringLicense_vue___default.a,
    name: 'ExpiringLicense',
    meta: {
        title: 'Drivers',
        description: 'ThinkGas Driver whose license are expiring within 2 months'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_HcvStatus_HcvStatus_vue__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_HcvStatus_HcvStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_HcvStatus_HcvStatus_vue__);


var routes = [{
    path: 'hcvdetails',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_HcvStatus_HcvStatus_vue___default.a,
    name: 'HcvStatus',
    meta: {
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_main_Main_vue__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_main_Main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_main_Main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roles_route__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__devices_route__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_route__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__region_route__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vehicles_route__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driver_route__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sites_route__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__trips_route__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tripRoute_route__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__salesdata_route__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reportgeneration_route__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__schedulereport_route__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dashboard_route__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__VehicleStatus_route__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__technician_route__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__register_route__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__profile_route__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__operatorreport_route__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__complianceReport_route__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__trip_group_route__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hcvdetails_route__ = __webpack_require__(511);


























var routes = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_main_Main_vue___default.a,
    children: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__sites_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__driver_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__vehicles_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__devices_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__region_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__users_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__roles_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__trips_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__tripRoute_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__salesdata_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__reportgeneration_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__schedulereport_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__dashboard_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__VehicleStatus_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__technician_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__register_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__profile_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_19__operatorreport_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__complianceReport_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__trip_group_route__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__hcvdetails_route__["a" /* default */]))
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_operatorReport_OperatorReport_vue__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_operatorReport_OperatorReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_operatorReport_OperatorReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_operatorReport_ViewOperatorReport__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_operatorReport_ViewOperatorReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_operatorReport_ViewOperatorReport__);



var routes = [{
    path: 'operator_report',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_operatorReport_OperatorReport_vue___default.a,
    name: 'OperatorReport',
    meta: {
        title: 'Operator Report'
    }
}, {
    path: 'operator_report/:_id',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_operatorReport_ViewOperatorReport___default.a,
    name: 'ViewOperatorReport',
    meta: {
        title: 'Operator Report'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_profile_Profile_vue__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_profile_Profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_profile_Profile_vue__);


var routes = [{
    path: '/profile',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_profile_Profile_vue___default.a,
    name: 'Profile',
    meta: {
        title: 'Profile'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_region_Region_vue__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_region_Region_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_region_Region_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_region_RegionCreate_vue__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_region_RegionCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_region_RegionCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_region_RegionDetail_vue__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_region_RegionDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_region_RegionDetail_vue__);




var routes = [{
    path: 'ga',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_region_Region_vue___default.a,
    name: 'Region',
    meta: {
        description: 'List of Think Gas Geographical Areas',
        title: 'Geographical Areas',
        requiresAuth: true
    }
}, {
    path: 'ga/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_region_RegionCreate_vue___default.a,
    name: 'RegionCreate',
    meta: {
        description: 'Add a new G.A',
        title: 'Add Geographical Area',
        requiresAuth: true
    }
}, {
    path: '/ga/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'RegionCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_region_RegionDetail_vue___default.a,
    name: 'RegionDetail',
    meta: {
        description: 'Details for the selected G.A',
        title: 'Update Geographical Area',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_register_ActivateAccount_vue__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_register_ActivateAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_register_ActivateAccount_vue__);


var routes = [{
    path: 'activate',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_register_ActivateAccount_vue___default.a,
    name: 'ActivateAccount',
    meta: {

        title: 'Activate Account'

    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_reports_Report_vue__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_reports_Report_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_reports_Report_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_reports_ReportCreate_vue__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_reports_ReportCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_reports_ReportCreate_vue__);



var routes = [{
    path: 'reports',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_reports_Report_vue___default.a,
    name: 'Report',
    meta: {
        title: 'Reports History',
        requiresAuth: true
    }
}, {
    path: 'reports/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_reports_ReportCreate_vue___default.a,
    name: 'ReportCreate',
    meta: {
        title: 'Generate Report',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_roles_Roles_vue__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_roles_Roles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_roles_Roles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_roles_RoleDetails_vue__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_roles_RoleDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_roles_RoleDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_roles_RoleCreate_vue__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_roles_RoleCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_roles_RoleCreate_vue__);




var routes = [{
    path: 'roles',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_roles_Roles_vue___default.a,
    name: 'Roles',
    meta: {
        description: 'List of ThinkGas roles',
        title: 'Roles',
        requiresAuth: true
    }
}, {
    path: '/roles/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'RoleCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_roles_RoleDetails_vue___default.a,
    name: 'RoleDetails',
    meta: {
        description: 'Details for the selected role',
        title: 'Role Details',
        requiresAuth: true
    }
}, {
    path: '/roles/create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_roles_RoleCreate_vue___default.a,
    name: 'RoleCreate',
    meta: {
        description: 'Create a new role',
        title: 'Role Create',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Salesdata_salesdata_vue__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Salesdata_salesdata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Salesdata_salesdata_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Salesdata_SalesdataCreate_vue__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_Salesdata_SalesdataCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_Salesdata_SalesdataCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Salesdata_SalesdataDetails_vue__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Salesdata_SalesdataDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_Salesdata_SalesdataDetails_vue__);




var routes = [{
    path: 'sales_settings',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_Salesdata_salesdata_vue___default.a,
    name: 'salesdata',
    meta: {
        title: 'Sales Status',
        requiresAuth: true
    }
}, {
    path: 'sales_settings/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_Salesdata_SalesdataCreate_vue___default.a,
    name: 'salesdataCreate',
    meta: {
        description: 'Daily Sales Status Report',
        title: 'Add Sales Status',
        requiresAuth: true
    }
}, {
    path: '/sales_settings/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'salesdataCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_Salesdata_SalesdataDetails_vue___default.a,
    name: 'SalesdataDetails',
    meta: {
        description: 'Daily Sales Status Report',
        title: 'Update Sales Status',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_reportschedule_ReportSchedule_vue__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_reportschedule_ReportSchedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_reportschedule_ReportSchedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_reportschedule_ReportScheduleCreate__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_reportschedule_ReportScheduleCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_reportschedule_ReportScheduleCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_reportschedule_ReportScheduleDetails__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_reportschedule_ReportScheduleDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_reportschedule_ReportScheduleDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_SchedulesExpiry__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_SchedulesExpiry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_SchedulesExpiry__);





var routes = [{
    path: 'report_settings',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_reportschedule_ReportSchedule_vue___default.a,
    name: 'ReportSchedule',
    meta: {
        title: 'Report Schedules',
        requiresAuth: true
    }
}, {
    path: 'report_settings/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_reportschedule_ReportScheduleCreate___default.a,
    name: 'ReportScheduleCreate',
    meta: {
        title: ' Add Report Schedule',
        description: 'Add Report Schedule',
        requiresAuth: true
    }
}, {
    path: '/report_settings/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'ReportScheduleCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_reportschedule_ReportScheduleDetails___default.a,
    name: 'ReportScheduleDetails',
    meta: {
        description: 'Details for the selected Schedule',
        title: 'Update Schedule',
        requiresAuth: true
    }
}, {
    path: 'reportScheduleExpiry',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_dashboard_SchedulesExpiry___default.a,
    name: 'SchedulesExpiry',
    meta: {
        title: 'Schedules Expiry',
        description: 'Reports Schedules expiry in 1 week'
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_site_Sites_vue__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_site_Sites_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_site_Sites_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_site_SiteCreate_vue__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_site_SiteCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_site_SiteCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_site_SiteDetail_vue__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_site_SiteDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_site_SiteDetail_vue__);




var routes = [{
    path: 'location',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_site_Sites_vue___default.a,
    name: 'Sites',
    meta: {
        description: 'List of Think Gas Locations',
        title: 'Locations',
        requiresAuth: true
    }
}, {
    path: 'location/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_site_SiteCreate_vue___default.a,
    name: 'SiteCreate',
    meta: {
        description: 'Add a new location',
        title: 'Add Location',
        requiresAuth: true
    }
}, {
    path: '/location/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'SiteCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_site_SiteDetail_vue___default.a,
    name: 'SiteDetail',
    meta: {
        description: 'Details for the selected Location',
        title: 'Update Location',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_technician_Technician_vue__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_technician_Technician_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_technician_Technician_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_technician_TechnicianCreate_vue__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_technician_TechnicianCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_technician_TechnicianCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_technician_TechnicianDetails_vue__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_technician_TechnicianDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_technician_TechnicianDetails_vue__);




var routes = [{
    path: 'operator',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_technician_Technician_vue___default.a,
    name: 'Technician',
    meta: {
        description: 'List of Think Gas Operators',
        title: 'Operators ',
        requiresAuth: true
    }
}, {
    path: '/operator/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_technician_TechnicianCreate_vue___default.a,
    name: 'TechnicianCreate',
    meta: {
        description: 'Add a new Operator',
        title: 'Add Operator',
        requiresAuth: true
    }
}, {
    path: '/operator/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'TechnicianCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_technician_TechnicianDetails_vue___default.a,
    name: 'TechnicianDetails',
    meta: {
        description: 'Details for the selected Operator',
        title: 'Update Operator',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_trip_group_TripGroup_vue__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_trip_group_TripGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_trip_group_TripGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_trip_group_Trip_Group_Create_vue__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_trip_group_Trip_Group_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_trip_group_Trip_Group_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripCreate_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_trip_group_TripGroupDetail_vue__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_trip_group_TripGroupDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_trip_group_TripGroupDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_trip_group_Trip_Group_Activity_vue__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_trip_group_Trip_Group_Activity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_trip_group_Trip_Group_Activity_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_trip_group_Update_Locations_vue__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_trip_group_Update_Locations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_trip_group_Update_Locations_vue__);









var routes = [{
    path: '/trip-group',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_trip_group_TripGroup_vue___default.a,
    name: 'TripGroup',
    meta: {
        description: 'List of Think Gas Group Trips',
        title: 'Group Trip',
        requiresAuth: true
    }
}, {
    path: 'trip-group/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_trip_group_Trip_Group_Create_vue___default.a,
    name: 'TripGroupCreate',
    meta: {
        description: 'Add a new Group Trip',
        title: 'Add Group Trip',
        requiresAuth: true
    }
}, {
    path: '/trip-group/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' && to.params.status === 'ongoing' && to.params.status === 'completed' ? next({ name: 'TripCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_trip_group_Trip_Group_Activity_vue___default.a,
    name: 'Trip-Group-Activity',
    meta: {
        description: 'Activity log of Group Trip',
        title: 'Group Trip Activity',
        requiresAuth: true
    }
}, {
    path: '/trip-group/:_id/status',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' && (to.params.status === 'scheduled' || to.params.status === 'halt') ? next({ name: 'TripCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_trip_group_TripGroupDetail_vue___default.a,
    name: 'TripGroupDetail',
    meta: {
        description: 'Details for the selected Group trip',
        title: 'Update Group Trip',
        requiresAuth: true
    }
}, {
    path: '/scheduledTrip',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue___default.a,
    name: 'UpComing',
    meta: {
        title: 'Scheduled Group Trips',
        description: 'ThinkGas Scheduled Group Trips'
    }
}, {
    path: '/ongoingTrip',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue___default.a,
    name: 'OnGoing',
    meta: {
        title: 'Ongoing Group Trips',
        description: 'ThinkGas Ongoing Group Trips'
    }
}, {
    path: '/completedTrip',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue___default.a,
    name: 'Completed',
    meta: {
        title: 'Completed Group Trips',
        description: 'ThinkGas Completed Group Trips'
    }
}, {
    path: 'trip-group/updateDestination',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'UpdateDestination' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_trip_group_Update_Locations_vue___default.a,
    name: 'UpdateLocations',
    meta: {
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_tripRoute_tripRoute_vue__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_tripRoute_tripRoute_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_tripRoute_tripRoute_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_tripRoute_RouteCreate_vue__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_tripRoute_RouteCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_tripRoute_RouteCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_tripRoute_RouteDetail_vue__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_tripRoute_RouteDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_tripRoute_RouteDetail_vue__);




var routes = [{
    path: 'routes',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_tripRoute_tripRoute_vue___default.a,
    name: 'Route',
    meta: {
        description: 'List of Think Gas Routes',
        title: 'Routes',
        requiresAuth: true
    }
}, {
    path: 'routes/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_tripRoute_RouteCreate_vue___default.a,
    name: 'RouteCreate',
    meta: {
        description: 'Add a new Route',
        title: 'Add Route',
        requiresAuth: true
    }
}, {
    path: '/routes/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'RouteCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_tripRoute_RouteDetail_vue___default.a,
    name: 'RouteDetail',
    meta: {
        description: 'Details for the selected Route',
        title: 'Update Route',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_trip_Trip_vue__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_trip_Trip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_trip_Trip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_trip_TripCreate_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_trip_TripCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_trip_TripCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripDetail_vue__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_trip_TripActivity_vue__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_trip_TripActivity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_trip_TripActivity_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_trip_UpdateDestination_vue__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_trip_UpdateDestination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_trip_UpdateDestination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue__);








var routes = [{
    path: 'trip',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_trip_Trip_vue___default.a,
    name: 'Trip',
    meta: {
        description: 'List of Think Gas Trips',
        title: 'Trips',
        requiresAuth: true
    }
}, {
    path: 'trip/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_trip_TripCreate_vue___default.a,
    name: 'TripCreate',
    meta: {
        description: 'Add a new Trip',
        title: 'Add Trip',
        requiresAuth: true
    }
}, {
    path: '/trip/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' && to.params.status === 'ongoing' && to.params.status === 'completed' ? next({ name: 'TripCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_trip_TripActivity_vue___default.a,
    name: 'TripActivity',
    meta: {
        description: 'Activity log of Trip',
        title: 'Trip Activity',
        requiresAuth: true
    }
}, {
    path: '/trip/:_id/status',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' && (to.params.status === 'scheduled' || to.params.status === 'halt') ? next({ name: 'TripCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_trip_TripDetail_vue___default.a,
    name: 'TripDetail',
    meta: {
        description: 'Details for the selected trip',
        title: 'Update Trip',
        requiresAuth: true
    }
}, {
    path: '/scheduledTrip',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_trip_UpComingTrip_vue___default.a,
    name: 'UpComing',
    meta: {
        title: 'Scheduled Trips',
        description: 'ThinkGas Scheduled Trips'
    }
}, {
    path: '/ongoingTrip',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_trip_OnGoingTrip_vue___default.a,
    name: 'OnGoing',
    meta: {
        title: 'Ongoing Trips',
        description: 'ThinkGas Ongoing Trips'
    }
}, {
    path: '/completedTrip',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_trip_CompletedTrip_vue___default.a,
    name: 'Completed',
    meta: {
        title: 'Completed Trips',
        description: 'ThinkGas Completed Trips'
    }
}, {
    path: 'trip/updateDestination',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'UpdateDestination' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_trip_UpdateDestination_vue___default.a,
    name: 'UpdateDestination',
    meta: {
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_users_Users_vue__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_users_Users_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_users_Users_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_users_UserDetails_vue__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_users_UserDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_users_UserDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_users_UserCreate_vue__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_users_UserCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_users_UserCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_users_CreateUser_vue__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_users_CreateUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_users_CreateUser_vue__);





var routes = [{
    path: 'users',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_users_Users_vue___default.a,
    name: 'Users',
    meta: {
        description: 'List of Think Gas Users',
        title: 'Users',
        requiresAuth: true
    }
}, {
    path: '/users/create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_users_UserCreate_vue___default.a,
    name: 'UserCreate',
    meta: {
        description: 'Add a new User',
        title: 'Add User',
        requiresAuth: true
    }
}, {
    path: '/users/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: 'UserCreate' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_users_UserDetails_vue___default.a,
    name: 'UserDetails',
    meta: {
        description: 'Details for the selected User',
        title: 'Update User',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_vehicles_Vehicles_vue__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_vehicles_Vehicles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_vehicles_Vehicles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_vehicles_VehicleCreate_vue__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_vehicles_VehicleCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_views_vehicles_VehicleCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_vehicles_VehicleDetail_vue__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_vehicles_VehicleDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_vehicles_VehicleDetail_vue__);




var routes = [{
    path: 'vehicle',
    component: __WEBPACK_IMPORTED_MODULE_0__components_views_vehicles_Vehicles_vue___default.a,
    name: 'Vehicle',
    meta: {
        description: 'List of Think Gas Vehicles',
        title: 'Vehicles',
        requiresAuth: true
    }
}, {
    path: 'vehicle/create',
    component: __WEBPACK_IMPORTED_MODULE_1__components_views_vehicles_VehicleCreate_vue___default.a,
    name: 'VehicleCreate',
    meta: {
        description: 'Add a new vehicle',
        title: 'Add Vehicles',
        requiresAuth: true
    }
}, {
    path: '/vehicle/:_id',
    beforeEnter: function beforeEnter(to, from, next) {
        to.params._id === 'create' ? next({ name: '' }) : next();
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_vehicles_VehicleDetail_vue___default.a,
    name: 'VehicleDetail',
    meta: {
        description: 'Details for the selected vehicle',
        title: 'Update Vehicle',
        requiresAuth: true
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);






var internals = {};

internals.responseError = function (error) {
    var response = error.response;
    if (response.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var spcook = cookies[i].split("=");
            document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
        }

        window.location.href = '/login';
    } else if (response.status === 403) {
        console.debug('authInterceptor.service: 403: response:', response);
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
};

/* harmony default export */ __webpack_exports__["a"] = ({
    responseError: internals.responseError
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(3);








var internals = {};

internals.login = function (credentials) {
  var userDet;
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/login', credentials).then(function (response) {
    console.log("rrr", response.data);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setAuth', response.data);
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

internals.getUserRegionDetails = function (credentials) {
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].get('user/details?regionId=' + credentials).then(function (response) {
    console.log('result', response);
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

internals.loginAzure = function (credentials) {
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/auth/azure', credentials).then(function (response) {
    console.log('This is email', response.data.user._id);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setAuth', response.data);
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

internals.logout = function () {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/useRefreshToken');
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].delete('/logout').then(function (response) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/clearAuth');
  }).catch(function (error) {
    console.error('authService.logout-error:\n', error);
    throw error;
  });
};

internals.registerUser = function (user) {
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/register', { user: user, registerType: 'Register' }).catch(function (error) {
    console.error('authService.registerUser-error:\n', error);
    throw error;
  });
};

internals.inviteUser = function (user) {
  user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, user);
  console.log("user", user);
  user.role = user.role.name;
  user.rank = user.role.rank;
  user.invested_amount = user.invested_amount;
  user.password = user.password;
  user.startDate = user.startDate;

  delete user.isActive;
  delete user.isEnabled;

  var groups = (user.groups || []).concat([]).map(function (group) {
    return group.group._id;
  });
  var permissions = (user.permissions || []).concat([]).map(function (permission) {
    return { childId: permission.permission._id, state: permission.state };
  });

  delete user.permissions;
  delete user.groups;

  var promises = [];
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/register', { user: user, registerType: 'Invite' }).then(function (result) {
    user = result.data;
    if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(groups)) {
      promises.push(__WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.addManyGroups(user._id, groups));
    }
    if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(permissions)) {
      promises.push(__WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.addManyPermissions(user._id, permissions));
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
  }).catch(function (error) {
    console.error('authService.inviteUser-error:\n', error);
    throw error;
  });
};

internals.sendActivationEmail = function (email) {
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/register/send-activation-email', { email: email }).catch(function (error) {
    console.error('authService.sendActivationEmail-error:\n', error);
    throw error;
  });
};

internals.sendResetLink = function (email) {
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/login/forgot', { email: email }).catch(function (error) {
    console.error('authService.sendResetLink-error:\n', error);
    throw error;
  });
};

internals.resetPassword = function (token, password) {
  console.log('reset', token);
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/login/reset', { token: token, password: password }).catch(function (error) {
    console.error('authService.resetPassword-error:\n', error);
    throw error;
  });
};

internals.activateAccount = function (token) {
  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* httpClient */].post('/register/activate', { token: token }).catch(function (error) {
    console.error('authService.activateAccount-error:\n', error);
    throw error;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);


var internals = {};

internals.getConversationById = function (conversationId) {
  return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].get('/conversation/my', { conversation: conversationId }).then(function (response) {
    return response.data;
  }).catch(function (error) {
    console.error('chatService.getConversationById-error:\n', error);
    throw error;
  });
};

internals.getConversationByUser = function (userId) {
  return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].get('/conversation/my', { user: userId }).then(function (response) {
    return response.data;
  }).catch(function (error) {
    console.error('chatService.getConversationByContacts-error:\n', error);
    throw error;
  });
};

internals.getConversations = function () {
  return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].get('/conversations/my').then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('chatService.getConversations-error:\n', error);
    throw error;
  });
};

internals.markAsRead = function (conversationId) {
  return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].put('/conversation/' + conversationId + '/read').then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('chatService.markAsRead-error:\n', error);
    throw error;
  });
};

internals.markAsUnread = function (conversationId) {
  return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].put('/conversation/' + conversationId + '/unread').then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('chatService.markAsUnread-error:\n', error);
    throw error;
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = (internals);

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);




var internals = {};

internals.addDevice = function (device) {
    device = function (_ref) {
        var brand = _ref.brand,
            deviceModel = _ref.deviceModel,
            imei = _ref.imei,
            connectionId = _ref.connectionId,
            deviceId = _ref.deviceId,
            status = _ref.status,
            dateAdded = _ref.dateAdded,
            deviceDescription = _ref.deviceDescription;

        return {
            brand: brand,
            deviceModel: deviceModel,
            imei: imei,
            connectionId: connectionId,
            deviceId: deviceId,
            status: status,
            dateAdded: dateAdded,
            deviceDescription: deviceDescription
        };
    }(device);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$deviceDataRepository.create(device).then(function (result) {
        device = result.data;
        return device;
    }).catch(function (error) {
        console.error('deviceService.createRole-error:\n', error);
        throw error;
    });
};

internals.updateDevice = function (device) {
    device = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, device);
    device = function (_ref2) {
        var _id = _ref2._id,
            brand = _ref2.brand,
            deviceModel = _ref2.deviceModel,
            imei = _ref2.imei,
            connectionId = _ref2.connectionId,
            deviceId = _ref2.deviceId,
            status = _ref2.status,
            dateAdded = _ref2.dateAdded,
            deviceDescription = _ref2.deviceDescription;

        return {
            _id: _id,
            brand: brand,
            deviceModel: deviceModel,
            imei: imei,
            connectionId: connectionId,
            deviceId: deviceId,
            status: status,
            dateAdded: dateAdded,
            deviceDescription: deviceDescription
        };
    }(device);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$deviceDataRepository.update(device._id, device).then(function (result) {
        device = result.data;
        return device;
    }).catch(function (error) {
        console.error('deviceUpdate.update-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);




var internals = {};

internals.addDriver = function (driver) {
  driver = function (_ref) {
    var driverName = _ref.driverName,
        driverLastName = _ref.driverLastName,
        mobileNumber = _ref.mobileNumber,
        dateOfBirth = _ref.dateOfBirth,
        languageKnown = _ref.languageKnown,
        defaultLanguage = _ref.defaultLanguage,
        lisenceNumber = _ref.lisenceNumber,
        status = _ref.status,
        addressDetails = _ref.addressDetails,
        driverPin = _ref.driverPin,
        photo = _ref.photo,
        licenseExpiryDate = _ref.licenseExpiryDate,
        region = _ref.region,
        documents = _ref.documents,
        driverImage = _ref.driverImage,
        _id = _ref._id,
        DDTNumber = _ref.DDTNumber,
        hazNumber = _ref.hazNumber,
        ddtExpiryDate = _ref.ddtExpiryDate,
        hazExpiryDate = _ref.hazExpiryDate;

    return {
      driverName: driverName,
      driverLastName: driverLastName,
      mobileNumber: mobileNumber,
      dateOfBirth: dateOfBirth,

      languageKnown: languageKnown,
      defaultLanguage: defaultLanguage,

      status: status,
      lisenceNumber: lisenceNumber,
      addressDetails: addressDetails,
      driverPin: driverPin,
      photo: photo,
      licenseExpiryDate: licenseExpiryDate,
      region: region,
      documents: documents,
      driverImage: driverImage,

      _id: _id,
      DDTNumber: DDTNumber,
      hazNumber: hazNumber,
      ddtExpiryDate: ddtExpiryDate,
      hazExpiryDate: hazExpiryDate
    };
  }(driver);

  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$driverDataRepository.create(driver).then(function (result) {
    driver = result.data;
    return driver;
  }).catch(function (error) {
    console.error('deviceService.createRole-error:\n', error);
    throw error;
  });
};

internals.updateDriver = function (driver) {
  driver = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, driver);

  driver = function (_ref2) {
    var driverName = _ref2.driverName,
        driverLastName = _ref2.driverLastName,
        mobileNumber = _ref2.mobileNumber,
        dateOfBirth = _ref2.dateOfBirth,
        languageKnown = _ref2.languageKnown,
        defaultLanguage = _ref2.defaultLanguage,
        lisenceNumber = _ref2.lisenceNumber,
        status = _ref2.status,
        addressDetails = _ref2.addressDetails,
        driverPin = _ref2.driverPin,
        photo = _ref2.photo,
        licenseExpiryDate = _ref2.licenseExpiryDate,
        region = _ref2.region,
        documents = _ref2.documents,
        _id = _ref2._id,
        DDTNumber = _ref2.DDTNumber,
        hazNumber = _ref2.hazNumber,
        ddtExpiryDate = _ref2.ddtExpiryDate,
        hazExpiryDate = _ref2.hazExpiryDate;

    return {
      driverName: driverName,
      driverLastName: driverLastName,
      mobileNumber: mobileNumber,
      dateOfBirth: dateOfBirth,

      languageKnown: languageKnown,
      defaultLanguage: defaultLanguage,
      status: status,
      lisenceNumber: lisenceNumber,
      addressDetails: addressDetails,
      driverPin: driverPin,
      photo: photo,
      licenseExpiryDate: licenseExpiryDate,
      region: region,
      documents: documents,

      _id: _id,

      DDTNumber: DDTNumber,
      hazNumber: hazNumber,
      ddtExpiryDate: ddtExpiryDate,
      hazExpiryDate: hazExpiryDate
    };
  }(driver);
  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$driverDataRepository.update(driver._id, driver).then(function (result) {
    driver = result.data;
    return driver;
  }).catch(function (error) {
    console.error('driverUpdate.update-error:\n', error);
    throw error;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);


var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (eventBus);

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);




var internals = {};

internals.exportData = function (modelName) {
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].get('/v1/exportMaster?model=' + modelName).then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = (internals);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(3);


var internals = {};

internals.uploadProfileImage = function (name, file, options) {
	var data = new FormData();
	data.append('name', name);
	data.append('file', file);
	return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].post('/file/upload/profile-image', data, options);
};

internals.uploadImage = function (name, file, options) {
	var data = new FormData();
	data.append('name', name);
	data.append('file', file);
	return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* httpClient */].post('/file/upload/image', data, options);
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 536:
/***/ (function(module, exports) {



/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);



var internals = {};

internals.updateTrip = function (docId, prevDestination, divertedDestination) {
    var ss = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref(docId + '/').set({
        prev_destination: prevDestination,
        next_destination: divertedDestination
    });
    console.log("SSSSSS", ss);
};

/* unused harmony default export */ var _unused_webpack_default_export = (internals);

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_index__ = __webpack_require__(1);





var internals = {};

internals.minlengthValidator = function (input, minlength) {
	return input.length >= minlength;
};

internals.emailValidator = function (email) {
	return __WEBPACK_IMPORTED_MODULE_1_validator___default.a.isEmail(email);
};

internals.emailUniqueValidator = function (email, originalEmail) {
	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		if (email === originalEmail) {
			resolve(true);
		} else {
			__WEBPACK_IMPORTED_MODULE_2__index__["a" /* httpClient */].post(__WEBPACK_IMPORTED_MODULE_3__config_index__["c" /* API */].USER + '/check-email', { email: email }).then(function (result) {
				resolve(!result.data);
			}).catch(function (error) {
				console.error('formService.emailUniqueValidator-error:\n', error);
				reject(error);
			});
		}
	});
};

internals.passwordScoreValidator = function (passwordScore) {
	return passwordScore >= __WEBPACK_IMPORTED_MODULE_3__config_index__["f" /* REQUIRED_PASSWORD_STRENGTH */];
};

internals.passwordConfirmValidator = function (newPassword, confirmPassword) {
	return newPassword === confirmPassword;
};

internals.fieldClassName = function (field) {
	if (!field) {
		return '';
	}
	if ((field.$touched || field.$submitted) && field.$valid) {
		return ['has-success', 'has-feedback'];
	}
	if ((field.$touched || field.$submitted) && field.$invalid) {
		return ['has-error', 'has-feedback'];
	}
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);





var internals = {};

internals.get = function (url, params, options) {
	var config = {
		method: 'GET',
		url: url,
		params: params
	};
	config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config, options);
	return __WEBPACK_IMPORTED_MODULE_2_axios___default()(config).then(function (response) {
		if (response.headers['x-access-token']) {
			internals.updateTokens(response.headers);
		}
		return response;
	}).catch(function (error) {
		if (error === __WEBPACK_IMPORTED_MODULE_3__config__["e" /* RESPONSE_MESSAGES */].EXPIRED_ACCESS_TOKEN) {
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/useRefreshToken');
			return internals.get(url, params, options);
		} else {
			throw error;
		}
	});
};

internals.put = function (url, payload, options) {
	var config = {
		method: 'PUT',
		url: url,
		data: payload
	};
	config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config, options);
	return __WEBPACK_IMPORTED_MODULE_2_axios___default()(config).then(function (response) {
		if (response.headers['x-access-token']) {
			internals.updateTokens(response.headers);
		}
		return response;
	}).catch(function (error) {
		if (error === __WEBPACK_IMPORTED_MODULE_3__config__["e" /* RESPONSE_MESSAGES */].EXPIRED_ACCESS_TOKEN) {
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/useRefreshToken');
			return internals.put(url, payload, options);
		} else {
			throw error;
		}
	});
};

internals.post = function (url, payload, options) {
	var config = {
		method: 'POST',
		url: url,
		data: payload
	};
	config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config, options);
	return __WEBPACK_IMPORTED_MODULE_2_axios___default()(config).then(function (response) {
		if (response.headers['x-access-token']) {
			internals.updateTokens(response.headers);
		}
		return response;
	}).catch(function (error) {
		if (error === __WEBPACK_IMPORTED_MODULE_3__config__["e" /* RESPONSE_MESSAGES */].EXPIRED_ACCESS_TOKEN) {
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/useRefreshToken');
			return internals.post(url, payload, options);
		} else {
			throw error;
		}
	});
};

internals.delete = function (url, payload, options) {
	var config = {
		method: 'DELETE',
		url: url,
		data: payload
	};
	config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(config, options);
	return __WEBPACK_IMPORTED_MODULE_2_axios___default()(config).then(function (response) {
		if (response.headers['x-access-token']) {
			internals.updateTokens(response.headers);
		}
		return response;
	}).catch(function (error) {
		if (error === __WEBPACK_IMPORTED_MODULE_3__config__["e" /* RESPONSE_MESSAGES */].EXPIRED_ACCESS_TOKEN) {
			__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/useRefreshToken');
			return internals.delete(url, payload, options);
		} else {
			throw error;
		}
	});
};

internals.updateTokens = function (headers) {
	var tokens = {
		accessToken: headers['x-access-token'],
		refreshToken: headers['x-refresh-token']
	};
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/updateTokens', tokens);
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);




var internals = {};

internals.getTotalAmountAll = function (modelName) {
    return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].get('/total/portfolio').then(function (response) {
        return response;
    }).catch(function (error) {
        console.error('authService.login-error:\n', error);
        throw error;
    });
};
internals.getListPnLAll = function (id) {
    return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].get('/investor/history?id=' + id).then(function (response) {
        return response;
    }).catch(function (error) {
        console.error('authService.login-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);




var internals = {};

internals.addRegion = function (region) {
    region = function (_ref) {
        var name = _ref.name,
            status = _ref.status,
            regionManager = _ref.regionManager,
            journeyManager = _ref.journeyManager,
            jmaUser = _ref.jmaUser,
            regionCode = _ref.regionCode;

        return {
            name: name,
            status: status,
            regionManager: regionManager,
            journeyManager: journeyManager,
            jmaUser: jmaUser,
            regionCode: regionCode
        };
    }(region);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$regionDataRepository.create(region).then(function (result) {
        region = result.data;
        return region;
    }).catch(function (error) {
        console.error('regionService.createRegion-error:\n', error);
        throw error;
    });
};

internals.updateRegion = function (region) {
    region = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, region);
    region = function (_ref2) {
        var _id = _ref2._id,
            name = _ref2.name,
            status = _ref2.status,
            regionManager = _ref2.regionManager,
            journeyManager = _ref2.journeyManager,
            jmaUser = _ref2.jmaUser,
            regionCode = _ref2.regionCode;

        return {
            _id: _id,
            name: name,
            status: status,
            regionManager: regionManager,
            journeyManager: journeyManager,
            jmaUser: jmaUser,
            regionCode: regionCode
        };
    }(region);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$regionDataRepository.update(region._id, region).then(function (result) {
        region = result.data;
        return region;
    }).catch(function (error) {
        console.error('regionUpdate.update-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(12);


var internals = {};

internals.addReport = function (reportgeneration) {
    reportgeneration = function (_ref) {
        var reportType = _ref.reportType,
            downloadType = _ref.downloadType,
            startDate = _ref.startDate,
            endDate = _ref.endDate,
            gaManager = _ref.gaManager,
            station = _ref.station,
            region = _ref.region,
            generatedBy = _ref.generatedBy,
            vehicleId = _ref.vehicleId,
            allVehicle = _ref.allVehicle;

        return { reportType: reportType, downloadType: downloadType, startDate: startDate, endDate: endDate, gaManager: gaManager, station: station, region: region, generatedBy: generatedBy, vehicleId: vehicleId, allVehicle: allVehicle };
    }(reportgeneration);

    return __WEBPACK_IMPORTED_MODULE_0__main__["default"].$reportgenerationDataRepository.create(reportgeneration).then(function (result) {
        reportgeneration = result.data;
        return reportgeneration;
    }).catch(function (error) {
        console.error('reportgenerationService.createRegion-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(12);






var internals = {};

internals.createRole = function (role) {
    role = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, role);

    var permissions = (role.permissions || []).concat([]).map(function (permission) {
        return { childId: permission.permission._id, state: permission.state };
    });

    var promises = [];
    return __WEBPACK_IMPORTED_MODULE_3__main__["default"].$roleRepository.create(role).then(function (result) {
        role = result.data;
        if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(permissions)) {
            promises.push(__WEBPACK_IMPORTED_MODULE_3__main__["default"].$roleRepository.addManyPermissions(role._id, permissions));
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
    }).catch(function (error) {
        console.error('roleService.createRole-error:\n', error);
        throw error;
    });
};

internals.updateRole = function (newRole, oldRole) {
    newRole = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newRole);
    oldRole = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, oldRole);

    var newPermissions = (newRole.permissions || []).concat([]);
    var oldPermissions = (oldRole.permissions || []).concat([]);

    delete newRole.permissions;

    var promises = [];
    promises.push(__WEBPACK_IMPORTED_MODULE_3__main__["default"].$roleRepository.update(newRole._id, newRole));
    promises.push(internals.updateRolePermissions(newRole._id, newPermissions, oldPermissions));

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
};

internals.updateRolePermissions = function (roleId, newPermissions, oldPermissions) {
    var permissionsToAdd = newPermissions.filter(function (newPermission) {
        return !oldPermissions.find(function (oldPermission) {
            return oldPermission.permission._id === newPermission.permission._id && oldPermission.state === newPermission.state;
        });
    }).map(function (permission) {
        return { childId: permission.permission._id, state: permission.state };
    });

    var permissionsToRemove = oldPermissions.filter(function (oldPermission) {
        return !newPermissions.find(function (newPermission) {
            return oldPermission.permission._id === newPermission.permission._id && oldPermission.state === newPermission.state;
        });
    }).map(function (permission) {
        return permission.permission._id;
    });

    var promise = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(permissionsToAdd) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_3__main__["default"].$roleRepository.addManyPermissions(roleId, permissionsToAdd);

    return promise.then(function () {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(permissionsToRemove) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_3__main__["default"].$roleRepository.removeManyPermissions(roleId, permissionsToRemove);
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);



var internals = {};

internals.addsalesdata = function (salesdata) {
    salesdata = function (_ref) {
        var region = _ref.region,
            site = _ref.site,
            totalValue = _ref.totalValue,
            dispenserData = _ref.dispenserData,
            reportedDate = _ref.reportedDate,
            _id = _ref._id;

        return {
            region: region,
            site: site,
            totalValue: totalValue,
            dispenserData: dispenserData,
            reportedDate: reportedDate,
            _id: _id
        };
    }(salesdata);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$salesdataDataRepository.create(salesdata).then(function (result) {
        salesdata = result.data;
        return salesdata;
    }).catch(function (error) {
        console.error('salesdataService.createsalesdata-error:\n', error);
        throw error;
    });
};

internals.updatesalesdata = function (salesdata) {
    salesdata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, salesdata);

    salesdata = function (_ref2) {
        var region = _ref2.region,
            site = _ref2.site,
            totalValue = _ref2.totalValue,
            dispenserData = _ref2.dispenserData,
            reportedDate = _ref2.reportedDate,
            _id = _ref2._id;

        return {
            region: region,
            site: site,
            totalValue: totalValue,
            dispenserData: dispenserData,
            reportedDate: reportedDate,
            _id: _id
        };
    }(salesdata);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$salesdataDataRepository.update(salesdata._id, salesdata).then(function (result) {
        salesdata = result.data;
        return salesdata;
    }).catch(function (error) {
        console.error('salesdataUpdate.update-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);



var internals = {};

internals.addReport = function (schedulereport) {
    schedulereport = function (_ref) {
        var reportType = _ref.reportType,
            reportFrequency = _ref.reportFrequency,
            scheduleStartDate = _ref.scheduleStartDate,
            scheduleEndDate = _ref.scheduleEndDate,
            scheduleDay = _ref.scheduleDay,
            station = _ref.station,
            region = _ref.region,
            generatedBy = _ref.generatedBy,
            emailTo = _ref.emailTo,
            emailCc = _ref.emailCc,
            reportGenerationTime = _ref.reportGenerationTime,
            status = _ref.status,
            downloadType = _ref.downloadType,
            lastDays = _ref.lastDays,
            vehicleId = _ref.vehicleId,
            allVehicle = _ref.allVehicle;

        return {
            reportType: reportType,
            reportFrequency: reportFrequency,
            scheduleStartDate: scheduleStartDate,
            scheduleEndDate: scheduleEndDate,
            scheduleDay: scheduleDay,
            station: station,
            region: region,
            generatedBy: generatedBy,
            emailTo: emailTo,
            emailCc: emailCc,
            reportGenerationTime: reportGenerationTime,
            status: status,
            downloadType: downloadType,
            lastDays: lastDays,
            vehicleId: vehicleId, allVehicle: allVehicle
        };
    }(schedulereport);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$schedulereportDataRepository.create(schedulereport).then(function (result) {
        schedulereport = result.data;
        return schedulereport;
    }).catch(function (error) {
        console.error('schedulereportService.createRegion-error:\n', error);
        throw error;
    });
};
internals.updateSchedule = function (schedulereport) {
    schedulereport = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, schedulereport);

    schedulereport = function (_ref2) {
        var _id = _ref2._id,
            reportType = _ref2.reportType,
            reportFrequency = _ref2.reportFrequency,
            scheduleStartDate = _ref2.scheduleStartDate,
            scheduleEndDate = _ref2.scheduleEndDate,
            scheduleDay = _ref2.scheduleDay,
            station = _ref2.station,
            region = _ref2.region,
            generatedBy = _ref2.generatedBy,
            emailTo = _ref2.emailTo,
            emailCc = _ref2.emailCc,
            reportGenerationTime = _ref2.reportGenerationTime,
            status = _ref2.status,
            downloadType = _ref2.downloadType,
            lastDays = _ref2.lastDays,
            vehicleId = _ref2.vehicleId,
            allVehicle = _ref2.allVehicle;

        return {
            _id: _id,
            reportType: reportType,
            reportFrequency: reportFrequency,
            scheduleStartDate: scheduleStartDate,
            scheduleEndDate: scheduleEndDate,
            scheduleDay: scheduleDay,
            station: station,
            region: region,
            generatedBy: generatedBy,
            emailTo: emailTo,
            emailCc: emailCc,
            reportGenerationTime: reportGenerationTime,
            status: status,
            downloadType: downloadType,
            lastDays: lastDays,
            vehicleId: vehicleId, allVehicle: allVehicle
        };
    }(schedulereport);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$schedulereportDataRepository.update(schedulereport._id, schedulereport).then(function (result) {
        schedulereport = result.data;
        return schedulereport;
    }).catch(function (error) {
        console.error('schedulereportUpdate.update-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);




var internals = {};

internals.addSite = function (site) {
    site = function (_ref) {
        var _id = _ref._id,
            siteName = _ref.siteName,
            siteCode = _ref.siteCode,
            siteType = _ref.siteType,
            capacity = _ref.capacity,
            latitude = _ref.latitude,
            longitude = _ref.longitude,
            address = _ref.address,
            supervisor = _ref.supervisor,
            ownerName = _ref.ownerName,
            ownerMobile = _ref.ownerMobile,
            ownerEmail = _ref.ownerEmail,
            region = _ref.region,
            ownerAddress = _ref.ownerAddress,
            dateAdded = _ref.dateAdded,
            status = _ref.status,
            dispenserCount = _ref.dispenserCount,
            motherStation = _ref.motherStation,
            siteInfoImage = _ref.siteInfoImage,
            gisId = _ref.gisId,
            deviceId = _ref.deviceId,
            defaultMS = _ref.defaultMS,
            cascadeCapacity = _ref.cascadeCapacity,
            location_tag = _ref.location_tag;

        return {
            _id: _id,
            siteName: siteName,
            siteCode: siteCode,
            siteType: siteType,
            capacity: capacity,
            latitude: latitude,
            longitude: longitude,
            address: address,
            supervisor: supervisor,
            ownerName: ownerName,
            ownerMobile: ownerMobile,
            ownerEmail: ownerEmail,
            region: region,
            ownerAddress: ownerAddress,
            dateAdded: dateAdded,
            status: status,
            dispenserCount: dispenserCount,
            motherStation: motherStation,
            siteInfoImage: siteInfoImage,
            gisId: gisId,
            deviceId: deviceId,
            defaultMS: defaultMS,
            cascadeCapacity: cascadeCapacity,
            location_tag: location_tag
        };
    }(site);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$siteDataRepository.create(site).then(function (result) {
        site = result.data;
        return site;
    }).catch(function (error) {
        console.error('siteService.createRole-error:\n', error);
        throw error;
    });
};

internals.updateSite = function (site) {
    site = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, site);

    site = function (_ref2) {
        var _id = _ref2._id,
            siteName = _ref2.siteName,
            siteCode = _ref2.siteCode,
            siteType = _ref2.siteType,
            capacity = _ref2.capacity,
            latitude = _ref2.latitude,
            longitude = _ref2.longitude,
            address = _ref2.address,
            supervisor = _ref2.supervisor,
            ownerName = _ref2.ownerName,
            ownerMobile = _ref2.ownerMobile,
            ownerEmail = _ref2.ownerEmail,
            region = _ref2.region,
            ownerAddress = _ref2.ownerAddress,
            dateAdded = _ref2.dateAdded,
            status = _ref2.status,
            dispenserCount = _ref2.dispenserCount,
            motherStation = _ref2.motherStation,
            siteInfoImage = _ref2.siteInfoImage,
            gisId = _ref2.gisId,
            deviceId = _ref2.deviceId,
            defaultMS = _ref2.defaultMS,
            cascadeCapacity = _ref2.cascadeCapacity,
            location_tag = _ref2.location_tag;

        return {
            _id: _id,
            siteName: siteName,
            siteCode: siteCode,
            siteType: siteType,
            capacity: capacity,
            latitude: latitude,
            longitude: longitude,
            address: address,
            supervisor: supervisor,
            ownerName: ownerName,
            ownerMobile: ownerMobile,
            ownerEmail: ownerEmail,
            region: region,
            ownerAddress: ownerAddress,
            dateAdded: dateAdded,
            status: status,
            dispenserCount: dispenserCount,
            motherStation: motherStation,
            siteInfoImage: siteInfoImage,
            gisId: gisId,
            deviceId: deviceId,
            defaultMS: defaultMS,
            cascadeCapacity: cascadeCapacity,
            location_tag: location_tag
        };
    }(site);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$siteDataRepository.update(site._id, site).then(function (result) {
        site = result.data;
        return site;
    }).catch(function (error) {
        console.error('siteUpdate.update-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);




var internals = {};

internals.addTechnician = function (technician) {
    technician = function (_ref) {
        var name = _ref.name,
            mobileNumber = _ref.mobileNumber,
            dateOfBirth = _ref.dateOfBirth,
            manager = _ref.manager,
            languageKnown = _ref.languageKnown,
            defaultLanguage = _ref.defaultLanguage,
            status = _ref.status,
            addressDetails = _ref.addressDetails,
            userPin = _ref.userPin,
            region = _ref.region,
            deviceId = _ref.deviceId,
            _id = _ref._id,
            site = _ref.site,
            userType = _ref.userType;

        return {
            name: name,
            mobileNumber: mobileNumber,
            dateOfBirth: dateOfBirth,
            manager: manager,
            languageKnown: languageKnown,
            defaultLanguage: defaultLanguage,
            status: status,
            addressDetails: addressDetails,
            userPin: userPin,
            region: region,
            deviceId: deviceId,
            _id: _id,
            site: site,
            userType: userType
        };
    }(technician);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$tempuserDataRepository.create(technician).then(function (result) {
        technician = result.data;
        return technician;
    }).catch(function (error) {
        console.error('technicianService.createRole-error:\n', error);
        throw error;
    });
};

internals.updateTechnician = function (technician) {
    technician = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, technician);

    technician = function (_ref2) {
        var name = _ref2.name,
            mobileNumber = _ref2.mobileNumber,
            dateOfBirth = _ref2.dateOfBirth,
            manager = _ref2.manager,
            languageKnown = _ref2.languageKnown,
            defaultLanguage = _ref2.defaultLanguage,
            status = _ref2.status,
            addressDetails = _ref2.addressDetails,
            userPin = _ref2.userPin,
            region = _ref2.region,
            deviceId = _ref2.deviceId,
            _id = _ref2._id,
            site = _ref2.site,
            userType = _ref2.userType;

        return {
            name: name,
            mobileNumber: mobileNumber,
            dateOfBirth: dateOfBirth,
            manager: manager,
            languageKnown: languageKnown,
            defaultLanguage: defaultLanguage,
            status: status,
            addressDetails: addressDetails,
            userPin: userPin,
            region: region,
            deviceId: deviceId,
            _id: _id,
            site: site,
            userType: userType
        };
    }(technician);
    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$tempuserDataRepository.update(technician._id, technician).then(function (result) {
        technician = result.data;
        return technician;
    }).catch(function (error) {
        console.error('technicianUpdate.update-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);





var internals = {};

internals.addTrip = function (trip) {
  trip = function (_ref) {
    var driverId = _ref.driverId,
        deviceId = _ref.deviceId,
        vehicleId = _ref.vehicleId,
        _id = _ref._id,
        routeName = _ref.routeName,
        scheduleDate = _ref.scheduleDate,
        returnTrip = _ref.returnTrip,
        routeId = _ref.routeId,
        status = _ref.status,
        startSite = _ref.startSite,
        endSite = _ref.endSite,
        regionManager = _ref.regionManager,
        scheduleTime = _ref.scheduleTime,
        journeyManager = _ref.journeyManager,
        subTrips = _ref.subTrips;

    return {
      driverId: driverId,
      deviceId: deviceId,
      vehicleId: vehicleId,
      _id: _id,
      routeName: routeName,
      scheduleDate: scheduleDate,
      returnTrip: returnTrip,
      routeId: routeId,
      status: status,
      startSite: startSite,
      endSite: endSite,
      regionManager: regionManager,
      scheduleTime: scheduleTime,
      journeyManager: journeyManager,
      subTrips: subTrips
    };
  }(trip);

  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$tripDataRepository.create(trip).then(function (result) {
    trip = result.data;
    return trip;
  }).catch(function (error) {
    console.error('tripService.createTrip-error:\n', error);
    throw error;
  });
};

internals.updateTrip = function (trip) {
  console.log('trip at sercibchj', trip);
  trip = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, trip);

  trip = function (_ref2) {
    var driverId = _ref2.driverId,
        deviceId = _ref2.deviceId,
        vehicleId = _ref2.vehicleId,
        _id = _ref2._id,
        routeName = _ref2.routeName,
        scheduleDate = _ref2.scheduleDate,
        originReachedAt = _ref2.originReachedAt,
        startDate = _ref2.startDate,
        destinationReachedAt = _ref2.destinationReachedAt,
        returnTrip = _ref2.returnTrip,
        routeId = _ref2.routeId,
        status = _ref2.status,
        startSite = _ref2.startSite,
        endSite = _ref2.endSite,
        regionManager = _ref2.regionManager,
        scheduleTime = _ref2.scheduleTime,
        journeyManager = _ref2.journeyManager,
        endDate = _ref2.endDate;

    return {
      driverId: driverId,
      deviceId: deviceId,
      vehicleId: vehicleId,
      _id: _id,
      routeName: routeName,
      scheduleDate: scheduleDate,
      returnTrip: returnTrip,
      routeId: routeId,
      status: status,
      startSite: startSite,
      endSite: endSite,
      regionManager: regionManager,
      scheduleTime: scheduleTime,
      journeyManager: journeyManager,
      endDate: endDate,
      originReachedAt: originReachedAt,
      startDate: startDate,
      destinationReachedAt: destinationReachedAt
    };
  }(trip);

  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$tripDataRepository.update(trip._id, trip).then(function (result) {
    trip = result.data;
    return trip;
  }).catch(function (error) {
    console.error('tripUpdate.update-error:\n', error);
    throw error;
  });
};

internals.tripGroupAdd = function (trip) {
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].post('v1/createTripGroup', trip).then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

internals.tripGroupDelete = function (trip) {
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].delete('v1/deleteTripgroup?groupTripId=' + trip).then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

internals.tripGroupDriverDetails = function (trip) {
  return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].get('v1/group/trip/drivers?tripId=' + trip).then(function (response) {
    return response;
  }).catch(function (error) {
    console.error('authService.login-error:\n', error);
    throw error;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(12);


var internals = {};

internals.addtripException = function (tripException) {

    tripException = function (_ref) {
        var docId = _ref.docId,
            prevDestination = _ref.prevDestination,
            divertedDestination = _ref.divertedDestination,
            recordedTime = _ref.recordedTime,
            _id = _ref._id;

        return {
            docId: docId,
            prevDestination: prevDestination,
            divertedDestination: divertedDestination,
            recordedTime: recordedTime,
            _id: _id
        };
    }(tripException);

    return __WEBPACK_IMPORTED_MODULE_0__main__["default"].$tripExceptionDataRepository.create(tripException).then(function (result) {
        tripException = result.data;
        return tripException;
    }).catch(function (error) {
        console.error('tripExceptionService.createTripException-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);





var internals = {};

internals.addtripRoute = function (tripRoute) {
    tripRoute = function (_ref) {
        var _id = _ref._id,
            name = _ref.name,
            approxDistance = _ref.approxDistance,
            approxTime = _ref.approxTime,
            status = _ref.status,
            startSite = _ref.startSite,
            endSite = _ref.endSite,
            routeMarkers = _ref.routeMarkers,
            region = _ref.region,
            reportAssessment = _ref.reportAssessment;

        return {
            _id: _id,
            name: name,
            approxDistance: approxDistance,
            approxTime: approxTime,
            status: status,
            startSite: startSite,
            endSite: endSite,
            routeMarkers: routeMarkers,
            region: region,
            reportAssessment: reportAssessment
        };
    }(tripRoute);

    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$tripCreateRouteDataRepository.create(tripRoute).then(function (result) {
        tripRoute = result.data;
        return tripRoute;
    }).catch(function (error) {
        console.error('tripRouteService.createtripRoute-error:\n', error);
        throw error;
    });
};

internals.updatetripRoute = function (tripRoute) {
    tripRoute = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, tripRoute);
    tripRoute = function (_ref2) {
        var _id = _ref2._id,
            name = _ref2.name,
            approxDistance = _ref2.approxDistance,
            approxTime = _ref2.approxTime,
            status = _ref2.status,
            startSite = _ref2.startSite,
            endSite = _ref2.endSite,
            routeMarkers = _ref2.routeMarkers,
            region = _ref2.region,
            reportAssessment = _ref2.reportAssessment;

        return {
            _id: _id,
            name: name,
            approxDistance: approxDistance,
            approxTime: approxTime,
            status: status,
            startSite: startSite,
            endSite: endSite,
            routeMarkers: routeMarkers,
            region: region,
            reportAssessment: reportAssessment
        };
    }(tripRoute);
    return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$triprouteDataRepository.update(tripRoute._id, tripRoute).then(function (result) {
        tripRoute = result.data;
        return tripRoute;
    }).catch(function (error) {
        console.error('tripRouteUpdate.update-error:\n', error);
        throw error;
    });
};

internals.updatesubTripRouteDetails = function (subTripDetails) {
    return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].put('/v1/update/group/trip/subtrip?groupTripId=' + subTripDetails._id, {
        subtrips: subTripDetails.subtrips
    }).then(function (response) {
        return response;
    }).catch(function (error) {
        console.error('authService.login-error:\n', error);
        throw error;
    });
};

internals.updatetripRouteDetails = function (trip) {

    return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* httpClient */].put('v1/updateGroupTrip?groupTripId=' + trip._id, {

        driverId: trip.driverId,
        status: trip.status,
        scheduleTime: trip.scheduleTime,
        deviceId: trip.deviceId,
        journeyManager: trip.journeyManager,
        regionManager: trip.regionManager,
        scheduleDate: trip.scheduleDate,
        geographical_area: trip.geographical_area,
        vehicleId: trip.vehicleId
    }).then(function (result) {
        trip = result.data;
        return result;
    }).catch(function (error) {
        console.error('update group Trip-error:\n', error);
        throw error;
    });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__(3);









var internals = {};

internals.updateUser = function (newUser, oldUser) {
    newUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, newUser);
    oldUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, oldUser);
    newUser.role = newUser.role._id;

    newUser = function (_ref) {
        var email = _ref.email,
            firstName = _ref.firstName,
            lastName = _ref.lastName,
            role = _ref.role,
            groups = _ref.groups,
            permissions = _ref.permissions,
            rank = _ref.rank,
            invested_amount = _ref.invested_amount,
            startDate = _ref.startDate,
            withdrawl_amount = _ref.withdrawl_amount;

        return { email: email, firstName: firstName, lastName: lastName, role: role, groups: groups, permissions: permissions, rank: rank, invested_amount: invested_amount, startDate: startDate, withdrawl_amount: withdrawl_amount };
    }(newUser);

    var newGroups = (newUser.groups || []).concat([]);
    var oldGroups = (oldUser.groups || []).concat([]);
    var newPermissions = (newUser.permissions || []).concat([]);
    var oldPermissions = (oldUser.permissions || []).concat([]);

    delete newUser.permissions;
    delete newUser.groups;

    var promises = [];
    promises.push(__WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.update(oldUser._id, newUser));
    promises.push(internals.updateUserGroups(oldUser._id, newGroups, oldGroups));
    promises.push(internals.updateUserPermissions(oldUser._id, newPermissions, oldPermissions));

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);
};

internals.updateUserGroups = function (userId, newGroups, oldGroups) {
    var groupsToAdd = newGroups.filter(function (newGroup) {
        return !oldGroups.find(function (oldGroup) {
            return oldGroup.group._id === newGroup.group._id;
        });
    }).map(function (group) {
        return group.group._id;
    });

    var groupsToRemove = oldGroups.filter(function (oldGroup) {
        return !newGroups.find(function (newGroup) {
            return oldGroup.group._id === newGroup.group._id;
        });
    }).map(function (group) {
        return group.group._id;
    });

    var promise = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(groupsToAdd) ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.addManyGroups(userId, groupsToAdd);

    return promise.then(function () {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(groupsToRemove) ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.removeManyGroups(userId, groupsToRemove);
    });
};

internals.updateUserPermissions = function (userId, newPermissions, oldPermissions) {
    var permissionsToAdd = newPermissions.filter(function (newPermission) {
        return !oldPermissions.find(function (oldPermission) {
            return oldPermission.permission._id === newPermission.permission._id && oldPermission.state === newPermission.state;
        });
    }).map(function (permission) {
        return { childId: permission.permission._id, state: permission.state };
    });

    var permissionsToRemove = oldPermissions.filter(function (oldPermission) {
        return !newPermissions.find(function (newPermission) {
            return oldPermission.permission._id === newPermission.permission._id;
        });
    }).map(function (permission) {
        return permission.permission._id;
    });

    var promise = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(permissionsToAdd) ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.addManyPermissions(userId, permissionsToAdd);

    return promise.then(function () {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(permissionsToRemove) ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_4__main__["default"].$userRepository.removeManyPermissions(userId, permissionsToRemove);
    });
};

internals.getAvailablePermissions = function (query) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].get(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].PERMISSION + '/available', query);
};

internals.updateUserProfile = function (profile) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/my/profile', { profile: profile });
};

internals.deleteCurrentAccount = function () {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].delete(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/my');
};

internals.updateUserPassword = function (password) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/my/password', { password: password });
};

internals.updateUserPIN = function (pin) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/my/pin', { pin: pin });
};

internals.checkPassword = function (password, userInputs) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].post(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/check-password', { password: password });
};

internals.getUserScope = function (userId) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].get(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/' + userId + '/scope');
};

internals.disableUser = function (userId) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/' + userId + '/disable');
};

internals.enableUser = function (userId) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/' + userId + '/enable');
};

internals.activateUser = function (userId) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/' + userId + '/activate');
};

internals.deactivateUser = function (userId) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].put(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/' + userId + '/deactivate');
};

internals.getConnectionStats = function (userId) {
    return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* httpClient */].get(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* API */].USER + '/' + userId + '/connection-stats');
};

internals.getEffectivePermissions = function (role, groups, permissions) {
    var effectivePermissions = role.permissions.concat([]);

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(groups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var group = _step.value;

            var _loop2 = function _loop2(groupPermission) {
                var matchIndex = -1;
                effectivePermissions.find(function (permission, index) {
                    if (permission.permission._id === groupPermission.permission._id) {
                        matchIndex = index;
                        return true;
                    }
                });

                if (matchIndex > -1) {
                    effectivePermissions[matchIndex] = groupPermission;
                } else {
                    effectivePermissions.push(groupPermission);
                }
            };

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(group.group.permissions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var groupPermission = _step3.value;

                    _loop2(groupPermission);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _loop = function _loop(userPermission) {
        var matchIndex = -1;
        effectivePermissions.find(function (permission, index) {
            if (permission.permission._id === userPermission.permission._id) {
                matchIndex = index;
                return true;
            }
        });

        if (matchIndex > -1) {
            effectivePermissions[matchIndex] = userPermission;
        } else {
            effectivePermissions.push(userPermission);
        }
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(permissions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var userPermission = _step2.value;

            _loop(userPermission);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return effectivePermissions;
};

internals.getSpecificScope = function (user) {
    var scope = [];
    scope.push('user-' + user._id);
    return scope;
};

internals.computeUserScope = function (user) {
    var effectivePermissions = internals.getEffectivePermissions(user.role, user.groups, user.permissions);

    var computedScope = [];
    computedScope.push(user.role.name);
    computedScope = computedScope.concat(user.groups.map(function (group) {
        return group.group.name;
    }));

    computedScope = computedScope.concat(effectivePermissions.map(function (permission) {
        switch (permission.state) {
            case __WEBPACK_IMPORTED_MODULE_5__config__["d" /* PERMISSION_STATES */].INCLUDED:
                return permission.permission.name;
            case __WEBPACK_IMPORTED_MODULE_5__config__["d" /* PERMISSION_STATES */].EXCLUDED:
                return;
            case __WEBPACK_IMPORTED_MODULE_5__config__["d" /* PERMISSION_STATES */].FORBIDDEN:
                return '-' + permission.permission.name;
        }
    }).filter(Boolean));

    var specificScope = internals.getSpecificScope(user);

    computedScope = computedScope.concat(specificScope);

    return computedScope;
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(12);




var internals = {};

internals.addVehicle = function (vehicle) {
  vehicle = function (_ref) {
    var regNo = _ref.regNo,
        capacity = _ref.capacity,
        dateCommissioning = _ref.dateCommissioning,
        status = _ref.status,
        ownerName = _ref.ownerName,
        ownerContact = _ref.ownerContact,
        billingInfo = _ref.billingInfo,
        camera = _ref.camera,
        cgpsMonitoring = _ref.cgpsMonitoring,
        permitDetails = _ref.permitDetails,
        region = _ref.region,
        otherInfo = _ref.otherInfo,
        ownerDetails = _ref.ownerDetails,
        driverName = _ref.driverName,
        _id = _ref._id,
        transportSupervisorName = _ref.transportSupervisorName,
        transportSupervisorContact = _ref.transportSupervisorContact,
        rcDoc = _ref.rcDoc,
        insuranceDoc = _ref.insuranceDoc,
        pucDoc = _ref.pucDoc,
        fitCertDoc = _ref.fitCertDoc,
        gcpDoc = _ref.gcpDoc,
        rcValidity = _ref.rcValidity,
        insuranceValidity = _ref.insuranceValidity,
        pucValidity = _ref.pucValidity,
        fitCertValidity = _ref.fitCertValidity,
        gcpValidity = _ref.gcpValidity,
        deviceId = _ref.deviceId,
        cylinders = _ref.cylinders;

    return {
      regNo: regNo,
      capacity: capacity,
      dateCommissioning: dateCommissioning,
      status: status,
      ownerName: ownerName,
      ownerContact: ownerContact,
      billingInfo: billingInfo,
      camera: camera,
      cgpsMonitoring: cgpsMonitoring,
      permitDetails: permitDetails,
      region: region,
      otherInfo: otherInfo,
      ownerDetails: ownerDetails,
      driverName: driverName,
      _id: _id,
      transportSupervisorName: transportSupervisorName,
      transportSupervisorContact: transportSupervisorContact,
      rcDoc: rcDoc,
      insuranceDoc: insuranceDoc,
      pucDoc: pucDoc,
      fitCertDoc: fitCertDoc,
      gcpDoc: gcpDoc,
      rcValidity: rcValidity,
      insuranceValidity: insuranceValidity,
      pucValidity: pucValidity,
      fitCertValidity: fitCertValidity,
      gcpValidity: gcpValidity,
      deviceId: deviceId,
      cylinders: cylinders

    };
  }(vehicle);

  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$vehicleDataRepository.create(vehicle).then(function (result) {
    vehicle = result.data;
    return vehicle;
  }).catch(function (error) {
    console.error('vehicleService.createRegion-error:\n', error);
    throw error;
  });
};

internals.updateVehicle = function (vehicle) {
  vehicle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, vehicle);
  vehicle = function (_ref2) {
    var regNo = _ref2.regNo,
        capacity = _ref2.capacity,
        dateCommissioning = _ref2.dateCommissioning,
        status = _ref2.status,
        ownerName = _ref2.ownerName,
        ownerContact = _ref2.ownerContact,
        billingInfo = _ref2.billingInfo,
        camera = _ref2.camera,
        cgpsMonitoring = _ref2.cgpsMonitoring,
        permitDetails = _ref2.permitDetails,
        region = _ref2.region,
        otherInfo = _ref2.otherInfo,
        ownerDetails = _ref2.ownerDetails,
        driverName = _ref2.driverName,
        _id = _ref2._id,
        transportSupervisorName = _ref2.transportSupervisorName,
        transportSupervisorContact = _ref2.transportSupervisorContact,
        rcDoc = _ref2.rcDoc,
        insuranceDoc = _ref2.insuranceDoc,
        pucDoc = _ref2.pucDoc,
        fitCertDoc = _ref2.fitCertDoc,
        gcpDoc = _ref2.gcpDoc,
        rcValidity = _ref2.rcValidity,
        insuranceValidity = _ref2.insuranceValidity,
        pucValidity = _ref2.pucValidity,
        fitCertValidity = _ref2.fitCertValidity,
        gcpValidity = _ref2.gcpValidity,
        deviceId = _ref2.deviceId,
        cylinders = _ref2.cylinders;

    return {
      regNo: regNo,
      capacity: capacity,
      dateCommissioning: dateCommissioning,
      status: status,
      ownerName: ownerName,
      ownerContact: ownerContact,
      billingInfo: billingInfo,
      camera: camera,
      cgpsMonitoring: cgpsMonitoring,
      permitDetails: permitDetails,
      region: region,
      otherInfo: otherInfo,
      ownerDetails: ownerDetails,
      driverName: driverName,
      _id: _id,
      transportSupervisorName: transportSupervisorName,
      transportSupervisorContact: transportSupervisorContact,
      rcDoc: rcDoc,
      insuranceDoc: insuranceDoc,
      pucDoc: pucDoc,
      fitCertDoc: fitCertDoc,
      gcpDoc: gcpDoc,
      rcValidity: rcValidity,
      insuranceValidity: insuranceValidity,
      pucValidity: pucValidity,
      fitCertValidity: fitCertValidity,
      gcpValidity: gcpValidity,
      deviceId: deviceId,
      cylinders: cylinders

    };
  }(vehicle);

  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$vehicleDataRepository.update(vehicle._id, vehicle).then(function (result) {
    vehicle = result.data;
    return vehicle;
  }).catch(function (error) {
    console.error('vehicleUpdate.update-error:\n', error);
    throw error;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nes_lib_client__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nes_lib_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nes_lib_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1);





var internals = {};

internals.client = new __WEBPACK_IMPORTED_MODULE_2_nes_lib_client___default.a.Client(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].websocketURI);

internals.connect = function () {
  internals.client.connect({
    auth: {
      headers: { authorization: 'Bearer' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.accessToken }
    }
  }, function (error) {
    if (error) {
      if (error.message === __WEBPACK_IMPORTED_MODULE_3__config__["e" /* RESPONSE_MESSAGES */].EXPIRED_ACCESS_TOKEN) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/useRefreshToken');
        internals.client.disconnect();
        internals.client.connect({
          auth: {
            headers: {
              authorization: 'Bearer' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.refreshToken
            }
          }
        }, function (error) {
          if (error) {
            console.error(error);
          }
        });
      } else {
        console.error(error);
      }
    }
  });

  internals.client.onError = function (err) {
    console.error('client ERROR:', err);
  };

  internals.client.onConnect = function () {
    console.log('CONNECTED:');
  };

  internals.client.onDisconnect = function (willReconnect, log) {
    console.log('DISCONNECTED:', willReconnect, log);
  };
};

internals.disconnect = function () {
  console.log('DISCONNECTING');
  internals.client.disconnect();
};

internals.request = function (options) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    internals.client.request(options, function (error, payload, statusCode, headers) {
      if (error) {
        if (error === __WEBPACK_IMPORTED_MODULE_3__config__["e" /* RESPONSE_MESSAGES */].EXPIRED_ACCESS_TOKEN) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('auth/useRefreshToken');
          return resolve(internals.request(options));
        } else {
          return reject(error);
        }
      } else {
        return resolve({ payload: payload, statusCode: statusCode, headers: headers });
      }
    });
  });
};

internals.subscribe = function (path, handler) {
  console.log('CURRENT SUBSCRIPTIONS:', internals.client.subscriptions());
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    internals.client.subscribe(path, handler, function (error) {
      if (error) {
        return reject(error);
      } else {
        console.log('NEW SUBSCRIPTIONS:', internals.client.subscriptions());
        return resolve();
      }
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (internals);

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["a"] = ({
  setBreadcrumbTitle: function setBreadcrumbTitle(_ref, breadcrumbTitle) {
    var state = _ref.state,
        commit = _ref.commit;

    var parts = __WEBPACK_IMPORTED_MODULE_2__main__["default"].$router.currentRoute.path.split('/').slice(1);
    var breadcrumbs = state.breadcrumbs;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parts.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref2 = _step.value;

        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 1);

        var index = _ref3[0];

        var subPath = '';
        for (var i = 0; i <= index; i++) {
          subPath += '/' + parts[i];
        }
        if (subPath === __WEBPACK_IMPORTED_MODULE_2__main__["default"].$router.currentRoute.path) {
          breadcrumbs[index].title = breadcrumbTitle;
          commit('SET_BREADCRUMBS', breadcrumbs);
          return;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  setBreadcrumbs: function setBreadcrumbs(_ref4, _ref5) {
    var state = _ref4.state,
        commit = _ref4.commit;
    var currentPath = _ref5.currentPath;

    if (__WEBPACK_IMPORTED_MODULE_2__main__["default"]) {
      var parts = currentPath.split('/').slice(1);
      var breadcrumbs = [];

      var _loop = function _loop(index) {
        var subPath = '';
        for (var i = 0; i <= index; i++) {
          subPath += '/' + parts[i];
        }

        var breadcrumb = state.breadcrumbs.find(function (breadcrumb) {
          return breadcrumb.path === subPath;
        });
        if (!breadcrumb) {
          var _vm$$router$resolve = __WEBPACK_IMPORTED_MODULE_2__main__["default"].$router.resolve(subPath),
              route = _vm$$router$resolve.route;

          breadcrumb = {
            path: subPath,
            title: route.meta.title
          };
        }
        breadcrumbs.push(breadcrumb);
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parts.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref6 = _step2.value;

          var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 1);

          var index = _ref7[0];

          _loop(index);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      commit('SET_BREADCRUMBS', breadcrumbs);
    }
  }
});

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_generate_mutations__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(3);




var state = {
	user: {},
	userRegion: {},
	scope: [],
	accessToken: '',
	refreshToken: ''
};

var mutations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_generate_mutations__["a" /* default */])(state);

var actions = {
	updateTokens: function updateTokens(_ref, _ref2) {
		var commit = _ref.commit;
		var accessToken = _ref2.accessToken,
		    refreshToken = _ref2.refreshToken;

		__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
		__WEBPACK_IMPORTED_MODULE_2__services__["b" /* wsClient */].client.overrideReconnectionAuth({
			headers: { authorization: 'Bearer' + accessToken }
		});

		commit('SET_ACCESS_TOKEN', accessToken);
		commit('SET_REFRESH_TOKEN', refreshToken);

		console.debug('Tokens updated');
	},
	useRefreshToken: function useRefreshToken(_ref3) {
		var state = _ref3.state;

		__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = 'Bearer ' + state.refreshToken;
		__WEBPACK_IMPORTED_MODULE_2__services__["b" /* wsClient */].client.overrideReconnectionAuth({
			headers: { authorization: 'Bearer' + state.refreshToken }
		});

		console.debug('Using refresh token');
	},
	setAuth: function setAuth(_ref4, data) {
		var commit = _ref4.commit,
		    dispatch = _ref4.dispatch;

		dispatch('updateTokens', data);
		commit('SET_SCOPE', data.scope);
		commit('SET_USER', data.user);
		commit('SET_USER_REGION', data);
		__WEBPACK_IMPORTED_MODULE_2__services__["b" /* wsClient */].connect();
	},
	clearAuth: function clearAuth(_ref5) {
		var commit = _ref5.commit,
		    dispatch = _ref5.dispatch;

		__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = undefined;
		commit('CLEAR_ACCESS_TOKEN');
		commit('CLEAR_REFRESH_TOKEN');
		commit('CLEAR_SCOPE');
		commit('CLEAR_USER');

		__WEBPACK_IMPORTED_MODULE_2__services__["b" /* wsClient */].disconnect();
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions
});

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  }
});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  breadcrumbs: [],
  conversations: [],
  notifications: [],
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  }
});

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    getTitle: function getTitle(str) {
      return str.charAt(0).toUpperCase + str.charAt(1);
    }
  }
});

/***/ })

},[12]);


// WEBPACK FOOTER //
// static/js/app.9259e1d2e5cf3ea98bc0.js